// Germany
export const locale = {
	lang: 'de',
	data: {
		WHAT_IF: {
			SIMULATION: { ACTUAL_VALUE: 'Istwert' },
			GRAPH: {
				BASELINE_TIMESTAMP: 'Baseline-Zeitstempel',
				NO_DATA: 'Keine Daten gefunden!',
				RUN_SIMULATION_TITLE: 'Führen Sie eine Simulation aus, um Diagrammergebnisse anzuzeigen',
				RUN_SIMULATION_HINT: 'Klicken Sie nach der Konfiguration der Simulationsparameter auf „Ausführen“.',
				RAW_TAG_DEPENDENCY: 'Roh-Tag-Abhängigkeit',
				BASELINE: 'Baseline',
				SIMULATION: 'Simulation',
				SIMULATED: 'Simuliert',
			},
			SEARCH: {
				PLACEHOLDER: 'Anlage, System, Einheit oder Tag suchen',
				SEARCHING: 'Suchen…',
				NO_RESULTS: 'Keine Treffer gefunden',
				ERROR: 'Suche fehlgeschlagen. Bitte erneut versuchen.',
			},
			TABLE: {
				DELTA_TOOLTIP: 'Absolute Änderung (Simuliert − Basislinie)',
				DELTA_PERCENT_TOOLTIP: 'Prozentuale Änderung gegenüber der Basislinie',
				IMPACT_PROGRESS: 'Auswirkungsfortschritt',
				IMPACT: 'Auswirkung',
			},
			IMPACTED_KPI: {
				TITLE: 'Betroffene berechnete KPIs ({{count}})',
				NO_IMPACTED_KPIS: 'Noch keine betroffenen KPIs',
				EMPTY_HINT: 'Wählen Sie links Rohdaten-Tags aus, um die nachgelagerte KPI-Auswirkung zu sehen.',
				LOADING: 'Berechnete Tags werden geladen...',
				SELECTION_HINT: '{{checked}} von {{total}} KPIs im Primärsystem ausgewählt — deaktivieren, um von der Simulation auszuschließen. Driven-by-Chips zeigen, welche Rohdaten-Tags jede KPI beeinflussen. Nebensysteme mit derselben Tag-Signatur werden unten als schreibgeschützte systemübergreifende Auswirkungen aufgeführt.',
				CROSS_SYSTEM_IMPACT: 'Systemübergreifende Auswirkung',
				KPI_COUNT: '{{count}} KPIs',
				TAG_PARAMETER: 'Tag / Parameter',
				CALCULATED_TAG: 'Berechneter Tag',
				DRIVEN_BY: 'Beeinflusst durch:',
			},
			PAGE: {
				TITLE: 'What-If',
				SELECT_RAW_TAGS_TITLE: 'Rohdaten-Tags zur Simulation auswählen',
				SELECT_RAW_TAGS_SUBTITLE: 'Tags aus der Hierarchie unten auswählen',
				SIMULATION_SETUP_TITLE: 'Simulationseinrichtung',
				SIMULATION_SETUP_SUBTITLE: 'Wählen Sie oben Tags aus, um zu beginnen',
				RUN: 'Ausführen',
				RESET: 'Zurücksetzen',
				NO_TAGS_SELECTED: 'Keine Tags ausgewählt',
				NO_TAGS_SELECTED_DESC: 'Wählen Sie oben Rohdaten-Tags aus, um Änderungen zu definieren.',
				CLICK_TIMESTAMP_HINT: 'Klicken Sie irgendwo auf das Diagramm, um einen Betriebszustand-Zeitstempel auszuwählen.',
				CLICK_RANGE_HINT: 'Klicken Sie zweimal auf das Diagramm, um den Betriebszustandsbereich auszuwählen.',
				SELECTED_OPERATING_STATE: 'Ausgewählter Betriebszustand:',
				SELECTED_OPERATING_RANGE: 'Ausgewählter Betriebsbereich:',
				FIRST_POINT_PREFIX: 'Erster Punkt:',
				FIRST_POINT_SUFFIX: '— erneut klicken, um das Bereichsende festzulegen.',
				SIMULATION_RESULTS: 'Simulationsergebnisse',
				TABLE_VIEW: 'Tabellenansicht',
				RUN_SIMULATION_TABLE_TITLE: 'Führen Sie eine Simulation aus, um Tabellenergebnisse zu sehen',
				TABLE_UNAVAILABLE_PERIOD: 'Tabellenansicht ist für Zeitraum-Simulationen nicht verfügbar',
				SWITCH_TO_SINGLE_POINT: 'Wechseln Sie zum Modus „Einzelpunkt“ oder verwenden Sie die Diagrammansicht.',
				NO_KPI_ROWS: 'Keine KPI-Zeilen anzuzeigen',
				NO_KPI_ROWS_DESC: 'Alle betroffenen KPIs sind deaktiviert. Wählen Sie KPIs im Tab „Betroffene KPIs“ aus, um sie hier zu sehen.',
				GRAPH_VIEW: 'Diagrammansicht',
				SIMULATION_TYPE_PERCENT: '% Änderung',
				SIMULATION_TYPE_ABSOLUTE: 'Absoluter Wert',
				TIME_CONTEXT_SINGLE: 'Einzelpunkt',
				TIME_CONTEXT_PERIOD: 'Zeitraum',
			},
			IMPACTED_KPIS_TAB_LABEL: 'Betroffene KPIs',
			IMPACTED_KPIS_TAB_LABEL_COUNT: 'Betroffene KPIs ({{count}})',
			HIERARCHY_TOOLTIP: {
				TAG_NAME: 'Tag-Name',
				TAG_ID: 'Tag-ID',
				TAG_DESCRIPTION: 'Beschreibung',
				ASSET_NAME: 'Asset-Name',
				SYSTEM_NAME: 'Systemname',
			},
		},
		TRANSLATOR: {
			SELECT: 'Wähle deine Sprache',
		},
		VALIDATION: {
			REQUIRED: 'Dieses Feld ist erforderlich',
			PATTERN: 'Ungültiges Format',
			MIN: 'Wert ist zu klein',
			MAX: 'Wert ist zu groß',
			MIN_LENGTH: 'Wert ist zu kurz',
			MAX_LENGTH: 'Wert ist zu lang',
			SELECT_AT_LEAST_ONE: 'Wählen Sie mindestens eine Option',
			INVALID: 'Ungültiger Wert',
			FIELD_REQUIRED: '{{field}} ist erforderlich',
		},
		COMMON: {
			NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
			TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche',
			SELECT_A_SYSTEM: 'Wählen Sie ein System aus.',
			SELECT_DIFF_UNIT: 'Wählen Sie eine andere Einheit oder Anlage aus',
			SELECT_DIFF: 'Wählen Sie eine andere Anlage, Einheit oder ein anderes System aus',
			NO_TAGS_FOUND: 'Keine Tags gefunden',
			SELECT_FACILITY: 'Wählen Sie eine andere Anlage aus',
			ADDED_FROM_ROOTY: 'Hinzugefügt von {{name}}',
		},
		COMMENT_POPUP: {
			TITLE: 'Kommentar hinterlassen',
			ENTER_MESSAGE: 'Geben Sie Ihre Nachricht ein',
			COMMENT_PLACEHOLDER: 'Kommentar hinzufügen, verwenden Sie @, um Teammitglieder zu markieren',
			FILE_SIZE_LIMIT_ERROR: '{{fileName}} konnte aufgrund der Dateigrößenbeschränkung nicht hochgeladen werden.',
			UPLOAD_FAILED_ERROR: '{{fileName}} konnte nicht hochgeladen werden.',
			INVALID_FILES_ERROR: 'Keine gültigen Dateien ausgewählt. Nur Dateien mit den Erweiterungen {{extensions}} sind zulässig',
		},
		REGENERATE_HYPOTHESES_POPUP: {
			TITLE: 'Hypothesen neu generieren',
			DESCRIPTION: 'Alle Hypothesen werden anhand des Feedbacks zur Kausalkette, den Empfehlungen und den vorgeschlagenen Nachweisen neu generiert. Die aktuelle Version wird im Verlauf gespeichert.',
			REGENERATION_CONTEXT: 'Kontext der Neugenerierung',
			TOTAL_FEEDBACKS: 'Feedback insgesamt',
			ADDED_AS_EVIDENCE: 'Als Nachweis hinzugefügt',
			APPROVED: 'Genehmigt',
			RELEARNED: 'Neu gelernt',
			SETTINGS: 'Einstellungen',
			DOCUMENT_INSIGHTS: 'Dokumenteneinblicke',
			SAP_INSIGHTS: 'SAP-Einblicke',
			CONNECTED_SYSTEMS_REVIEW: 'Überprüfung verbundener Systeme',
			ALERT_REVIEW_WINDOW: 'Alarm-Überprüfungszeitraum',
			DAYS: 'Tage',
			RESET_AND_RERUN: 'Zurücksetzen & erneut ausführen',
			RESET_AND_RERUN_INFO: 'Bisherige Hypothesen, Feedback, Empfehlungen und vorgeschlagene Nachweise werden ignoriert. Die RCA wird von Grund auf neu erstellt, nur mit den aktuell verfügbaren Daten.',
			VERSION_HISTORY_NOTE: 'Die aktuellen Hypothesen werden im Versionsverlauf gespeichert. Sie können frühere Versionen jederzeit wiederherstellen.',
			USER_CONSENT: 'Mir ist bewusst, dass der bisherige RCA-Kontext für diesen Lauf nicht verwendet wird.',
			CANCEL: 'Abbrechen',
			REGENERATE_ALL: 'Alle neu generieren',
			REGENERATE_ALL_TOOLTIP: 'Aktuelle RCA mit vorhandenem Kontext verbessern',
			RESET_AND_RERUN_BTN: 'Zurücksetzen & erneut ausführen',
			RESET_AND_RERUN_TOOLTIP: 'Neue RCA von Grund auf erstellen',
		},
		SHARE_REPORT_POPUP: {
			TITLE: 'Bericht teilen',
			ADD_PEOPLE: 'Personen hinzufügen',
			MESSAGE: 'Nachricht',
			MESSAGE_PLACEHOLDER: 'Nachricht eingeben (optional)',
			COPY_LINK: 'Link kopieren',
			CANCEL: 'Abbrechen',
			SEND: 'Senden',
		},
		FEEDBACK_POPUP: {
			PREVIOUSLY_APPROVED: 'Zuvor genehmigt',
			PREVIOUSLY_RELEARNED: 'Zuvor neu gelernt',
			SEE_LESS: 'Weniger anzeigen',
			SEE_MORE: 'Mehr anzeigen...',
			FEEDBACK_LABEL: 'Feedback',
			FEEDBACK_TOOLTIP: 'Dieses Feedback wird bei der erneuten RCA-Ausführung verwendet.',
			CANCEL: 'Abbrechen',
			CONFIRM: 'Bestätigen',
			RELEARNED_BY: 'Neu gelernt von:',
			NO_REASON_ADDED: 'Kein Grund hinzugefügt',
		},
		ASK_ROOTY_POPUP: {
			ENTER_MESSAGE_TO_START: 'Geben Sie Ihre Nachricht ein, um einen Chat zu starten',
			MESSAGE_PLACEHOLDER: 'Geben Sie Ihre Nachricht ein...',
		},
		ROOTY_CHAT: {
			FOLLOW_UP_SUGGESTIONS: 'Vorschläge für Folgefragen',
			ASK_TITLE: '{{name}} fragen',
			UPLOAD_TOOLTIP: 'PDF-, Word-, Excel-, PNG-, JPG- und JPEG-Dateien hochladen, damit {{name}} sie analysieren kann.',
			DISCLAIMER: '{{name}} liefert KI-unterstützte Antworten und ist möglicherweise nicht immer korrekt. Bitte vor dem Handeln überprüfen.',
			FEEDBACK_SUBTITLE: 'Wählen Sie das Hauptproblem aus, damit wir zukünftige Antworten von {{name}} verbessern können.',
			POPUP_TITLE: '{{name}} fragen',
			NOT_ENABLED: '{{name}} ist für den aktuellen Benutzer nicht aktiviert.',
			SHARE: 'Teilen',
			RENAME: 'Umbenennen',
			DELETE: 'Löschen',
			HISTORY: 'Verlauf',
			CLOSE: 'Schließen',
			SEARCH: 'Suchen...',
			UNSAVED: 'Nicht gespeichert',
			NO_HISTORY_HEADING: 'Kein Verlauf verfügbar.',
			NO_HISTORY_DESC: 'Wir konnten keine historischen Daten finden.',
			START_NEW_CHAT: 'Neuen Chat starten',
			AGENT_CONTEXT_TOOLTIP: 'Agenten-Kontext',
			CHAT_HISTORY_TOOLTIP: 'Chatverlauf',
			UNPIN: 'Lösen',
			PIN: 'Anheften',
			FULL_SCREEN: 'Vollbild',
			EXIT_FULL_SCREEN: 'Vollbild verlassen',
			EXPAND: 'Erweitern',
			COLLAPSE: 'Einklappen',
			INTRO_TITLE: 'Hallo! Brauchen Sie Hilfe bei dem, was Sie sich gerade ansehen?',
			INTRO_DESC: 'Fragen Sie mich alles, oder ich kann diesen Bildschirm zusammenfassen, Trends erklären, Elemente vergleichen und nächste Schritte vorschlagen.',
			SUGGESTIONS: 'Vorschläge',
			SUGGESTION_1: 'Fassen Sie diese RCA in 30 Sekunden zusammen (was ist passiert und warum).',
			SUGGESTION_2: 'Welche Hypothese wird durch die hier gezeigten Belege am stärksten unterstützt?',
			SUGGESTION_3: 'Vergleichen Sie die Hypothesen: Was ist der stärkste Beleg für jede?',
			CP_INTRO_TITLE: 'Hallo! Brauchen Sie Hilfe bei der Kapazitätsoptimierung und Szenarioplanung?',
			CP_INTRO_DESC: 'Ich kann Ihnen helfen, Planungsmodelle zu erstellen, Ausfallszenarien von Anlagen zu testen, das Wachstum der Spitzenlast zu simulieren und die Machbarkeit von Strom- und Wasserergebnissen zu analysieren.',
			CP_SUGGESTION_1: 'Fassen Sie die Gesamterzeugungskosten, den Brennstoffverbrauch und die Aufschlüsselung nach Anlagen für diesen Lauf zusammen.',
			CP_SUGGESTION_2: 'Wie groß ist unsere Reserveleistung (Spinning Reserve) und gibt es Engpasszeiten?',
			CP_SUGGESTION_3: 'Was passiert, wenn H5_GT während der Spitzenlast ausfällt?',
			CP_SUGGESTION_4: 'Simulieren Sie ein Wachstum der Spitzenlast um +5% für dieses Szenario.',
			LOADING_EARLIER: 'Frühere Unterhaltung wird geladen…',
			SHOW_EARLIER: 'Frühere Unterhaltung anzeigen',
			RESPONSE_STOPPED: 'Antwortgenerierung gestoppt',
			LOADING_ALT: 'Wird geladen',
			THINKING: 'Denkt nach',
			THOUGHT_FOR: '{{seconds}}s nachgedacht',
			DOWNLOAD_CSV: 'CSV herunterladen',
			COPY_CSV: 'CSV kopieren',
			DOWNLOAD_IMAGE: 'Bild herunterladen',
			COPY_IMAGE: 'Bild kopieren',
			WHAT_IF_SCENARIO_CREATED: 'What-If-Szenario erstellt',
			CHANGE_APPLIED: 'Änderung angewendet:',
			NEW_SCENARIO: 'Neues Szenario:',
			VIEW_CONFIGURATION: 'Konfiguration anzeigen',
			RUN_OPTIMIZATION: 'Optimierung ausführen',
			RESULTS_COMPARISON: 'Ergebnisvergleich',
			ALL_IMPROVED: 'Alles verbessert',
			KPI: 'KPI',
			BASE: 'Basis',
			WHAT_IF: 'What-If',
			YES: 'Ja',
			NO: 'Nein',
			CHANGED: 'geändert',
			WHATIF_KPI_POWER_FEASIBLE: 'Leistung realisierbar',
			WHATIF_KPI_WATER_FEASIBLE: 'Wasser realisierbar',
			WHATIF_KPI_EST_COST: 'Geschätzte Kosten',
			WHATIF_KPI_POWER_SHORTFALL: 'Leistungsdefizit',
			WHATIF_KPI_WATER_SHORTFALL: 'Wasserdefizit',
			WHATIF_KPI_AVG_GENERATION: 'Durchschn. Erzeugung',
			WHATIF_KPI_AVG_HEADROOM: 'Durchschn. Reserve',
			WHATIF_KPI_TOTAL_STARTS: 'Starts gesamt',
			WHATIF_KPI_AVG_WATER_OUTPUT: 'Durchschn. Wasserleistung',
			WHATIF_KPI_GAP_PERCENT: 'Abweichung %',
			WHATIF_POWER_BALANCE: 'Leistungsbilanz (MW)',
			WHATIF_TIME_AXIS: 'Zeit',
			WHATIF_POWER_AXIS: 'Leistung (MW)',
			WHATIF_WATER_OUTPUT: 'Wasserleistung (MIGD)',
			WHATIF_WATER_AXIS: 'Wasser (MIGD)',
			WHATIF_TRACE_DEMAND: 'Bedarf',
			WHATIF_TRACE_GEN: 'Erz.',
			WHATIF_TRACE_WATER: 'Wasser',
			NO_MAJOR_DIFF: 'Kein KPI hat sich zwischen den beiden Szenarien um mehr als 5 % geändert.',
			VIEW_FULL_RESULTS: 'Vollständige Ergebnisse anzeigen',
			APPLY_AS_EVIDENCE: 'Als Beleg anwenden',
			ADDED_AS_EVIDENCE: 'Als Beleg hinzugefügt',
			ALREADY_ADDED_AS_EVIDENCE: 'Bereits als Beleg hinzugefügt',
			ADD_AS_EVIDENCE: 'Als Beleg hinzufügen',
			BRANCH_VISIBILITY_NOTICE: 'Neue Nachrichten sind nur für Sie sichtbar.',
			CONTINUE: 'Weiter',
			SEARCH_SCENARIOS: 'Szenarien suchen...',
			FILTER_SCENARIOS: 'Szenarien filtern',
			SOURCE: 'Quelle',
			ALL_SOURCES: 'Alle Quellen',
			HUMAN_MANUAL: 'Manuell (Mensch)',
			AI_GENERATED: 'KI-generiert',
			STRATEGY_AUTO: 'Strategie (Automatisch)',
			DATE_MODIFIED: 'Änderungsdatum',
			ALL_TIME: 'Gesamter Zeitraum',
			TODAY: 'Heute',
			LAST_7_DAYS: 'Letzte 7 Tage',
			RECENT: 'Kürzlich',
			OFFICIAL: 'Offiziell',
			ALL_SCENARIOS: 'Alle Szenarien',
			NO_SCENARIOS_MATCH: 'Keine Szenarien stimmen mit "{{query}}" überein',
			DRAFT: 'Entwurf',
			DISMISS: 'Verwerfen',
			CONTEXT_PREFIX: 'Kontext:',
			REMOVE_CONTEXT: 'Kontext entfernen',
			SELECT_A_SCENARIO: 'Szenario auswählen',
			CLEAR_SCENARIO: 'Szenario löschen',
			LATEST_RUN_DEFAULT: 'Letzter Lauf (Standard)',
			DROP_FILES_HERE: 'Dateien hier ablegen',
			COMPOSER_PLACEHOLDER: 'Stellen Sie eine Frage oder eine Anfrage...',
			ADD_FILES_OR_IMAGES: 'Dateien oder Bilder hinzufügen',
			LANGUAGE: 'Sprache',
			MIC_BLOCKED: 'Mikrofonzugriff ist blockiert. Mikrofonberechtigung erlauben',
			USE_VOICE_INPUT: 'Spracheingabe verwenden',
			VOICE_INPUT_ALT: 'Spracheingabe',
			STOP_RECORDING: 'Aufnahme stoppen',
			STOP_RECORDING_ALT: 'Aufnahme stoppen',
			STOP_GENERATION: 'Generierung stoppen',
			SEND_ALT: 'Senden',
			FEEDBACK_WHAT_WENT_WRONG: 'Was ist bei dieser Antwort schiefgelaufen?',
			FEEDBACK_CATEGORY: 'Feedback-Kategorie',
			SELECT_AN_ISSUE: 'Ein Problem auswählen',
			SELECT_CATEGORY_TO_CONTINUE: 'Bitte wählen Sie eine Kategorie aus, um fortzufahren',
			ADDITIONAL_DETAILS_OPTIONAL: 'Zusätzliche Details (Optional)',
			FEEDBACK_COMMENT_PLACEHOLDER: 'Erzählen Sie uns mehr darüber, was falsch war.',
			CANCEL: 'Abbrechen',
			SUBMIT_FEEDBACK: 'Feedback senden',
			ERROR: 'Fehler',
			FEEDBACK_SUBMIT_ERROR: 'Feedback konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
			TRY_AGAIN: 'Erneut versuchen',
			OPEN_LINK: 'Link öffnen',
			OPEN_DOCUMENT: 'Dokument öffnen',
			PAGE_PREFIX: 'Seite-{{page}}',
			FEEDBACK_CATEGORY_INCORRECT_ANSWER: 'Falsche Antwort',
			FEEDBACK_CATEGORY_DID_NOT_ANSWER: 'Hat meine Frage nicht beantwortet',
			FEEDBACK_CATEGORY_MISSING_DATA: 'Relevante Daten fehlen',
			FEEDBACK_CATEGORY_INCORRECT_REASONING: 'Falsche Analyse oder Argumentation',
			FEEDBACK_CATEGORY_POOR_CHART: 'Schlechtes Diagramm oder Visualisierung',
			FEEDBACK_CATEGORY_POOR_DOCUMENT: 'Schlechte Dokumentantwort',
			FEEDBACK_CATEGORY_TOO_SLOW: 'Anfrage war zu langsam',
			FEEDBACK_CATEGORY_INCOMPLETE: 'Antwort war unvollständig',
			FEEDBACK_CATEGORY_OTHER: 'Sonstiges',
			CHATBOT_PRIVATE: 'Privat',
			CHATBOT_INHOUSE_GPT: 'Inhouse GPT',
			LANGUAGE_ENGLISH_US: 'Englisch (USA)',
			LANGUAGE_ARABIC: 'Arabisch',
			MODE_AUTO: 'Automatisch',
			MODE_GENERAL: 'Allgemein',
			MODE_DOCS: 'Dokumente',
			MODE_OPTIMIZER: 'Optimierer',
			DATE_TODAY: 'Heute',
			DATE_YESTERDAY: 'Gestern',
			DATE_THIS_WEEK: 'Diese Woche',
			DATE_LAST_WEEK: 'Letzte Woche',
			DATE_THIS_MONTH: 'Diesen Monat',
			DATE_LAST_MONTH: 'Letzten Monat',
			DATE_OLDER: 'Älter',
			CONTEXT: {
				FROM: 'Kontext von {{source}}',
				LAUNCHED_FROM: 'Rooty gestartet von {{source}}',
				UPDATED: 'Kontext aktualisiert',
				REMOVED: 'Kontext entfernt',
				APPLIED: 'Kontext angewendet',
				GENERAL: 'verwendet jetzt den allgemeinen Chat-Kontext',
				MORE: 'Mehr',
				SEE_LESS: 'Weniger anzeigen',
				LABEL: {
					ALERT: 'Alarm',
					RCA: 'RCA',
					SCOPE: 'Bereich',
					SYSTEM: 'System',
					SCENARIO: 'Szenario',
					SIMULATION_TYPE: 'Simulationstyp',
					PREVIOUS: 'Vorherige',
					NEW: 'Neu',
					SOURCE: 'Quelle',
				},
				SOURCE: {
					ALERT: 'Alarmdetails',
					RCA: 'RCA',
					SYSTEM: 'Systemansicht',
					WHAT_IF: 'Was-wäre-wenn-Analyse',
				},
				SUMMARY: {
					ALERT: 'Alarm {{value}}',
					RCA: 'RCA für Alarm {{value}}',
					SYSTEM: 'System {{value}}',
					WHAT_IF: 'Was-wäre-wenn: {{value}}',
				},
			},
			TOAST_FEEDBACK_THANKS: 'Danke. Wir nutzen dies, um Rooty zu verbessern.',
			TOAST_FEEDBACK_POSITIVE_THANKS: 'Danke für Ihr Feedback.',
			TOAST_COPIED_MESSAGE: 'Nachricht kopiert.',
			TOAST_LINK_COPIED: 'Kopiert',
			TOAST_CHAT_DELETED: 'Chat gelöscht',
			TOAST_CHAT_DELETE_FAILED: 'Chat konnte nicht gelöscht werden.',
			TOAST_NEW_CHAT_STARTED: 'Neuer Chat gestartet',
		},
		AGENT_CONTEXT: {
			CONSIDERED: 'Berücksichtigter Agentenkontext',
			ITEMS: 'Elemente',
			ADD: 'Agentenkontext hinzufügen',
			UPDATED: 'Aktualisiert',
			DIALOG_DESC: 'Erfassen Sie wiederverwendbare betriebliche Hinweise für {{name}} und RCA.',
			DIALOG_DISCLAIMER: 'Dieser Kontext kann zukünftige Antworten von {{name}} und RCA für passende Analysen beeinflussen. Er wirkt sich nicht auf die Anomalieerkennung oder Vorhersagemodelle aus.',
			SIDEPANEL_DESC: 'Wiederverwendbares Betriebswissen, das {{name}} und RCA zur Verfügung steht.',
			SIDEPANEL_EMPTY: 'Erfassen Sie wiederverwendbares Betriebswissen für {{name}} und RCA, z. B. Interpretationshinweise, Untersuchungsleitfäden und Terminologie.',
			REMOVE_CONFIRM: '"<strong>{{title}}</strong>" wird entfernt und von {{name}} oder RCA nicht mehr berücksichtigt.<br>Diese Aktion kann nicht rückgängig gemacht werden.',
			TITLE: 'Agenten-Kontext',
			READ_ONLY: 'Nur Lesezugriff',
			ADD_SHORT: 'Hinzufügen',
			CLOSE: 'Schließen',
			SEARCH_PLACEHOLDER: 'Nach Titel oder Bereich suchen...',
			EDIT: 'Bearbeiten',
			DELETE: 'Löschen',
			EMPTY_HEADING: 'Noch kein Agenten-Kontext vorhanden',
			LAST_UPDATED_PREFIX: 'Zuletzt aktualisiert',
			BY_PREFIX: 'Von',
			SECTION_CONTEXT_TYPE: '1. KONTEXTTYP',
			SECTION_SCOPE: '2. BEREICH',
			SECTION_CONTEXT: '3. KONTEXT',
			SELECT_SCOPE: 'Bereich auswählen',
			CONTEXT_TITLE_LABEL: 'Titel',
			CONTEXT_TITLE_PLACEHOLDER: 'Kontexttitel eingeben',
			GUIDANCE_LABEL: 'Leitfadenbeschreibung',
			GUIDANCE_PLACEHOLDER: 'Leitfadenbeschreibung eingeben',
			PLAYBOOK_NAME_LABEL: 'Playbook-Name',
			PLAYBOOK_NAME_PLACEHOLDER: 'Playbook-Namen eingeben',
			INVESTIGATION_STEPS_LABEL: 'Untersuchungsschritte',
			STEP_PLACEHOLDER: 'Schrittbeschreibung eingeben',
			ADD_STEP: '+ Schritt hinzufügen',
			TERM_HEADER: 'Begriff',
			MEANING_HEADER: 'Bedeutung',
			TERM_PLACEHOLDER: 'Begriff hinzufügen',
			MEANING_PLACEHOLDER: 'Bedeutung eingeben',
			CANCEL: 'Abbrechen',
			CARD_REASONING_GUIDANCE_TITLE: 'Argumentationsleitfaden',
			CARD_REASONING_GUIDANCE_DESC: 'Anlagenspezifische Interpretationsregeln, die KI-Agenten beim Verhaltensverständnis unterstützen.',
			CARD_INVESTIGATION_PLAYBOOK_TITLE: 'Untersuchungs-Playbook',
			CARD_INVESTIGATION_PLAYBOOK_DESC: 'Strukturierter Fehlerbehebungsworkflow für ein wiederkehrendes Betriebsproblem.',
			CARD_TERMINOLOGY_TITLE: 'Terminologie',
			CARD_TERMINOLOGY_DESC: 'Anlagenspezifische Aliasnamen, Abkürzungen und Namenskonventionen.',
			SAVE_IN_PROGRESS: 'Speichern läuft. Bitte warten.',
			SCOPE_REQUIRED: 'Vor dem Speichern muss ein Bereich ausgewählt werden.',
			TITLE_REQUIRED: 'Vor dem Speichern ist ein Titel erforderlich.',
			GUIDANCE_DESC_REQUIRED: 'Vor dem Speichern ist eine Leitfadenbeschreibung erforderlich.',
			PLAYBOOK_NAME_REQUIRED: 'Vor dem Speichern ist ein Playbook-Name erforderlich.',
			STEPS_REQUIRED: 'Alle Untersuchungsschritte müssen vor dem Speichern ausgefüllt werden.',
			TERMINOLOGY_REQUIRED: 'Alle Terminologieeinträge müssen vor dem Speichern einen Begriff und eine Bedeutung haben.',
			SOME_ERROR_OCCURRED: 'Ein Fehler ist aufgetreten',
			EDIT_TITLE: 'Agenten-Kontext bearbeiten',
			SAVE_CHANGES: 'Änderungen speichern',
			DELETE_CONTEXT_TITLE: 'Diesen Kontext löschen?',
			DELETED_SUCCESSFULLY: 'Erfolgreich gelöscht.',
		SECTION_GUIDANCE: 'Leitfaden',
		TERMS_LABEL: 'Begriffe',
		REASONING_LABEL: 'Argumentation',
		PLAYBOOK_LABEL: 'Playbook',
		},
		MENU: {
			NEW: 'Neu',
			ACTIONS: 'Aktionen',
			CREATE_POST: 'Erstellen Sie einen neuen Beitrag',
			PAGES: 'Pages',
			FEATURES: 'Eigenschaften',
			APPS: 'Apps',
			HOME: 'Startseite',
			SYSTEM: 'System',
			ANALYSIS: 'Analyse',
			CONFIGURATION: 'Konfiguration',
			ALERTS: 'Warnungen',
			ALERT_TRIAGE: 'Alarm-Triage',
			KNOWLEDGE_GRAPH: 'Wissensgraph',
			ASSET_EXPLORER: 'Asset-Explorer',
			LIBRARY: 'Bibliothek',
			USER_MANAGEMENT: 'Benutzerverwaltung',
			MODEL_WIZARD: 'Modellassistent',
			DASHBOARD_WIZARD: 'Dashboard-Assistent',
			IOW: 'IOW',
			PROCESS: 'Prozess',
			GENAI: 'GenAI',
			MAINTENANCE_OPTIMIZATION: 'Wartungsoptimierung',
			RCM: 'RCM',
			SETTINGS: 'Einstellungen',
			HAZOP: 'Hazop',
			CASES: 'Fälle',
			CAPACITY_OPTIMIZATION: 'Kapazitätsoptimierung',
			WHAT_IF: 'What-if',
			HEALTH_METRICS: 'Gesundheitsmetriken',
			PLATFORM_CONFIGURATION: 'Plattformkonfiguration',
			DATA_MANAGEMENT: 'Datenverwaltung',
			PLATFORM_POLICIES: 'Plattformrichtlinien',
			CONNECTIONS_APIS: 'Verbindungen & APIs',
			MODULE_CONFIGURATION: 'Modulkonfiguration',
			AI_MANAGEMENT: 'KI-Verwaltung',
			ROOTY: '{{name}}',
			NOTIFICATION: 'Benachrichtigung',
			HELP: 'Hilfe',
			PROFILE: 'Mein Profil',
			LOGOUT: 'Abmelden',
			LANGUAGE: 'Sprache',
			BASIC_USER_GUIDE: 'Grundlegendes Handbuch',
			ADVANCED_USER_GUIDE: 'Erweitertes Handbuch'
		},
		AUTH: {
			PASSWORD_REQUIREMENTS: {
				TITLE: 'Ihr Passwort muss Folgendes enthalten:',
				MIN_CHARACTERS: 'Mindestens 8 Zeichen',
				UPPERCASE_LETTER: 'Mindestens 1 Großbuchstabe',
				NUMBER: 'Mindestens 1 Zahl',
				SPECIAL_CHARACTER: 'Mindestens 1 Sonderzeichen',
			},
			GENERAL: {
				OR: 'Oder',
				SUBMIT_BUTTON: 'einreichen',
				NO_ACCOUNT: 'Hast du kein Konto?',
				SIGNUP_BUTTON: 'Anmelden',
				FORGOT_BUTTON: 'Passwort vergessen',
				BACK_BUTTON: 'Zurück',
				PRIVACY: 'Privatsphäre',
				LEGAL: 'Legal',
				CONTACT: 'Kontakt',
				VERIFY_BUTTON: 'Verifizieren',
				ENTER_OTP: 'OTP eingeben',
				HAVE_ACCOUNT: 'Ich habe ein Konto',
			},
			LOGIN: {
				TITLE: 'Konto erstellen',
				BUTTON: 'Anmelden',
				SIGN_IN_MICROSOFT: 'Mit Microsoft anmelden',
				SIGN_IN_SAML: 'Mit SAML anmelden',
				REMEMBER_ME: 'Angemeldet bleiben',
				SIGNING_IN: 'Anmeldung läuft. Bitte warten...',
				BPCL_WELCOME: 'Willkommen bei der KI-basierten Anlagenleistungslösung von BPCL!',
			},
			RESET: {
				TITLE: 'Passwort zurücksetzen',
				SUCCESS: 'Passwort erfolgreich geändert.',
				NEWPASSWORD: 'Neues Passwort',
				REENTERNEWPASSWORD: 'Passwort bestätigen',
				VERIFICATION_CODE_SENT: 'Geben Sie den Bestätigungscode ein, der gesendet wurde an',
				NO_CODE_RECEIVED: 'Keinen Code erhalten?',
				RESEND: 'Erneut senden',
				RESEND_IN: 'in',
			},
			FORGOT: {
				TITLE: 'Passwort vergessen?',
				DESC: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen',
				SUCCESS: 'Überprüfen Sie Ihre E-Mail auf OTP.',
				REQUEST_RESET_BUTTON: 'Passwort-Zurücksetzung anfordern',
				BACK_TO_SIGNIN: 'Zurück zur Anmeldung',
			},
			REGISTER: {
				TITLE: 'Registrieren',
				DESC: 'Geben Sie Ihre Daten ein, um Ihr Konto zu erstellen',
				SUCCESS: 'Ihr Konto wurde erfolgreich registriert.',
				ORGANIZATION_NAME: 'Organisationsname',
				NAME: 'Name',
				AGREE_PREFIX: 'Ich stimme den',
				TERMS_CONDITIONS: 'Allgemeinen Geschäftsbedingungen zu',
				EMAIL_ALREADY_REGISTERED: 'Diese E-Mail-Adresse ist bereits registriert.',
			},
			INPUT: {
				EMAIL: 'E-Mail',
				EMAIL_ADDRESS: 'E-Mail-Adresse',
				FULLNAME: 'Vollständiger Name',
				PASSWORD: 'Passwort',
				CONFIRM_PASSWORD: 'Passwort bestätigen',
				USERNAME: 'Nutzername'
			},
			PLACEHOLDER:{
				EMAIL: 'E-Mail eingeben',
				PASSWORD: 'Passwort eingeben'
			},
			VERIFY:{
				VERIFY_EMAIL: 'E-Mail-Verifizierung',
				BACK_TO_SIGNIN: 'Zurück zur Anmeldung',
			},
			SUBSCRIPTION: {
				EXPIRED: 'Ihr Abonnement ist abgelaufen.',
				RENEW: 'Jetzt verlängern oder den Support um Hilfe bitten.',
			},
			VALIDATION: {
				INVALID: '{{name}} ist ungültig',
				INVALID_EMAIL: 'Geben Sie eine gültige E-Mail-Adresse ein',
				REQUIRED: '{{name}} ist erforderlich',
				MIN_LENGTH: 'Die Mindestlänge für {{name}} beträgt {{min}}',
				AGREEMENT_REQUIRED: 'Die Zustimmung zu den Nutzungsbedingungen ist erforderlich',
				NOT_FOUND: 'Das angeforderte {{name}} wurde nicht gefunden',
				INVALID_LOGIN: 'Die Anmeldedaten sind ungültig',
				INVALID_RESET: 'Das eingegebene OTP ist falsch oder abgelaufen. Bitte versuchen Sie es erneut.',
				REQUIRED_FIELD: 'Pflichtfeld',
				MIN_LENGTH_FIELD: 'Mindestlänge des Feldes:',
				MAX_LENGTH_FIELD: 'Maximale Länge des Feldes:',
				INVALID_FIELD: 'Feld ist ungültig',
				OTP_REQUIRED: 'Geben Sie den Bestätigungscode ein, der an Ihre E-Mail gesendet wurde.'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		HEALTH_METRICS: {
			TITLE: 'Gesundheitsmetriken',
			SYSTEM_MODEL_METRICS: 'System & Modell Gesundheitsmetriken',
			DATA_FEED_HEALTH: 'Daten-Feed Gesundheit',
			QC_CHECK: 'QC-Prüfung',
			QC: {
				RAW_TAG_QC: 'Roh-Tag-QC',
				CALCULATED_TAG_QC: 'Berechnetes Tag-QC',
				MODEL_QC: 'Modell-QC',
				COMING_SOON: 'Demnächst verfügbar',
				CONFIGURATION: 'QC-Prüfungskonfiguration',
				ALL_TAGS: 'Alle Tags',
				PROBLEM_TAGS: 'Problem-Tags',
				SEARCH: 'Suchen...',
				COLUMN_CONFIG: 'Spaltenkonfiguration',
				ADD_TAG: 'Tag hinzufügen',
				EXPORT: 'Exportieren',
				UPLOAD: 'Tags hochladen (Excel)',
				DOWNLOAD: 'Tags herunterladen (Excel)',
				VIEW: 'Ansehen',
				EDIT: 'Bearbeiten',
				NO_TAGS_FOUND: 'Keine Tags gefunden',
				ADD_DESCRIPTION: 'Beschreibung hinzufügen',
				ADD_UOM: 'Einheit hinzufügen',
				COL_INDEX: '#',
				COL_SYSTEM_NAME: 'Systemname',
				COL_TAG_NAME: 'Tag-Name',
				COL_TAG_ID: 'Tag-ID',
				COL_TAG_DESCRIPTION: 'Tag-Beschreibung',
				COL_UOM: 'Einheit',
				COL_IR_UPPER: 'IR Oben',
				COL_TRIP_UPPER: 'Auslösung Oben',
				COL_ALARM_UPPER: 'Alarm Oben',
				COL_THRES_UPPER: 'Schwelle Oben',
				COL_OPS_UPPER: 'Betrieb Oben',
				COL_OPS_LOWER: 'Betrieb Unten',
				COL_THRES_LOWER: 'Schwelle Unten',
				COL_ALARM_LOWER: 'Alarm Unten',
				COL_TRIP_LOWER: 'Auslösung Unten',
				COL_IR_LOWER: 'IR Unten',
				COL_FLATLINE: 'Flachlinien-Erkennung',
				COL_OUTLIER: 'Ausreißer-Erkennung',
				COL_RANGE: 'Erkennung außerhalb des Bereichs',
				COL_MISSING_DATA: 'Fehlende Daten Erkennung',
				COL_FLATLINE_ALERT: 'Flachlinien-Warnung Gen.',
				COL_OUTLIER_ALERT: 'Ausreißer-Warnung Gen.',
				COL_RANGE_ALERT: 'Außerhalb des Bereichs Warnung Gen.',
				COL_MISSING_DATA_ALERT: 'Fehlende Daten Warnung Gen.',
				COL_ATTENTION: 'Achtung',
				COL_THRES_NOT: 'Schwellen-Ben.',
				COL_KPI: 'KPI',
				COL_DIRECTIONALITY: 'Direktionalität',
				COL_IOW_LOWER: 'IOW Untere',
				COL_IOW_UPPER: 'IOW Obere',
				COL_ACTIONS: 'Aktionen',
				COL_DESCRIPTION: 'Beschreibung',
				EDIT_TAG: 'Tag bearbeiten',
				LOWER: 'Unten',
				UPPER: 'Oben',
				INSTRUMENT_RANGE: 'Messbereich',
				TRIP_LIMITS: 'Auslösegrenzen',
				ALARM_LIMITS: 'Alarmgrenzen',
				THRESHOLD_LIMITS: 'Schwellenwertgrenzen',
				DIRECTIONALITY: 'Direktionalität',
				IOW_CRITICALITY: 'IOW-Kritikalität',
				FLATLINE_DETECTION: 'Flatline-Erkennung',
				THRESHOLD_NOTIFICATION: 'Schwellenbenachrichtigung',
				ASSET: 'Asset',
				CALCULATED_FLAG: 'Berechnetes Flag',
				REMARK: 'Bemerkung',
				REMARK_PLACEHOLDER: 'Bemerkung zum Bearbeiten eingeben',
				CANCEL: 'Abbrechen',
				SAVE: 'Speichern',
			},
			DATA_FEED: {
				TITLE: 'Daten-Feed Gesundheit (Überwachung)',
				ALL_TAGS: 'Alle Tags',
				GOOD_TAGS: 'Gute Tags',
				BAD_TAGS: 'Schlechte Tags',
				GROUP_BY: 'Gruppieren',
				DOWNLOAD: 'Herunterladen',
				NO_TAGS_FOUND_TITLE: 'Keine Tags gefunden',
				NO_TAGS_FOUND_DESC: 'Überprüfen Sie Filter und Datumsbereich',
				TAGS: 'Tags',
				SHOW: 'Anzeigen',
				MORE_TAGS: 'weitere Tags',
				NO_TAGS: 'Keine Tags gefunden.',
				SYSTEM_NAME: 'Systemname',
				VALUE: 'Wert',
				QUALITY: 'Qualität',
				TIMESTAMP: 'Zeitstempel',
				TAG_NAME: 'Tag Name',
				TAG_ID: 'Tag ID'
			},
			MODEL_HEALTH: {
				TITLE: 'System & Modell Gesundheitsmetriken',
				ALL_SYSTEMS: 'Alle Systeme',
				PROBLEM_SYSTEMS: 'Problem-Systeme',
				NO_PROBLEM_SYSTEMS: 'Keine Probleme gefunden',
				SEARCH: 'Suche...',
				REFRESH: 'Daten aktualisieren',
				DOWNLOAD: 'Herunterladen',
				SYSTEM_NAME: 'Systemname',
				STATUS: 'STATUS',
				DEPLOYED_VERSION: 'Bereitgestellte Version',
				LAST_DATA_PULL: 'Letzter Datenabruf',
				DATA_HEALTH: 'Daten Gesundheit',
				MODEL_HEALTH: 'Modell Gesundheit',
				PREDICTION_TIME: 'Vorhersagezeit',
				LAST_PREDICTION: 'Letzte Vorhersage',
				PREDICTIONS_OLDER_THAN_2_HOURS: 'Vorhersagen > 2h = Problem-System',
				LAST_DATA_WRITTEN: 'Zuletzt geschriebene Daten',
				LAST_ANOMALY_WRITTEN: 'Letzte Anomalie',
				FETCH_STATUS: 'Abrufstatus',
				FETCH_RATE: 'Abrufrate',
				FETCH_SAMPLING_RATE: 'Abtastrate',
				PREDICTION_STATUS: 'Vorhersagestatus',
				PREDICTION_RATE: 'Vorhersagerate',
				SAMPLING_RATE: 'Abtastrate',
				ACTIONS: 'Aktionen',
				CUSTOMIZE_COLUMNS: 'Spalten anpassen',
				NO_DATA_MATCHING: 'Keine Daten für die ausgewählte Anlage verfügbar',
				DEPLOYED_DATE: 'Bereitstellungsdatum',
				DEPLOYED_BY: 'Bereitgestellt von',
				DEPLOYMENT_NOTE: 'Bereitstellungshinweis',
				ACTIVE_ALERTS: 'Aktive Warnungen',
				RETRAINING_RECOMMENDED: {
					TITLE: 'Nachtraining empfohlen',
					DESCRIPTION: 'Die aktuelle Auswertung deutet darauf hin, dass das Modell das aktuelle Betriebsverhalten möglicherweise nicht mehr widerspiegelt. Die folgenden Tags tragen am meisten zu dieser Empfehlung bei.',
					CONTRIBUTING_TAGS: 'Beitragende Tags (bis zu 5)',
					TAG_NAME_AND_ID: 'Tag-Name und ID',
					TAG_TOOLTIP: 'Name: {{tagName}}\nTagID: {{tagId}}',
					CONTRIBUTION_SCORE: 'Beitragsscore',
					LAST_EVALUATED: 'Zuletzt ausgewertet',
					MODEL_VERSION: 'Modell',
					COPY_TAGS: 'Tags kopieren',
					COPY_FULL_DETAILS: 'Vollständige Details kopieren',
					RETRAIN_MODEL: 'Modell neu trainieren',
					RETRAIN: 'Nachtrainieren',
					TIP_PREFIX: 'Tipp: Klicken Sie auf den',
					TIP_SUFFIX: 'Chip in der Spalte „Modellzustand“, um zu erfahren, warum ein Nachtraining empfohlen wird.',
					NO_TAGS: 'Keine beitragenden Tags gefunden.',
					TAGS_COPIED: 'Tags kopiert.\nIn der Zwischenablage verfügbar.',
					DETAILS_COPIED: 'Details kopiert.\nIn der Zwischenablage verfügbar.',
					RECOMMENDED_DATE_RANGE: 'Empfohlener Datumsbereich für Nachtraining',
					RECOMMENDED_DATE_RANGE_HINT: 'Verwenden Sie diesen Datumsbereich, um das Modell mit den relevantesten Daten zu überprüfen und neu zu trainieren.',
					NO_DATE_RANGE: 'Kein Datumsbereich zum Nachtrainieren des Modells verfügbar',
					ADD_COMMENT: 'Kommentar hinzufügen',
					ADD_COMMENT_PLACEHOLDER: 'Grund hinzufügen',
					START_RETRAINING: 'Nachtraining starten',
					BACK: 'Zurück',
					FORCE_INCLUDE_BANNER: 'Empfohlene Bereiche wurden automatisch als Force Include-Bereiche hinzugefügt.',
					TRAINING_PERIOD: 'Trainingszeitraum',
					EXISTING_TRAINING_REGION: 'Vorhandener Trainingsbereich',
					CURRENT_MODEL_VERSION: 'Aktuelle Modellversion',
					RECOMMENDED_REGION: 'Empfohlener Bereich',
					FROM_MODEL_HEALTH_EVALUATION: 'Aus der Modellzustandsbewertung',
					NO_TRAINING_RANGES: 'Keine Trainingsbereiche verfügbar.',
					LOADING_RANGES: 'Trainingsbereiche werden geladen...',
				}
			}
		},
		SHARED_MODULE: {
			COLUMN_CONFIG: {
				TITLE: 'Spalten anzeigen',
				SEARCH: 'Suche...',
				SELECT_ALL: 'Alle auswählen',
				RESET_TO_DEFAULT: 'Zurücksetzen'
			},
			CALCULATED_TAG_POPUP: {
				EXPRESSION: 'Ausdruck',
				EXPRESSION_DESCRIPTION: 'Ausdrucksbeschreibung'
			}
		},
		DATA_MANAGEMENT: {
			QC: {
				RUN_QC: 'QC ausführen',
				RUN_QC_SELECTED: 'QC für Auswahl ausführen',
				RUN_QC_TOOLTIP: 'Den Datenqualitätsagenten für die aktuellen Datensätze ausführen',
				RUNNING: 'QC läuft',
				DETAIL_TITLE: 'Wartungsdatensatz',
				TAB_DETAILS: 'Details',
				TAB_REVIEW: 'Überprüfung',
				NO_DETAILS: 'Keine Details verfügbar.',
				VIEW_DETAILS: 'Details anzeigen',
				FIELDS: {
					NOTIFICATION_NO: 'Meldungsnr.',
					ORDER: 'Auftrag',
					TYPE: 'Typ',
					EQUIPMENT: 'Equipment',
					EQUIPMENT_DESC: 'Equipment-Beschreibung',
					FUNCTIONAL_LOC: 'Technischer Platz',
					PLAN_GROUP: 'Planergruppe',
					PLAN_GROUP_DESC: 'Planergruppe-Beschreibung',
					MAINTENANCE_PLANT: 'Wartungswerk',
					MAINTENANCE_PLANT_DESC: 'Wartungswerk-Beschreibung',
					PLANT_SECTION: 'Werksbereich',
					PRIORITY: 'Priorität',
					DAMAGE: 'Schaden',
					DESCRIPTION: 'Beschreibung',
					STATUS: 'Status',
					USER_STATUS: 'Benutzerstatus',
					CREATED_ON: 'Erstellt am',
					COMPLETED_ON: 'Abgeschlossen am',
					BREAKDOWN_DURATION: 'Ausfalldauer',
					INTERNAL_LABOUR: 'Interne Arbeitskosten',
					EXTERNAL_LABOUR: 'Externe Arbeitskosten',
					EXTERNAL_SERVICE: 'Externe Servicekosten'
				},
				LAST_RUN: 'Letzter QC-Lauf',
				VIEW_FINDINGS: 'Ergebnisse anzeigen',
				FINDINGS_TITLE: 'Datenqualitätsergebnisse',
				NO_FINDINGS: 'Keine Probleme für diesen Datensatz gefunden.',
				BLOCKERS: 'Blocker',
				WARNINGS: 'Warnungen',
				RULE: 'Regel',
				FIELD: 'Feld',
				EVIDENCE: 'Nachweis',
				RECOMMENDATION: 'Empfehlung',
				CONFIG_TITLE: 'Datenqualitätsregeln',
				SCOPE_GLOBAL: 'Global',
				SCOPE_SYSTEM: 'Dieses System',
				RULE_MANDATORY_FIELDS: 'Pflichtfelder',
				MANDATORY_FIELDS_LABEL: 'Erforderliche Felder',
				SEVERITY: 'Schweregrad',
				RULE_DESCRIPTION: 'Beschreibungslänge',
				MIN_LENGTH: 'Mindestlänge (Zeichen)',
				RULE_DATES: 'Datumskonsistenz',
				ALLOW_COMPLETION_BEFORE_CREATION: 'Abschlussdatum vor Erstellungsdatum zulassen',
				RULE_DUPLICATES: 'Duplikaterkennung',
				WINDOW_DAYS: 'Duplikatfenster (Tage)',
				RULE_PLANNING: 'Planung',
				REQUIRE_LABOR: 'Arbeitszeit bei Aufträgen erforderlich',
				RULE_COMPLETION: 'Abschluss',
				REQUIRE_ROOT_CAUSE: 'Ursache bei abgeschlossenen Datensätzen erforderlich',
				RULE_TEXT_QUALITY: 'Textqualität (AI)',
				TEXT_QUALITY_HINT: 'Verwendet das Sprachmodell zur Prüfung von Rechtschreibung und Beschreibungsqualität',
				CHECK_SPELLING: 'Rechtschreibung prüfen',
				CHECK_DESCRIPTION_MEANING: 'Aussagekraft der Beschreibung prüfen',
				CHECK_ROOT_CAUSE: 'Angemessenheit der Ursache prüfen',
				RULE_WORK_ORDER: 'Arbeitsauftrag erforderlich',
				WORK_ORDER_HINT: 'Markiert einen fehlenden Arbeitsauftrag nur, wenn die Meldung abgeschlossen ist und zu den unten ausgewählten Meldungsarten gehört.',
				WORK_ORDER_TYPES_LABEL: 'Meldungsarten, die einen Arbeitsauftrag erfordern',
				RULE_SLA: 'SLA / Erforderliches Datum',
				SLA_CHECK_OVERDUE: 'Meldungen markieren, die das erforderliche Abschlussdatum überschritten haben',
				SLA_CHECK_LATE: 'Meldungen markieren, die nach dem erforderlichen Abschlussdatum abgeschlossen wurden',
				RULE_BREAKDOWN_CONSISTENCY: 'Konsistenz des Störungskennzeichens',
				BREAKDOWN_CONSISTENCY_HINT: 'Prüft das Störungskennzeichen (Effect) gegen die erfasste Ausfallzeit. Wählen Sie die Effect-Werte, die an diesem Standort eine Störung kennzeichnen.',
				BREAKDOWN_EFFECT_VALUES_LABEL: 'Effect-Werte, die eine Störung anzeigen',
				RULE_AGING: 'Alterung / Rückstand',
				MAX_OPEN_DAYS: 'Maximale Anzahl Tage, die eine Meldung offen bleiben darf',
				RULE_STATUS_CONSISTENCY: 'Konsistenz des Abschlussstatus',
				STATUS_CONSISTENCY_HINT: 'Prüft das Abschlussdatum gegen den Workflow-Abschlussstatus. Wählen Sie die Statuscodes, die an diesem Standort \'abgeschlossen\' bedeuten.',
				CLOSED_KEYWORDS_LABEL: 'Statuscodes, die \'abgeschlossen\' bedeuten',
				RULE_COST_SANITY: 'Kostenplausibilität',
			},
			TABS: {
				DOCUMENTS: 'Dokumente',
				TAGS: 'Tags',
				MAINTENANCE: 'Wartung',
				PIDS: 'P&IDs',
				RELIABILITY: 'Zuverlässigkeit'
			},
			COMMON: {
				PROCESSING: 'Wird bearbeitet',
				READY: 'Bereit',
				REVIEW: 'Überprüfung',
				BLOCKED: 'Blockiert',
				PENDING: 'Ausstehend',
				SEARCH: 'Suche...',
				SEARCH_RECORDS: 'Aufzeichnungen suchen...',
				ADD_DOCUMENT: 'Dokument hinzufügen',
				NO_MATCHING: 'Keine Dokumente gefunden.',
				LOADING: 'Daten laden...',
				LOADING_MORE: 'Weitere Dokumente laden...',
				LOADING_MORE_RECORDS: 'Weitere Aufzeichnungen laden...',
				CANCEL: 'Abbrechen',
				EDIT: 'Bearbeiten',
				SAVE: 'Speichern',
				SAVING: 'Speichern...',
				ASK_ROOTY: 'Rooty fragen',
				DOWNLOAD: 'Herunterladen',
				IMPORT_DATA: 'Daten importieren',
				REPLACE_FILE: 'Datei ersetzen',
				UPLOAD: 'Hochladen'
			},
			FILTERS: {
				ALL_ISSUES: 'Alle Probleme',
				CHOOSE_ISSUES: 'Probleme anzeigen',
				ALL_CLASSES: 'Alle Klassen',
				CHOOSE_CLASSES: 'Klassen anzeigen',
				GROUP_BY: 'Gruppieren',
				ALL_TYPES: 'Alle Typen',
				EVENT_TYPES: 'Ereignistypen',
				FILTER_ISSUE_TYPE: 'Problemtyp'
			},
			IMPORT_BANNER: {
				IMPORTING: 'Importieren von {{ count }} Dokumenten',
				IMPORTING_AUTO: 'Importieren von {{ uploaded }} Dokumenten, {{ remaining }} verbleibend (Gesamt: {{ total }})',
				INITIALIZING_AUTO: 'Dokumentensynchronisierung wird initialisiert...',
				AUTO_TAKE_MINS: 'Bitte warten Sie, während wir Ihre Dokumente im Hintergrund synchronisieren...',
				TAKE_30_MINS: 'Kann bis zu 30 Minuten dauern.',
				IMPORTED_SUCCESS: '{{ count }} Dokumente importiert',
				SUMMARY: 'Import Zusammenfassung:',
				NEEDS_REVIEW: 'Benötigt Überprüfung',
				ALREADY_PRESENT: 'Bereits vorhanden',
				REMOVED_AT_SOURCE: 'An der Quelle entfernt',
				SYNC_FAILED: 'Synchronisierung fehlgeschlagen'
			},
			TABLE_COLUMNS: {
				DOCUMENT: 'Dokument',
				CLASS: 'Klasse',
				DOC_TYPE: 'Art',
				STATUS: 'Status',
				SOURCE: 'Quelle',
				ISSUES: 'Probleme',
				LAST_UPDATED: 'Letzte Aktualisierung',
				ACTIONS: 'Aktionen',
				NOTIFICATION: 'Benachrichtigung',
				EQUIPMENT: 'Ausrüstung',
				DESCRIPTION: 'Beschreibung',
				TYPE: 'Typ',
				MAINTENANCE_PLANT: 'Pflanze',
				FAILURE_MODE: 'Fehlermodus',
				SECTION: 'Abschnitt',
				DATES: 'Daten',
				CONTEXT: 'Kontext',
				TIME_HRS: 'Zeit (h)',
				RCA: 'RCA',
				SOURCE_NAME: 'Quellenname',
				PATH: 'Pfad',
				SYNC_FREQUENCY: 'Synchronisierungsfrequenz',
				LAST_SYNCED: 'Zuletzt synchronisiert',
			},
			EMPTY_STATE: {
				NO_DOCS_TITLE: 'Keine Dokumente importiert',
				NO_DOCS_SUBTITLE: 'Fügen Sie Dokumente manuell oder über das KI-Tool hinzu.',
				NO_MAINT_TITLE: 'Keine Wartungsdaten importiert',
				NO_MAINT_SUBTITLE: 'Wählen Sie "Daten importieren", um mit dem Hinzufügen von Wartungsdaten zu beginnen.'
			},
			ADD_DOC_DIALOG: {
				FILE_UPLOAD: 'Datei-Upload',
				UPLOAD_MANUALLY: 'Dateien manuell hochladen',
				BULK_UPLOAD_TITLE: 'Massen-Upload mit Ordnervorlage',
				BULK_UPLOAD_DESC: 'Laden Sie die Ordnerstruktur herunter, legen Sie Ihre Dokumente ab und laden Sie den gesamten Ordner hoch.',
				DOWNLOAD_TEMPLATE: 'Vorlage herunterladen',
				DRAG_DROP: 'Ziehen Sie Ihre Datei hierher oder',
				BROWSE: 'durchsuchen',
				SUPPORTS: 'Unterstützt PDF, Word, Excel, Bilder oder eine ZIP-Datei für den Massenupload.',
				SELECTED_FILES: 'Ausgewählte Dateien',
				APPLY_TO_ALL: 'Für alle übernehmen:',
				CLASS: 'Klasse',
				DOC_TYPE: 'Dokumententyp',
				LINKED_TO: 'Verknüpft mit',
				SELECT_CLASS: 'Klasse auswählen',
				SELECT_DOC_TYPE: 'Dokumententyp auswählen',
				CHOOSE_LINK: 'Verknüpfung auswählen',
				FILE_SELECTED: 'Datei ausgewählt',
				FILES_SELECTED: 'Dateien ausgewählt',
				CONFIRM_IMPORT: 'Bestätigen / Importieren',
				REPLACE_HINT: 'Bitte laden Sie die korrekte Ersatzdatei für dieses Dokument hoch. Idealerweise sollte es dieselbe Datei wie ursprünglich beabsichtigt sein.',
				DUPLICATE_BADGE: 'Duplikat',
				DUPLICATES_SKIPPED_BANNER: '{{count}} doppelte Datei(en) erkannt. Sie werden ausgeschlossen und nicht hochgeladen.',
				DUPLICATES_SKIPPED_INLINE: '({{count}} Duplikat übersprungen)',
				REMOVE_DUPLICATES: 'Duplikate entfernen'
			},
			DOC_VIEWER: {
				DOC_DETAILS: 'Dokumentendetails',
				PREVIEW: 'Vorschau',
				FULL_SCREEN: 'Vollbild',
				NO_PREVIEW: 'Keine Vorschau',
				NO_PREVIEW_DESC: 'Dateityp kann im Browser nicht angezeigt werden.',
				METADATA: 'Metadaten',
				DOC_IDENTIFICATION: 'Identifikation',
				DOC_NAME: 'Dokumentenname',
				DOC_ID: 'Dokumenten-ID',
				DOC_CLASS: 'Dokumentenklasse',
				DOC_TYPE: 'Dokumenttyp',
				MISSING: 'Fehlend',
				DOC_SOURCE: 'Quelle',
				FILE_SIZE: 'Dateigröße',
				FILE_UPLOAD_SOURCE: 'Datei-Upload',
				EXTERNAL_SOURCE: 'Extern (Sharepoint usw.)',
				VERSIONING: 'Versionierung',
				UPLOADED_ON: 'Hochgeladen am',
				LAST_MODIFIED: 'Zuletzt geändert',
				EFFECTIVE_DATE: 'Inkrafttretungsdatum',
				EXPIRY_DATE: 'Ablaufdatum',
				REVISION: 'Überarbeitung',
				VERSION_1: 'Version 1',
				VERSION_2: 'Version 2',
				STATUS: 'Status',
				STATUS_UPLOADING: 'Wird hochgeladen',
				STATUS_QUEUED: 'In Warteschlange',
				STATUS_PROCESSING: 'Verarbeitung',
				STATUS_READY: 'Bereit',
				STATUS_PENDING: 'Ausstehend',
				LINKED_TO: 'Verknüpft mit',
				FACILITIES: 'Einrichtungen',
				UNITS: 'Einheiten',
				SYSTEMS: 'Systeme',
				CHOOSE_LINK_DESC: 'Wählen Sie den Link aus.',
				EXTRACTED_DATA: 'Extrahierte Daten',
				NO_EXTRACTED_DATA: 'Keine Daten verfügbar.'
			},
			TOOLTIPS: {
				ISSUE_FILTER: 'Problemfilter',
				CLASS_FILTER: 'Klassenfilter',
				CUSTOMIZE_COLUMNS: 'Spalten anpassen',
				VIEW_DETAILS: 'Details ansehen',
				DELETE_FILE: 'Datei löschen',
				STATUS_QUEUED_PROCESSING: 'Ihr Dokument befindet sich in der Warteschlange und wird in Kürze bearbeitet.',
				STATUS_READY: 'Ihr Dokument wurde verarbeitet und ist einsatzbereit.'
			},
			DEDUP_MENU: {
				TRIGGER_LABEL: 'Duplikate',
				TITLE: 'Duplikate aufgelöst',
				SUMMARY: '{{dupes}} von {{total}} ausgewählten Datei(en) haben Duplikate',
				DESCRIPTION: 'Originale werden beibehalten. Die anderen {{unaffected}} Datei(en) werden nicht geändert.',
				MERGE_TAGS: 'Duplikate entfernen, Tags zusammenführen ({{count}})',
				NO_MERGE_TAGS: 'Duplikate entfernen, Tags NICHT zusammenführen ({{count}})',
				FAILURE: 'Einige Duplikate konnten nicht entfernt werden',
				TOAST_MERGED: '{{count}} doppelte Datei(en) entfernt. Tags wurden mit den Originaldateien zusammengeführt.',
				TOAST_NOT_MERGED: '{{count}} doppelte Datei(en) entfernt. Die Tags der Originaldatei blieben unverändert.'
			},
			CONNECTED_SOURCES: {
				CLOSE: 'Schließen',
				DISCONNECT_MSG: 'Das Trennen von {{provider}} stoppt die Dokumentensynchronisierung und verhindert, dass UptimeAI auf Dateien des verbundenen {{provider}}-Kontos zugreift.<br/>Bereits in UptimeAI importierte Dokumente bleiben verfügbar, erhalten jedoch keine Updates mehr von {{provider}}.',
				DISCONNECT_TITLE: '{{provider}}-Integration trennen?',
				DISCONNECT_OK: '{{provider}} trennen',
				FETCH_SOURCES_FAILED: 'Fehler beim Abrufen verbundener Quellen.',
				SOURCE_UPDATED_SUCCESS: 'Quelle erfolgreich aktualisiert.',
				SOURCE_CONNECTED_SUCCESS: 'Quelle erfolgreich verbunden.',
				TRIGGERING_SYNC: 'Synchronisierung wird ausgelöst...',
				SYNC_STARTED_SUCCESS: 'Synchronisierung erfolgreich gestartet.',
				FAILED_TRIGGER_SYNC: 'Fehler beim Auslösen der Synchronisierung.',
				INACTIVE_REASON_COVERED: 'Von aktiver übergeordneter Quelle \'{{name}}\' ({{path}}) abgedeckt',
				REAL_TIME: 'Echtzeit',
				ONE_TIME: 'Einmalig',
				DAILY: 'Täglich',
				HOURLY: 'Stündlich',
				WEEKLY: 'Wöchentlich',
				MONTHLY: 'Monatlich',
				NA: 'N/A',
				PAUSED: 'Pausiert',
				INACTIVE: 'Inaktiv',
				UNKNOWN: 'Unbekannt',
				TITLE: 'Verbundene Quellen',
				ACTIVE: 'Aktiv',
				CONNECT_SOURCE: 'Quelle verbinden',
				NO_SOURCES_HEADING: 'Noch keine verbundenen Quellen.',
				NO_SOURCES_CONTENT: 'Verbinden Sie eine Quelle, um Dateien zu durchsuchen und zu importieren.',
				NEVER: 'Niemals',
				SYNC_NOW: 'Jetzt synchronisieren',
				MONITOR: 'Überwachen',
				SETTINGS: 'Einstellungen',
				DISCONNECT: 'Trennen',
				SYNC_ACTIVITY: 'Synchronisierungsaktivität',
				NO_RECENT_ACTIVITY: 'Keine kürzliche Synchronisierungsaktivität gefunden.',
				STATUS_SUCCESS: 'Erfolg',
				STATUS_PARTIAL: 'Teilweise',
				STATUS_FAILED: 'Fehlgeschlagen',
				STATUS_RUNNING: 'Wird ausgeführt',
				SYNC_FAILED_ERROR: 'Synchronisierung aufgrund eines Fehlers fehlgeschlagen.',
				SYNC_STATS: '+ {{new}} neu · {{updated}} aktualisiert · {{skipped}} unverändert',
				SYNC_STATS_PARTIAL: '+ {{new}} neu · {{updated}} aktualisiert · {{skipped}} unverändert · {{failed}} fehlgeschlagen',
			},
			CONNECT_SOURCE: {
				PROVIDERS: {
					DOCUMENT_LOCATOR: {
						NAME: 'Document Locator',
						DESC: 'Mit einer Document Locator-Datenbank verbinden, um Dokumente kontinuierlich zu synchronisieren.'
					}
				},
				PROVIDER_FIELDS: {
					DOCUMENT_LOCATOR: {
						DIALECT: 'Datenbanktyp',
						HOST: 'Server-Host',
						PORT: 'Port',
						DATABASE: 'Datenbankname',
						USER: 'Benutzername',
						PASSWORD: 'Passwort',
						ENCRYPT: 'Verbindung verschlüsseln',
						TRUST_CERT: 'Serverzertifikat vertrauen',
						SP_FILE_INFO: 'Prozedur für Dateiinformationen',
						SP_FILE_CONTENT: 'Prozedur für Dateiinhalt',
						SP_PLACEHOLDER: 'Namen der gespeicherten Prozedur eingeben'
					}
				},
				TITLE: 'Quelle verbinden',
				STEP_1: 'Mit Quelle verbinden',
				STEP_2: 'Quelle authentifizieren',
				STEP_3: 'Quelldetails',
				SHAREPOINT: 'SharePoint',
				SHAREPOINT_DESC: 'Verbinden Sie sich mit SharePoint-Bibliotheken, um Dokumente kontinuierlich zu synchronisieren.',
				CONNECT_TO_SHAREPOINT: 'Mit SharePoint verbinden',
				CONNECT_TO_PROVIDER: 'Mit {{provider}} verbinden',
				CONNECTION_VERIFIED: 'Verbindung überprüft.',
				DESCRIPTOR_LOAD_FAILED: 'Die Konfiguration für diese Quelle konnte nicht geladen werden.',
				TEST_CONNECTION_REQUIRED: 'Bitte testen Sie die Verbindung erfolgreich, bevor Sie eine Verbindung herstellen.',
				API_INTEGRATION: 'API-Integration',
				API_DESC: 'Verbinden Sie sich mit Dokumentenverwaltungs-APIs, um Dateien automatisch zu synchronisieren.',
				CMMS: 'CMMS',
				CMMS_DESC: 'Verbinden Sie sich mit Ihrem CMMS (SAP PM, Maximo usw.) für kontinuierliche Dokumentensynchronisation.',
				COMING_SOON: 'Demnächst',
				OAUTH_TAB: 'Mit Microsoft anmelden (OAuth)',
				TOKEN_TAB: 'Zugriffstoken (manuell)',
				SIGN_IN_MICROSOFT: 'Mit Microsoft anmelden',
				OAUTH_DESC: 'Verbinden Sie Ihr Microsoft-Konto, um SharePoint-Bibliotheken zu durchsuchen und Dokumente zu importieren.',
				SECURE_AUTH: 'Sichere Authentifizierung',
				SECURE_AUTH_DESC: 'Verwendet Microsoft OAuth. Ihre Anmeldedaten werden niemals in dieser Anwendung gespeichert.',
				READ_ONLY: 'Nur-Lese-Zugriff',
				READ_ONLY_DESC: 'Die Anwendung liest nur Dokumente. Keine Dateien werden in SharePoint geändert oder gelöscht.',
				TOKEN_PLACEHOLDER: 'Fügen Sie Ihr SharePoint-Zugriffstoken ein',
				TOKEN_WARNING: 'Zugriffstoken laufen ab. Erwägen Sie OAuth für unterbrechungsfreie Synchronisation.',
				MANUAL_AUTH_DESC: 'Geben Sie Ihre Azure App Registration-Anmeldeinformationen ein. Diese werden sicher auf dem Server gespeichert.',
				TENANT_ID_LABEL: 'Mandanten-ID',
				TENANT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_ID_LABEL: 'Client-ID (Anwendungs-ID)',
				CLIENT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_SECRET_LABEL: 'Client-Geheimnis',
				CLIENT_SECRET_PLACEHOLDER: 'Fügen Sie den Wert Ihres Client-Geheimnisses ein',
				SAVE_CREDENTIALS: 'Speichern & Fortfahren',
				STEP_CONNECTION_CONFIG: 'Verbindungskonfiguration',
				APP_CONNECTION_CONFIG: 'App-Verbindungskonfiguration',
				NEW_CONNECTION: 'Neue Verbindung',
				ACTIVE_CONNECTION_CONFIG: 'Aktive Verbindungskonfiguration',
				PROVIDER: 'Anbieter',
				MICROSOFT_SHAREPOINT: 'Microsoft SharePoint',
				APP_ID: 'App-ID (Client-ID)',
				REGISTER_CONFIG_DESC: 'Geben Sie Details ein, um eine neue App-Registrierungs-/Client-Anmeldeinformationskonfiguration zu registrieren.',
				CONFIG_NAME_LABEL: 'Konfigurationsname',
				CONFIG_NAME_PLACEHOLDER: 'z.B. SharePoint Production',
				BACK_TO_SELECTION: 'Zurück zur Auswahl',
				SAVE_CONNECTION_BTN: 'Verbindung speichern',
				PLEASE_SELECT_CONNECTION: 'Bitte wählen oder registrieren Sie zuerst eine Verbindungskonfiguration.',
				RESTORED_SESSION_FOR: 'Authentifizierte Sitzung wiederhergestellt für: {{user}}',
				PLEASE_COMPLETE_SIGNIN: 'Bitte schließen Sie zuerst die Microsoft-Anmeldung ab.',
				SELECT_APP_REGISTRATION: 'Bitte wählen oder registrieren Sie zuerst eine App-Registrierungsverbindung.',
				FAILED_AUTH_URL: 'Fehler beim Abrufen der Microsoft-Autorisierungs-URL.',
				ERROR_REQ_AUTH_LINK: 'Fehler bei der Anforderung des Autorisierungslinks.',
				FILL_ALL_FIELDS: 'Bitte füllen Sie alle Felder der Verbindungskonfiguration aus.',
				APP_REG_SAVED: 'App-Registrierungskonfiguration erfolgreich gespeichert.',
				FAILED_SAVE_CONFIG: 'Fehler beim Speichern der Konfiguration.',
				SITE_URL_LABEL: 'SharePoint-Website-URL (Die vollständige URL Ihrer SharePoint-Websitesammlung)',
				SITE_URL_PLACEHOLDER: 'https://company.sharepoint.com/sites/engineering',
				LIBRARY_PATH_LABEL: 'Bibliothekspfad',
				LIBRARY_PATH_DESC: '(Pfad zur Dokumentenbibliothek, z.B. /Shared Documents/Equipment)',
				LIBRARY_PATH_PLACEHOLDER: '/Shared Documents/Equipment',
				FILE_TYPE_LABEL: 'Dateityp-Filter (Nur Dateien importieren, die diesen Typen entsprechen; leer lassen für alle)',
				SYNC_FREQUENCY: 'Synchronisationsfrequenz',
				SYNC_AUTO: 'Auto (Echtzeit)',
				SYNC_HOURLY: 'Stündlich',
				SYNC_DAILY: 'Täglich',
				SYNC_DAILY_DESC: 'Alle 24 Stunden zu einer geplanten Zeit synchronisieren',
				SYNC_WEEKLY: 'Wöchentlich',
				SYNC_BIWEEKLY: 'Zweiwöchentlich',
				SYNC_MONTHLY: 'Monatlich',
				CONFLICT_LABEL: 'Konfliktlösung (Wie Dokumente behandelt werden, die bereits im System vorhanden sind)',
				CONFLICT_KEEP_NEWEST: 'Neueste Version behalten',
				TEST_CONNECTION: 'Verbindung testen',
				TEST_SUCCESS: 'Verbindung erfolgreich - {{count}} übereinstimmende Dokumentdateien gefunden',
				CANCEL: 'Abbrechen',
				CONNECT_AND_SYNC: 'Verbinden & Synchronisation starten',
				AUTH_SUCCESS: 'Sie haben sich erfolgreich authentifiziert. Klicken Sie unten auf Weiter, um die Quelldetails zu konfigurieren.',
				APP_ONLY_SYNC_DESC: 'Die reine App-Synchronisierung wird im Hintergrund mit der ausgewählten App-Registrierungskonfiguration ausgeführt. Es ist keine individuelle Benutzeranmeldung erforderlich.',
				FILE_TYPE_FILTER_DESC: 'Importieren Sie nur Dateien, die diesen Typen entsprechen. Lassen Sie die Auswahl aufheben, um alle Dateien zu importieren.',
				NEXT: 'Weiter',
				AUTHENTICATED_PROFILE: 'Authentifiziertes Microsoft-Profil',
				USER_NAME: 'Benutzername',
				EMAIL_ADDRESS: 'E-Mail-Adresse',
				SIGN_IN_DIFFERENT_ACCOUNT: 'Mit einem anderen Konto anmelden'
			}
		},
		MODULE_CONFIGURATION: {
			TABS: {
				TRIAGE: 'Alert Triage', MAINTENANCE: 'Wartung', COMING_SOON: 'Demnächst' },
			COMMON: { CANCEL: 'Abbrechen', SAVE: 'Speichern', EDIT: 'Bearbeiten', DOWNLOAD: 'Herunterladen', UPLOAD: 'Hochladen', DELETE: 'Löschen', SELECT_ALL: 'Alles auswählen', SEARCH: 'Aktivität suchen...', EDIT_CONFIGURATION: 'Konfiguration bearbeiten', SAVE_CONFIGURATION: 'Konfiguration speichern', APPLY_TEMPLATE: 'Vorlage anwenden', TEMPLATE_MANAGER: 'Vorlagenmanager', SAVED_CONFIGURATION: 'Gespeicherte Konfiguration', CONFIGURE: 'Konfigurieren', BETA_ANALYTICS: 'β-Analytik', UPDATE_TEMPLATE: 'Vorlage aktualisieren', SAVE_TEMPLATE: 'Vorlage speichern', FINISH_SAVE_PACKAGE: 'Paket abschließen & speichern', DONE: 'Fertig', RE_GENERATE: 'Neu generieren', YES: 'Ja', NO: 'Nein', LOADING: 'Loading...', COPY: 'Kopieren', APPLYING_TEMPLATE: 'Vorlage wird angewendet', LOADING_TEMPLATE: 'Vorlage wird geladen', TO: 'auf' },
			HEADER: { CONFIG_FOR: 'PM-Checkliste konfigurieren für:', SELECT_EQUIPMENT: 'Wählen Sie ein Gerät' },
			EQUIPMENT_EMPTY: { TITLE: 'Gerät auswählen', DESC: 'Wählen Sie ein Gerät aus dem Hierarchie-Panel zur Konfiguration', ACTIVITIES: 'PM-Aktivitäten, FMEA, CM.', NO_TEMPLATE_TITLE: 'Keine Vorlage angewendet', NO_TEMPLATE_DESC: 'Wenden Sie eine Vorlage an, um PM-Aktivitäten, FMEA und CM für dieses Gerät zu konfigurieren.' },
			COMING_SOON: { TITLE: 'Demnächst', DESC: 'Diese Funktion befindet sich derzeit in der Entwicklung und wird in einem zukünftigen Update verfügbar sein.' },
			MANAGER: { TITLE: 'Vorlagenmanager', EDIT_TEMPLATE: 'Vorlage bearbeiten', LINKED_ASSETS: 'verknüpfte Assets', SUB_HEADER: 'Wiederverwendbare PM-, CM- und Fehlermodus-Vorlagen verwalten', COL_NAME: 'Vorlagenname', COL_DESC: 'Beschreibung', COL_TYPE: 'Typ', COL_ASSETS: 'Verknüpfte Assets', COL_ASSET: 'Assets', COL_CREATOR: 'Erstellt von', COL_DATE: 'Zuletzt geändert', EMPTY_TITLE: 'Keine Vorlagen gefunden', EMPTY_DESC: 'Gespeicherte PM-, CM- und Fehlermodus-Vorlagen werden hier angezeigt.', SELECT_DESC: 'Wählen Sie eine vorgefertigte Vorlage, um sie auf Ihr Gerät anzuwenden.', SEARCH_TEMPLATE: 'Vorlage suchen...', EQ_TEMPLATE_LIBRARY: 'Geräte-Vorlagenbibliothek', COL_STATUS: 'Status', STATUS_IN_PROGRESS: 'In Bearbeitung', STATUS_READY: 'Einsatzbereit', STATUS_DEPRECATED: 'Veraltet', LIFECYCLE: 'Weitere Aktionen', LOCK: 'Sperren & als bereit markieren', LOCK_HINT: 'Vervollständigen Sie die Vorlage auf 100 %, um sie zu sperren.', UNLOCK: 'Entsperren', DEPRECATE: 'Als veraltet markieren', REACTIVATE: 'Reaktivieren', DUPLICATING: 'Duplikat der Vorlage {{name}} wird erstellt...' },
			UPLOAD: { TITLE_PM: 'PM-Vorlage hochladen', TITLE_CM: 'CM-Vorlage hochladen', TITLE_FM: 'Fehlermodus-Vorlage hochladen', TEMPLATE_NAME: 'Vorlagenname', ENTER_TEMPLATE: 'Vorlagennamen eingeben', DRAG_DROP: 'Ziehen Sie Ihre Datei hierher oder', BROWSE: 'durchsuchen', REMOVE_FILE: 'Datei entfernen' },
			PM: { TITLE: 'PM Konfiguration', CONFIG_FOR: 'PM-Checkliste konfigurieren für:', SELECT_HOW: 'Wählen Sie, wie Sie PM-Aktivitäten konfigurieren möchten', APPLY_TEMPLATE: 'Vorlage anwenden', IMPORT_SAP: 'Aus SAP Importieren', UPLOAD_TEMPLATE: 'Vorlage Hochladen', DOWNLOAD_TEMPLATE: 'Vorlage Herunterladen', CHECKLIST_TEMPLATE: 'PM Checklisten-Vorlage', SAVE_TEMPLATE: 'Vorlage Speichern', EDIT_TEMPLATE: 'Vorlage Bearbeiten', OVERALL_VARS: 'Allgemeine PM-Stufen-Variablen', OVERALL_TIME: 'Gesamtzeit (in Stunden)', MUST_BE_POSITIVE: 'Geben Sie eine Zahl größer als 0 ein', OVERALL_MANNING: 'Gesamtpersonal', TECH_COUNT: 'Techniker (Anzahl)', HELPER_COUNT: 'Helfer (Anzahl)', COST_PARTS: 'Kosten der Teile (falls vorhanden) (in USD)', COST_CONS: 'Kosten für Verbrauchsmaterialien (in USD)', PM_INTERVAL: 'Aktuelles PM-Intervall (in Tagen)', PROD_LOSS: 'Produktionsverlust (in USD)', TAB_CHECKLIST: 'PM Checkliste', ACTIVITIES_CHECKLIST: 'PM Aktivitäten Checkliste', ACTIVITIES_CHECKLIST_DESC: 'Liste aller in dieser Checklisten-Vorlage definierten PM-Aktivitäten', ENRICH_ROOTY: 'Checkliste mit Rooty anreichern', ROOTY_LOADING: 'Rooty analysiert Ihre PM-Aktivitäten...', ROOTY_BUNDLE_TITLE: 'Vorgeschlagene Aktivitätsbündel', ROOTY_BUNDLE_DESC: 'Überprüfen Sie die vorgeschlagenen Bündel unten. Bestätigen Sie, um fortzufahren und Build-Flags zu generieren.', ROOTY_CONFIRM_BUNDLES: 'Sieht gut aus — Build-Flags generieren', ROOTY_CONFIRM_FLAGS: 'Sieht gut aus — Zeit pro Aktivität generieren', ROOTY_FLAGS_READY: 'Build-Flags generiert. Überprüfen Sie die Tabs unten.', ROOTY_FLAGS_OUTPUT: 'Build-Flags-Analyse', ROOTY_NO_SYSTEM: 'PM-Aktivität speichern, um die Anreicherung zu aktivieren', TAB_BUNDLES: 'Aktivitätsbündel', BUN_TITLE: 'PM Aktivitätsbündel', BUN_DESC: 'Gruppen Sie PM-Aktivitäten zur effizienten Planung in logische Pakete', TAB_FLAGS: 'Konfigurationsflags', FLAG_TITLE: 'Konfigurationsflags', FLAG_DESC: 'Klassifizieren Sie Aktivitäten als regulatorisch, verfahrenstechnisch oder operativ', TAB_TIME: 'Zeit pro Aktivität', TIME_TITLE: 'Zeit pro Aktivität', TIME_DESC: 'Schätzen Sie die erforderliche Zeit für jede PM-Aktivität', TAB_BETA: 'β definieren', BETA_TITLE: 'β definieren', BETA_DESC: 'Empfindlichkeit von CM/Fehlern bezüglich der PM-Häufigkeit für jede Aktivität festlegen', RE_GENERATE: 'Neu Generieren', CHECKLIST_CONFIG: 'PM Checklisten-Konfiguration', CONFIG_CHECKLIST_FOR: 'Checkliste konfigurieren für:', ROOTY_CANNED_1: 'Checkliste wird gelesen...', ROOTY_CANNED_2: 'PM-Aktivitäten werden analysiert...', ROOTY_CANNED_3: 'Vorschläge werden vorbereitet...' },
			PM_APPLY: { TITLE: 'Bibliothek für PM Checklisten-Vorlagen', STEP_1: 'Vorlage Auswählen', STEP_2: 'Gerät Auswählen', STEP_1_DESC: 'Wählen Sie eine im Voraus erstellte PM-Checklisten-Vorlage aus, um sie auf Ihr Gerät anzuwenden. Die Vorlagen enthalten konfigurierte PM-Aktivitätssequenzen aus bewährten Verfahren.', EMPTY: 'Keine Vorlagen gefunden.', CONFIG_FOR: 'Konfigurierte PM-Vorlage für', EXEC_SUCCESS: 'erfolgreich ausgeführt über die Intervallgrenzen hinweg.', PM_ACTIVITIES: 'PM Aktivitäten', INTERVAL: 'Intervall:', APPLIES_TO: 'Gilt für:', EQ_TITLE: 'Gerät auswählen, um Vorlage anzuwenden', EQ_SELECTED: 'Ausgewählte Geräte', SELECT_TEMPLATE: 'Vorlage Auswählen', APPLY_TEMPLATE: 'Vorlage Anwenden' },
			CM: { TITLE: 'CM Konfiguration', CONFIG_FOR: 'CM-Aktivitäten konfigurieren für:', SELECT_HOW: 'Wählen Sie, wie Sie CM-Aktivitäten konfigurieren möchten', APPLY_TEMPLATE: 'Vorlage anwenden', UPLOAD_TEMPLATE: 'Vorlage hochladen', DOWNLOAD_TEMPLATE: 'Vorlage herunterladen', CM_VARS: 'CM-Stufen-Variablen', EQ_REDUNDANCY: 'Geräteredundanz', PROD_LOSS: 'Produktionsverlust', TECH_COUNT: 'Anzahl erforderlicher Techniker', HELP_COUNT: 'Anzahl erforderlicher Helfer', COST_CONS: 'Kosten für Verbrauchsmaterialien (falls vorhanden)', SPARES_COST: 'Ersatzteilkosten berücksichtigen', YES: 'Ja', NO: 'Nein', LABOUR_VARS: 'Arbeitsvariablen', WRENCH_TIME_VARS: 'Schraubenschlüsselzeit-Variablen', WRENCH_WARNING: 'Ausfallzeiten können Wartezeiten enthalten — Schraubenschlüsselzeit-Schätzungen sind den dauerabhängigen Werten vorzuziehen', COL_FAILURE_MODE: 'Fehlermodus', COL_ACTIVITY: 'Aktivität', COL_CM_COUNT: 'CM-Anzahl', COL_WRENCH_TIME: 'Gesch. Schraubzeit (Std.)', COL_CONFIDENCE: 'Vertrauen', COL_OVERRIDE: 'Überschreiben (Std.)' },
			FM: { TITLE: 'Fehlermodus-Konfiguration', CONFIG_FOR: 'Fehlermodi konfigurieren für:', SELECT_HOW: 'Wählen Sie, wie Sie Fehlermodi konfigurieren möchten', SAVED_CONF: 'Gespeicherte Konfiguration', RCM_ANALYSIS: 'RCM Analyse', APPLY_LIB: 'Aus Vorlagenbibliothek anwenden', APPLY_LIB_DESC: 'Verwenden Sie im Voraus erstellte Fehlermodus-Vorlagen für Ihre Geräteklasse', APPLY_LIB_AVAIL: 'Verfügbare Vorlage: ACW-Pumpen-Vorlage', UPLOAD_RCM: 'Vorherige RCM-Analyse hochladen', UPLOAD_RCM_DESC: 'Importieren Sie Fehlermodi aus einer vorhandenen RCM-Studiendatei (Excel/CSV)', NEW_STUDY: 'Neue FMEA-Studie erstellen', NEW_STUDY_DESC: 'Starten Sie eine neue FMEA mithilfe des geführten Studienassistenten', APPLY_TEMPLATE: 'Vorlage anwenden', CREATE_ROOTY: 'Über ROOTY erstellen', UPLOAD_EXCEL: 'Aus Excel hochladen', DOWNLOAD_TEMPLATE: 'Vorlage herunterladen', COL_FM_ID: 'FM ID', COL_SUBSYSTEM: 'Teilsystem', COL_COMPONENT: 'Komponente', COL_FUNCTION: 'Funktion', COL_FUNC_FAIL: 'Funktionsversagen', COL_FAILURE_MODE: 'Fehlermodus', COL_CONSEQUENCE_CAT: 'Konsequenzkategorie', COL_FAILURE_BEHAVIOR: 'Fehlerverhalten', COL_PDM_APPLICABILITY: 'PdM-Anwendbarkeit', COL_LIKELY_CAUSES: 'Wahrscheinliche Ursachen', COL_SYMPTOMS: 'Symptome / Indikatoren', COL_LOCAL_EFFECTS: 'Lokale Auswirkungen', COL_SYSTEM_EFFECTS: 'Systemauswirkungen', COL_PLANT_EFFECTS: 'Anlagenauswirkungen', COL_EFFECTS: 'Auswirkungen', COL_IMPACTS: 'Auswirkungen', COL_EFFECT: 'Auswirkung', COL_TYPE: 'Typ', COL_STATUS: 'Status', COL_EVIDENCES: 'Nachweise', COL_TOTAL_COST: 'Gesamtkosten', COL_CATEGORY: 'Kategorie', COF_RATING: 'CoF-Bewertung', COF_CATEGORY: 'CoF-Kategorie', COST_SUMMARY: 'Kostenzusammenfassung', REPAIR_COST: 'Reparaturkosten (in USD)', SAFETY_RISK_COST: 'Sicherheitsrisikokosten (in USD)', PROD_LOSS: 'Produktionsverlust (in USD)', OUTAGE_DURATION: 'Ausfallzeit (in Stunden)', TOTAL_COST_USD: 'Gesamtkosten (in USD)', CONSEQUENCE_RATING: 'Konsequenzbewertung', SAFETY: 'Sicherheit', OPERATIONAL: 'Operativ', ENVIRONMENTAL: 'Umwelt', REPUTATIONAL: 'Reputation', CLASSIFICATION_HIDDEN: 'Klassifikation: Verdeckter Fehler', SUPPORTING_EVIDENCE: 'Unterstützende Nachweise', VIEW_EVIDENCE: 'Vollständige Nachweise anzeigen', NO_FM_FOUND: 'Keine Fehlermodus-Konfiguration gefunden...', EXPAND_ADDITIONAL_INFO: 'Zusätzliche Informationen', PERF_STANDARD: 'Leistungsstandard', FM_ANCHOR_LEVEL: 'FM-Ankerebene', FM_TYPE: 'FM-Typ', SYMPTOM_CHILDREN: 'Symptom-Unterelemente', CURRENT_CONTROLS: 'Aktuelle Steuerungsmaßnahmen', EVIDENCE_SOURCE: 'Nachweis-Quelle', WO_EVIDENCE_REFS: 'WO-Nachweis-Referenzen', VALIDATION_OUTCOME: 'Validierungsergebnis', UNVALIDATED_JUSTIFICATION: 'Nicht validierte Begründung', CONFIDENCE: 'Vertrauen', PF_INTERVAL: 'P-F-Intervall-Schätzung' },
			EDITOR: {
				SAVING: 'Speichern...',
				SAVE_TEMPLATE: 'Vorlage speichern',
				SAVE_ACTIVITY: 'Aktivität speichern',
				SAVE_PACKAGE: 'Gerätepaket speichern',
				CREATE_TEMPLATE: 'Vorlage erstellen',
				EMPTY_TEMPLATE: 'Leere Vorlage',
				CREATE_VIA_ROOTY: 'Per Rooty erstellen',
				SAVE_CONTINUE: 'Speichern & fortfahren',
				SAVE_TO_CONFIGURE: 'Speichern Sie die Vorlage, um mit der Konfiguration von PM, FMEA & CM zu beginnen.',
				DOWNLOAD: 'Vorlage herunterladen',
				UPLOAD: 'Vorlage hochladen',
				PM_CHECKLIST: 'PM Checkliste',
				FMEA_CONFIG: 'Fehlermodus-Konfiguration',
				CM_CHECKLIST: 'CM Checkliste (Demnächst)',
				DESC: 'Beschreibung',
				TEMPLATE_NAME: 'Vorlagenname',
				OVERALL_PM_VARS: 'Allgemeine PM-Stufen-Variablen',
				SAVE_PM_ACTIVITY: 'PM-Aktivität speichern',
				SAVE_FMEA_CONFIG: 'FMEA-Konfiguration speichern',
				SAVE_CM_CONFIG: 'CM-Konfiguration speichern',
					RE_GENERATE: 'Neu generieren',
				SAVED_INTERNALLY: 'erfolgreich intern gespeichert:',
				DEFINE_PM: 'PM-Checkliste definieren',
				DEFINE_FM: 'FMEA-Konfiguration definieren',
				DEFINE_CM: 'CM-Konfiguration definieren',
				DEFINE_WRENCH_TIME: 'Schraubenschlüsselzeit-Variablen definieren',
				DEFINE_DESC: 'Laden Sie ein Beispiel herunter oder laden Sie eine ausgefüllte Vorlage hoch.',
				NO_PM_ATTACHED: 'Keine PM-Konfiguration angehängt',
				NO_FM_ATTACHED: 'Keine Fehlermodus-Konfiguration angehängt',
				NO_CM_ATTACHED: 'Keine CM-Konfiguration angehängt',
				PM_CONFIG_TAB: 'PM Konfiguration',
				FM_CONFIG_TAB: 'FMEA Konfiguration',
				CM_CONFIG_TAB: 'CM Konfiguration',
				PM_FM_MAPPING_TAB: 'PM -> FM Zuordnung',
				DEFINE_PM_FM: 'PM-FM Zuordnung definieren',
				DEFINE_PM_FM_DESC: 'Konfigurieren Sie, welche PM-Aktivitäten Ausfallmodi für dieses Gerät mindern.',
				PM_FM_MAPPING_MATRIX: 'PM-FM Zuordnungsmatrix',
				PM_FM_MAPPING_SUBHEADER: 'Konfigurieren Sie PM-Aktivitäten für Ausfallmodi von {{equipment}}',
				PM_FM_SEARCH_PM: 'PM-Aktivität suchen...',
				PM_FM_SHOW_ALL: 'Alle anzeigen',
				PM_FM_SHOW_MAPPED: 'Zugeordnet',
				PM_FM_SHOW_UNMAPPED: 'Nicht zugeordnet',
				PM_FM_SHOW_ZERO_COVERAGE: 'Keine Abdeckung',
				PM_FM_LEGEND_FULL: '1 = Vollständig zugeordnet',
				PM_FM_LEGEND_PARTIAL: '0,1-0,9 = Teilweise Beziehung',
				PM_FM_LEGEND_EMPTY: 'Leer = Nicht zugeordnet',
				PM_FM_CONFIRM_ALL: 'Alle verbleibenden bestätigen',
				PM_FM_CONFIRM_ROW: 'Zuordnung bestätigen',
				PM_FM_UNMAP: 'Zuordnung aufheben',
				PM_FM_NO_PM_ATTACHED: 'Keine PM-Aktivitäten konfiguriert',
				PM_FM_NO_FM_ATTACHED: 'Keine Ausfallmodi konfiguriert',
				PM_FM_STALE_BANNER: 'PM oder FMEA wurde seit Erstellung dieser Zuordnung geändert. Neue oder geänderte Aktivitäten erscheinen unten als nicht zugeordnet — ordnen Sie sie direkt zu, oder verwenden Sie „Neu generieren“, damit Rooty alles von Grund auf neu analysiert (dies überschreibt Ihre geprüften Zuordnungen).',
				PM_FM_REGENERATE: 'Neu generieren',
				PM_FM_UNMAPPED_COUNT: '{{count}} nicht zugeordnet',
				PM_FM_ZERO_COVERAGE_HEADING: 'Nicht abgedeckte Ausfallmodi',
				PM_FM_NEW_PM_PROPOSALS: 'Neue PM-Vorschläge',
				PM_FM_ACCEPT_PROPOSAL: 'Vorschlag annehmen'
			}
		},
		CONFIGURATION: {
			CASES: {
				TITLE: 'Fälle-Konfiguration',
				LAST_UPDATED_BY: 'Zuletzt aktualisiert von {{name}} - {{date}}',
				MATRIX_TITLE: 'Wahrscheinlichkeits-Auswirkungs-Matrix',
				MATRIX_SUBTITLE: '(Konstante M1 — in Berechnungen verwendbar)',
				VALUE_INPUT_TITLE: 'Werteingabe',
				VALUE_INPUT_SUBTITLE: '(Werte, die Benutzer in die Wertfelder für einen Fall eingeben können)',
				CALCULATIONS_TITLE: 'Berechnungen',
				CALCULATIONS_SUBTITLE: '(Vom Benutzer konfigurierte Wertberechnungen innerhalb eines Falls)',
				OPTIONAL_TITLE: 'Optional',
				OPTIONAL_SUBTITLE: '(Zusätzliche Felder, die zu Verfolgungszwecken zu einem Fall hinzugefügt werden können)',
				COL_CONSTANT: 'Konstante',
				COL_UNIT_FIELD: 'Einheitenfeld',
				COL_FIELD_UOM: 'Feld-UoM',
				COL_DEFAULT_VALUE: 'Standardwert',
				COL_ACTIONS: 'Aktionen',
				COL_CALCULATION: 'Berechnung',
				COL_UOM: 'UoM',
				COL_FORMULA: 'Formel',
				COL_FIELD: 'Feld',
				COL_VALUE: 'Wert',
				COL_UNIT_OF_MEASURE: 'Maßeinheit',
				ADD: 'Hinzufügen',
				ADD_ROW: 'Zeile hinzufügen',
				CANCEL: 'Abbrechen',
				SAVE: 'Speichern',
				SAVE_SUCCESS: 'Fallkonfiguration erfolgreich gespeichert',
				IMPACT: 'AUSWIRKUNG',
				LIKELIHOOD: 'WAHRSCHEINLICHKEIT',
				DELETE_ROW: 'Zeile löschen',
				PLACEHOLDER_UNIT_FIELD: 'Einheitenfeld eingeben',
				PLACEHOLDER_FIELD_UOM: 'Feld-UoM eingeben',
				PLACEHOLDER_DEFAULT_VALUE: 'Standardwert eingeben',
				PLACEHOLDER_CALCULATION: 'Berechnungsname eingeben',
				PLACEHOLDER_UOM: 'UoM eingeben',
				PLACEHOLDER_FORMULA: 'Formel eingeben',
				PLACEHOLDER_FIELD_NAME: 'Feldname eingeben',
				DUPLICATE_FIELD_NAME: 'Feldname muss eindeutig sein',
				PLACEHOLDER_VALUE: 'Wert eingeben',
				PLACEHOLDER_UNIT_OF_MEASURE: 'Maßeinheit eingeben',
				RESET_TO_DEFAULTS: 'Auf Standard zurücksetzen',
				RESET_MATRIX_CONFIRM_TITLE: 'Auf Standard zurücksetzen?',
				RESET_MATRIX_CONFIRM_DESC: 'Dadurch wird die <strong>Wahrscheinlichkeits-Auswirkungs-Matrix</strong> auf ihre ursprünglichen Standardwerte zurückgesetzt. Alle vorgenommenen benutzerdefinierten Änderungen gehen verloren.',
				RESET_MATRIX_CONFIRM_OK: 'Bestätigen',
				LOAD_ERROR: 'Fallkonfiguration konnte nicht geladen werden',
				SAVE_ERROR: 'Fallkonfiguration konnte nicht gespeichert werden',
				RESET_ERROR: 'Fallkonfiguration konnte nicht zurückgesetzt werden',
				CONSTANT_USED_IN_FORMULA: 'Diese Konstante wird in einer Formel verwendet',
				FORMULA: {
					UNDEFINED_CONSTANT: 'Konstante "{{constant}}" ist nicht definiert',
					INVALID_CHARACTER: 'Die Formel enthält ein nicht unterstütztes Zeichen oder Operator',
					UNBALANCED_PARENTHESES: 'Die Formel hat unausgeglichene Klammern',
					EMPTY_PARENTHESES: 'Die Formel enthält leere Klammern',
					MISSING_OPERATOR: 'Der Formel fehlt ein Operator zwischen Werten',
					INVALID_OPERATOR_POSITION: 'Die Formel hat einen Operator an einer ungültigen Position',
					TRAILING_OPERATOR: 'Die Formel darf nicht mit einem Operator enden'
				}
			},
			FILTER: {
				TITLE: 'Filter',
				SEARCH: 'Suche'
			},
			ASSET_TEMPLATE: {
				TITLE: 'Asset-Vorlagenliste',
				SEARCH: 'Suche',
				TOOLTIP_ADD: 'Neues Asset hinzufügen',
				TOOLTIP_DELETE: 'Asset löschen',
				TOOLTIP_SYNC: 'Synchronisieren',
				TOOLTIP_SYNC_PROGRESS: 'Synchronisierung läuft',
				SYNC_STARTED_TOAST: 'Asset-Vorlagen-Synchronisierung gestartet.',
				SYNC_COMPLETED_TOAST: 'Asset-Vorlagen-Synchronisierung abgeschlossen.',
				SYNC_FAILED_TOAST: 'Asset-Vorlagen-Synchronisierung fehlgeschlagen{{errorSuffix}}.',
				COL_INDEX: 'Nr.',
				COL_TEMPLATE_NAME: 'Vorlagenname',
				COL_APPLICATION: 'Anwendung',
				COL_CREATED_ON: 'Erstellt am',
				COL_ACTIONS: 'Aktionen',
				NO_RECORDS: 'Keine Einträge gefunden',
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche',
				LOADING: 'Wird geladen...'
			},
			TAGS: {
				TOOLTIP_UPLOAD_SCADA: 'Tag-SCADA-Zuordnung hochladen',
				TITLE: 'Tag-Liste',
				SEARCH: 'Suche',
				TOOLTIP_ADD: 'Neuen Tag hinzufügen',
				TOOLTIP_UPLOAD: 'Tags hochladen',
				TOOLTIP_DOWNLOAD: 'Tag-Liste herunterladen',
				TOOLTIP_TAG_MAPPING: 'Tag-Zuordnung aufrufen',
				TOOLTIP_DELETE: 'Tag löschen',
				TOOLTIP_NO_FAILURE_MODES: 'Keine zugeordneten Fehlermodi',
				TOOLTIP_VIEW_CHANGES: 'Änderungen anzeigen',
				COL_INDEX: 'Nr.',
				COL_NAME: 'Name',
				COL_TAG_ID: 'Tag-ID',
				COL_SHARED: 'Geteilt',
				COL_UNIT: 'Einheit',
				COL_FAILURE_MODES: 'Fehlermodi',
				COL_MODELLING: 'Für Modellierung verwendet',
				COL_CALCULATED: 'Berechnet',
				COL_DESCRIPTION: 'Beschreibung',
				COL_ASSET: 'Asset',
				COL_ACTIONS: 'Aktionen',
				NO_TAGS: 'Für das ausgewählte Asset sind keine Tags verfügbar',
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche'
			},
			FAILURE_MODE: {
				TITLE: 'Fehlermodus-Liste',
				SEARCH: 'Suche',
				TOOLTIP_UPLOAD: 'Fehlermodi hochladen',
				TOOLTIP_ADD: 'Neuen Fehlermodus hinzufügen',
				TOOLTIP_EDIT: 'Fehlermodus bearbeiten',
				TOOLTIP_FILTER: 'Filter',
				TOOLTIP_DELETE: 'Löschen',
				TOOLTIP_EDIT_DIRECTIONALITY: 'Tag-Direktionalität bearbeiten',
				COL_INDEX: 'Nr.',
				COL_NAME: 'Name',
				COL_DESCRIPTION: 'Beschreibung',
				COL_TAG: 'Tag',
				COL_ASSET: 'Asset',
				COL_RECOMMENDATIONS: 'Empfehlungen',
				COL_ACTIONS: 'Aktionen',
				NO_RECORDS: 'Keine Einträge gefunden'
			},
			DIGITIZATION: {
				TITLE: 'Digitalisierungsliste',
				SEARCH: 'Suche',
				TOOLTIP_ADD: 'Neue Digitalisierung hinzufügen',
				TOOLTIP_DELETE: 'Digitalisierung löschen',
				COL_INDEX: 'Nr.',
				COL_MANUFACTURER: 'Hersteller',
				COL_MODEL: 'Modell',
				COL_INDUSTRY_TYPE: 'Branchentyp',
				COL_MODIFIED_ON: 'Geändert am',
				COL_CREATED_ON: 'Erstellt am',
				NO_RECORDS: 'Keine Einträge gefunden',
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche'
			},
			TABS: {
				ASSET_TEMPLATE: 'Asset-Vorlage',
				ASSETS: 'Assets',
				DIGITIZATION: 'Digitalisierung',
				SETTINGS: 'Einstellungen',
				CASES: 'Fälle'
			},
			SETTINGS: {
				TITLE: 'Einstellungen aktualisieren',
				COL_INDEX: '#',
				COL_PAGE_NAME: 'Seitenname',
				COL_LAST_UPDATED: 'Zuletzt aktualisiert',
				COL_UPDATED_BY: 'Aktualisiert von',
				TOOLTIP_SETTINGS: 'Einstellungen',
				LOADING: 'Einstellungen werden geladen...',
				NO_SETTINGS: 'Keine Einstellungen gefunden'
			},
			ASSETS: {
				TITLE: 'Asset-Liste',
				SEARCH: 'Suchen',
				TOOLTIP_FILTER: 'Asset filtern',
				TOOLTIP_DELETE: 'Asset löschen',
				TOOLTIP_VIEW_CHANGES: 'Änderungen anzeigen',
				COL_INDEX: 'Nr.',
				COL_NAME: 'Asset-Name',
				COL_TYPE: 'Asset-Typ',
				COL_UNIT: 'Einheit',
				COL_SYSTEM: 'System',
				COL_APPLICATION: 'Anwendung',
				COL_CONFIGURATION: 'Konfiguration',
				COL_INDUSTRY: 'Industrie',
				COL_AUTHOR: 'Autor',
				COL_MAKE_MODEL: 'Marke & Modell',
				COL_MAINTENANCE: 'Wartungsdaten',
				NO_RECORDS: 'Keine Datensätze gefunden',
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche',
			},
			FM_MAPPING_MENU: {
				HIGH: 'Hoch',
				LOW: 'Niedrig',
				STABLE: 'Stabil',
				REFERENCE: 'Referenz',
				UNMAPPED: 'Nicht zugeordnet',
				TOOLTIP_HIGH_PRIMARY: 'Hoch - Primärer Ausfallmodus',
				TOOLTIP_HIGH_SECONDARY: 'Hoch - Sekundärer Ausfallmodus',
				TOOLTIP_LOW_PRIMARY: 'Niedrig - Primärer Ausfallmodus',
				TOOLTIP_LOW_SECONDARY: 'Niedrig - Sekundärer Ausfallmodus',
				TOOLTIP_STABLE_PRIMARY: 'Stabil - Primärer Ausfallmodus',
				TOOLTIP_STABLE_SECONDARY: 'Stabil - Sekundärer Ausfallmodus',
				TOOLTIP_REFERENCE: 'Referenz-Ausfallmodus',
				FM_LOGIC: 'FM-Logik',
				HIGH_INCREASING: 'Hoch/Steigend',
				LOW_DECREASING: 'Niedrig/Fallend',
				RULE_BASED: 'Regelbasiert',
				UNMAP: 'Zuordnung aufheben',
				RULE_BASED_CONDITION: 'Regelbasierte Bedingung',
				OPERATOR: 'Operator',
				COMPARE_TO: 'Vergleichen mit',
				ENTER_VALUE: 'Wert eingeben',
				NUMERIC_INPUT_ONLY: 'Nur numerische Eingabe',
				PREFERENCE: 'Präferenz',
				APPLY: 'Anwenden'
			},
			QUICK_FILTER: {
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche',
				CLOSE: 'Schließen',
			},
			DIGITIZATION_POPUP: {
				FORM_ERROR: 'Oh nein! Hersteller und Modellname bereits vergeben. Bitte einige Angaben ändern und erneut senden.',
				MANUFACTURER: 'Hersteller',
				MANUFACTURER_NAME: 'Herstellername',
				MODEL: 'Modell',
				MODEL_NAME: 'Modellname',
				INDUSTRY_TYPE: 'Industrietyp',
				ENTER: 'Eingeben',
				SELECT: 'Auswählen',
				IS: 'ist',
				CUT_IN_SPEED: 'Einschaltgeschwindigkeit(m/s)',
				CUT_IN_SPEED_LABEL: 'Einschaltgeschwindigkeit',
				CUT_OFF_SPEED: 'Abschaltgeschwindigkeit(m/s)',
				CUT_OFF_SPEED_LABEL: 'Abschaltgeschwindigkeit',
				CAPACITY_KWH: 'Wert in kWh eingeben',
				CAPACITY: 'Kapazität',
				IS_REQUIRED: 'ist erforderlich',
				SMALLER_THAN_CUTOFF: 'sollte kleiner als der Ausschaltwert sein',
				GREATER_THAN_CUTIN: 'sollte größer als der Einschaltwert sein',
				GREATER_THAN_ZERO: 'sollte größer als 0 sein',
				POWER_CURVE: 'Leistungskurve',
				REQUIRED: 'erforderlich',
				UPLOAD_POWER_CURVE: 'Leistungskurve hochladen',
				DOWNLOAD_SAMPLE: 'Beispiel/zuvor hochgeladene Datei herunterladen',
				VIEW_POWER_CURVE: 'Hochgeladene Leistungskurvendaten anzeigen',
				ERROR_CODE_MAP: 'Fehlercodes-Zuordnung',
				UPLOAD_SCADA: 'SCADA-Ereigniscode hochladen',
				VIEW_SCADA: 'Hochgeladene SCADA-Ereigniscodedaten anzeigen',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			FAILURE_MODE_POPUP: {
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				NAME: 'Name',
				IS: 'ist',
				PRIORITY: 'Priorität',
				REQUIRED: 'erforderlich',
				START_TIME: 'Startzeit (in Stunden)',
				START_TIME_LABEL: 'Startzeit',
				END_TIME: 'Endzeit (in Stunden)',
				END_TIME_LABEL: 'Endzeit',
				IS_REQUIRED: 'ist erforderlich',
				TIME_RANGE: 'Bereich sollte zwischen 0,1 und 48 Stunden liegen',
				DESCRIPTION: 'Beschreibung',
				RELIABILITY_SAVINGS: 'Zuverlässigkeitseinsparungen (Potenzial)',
				MAINTENANCE_SAVINGS: 'Wartungseinsparungen (Potenzial)',
				PERFORMANCE_SAVINGS: 'Leistungseinsparungen (Potenzial)',
				REMARK: 'Anmerkung',
				REMARK_TO_EDIT: 'Anmerkung zum Bearbeiten',
				ENTER: 'Eingeben',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			TAG_DIRECTIONALITY_POPUP: {
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				TAG_NAME: 'Tag-Name',
				DIRECTIONALITY: 'Direktionalität',
				SELECT: 'Auswählen',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			FM_RECOMMENDATION_POPUP: {
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				RECOMMENDATION: 'Empfehlung',
				IS: 'ist',
				CATEGORY: 'Kategorie',
				SELECT: 'Auswählen',
				SELECT_FAILURE: 'Fehler auswählen',
				FAILURE: 'Fehler',
				REMARK: 'Anmerkung',
				REMARK_TO_EDIT: 'Anmerkung zum Bearbeiten',
				ENTER: 'Eingeben',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			TAGS_POPUP: {
				FORECASTING: 'Prognose',
				PERFORMANCE_DEGRADATION: 'Leistungsverschlechterung',
				PERFORMANCE_DEGRADATION_HINT: '(Prognose der Zeit bis zum Eingriff für dieses Tag aktivieren)',
				DYNAMIC_DEVIATION_THRESHOLD: 'Dynamischer Abweichungsschwellenwert',
				DEVIATION_LOW: 'Niedrig',
				DEVIATION_MEDIUM: 'Mittel',
				DEVIATION_HIGH: 'Hoch',
				ERRATIC_DETECTION: 'Sprunghafte Erkennung',
				ERRATIC_ALERT: 'Sprunghafter Alarm',
				MISSING_DATA_DETECTION: 'Fehlende Datenerkennung',
				OUTLIER_DETECTION: 'Ausreißer-Erkennung',
				OUT_OF_RANGE_DETECTION: 'Außerhalb des Bereichs Erkennung',
				DATA_QUALITY_ALERT_GENERATION: 'DATENQUALITÄTS-ALARME GENERIEREN',
				DATA_QUALITY_ALERT_DESC: 'Wählen Sie aus, welche erkannten DQ-Probleme Alarme auslösen sollen. Das Deaktivieren der Alarmierung stoppt die DQ-Berechnung nicht. Die Werte werden weiterhin in den DQ-Tabellen angezeigt.',
				FLATLINE_ALERT: 'Flatline-Alarm',
				MISSING_DATA_ALERT: 'Alarm für fehlende Daten',
				OUTLIER_ALERT: 'Ausreißer-Alarm',
				OUT_OF_RANGE_ALERT: 'Außerhalb-des-Bereichs-Alarm',
				ALERTS_NOTIFICATIONS_KPI: 'Warnungen, Benachrichtigungen & KPI',
				OPERATIONAL_LIMITS: 'Betriebsgrenzen',
				ADDITIONAL_SETTINGS: 'Zusätzliche Einstellungen',
				NO_TAGS_WITH_TAGID_MAPPED: 'Keine Tags mit gemappter TagId gefunden.',
				FUNCTION_NAME: 'Funktionsname',
				DATA_QUALITY_DETECTION: 'Datenqualitätserkennung',
				SELECT_TAG_TO_ADD_MORE: 'Wählen Sie das erste Tag aus, um weitere Tags hinzuzufügen',
				ENTER_FORMULA: 'Formel eingeben*',
				LOWER: 'Unterer',
				UPPER: 'Oberer',
				START: 'Start',
				END: 'Ende',
				DEADLINE: 'Frist',
				FORMULA_PLACEHOLDER: 'Formel eingeben. z.B. (t1+t2)*t3',
				SELECT_TAG: 'Tag auswählen',
				SELECT_KEY: 'Schlüssel auswählen',
				VALUE: 'Wert',
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				TAG_NAME: 'Tag-Name',
				DESCRIPTION: 'Beschreibung',
				TAG_ID: 'Tag-ID',
				UNIT: 'Einheit',
				INSTRUMENT_RANGE: 'Instrumentenbereich',
				TRIP_LIMITS: 'Trip-Grenzwerte',
				THRESHOLD_ALERT: 'Schwellenwert-Alarm',
				THRESHOLD_ALERT_DELAY: 'Schwellenwert-Alarmverzögerung',
				IOW_CRITICALITY: 'IOW-Kritikalität',
				DIRECTIONALITY: 'Direktionalität',
				DIRECTION: 'Richtung',
				FLATLINE_DETECTION: 'Flatline-Erkennung',
				ATTENTION: 'Aufmerksamkeit',
				THRESHOLD_NOTIFICATION: 'Schwellenwert-Benachrichtigung',
				KPI: 'KPI',
				STRING_CURRENT: 'String-Strom',
				STRING_CAPACITY: 'String-Kapazität',
				SCADA_ERROR_CODES: 'SCADA-Fehlercodes',
				COMMA_SEPARATED_ERROR_CODES: 'Kommagetrennte Fehlercodes hinzufügen',
				ASSET: 'Asset',
				CALCULATED_FLAG: 'Berechnetes Flag',
				REMARK: 'Anmerkung',
				REMARK_TO_EDIT: 'Anmerkung zum Bearbeiten',
				FUNCTION_TABLE: 'Funktionstabelle',
				PARAMETERS: 'Parameter',
				CONSTANTS: 'Konstanten',
				PLOT_CONTINUOUS: 'Als kontinuierlichen Linientrend darstellen (fehlende Werte ignorieren)',
				ENTER: 'Eingeben',
				SELECT: 'Auswählen',
				WRITE_CUSTOM_CODE: 'Benutzerdefinierten Code schreiben',
				UPLOAD_TAGS: 'Tags hochladen',
				DOWNLOAD_CORRELATION_CSV: 'Korrelations-CSV-Format herunterladen',
				UPLOAD_CORRELATION_CSV: 'Korrelations-CSV hochladen',
				DELETE: 'Löschen',
				ADD: 'Hinzufügen',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern',
				ALARM_LIMITS: 'Alarmgrenzen',
				THRESHOLD_LIMITS: 'Schwellenwertgrenzen',
				CORRELATION_CSV_UPLOAD_LABEL: 'Korrelations-CSV hochladen',
				TRIAL_RUN: 'Testlauf',
				SELECT_PYTHON_FUNCTION: 'Python-Funktion auswählen',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Funktionen suchen...',
				NO_MATCHING_FUNCTION_FOUND: 'Keine passende Funktion gefunden',
				SELECT_FUNCTION_ERROR: 'Bitte eine Python-Funktion auswählen',
				DEPRECATED: 'Veraltet',
				DEPRECATED_FORMULA_TOOLTIP: 'Diese Formel ist veraltet. Bitte wählen Sie die aktualisierte Formel aus.',
				DEPRECATED_FORMULA_ERROR: 'Diese Formel ist veraltet. Bitte wählen Sie die aktualisierte Formel aus.',
				CUSTOM_FORMULA_INVALID_VARS: 'Ungültige Variable(n) verwendet',
				CUSTOM_FORMULA_INVALID_SYNTAX: 'Ungültige Variable(n)/mathematischer Ausdruck',
				CUSTOM_FORMULA_REQUIRED: 'Formel ist erforderlich',
				SEARCH_ASSETS_PLACEHOLDER: 'Assets suchen...',
				NO_MATCHING_ASSET_FOUND: 'Kein passendes Asset gefunden',
				SEARCH_DOTS: 'Suchen...',
				NO_MATCHING_TAG_FOUND: 'Kein passender Tag gefunden',
				NO_TAGS_FOUND_WITH_TAGID_MAPPED: 'Keine Tags mit zugewiesener TagId gefunden.',
				SEARCH_PLAIN: 'Suchen',
				NO_MATCHING_KEY_FOUND: 'Kein passender Schlüssel gefunden',
				PARAMETER_NAME_HINT: 'Parametername',
				CONSTANT_NAME_HINT: 'Konstantenname',
				DISPLAY_EXPRESSION: 'Anzeigeausdruck',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Ausdruck eingeben',
				EXPRESSION_DESCRIPTION: 'Ausdrucksbeschreibung',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Ausdrucksbeschreibung eingeben'
			},
			ASSET_TEMPLATE_DELETE: {
				TITLE: 'Asset-Löschbestätigung',
				CONFIRM_MSG: 'Sind Sie sicher, dass Sie das Asset löschen möchten?',
				ASSOCIATED_ITEMS_MSG: 'Möchten Sie auch die folgenden mit dem Asset verknüpften Elemente löschen?',
				DELETE_TAGS: 'Verknüpfte Tags löschen',
				DELETE_FAILURE_MODES: 'Verknüpfte Ausfallmodi löschen',
				DELETING: 'Wird gelöscht...',
				CANCEL: 'Abbrechen',
				DELETE: 'Löschen'
			},
			FM_INFO: {
				TITLE: 'Ausfallmodus-Informationen',
				TOOLTIP_ADD: 'Hinzufügen',
				TOOLTIP_EDIT: 'Bearbeiten',
				TOOLTIP_UPLOAD: 'Hochladen',
				TOOLTIP_DOWNLOAD: 'Herunterladen',
				TOOLTIP_EDIT_MAPPING: 'Zuordnung bearbeiten',
				TOOLTIP_DELETE: 'Löschen',
				TOOLTIP_VIEW_CHANGES: 'Änderungen anzeigen',
				UPLOAD_FAILURE_MODES: 'Ausfallmodi hochladen',
				UPLOAD_FM_TAG_MAPPINGS: 'Ausfall-zu-Tag-Zuordnungen hochladen',
				DOWNLOAD_FAILURE_MODES: 'Ausfallmodi herunterladen',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Ausfall-zu-Tag-Zuordnungen herunterladen',
				COL_FAILURE_MODE: 'Ausfallmodus',
				COL_START_TIME: 'Startzeit',
				COL_END_TIME: 'Endzeit',
				COL_PRIORITY: 'Priorität',
				COL_ACTIONS: 'Aktionen',
				PRIORITY_DESCRIPTION: 'Beschreibung der Auswirkungspriorität',
				NO_RECORDS: 'Für das ausgewählte Asset sind keine Fehlermodi verfügbar'
			},
			RECOMMENDATIONS: {
				TITLE: 'Empfehlungen',
				TOOLTIP_ADD: 'Hinzufügen',
				TOOLTIP_EDIT: 'Bearbeiten',
				TOOLTIP_UPLOAD: 'Hochladen',
				TOOLTIP_DOWNLOAD: 'Herunterladen',
				TOOLTIP_EDIT_MAPPING: 'Mechanismen-zu-Empfehlungen-Zuordnung bearbeiten',
				TOOLTIP_DELETE: 'Löschen',
				TOOLTIP_VIEW_CHANGES: 'Änderungen anzeigen',
				UPLOAD_RECOMMENDATIONS: 'Empfehlungen hochladen',
				UPLOAD_REC_FM_MAPPINGS: 'Empfehlung-zu-FM-Zuordnungen hochladen',
				DOWNLOAD_RECOMMENDATIONS: 'Empfehlungen herunterladen',
				DOWNLOAD_REC_FM_MAPPINGS: 'Empfehlung-zu-FM-Zuordnungen herunterladen',
				COL_RECOMMENDATIONS: 'Empfehlungen',
				COL_CATEGORY: 'Kategorie',
				NO_RECORDS: 'Für das ausgewählte Asset sind keine Empfehlungen verfügbar'
			},
			ASSET_TEMPLATE_SYNC: {
				SYNC_MSG: 'In der Asset-Vorlage wurden folgende Änderungen vorgenommen. Bitte prüfen Sie, ob diese mit den mit dieser Vorlage erstellten Assets synchronisiert werden sollen.',
				ASSETS: 'Assets',
				SELECT_ALL: 'Alle auswählen',
				TAGS: 'Tags',
				FAILURES: 'Fehler',
				RECOMMENDATIONS: 'Empfehlungen',
				CLOSE_TOOLTIP: 'Popup schließen',
				CANCEL: 'Schließen',
				DONT_SYNC: 'Nicht synchronisieren',
				DONT_SYNC_TOOLTIP: 'Änderungen nicht synchronisieren',
				SYNC: 'Synchronisieren',
				SYNC_TOOLTIP: 'Änderungen synchronisieren'
			},
			TAG_TEMPLATE_LIST: {
				TITLE: 'Tag-Liste',
				SEARCH: 'Suchen',
				TOOLTIP_SEARCH: 'Suchen',
				TOOLTIP_ADD: 'Neuen Tag hinzufügen',
				TOOLTIP_UPLOAD: 'Tags hochladen',
				TOOLTIP_DOWNLOAD: 'Tag-Liste herunterladen',
				TOOLTIP_CLONE: 'Tag klonen',
				TOOLTIP_DELETE: 'Tag löschen',
				TOOLTIP_VIEW_CHANGES: 'Änderungen anzeigen',
				COL_INDEX: 'Nr.',
				COL_TAG_TYPE: 'Tag-Typ',
				COL_NAME: 'Name',
				COL_DESCRIPTION: 'Tag-Beschreibung',
				COL_UNIT: 'Einheit',
				COL_FAILURE_MODES: 'Ausfallmodus(-modi)',
				COL_DIRECTIONALITY: 'Direktionalität',
				COL_CALCULATED: 'Berechnet',
				COL_ACTIONS: 'Aktionen',
				NO_RECORDS: 'Für das ausgewählte Asset sind keine Tags verfügbar',
				TOOLTIP_NO_FM: 'Keine zugehörigen Ausfallmodi',
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche',
				LOADING: 'Wird geladen...'
			},
			SUBSYSTEMS: {
				TITLE: 'Subsysteme',
				SEARCH: 'Suchen'
			},
			ASSET_TEMPLATE_POPUP: {
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				NAME: 'Name',
				IS: 'ist',
				ALREADY_TAKEN: 'Bereits vergeben',
				TEMPLATE_NAME: 'Vorlagenname',
				APPLICATION: 'Anwendung',
				TEMPLATE_APPLICATION: 'Vorlageneanwendung',
				PLEASE_ENTER: 'Bitte eingeben',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			ASSETS_FM_INFO: {
				TITLE: 'Ausfallmodus-Informationen',
				TOOLTIP_ADD: 'Hinzufügen',
				TOOLTIP_EDIT: 'Bearbeiten',
				TOOLTIP_UPLOAD: 'Hochladen',
				TOOLTIP_DOWNLOAD: 'Herunterladen',
				TOOLTIP_EDIT_MAPPING: 'Tag-zu-Mechanismen bearbeiten',
				TOOLTIP_DELETE: 'Löschen',
				TOOLTIP_VIEW_CHANGES: 'Änderungen anzeigen',
				UPLOAD_FAILURE_MODES: 'Ausfallmodi hochladen',
				UPLOAD_FM_TAG_MAPPINGS: 'Ausfall-zu-Tag-Zuordnungen hochladen',
				DOWNLOAD_FAILURE_MODES: 'Ausfallmodi herunterladen',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Ausfall-zu-Tag-Zuordnungen herunterladen',
				COL_STATUS: 'Status',
				COL_FAILURE_MODE: 'Ausfallmodus',
				COL_PRIORITY: 'Priorität',
				COL_START_TIME: 'Startzeit',
				COL_END_TIME: 'Endzeit',
				COL_ACTIONS: 'Aktionen',
				PRIORITY_DESCRIPTION: 'Beschreibung der Auswirkungspriorität',
				NO_RECORDS: 'Für das ausgewählte Asset sind keine Fehlermodi verfügbar'
			},
			TAG_FM_POPUP: {
				TITLE: 'Tag zu Mechanismen',
				TAG_NAME: 'Tag-Name',
				SEARCH_TAG: 'Tag suchen',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern',
				NO_RECORDS: "Keine Tags und Fehlermodi gefunden",
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche',
			},
			ASSETS_RECOMMENDATIONS: {
				TITLE: 'Empfehlungen',
				TOOLTIP_ADD: 'Hinzufügen',
				TOOLTIP_EDIT: 'Bearbeiten',
				TOOLTIP_UPLOAD: 'Hochladen',
				TOOLTIP_DOWNLOAD: 'Herunterladen',
				TOOLTIP_EDIT_MAPPING: 'Mechanismen-zu-Empfehlungen-Zuordnung bearbeiten',
				TOOLTIP_DELETE: 'Löschen',
				TOOLTIP_VIEW_CHANGES: 'Änderungen anzeigen',
				UPLOAD_RECOMMENDATIONS: 'Empfehlungen hochladen',
				UPLOAD_REC_FM_MAPPINGS: 'Empfehlung-zu-FM-Zuordnungen hochladen',
				DOWNLOAD_RECOMMENDATIONS: 'Empfehlungen herunterladen',
				DOWNLOAD_REC_FM_MAPPINGS: 'Empfehlung-zu-FM-Zuordnungen herunterladen',
				COL_RECOMMENDATIONS: 'Empfehlungen',
				COL_CATEGORY: 'Kategorie',
				COL_ACTIONS: 'Aktionen',
				NO_RECORDS: 'Für das ausgewählte Asset sind keine Empfehlungen verfügbar'
			},
			REC_FM_POPUP: {
				TITLE: 'Mechanismen zu Empfehlungen',
				RECOMMENDATION: 'Empfehlung',
				CATEGORY: 'Kategorie',
				OFFLINE: 'Offline',
				ONLINE: 'Online',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			ASSET_DELETE: {
				TITLE: 'Asset-Löschbestätigung',
				CONFIRM_MSG: 'Sind Sie sicher, dass Sie das Asset löschen möchten?',
				ASSOCIATED_ITEMS_MSG: 'Möchten Sie auch die folgenden mit dem Asset verknüpften Elemente löschen?',
				DELETE_TAGS: 'Verknüpfte Tags löschen',
				DELETE_FAILURE_MODES: 'Verknüpfte Ausfallmodi löschen',
				DELETING: 'Wird gelöscht...',
				CANCEL: 'Abbrechen',
				DELETE: 'Löschen'
			},
			ASSET_POPUP: {
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				ASSET_NAME: 'Asset-Name',
				ASSET_MODEL: 'Asset-Modell',
				ASSET_ID: 'Asset-ID',
				DEPLOYED_DATE: 'Bereitstellungsdatum',
				SYSTEM: 'System',
				MAINTENANCE_DATA: 'Wartungsdaten',
				PROVIDER_DATA: 'Anbieter-Daten',
				ENTER: 'Eingeben',
				SELECT: 'Auswählen',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			NAME_MAPPING: {
				TITLE_TAG_FM: 'Tag-zu-Mechanismen hochladen',
				TITLE_REC_FM: 'Empfehlung-zu-Mechanismen hochladen',
				TAG_NAME_MAPPING: 'Tag-Namens-Zuordnung',
				REC_NAME_MAPPING: 'Empfehlungsnamens-Zuordnung',
				TAG_NAME: 'Tag-Name',
				RECOMMENDATION_NAME: 'Empfehlungsname',
				TAG_NAME_OPTIONS: 'Tag-Namens-Optionen',
				REC_NAME_OPTIONS: 'Empfehlungsnamens-Optionen',
				OPTIONS_PLACEHOLDER: 'Optionen',
				NO_TAG_SUGGESTIONS: 'Keine Vorschläge gefunden. Dieser Tag wird nicht in der endgültigen Zuordnung verwendet.',
				TAG_DELETED_FROM_MAPPING: 'Tag aus Zuordnung gelöscht',
				NO_REC_SUGGESTIONS: 'Keine Vorschläge gefunden. Diese Empfehlung wird nicht in der endgültigen Zuordnung verwendet.',
				REC_DELETED_FROM_MAPPING: 'Empfehlung aus Zuordnung gelöscht',
				FM_DELETED_FROM_MAPPING: 'Ausfallmodus aus Zuordnung gelöscht',
				ACTIONS: 'Aktionen',
				FM_MAPPING: 'Ausfallmodus-Zuordnung',
				FM_NAME: 'Ausfallmodus-Name',
				FM_OPTIONS: 'Ausfallmodus-Optionen',
				TOOLTIP_CLEAR: 'Auswahl löschen',
				TOOLTIP_DELETE_TAG: 'Tag löschen',
				TOOLTIP_UNDO_TAG: 'Tag-Löschung rückgängig machen',
				TOOLTIP_DELETE_FM: 'Ausfallmodus löschen',
				TOOLTIP_UNDO_FM: 'Ausfallmodus-Löschung rückgängig machen',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			TAG_TEMPLATE_POPUP: {
				ERRATIC_DETECTION: 'Sprunghafte Erkennung',
				ERRATIC_ALERT: 'Sprunghafter Alarm',
				MISSING_DATA_DETECTION: 'Fehlende Datenerkennung',
				OUTLIER_DETECTION: 'Ausreißer-Erkennung',
				OUT_OF_RANGE_DETECTION: 'Außerhalb des Bereichs Erkennung',
				DATA_QUALITY_ALERT_GENERATION: 'DATENQUALITÄTS-ALARME GENERIEREN',
				DATA_QUALITY_ALERT_DESC: 'Wählen Sie aus, welche erkannten DQ-Probleme Alarme auslösen sollen. Das Deaktivieren der Alarmierung stoppt die DQ-Berechnung nicht. Die Werte werden weiterhin in den DQ-Tabellen angezeigt.',
				FLATLINE_ALERT: 'Flatline-Alarm',
				MISSING_DATA_ALERT: 'Alarm für fehlende Daten',
				OUTLIER_ALERT: 'Ausreißer-Alarm',
				OUT_OF_RANGE_ALERT: 'Außerhalb-des-Bereichs-Alarm',
				ALERTS_AND_NOTIFICATIONS: 'Warnungen & Benachrichtigungen',
				OPERATIONAL_LIMITS: 'Betriebsgrenzen',
				DATA_QUALITY_DETECTION: 'Datenqualitätserkennung',
				SELECT_TAG_TO_ADD_MORE: 'Wählen Sie das erste Tag aus, um weitere Tags hinzuzufügen',
				LOWER_RANGE: 'Unterer Bereich',
				UPPER_RANGE: 'Oberer Bereich',
				LOWER: 'Unterer',
				UPPER: 'Oberer',
				ALARM_LIMITS: 'Alarmgrenzen',
				THRESHOLD_LIMITS: 'Schwellenwertgrenzen',
				START: 'Start',
				END: 'Ende',
				FORMULA_PLACEHOLDER: 'Formel eingeben. z.B. (t1+t2)*t3',
				SELECT_TAG: 'Tag auswählen',
				VALUE: 'Wert',
				DELETE: 'Löschen',
				ADD: 'Hinzufügen',
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				TAG_TYPE: 'Tag-Typ',
				TAG_NAME: 'Tag-Name',
				TAG_DESCRIPTION: 'Tag-Beschreibung',
				DESCRIPTION: 'Beschreibung',
				UNIT: 'Einheit',
				INSTRUMENT_RANGE: 'Instrumentenbereich',
				TRIP_LIMITS: 'Trip-Grenzwerte',
				THRESHOLD_ALERT: 'Schwellenwert-Alarm',
				THRESHOLD_ALERT_DELAY: 'Schwellenwert-Alarmverzögerung',
				DESIGN_VALUE: 'Designwert',
				DIRECTIONALITY: 'Direktionalität',
				DIRECTION: 'Richtung',
				IOW_CRITICALITY: 'IOW-Kritikalität',
				FLATLINE_DETECTION: 'Flatline-Erkennung',
				ATTENTION: 'Aufmerksamkeit',
				THRESHOLD_NOTIFICATION: 'Schwellenwert-Benachrichtigung',
				CALCULATED_FLAG: 'Berechnetes Flag',
				PARAMETERS: 'Parameter',
				CONSTANTS: 'Konstanten',
				UPLOAD_TAGS: 'Tags hochladen',
				ENTER: 'Eingeben',
				SELECT: 'Auswählen',
				SELECT_PYTHON_FUNCTION: 'Python-Funktion auswählen',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Funktionen suchen...',
				NO_MATCHING_FUNCTION_FOUND: 'Keine passende Funktion gefunden',
				SELECT_FUNCTION_ERROR: 'Bitte eine Python-Funktion auswählen',
				SEARCH_TAG_TYPE_PLACEHOLDER: 'Tag-Typ suchen...',
				NO_MATCHING_TAG_TYPE_FOUND: 'Kein passender Tag-Typ gefunden',
				SEARCH_DOTS: 'Suchen...',
				NO_MATCHING_TAG_FOUND: 'Kein passender Tag gefunden',
				PARAMETER_NAME_HINT: 'Parametername',
				CONSTANT_NAME_HINT: 'Konstantenname',
				DISPLAY_EXPRESSION: 'Anzeigeausdruck',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Ausdruck eingeben',
				EXPRESSION_DESCRIPTION: 'Ausdrucksbeschreibung',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Ausdrucksbeschreibung eingeben',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			TEMPLATE_NAME_MAPPING: {
				TITLE: 'Tag zu Mechanismen',
				TAG_NAME_MAPPING: 'Tag-Namens-Zuordnung',
				TAG_NAME: 'Tag-Name',
				TAG_NAME_OPTIONS: 'Tag-Namens-Optionen',
				OPTIONS_PLACEHOLDER: 'Optionen',
				NO_TAG_SUGGESTIONS: 'Keine Vorschläge gefunden. Dieser Tag wird nicht in der endgültigen Zuordnung verwendet.',
				TAG_DELETED_FROM_MAPPING: 'Tag aus Zuordnung gelöscht',
				FM_DELETED_FROM_MAPPING: 'Ausfallmodus aus Zuordnung gelöscht',
				ACTIONS: 'Aktionen',
				FM_MAPPING: 'Ausfallmodus-Zuordnung',
				FM_NAME: 'Ausfallmodus-Name',
				FM_OPTIONS: 'Ausfallmodus-Optionen',
				TOOLTIP_CLEAR: 'Auswahl löschen',
				TOOLTIP_DELETE_TAG: 'Tag löschen',
				TOOLTIP_UNDO_TAG: 'Tag-Löschung rückgängig machen',
				TOOLTIP_DELETE_FM: 'Ausfallmodus löschen',
				TOOLTIP_UNDO_FM: 'Ausfallmodus-Löschung rückgängig machen',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			FM_INFO_POPUP: {
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				NAME: 'Name',
				PRIORITY: 'Priorität',
				START_TIME: 'Startzeit (in Stunden)',
				START_TIME_LABEL: 'Startzeit',
				END_TIME: 'Endzeit (in Stunden)',
				END_TIME_LABEL: 'Endzeit',
				IS: 'ist',
				REQUIRED: 'erforderlich',
				DESCRIPTION: 'Beschreibung',
				RELIABILITY_SAVINGS: 'Zuverlässigkeitseinsparungen (Potenzial)',
				MAINTENANCE_SAVINGS: 'Wartungseinsparungen (Potenzial)',
				PERFORMANCE_SAVINGS: 'Leistungseinsparungen (Potenzial)',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			TAG_FM_INFO_POPUP: {
				TITLE: "Tag-Vorlagen-Fehlermodus-Zuordnung",
				TAG_NAME: "Tag-Name",
				SEARCH_TAG: "Tag suchen",
				NAME: "Name",
				TAG_ID: "Tag-ID",
				CANCEL: "Abbrechen",
				CANCEL_TOOLTIP: "Änderungen abbrechen",
				SAVE: "Speichern",
				SAVE_TOOLTIP: "Änderungen speichern",
				NO_RECORDS: "Keine Tags und Fehlermodi gefunden",
				NO_MATCHES: 'Keine Ergebnisse für "{{keyword}}" gefunden',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Versuchen Sie ein anderes Schlüsselwort oder löschen Sie die Suche',
			},
			RECOMMENDATIONS_POPUP: {
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				RECOMMENDATION: 'Empfehlung',
				IS: 'ist',
				CATEGORY: 'Kategorie',
				SELECT: 'Auswählen',
				SELECT_FAILURE: 'Fehler auswählen',
				FAILURE: 'Fehler',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			REC_TEMPLATE_FM_POPUP: {
				TITLE: 'Mechanismen zu Empfehlungen',
				RECOMMENDATION: 'Empfehlung',
				CATEGORY: 'Kategorie',
				OFFLINE: 'Offline',
				ONLINE: 'Online',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			},
			SUBSYSTEM_TEMPLATE: {
				TITLE: 'Subsystem-Vorlagenliste',
				SEARCH: 'Suchen',
				TOOLTIP_ADD: 'Neue Subsystem-Vorlage hinzufügen',
				TOOLTIP_EDIT: 'Subsystem-Vorlage bearbeiten',
				TOOLTIP_DELETE: 'Subsystem-Vorlage löschen',
				COL_INDEX: 'Nr.',
				COL_NAME: 'Name',
				COL_DESCRIPTION: 'Beschreibung',
				COL_CREATED_ON: 'Erstellt am'
			},
			SUBSYSTEM_TEMPLATE_DELETE: {
				TITLE: 'Subsystem-Vorlage löschen bestätigen',
				CONFIRM_MSG: 'Möchten Sie die Subsystem-Vorlage wirklich löschen?',
				DELETING: 'Wird gelöscht...',
				CANCEL: 'Abbrechen',
				DELETE: 'Löschen'
			},
			SUBSYSTEM_TEMPLATE_POPUP: {
				ADD_TITLE: 'Subsystem-Vorlage hinzufügen',
				EDIT_TITLE_PREFIX: 'Subsystem-Vorlage bearbeiten',
				NAME: 'Name',
				DESCRIPTION: 'Beschreibung',
				NAME_TAKEN_ERROR: 'Name ist bereits vergeben',
				NAME_REQUIRED_ERROR: 'Name ist erforderlich',
				FORM_ERROR: 'Oh nein! Bitte einige Angaben ändern und erneut senden.',
				CANCEL: 'Abbrechen',
				CANCEL_TOOLTIP: 'Änderungen abbrechen',
				SAVE: 'Speichern',
				SAVE_TOOLTIP: 'Änderungen speichern'
			}

		},
		ADVANCED_ANALYSIS: {
			TABS: {
				ADVANCED_ANALYSIS: 'Erweiterte Analyse',
				RENEWABLES: 'Erneuerbare Energien',
				SUMMARY: 'Zusammenfassung',
				DOWNTIME: 'Ausfallzeit',
				UNDERPERFORMANCE: 'Minderleistung',
				CURTAILMENT: 'Abregelung',
				SOILING_LOSS: 'Verschmutzungsverlust',
				LOSS_BUCKETING: 'Verlustklassifizierung',
				MAINTENANCE: 'Wartung'
			},
			TOOLBAR: {
				SELECT_ANALYSIS: 'Analyse auswählen',
				SEARCH_ANALYSIS: 'Analyse suchen...',
				NO_MATCHING_ANALYSIS: 'Keine passende Analyse gefunden',
				PUBLIC: 'Öffentlich',
				SAVE_ALL: 'Alle speichern',
				TOOLTIP_SAVE_ALL: 'Alle Änderungen speichern',
				TOOLTIP_DOWNLOAD: 'Statistiken für alle Analysen herunterladen',
				ANALYSIS_TYPE: 'Analysetyp'
			},
			HEADER: {
				CREATED_BY: 'von',
				CREATED_ON: 'Erstellt am:'
			},
			EMPTY_STATE: {
				HEADING: 'Wählen Sie eine vorhandene Analyse aus oder erstellen Sie eine neue',
				CONTENT: 'Bitte wählen oder fügen Sie eine Analyse hinzu.'
			},
			DESCRIPTION_LABEL: 'Beschreibung:',
			POPUP: {
				FORM_ERROR: 'Oh nein! Bitte ändern Sie einige Felder und versuchen Sie es erneut.',
				NAME_PLACEHOLDER: 'Name',
				NAME_ERROR_TAKEN: 'Bereits vergeben',
				NAME_HINT: 'Bitte eingeben',
				NAME_HINT_STRONG: 'Analysename',
				DESC_PLACEHOLDER: 'Beschreibung',
				DESC_ERROR_PREFIX: 'Beschreibung ist',
				DESC_HINT: 'Bitte eingeben',
				DESC_HINT_STRONG: 'Analysebeschreibung',
				SELECT_FACILITY: 'Anlage auswählen',
				SEARCH_FACILITY: 'Suche',
				NO_MATCHING_FACILITY: 'Keine passende Anlage gefunden',
				TOOLTIP_CANCEL: 'Änderungen abbrechen',
				TOOLTIP_SAVE: 'Änderungen speichern',
				BTN_CANCEL: 'Abbrechen',
				BTN_SAVE: 'Speichern'
			},
			SAVE_CONFIRMATION: {
				TITLE: 'Nicht gespeicherte Änderungen',
				MESSAGE: 'Es gibt nicht gespeicherte Änderungen. Möchten Sie fortfahren?',
				BTN_CANCEL: 'Abbrechen',
				BTN_SAVE_CONTINUE: 'Speichern und fortfahren',
				BTN_DISCARD: 'Änderungen verwerfen und fortfahren'
			},
			COMMON: {
				BTN_OK: 'Ok',
				BTN_CANCEL: 'Abbrechen',
				BTN_CLOSE: 'Schließen',
				BTN_RESET: 'Zurücksetzen',
				BTN_SAVE: 'Speichern',
				LOADING: 'Laden...',
				NO_RECORDS: 'Keine Datensätze gefunden',
				SEARCH: 'Suche',
				SEARCH_PLACEHOLDER: 'Suchen...',
				TOOLTIP_DELETE: 'Löschen',
				TOOLTIP_ADD: 'Hinzufügen',
				TOOLTIP_DOWNLOAD: 'Herunterladen',
				TOOLTIP_CANCEL: 'Änderungen abbrechen',
				TOOLTIP_SAVE: 'Änderungen speichern',
				TOOLTIP_REMOVE_CARD: 'Karte entfernen',
				DATE_RANGE: 'Datumsbereich'
			},
			FILTER: {
				TITLE: 'Filter',
				UNIT: 'Einheit',
				SYSTEM: 'System',
				SEARCH_SYSTEM: 'System suchen...',
				NO_MATCHING_SYSTEM: 'Kein passendes System gefunden'
			},
			BUCKETING_FILTER: {
				FACILITY_TYPE: 'Anlagentyp',
				SELECT_FACILITY: 'Anlage auswählen',
				TOOLTIP_CARD_VIEW: 'Kartenansicht',
				TOOLTIP_TABLE_VIEW: 'Tabellenansicht',
				SEARCH_SYSTEM: 'System suchen...',
				NO_SYSTEM_FOUND: 'Kein System gefunden',
				GROUP_BY: 'Gruppieren nach:',
				ENABLE_CLUSTERING: 'Clustering aktivieren',
				SELECT_CLUSTER: 'Cluster auswählen',
				WIND_DIRECTION: 'Windrichtung',
				SELECTED_DATE_RANGE: 'Ausgewählter Datumsbereich',
				START_DATE: 'Startdatum',
				END_DATE: 'Enddatum',
				CONFIGURE_LOSS: 'Verlust konfigurieren',
				SAP_FILTER_TITLE: 'SAP-Feld(er) Filter:'
			},
			BUCKETING_TABLE: {
				SEARCH: 'Suche',
				SORT_BY: 'Sortieren nach',
				SORT_NONE: 'Keine',
				SORT_ASC: 'Aufsteigend',
				SORT_DESC: 'Absteigend',
				COL_NAME: 'Name',
				COL_GENERATION: 'Erzeugung (in MWh)',
				COL_EFFICIENCY: 'Leistungseffizienz (%)',
				COL_BREAKDOWN_COUNT: 'Anzahl Ausfälle',
				COL_NOTIFICATION_COUNT: 'Anzahl Meldungen',
				COL_CLOSED: 'Geschlossen',
				COL_OPEN: 'Offen',
				COL_BLOCK: 'Block',
				COL_EFF_LOSS: 'Effizienzverlust',
				COL_INV: 'WR',
				COL_TIME: 'Zeit (hh:mm)',
				COL_CURTAILMENT_LOSS: 'Abregelungsverlust (MWh)',
				COL_GEN_LOSS: 'Erzeugungsverlust (MWh)',
				COL_GEN_LOSS_NET: 'Erzeugungsverlust (MWh)',
				COL_GEN_LOSS_MWH: 'Erzeugungsverlust (MWh)',
				COL_AVAILABILITY: 'Verfügbarkeit',
				COL_REV_LOSS: 'Umsatzverlust',
				COL_MAINTENANCE_COST: 'Wartungskosten',
				COL_DOWNTIME: 'Ausfallzeit',
				COL_DURATION_PCT: 'Dauer %',
				COL_MTTR: 'MTTR (hh:mm)',
				COL_ASSET: 'Asset',
				COL_MTBF: 'MTBF (hh:mm)',
				COL_IDEAL_GEN: 'Ideale Erzeugung (KWh)',
				COL_SOILING_LOSS: 'Verschmutzungsverlust (KWh)',
				COL_SOILING_LOSS_PCT: 'Verschmutzungsverlust (% der idealen Erzeugung)',
				COL_SCHEDULED_DATE: 'Geplantes Reinigungsdatum',
				COL_LAST_CLEANED: 'Zuletzt gereinigt',
				COL_LAST_CLEANED_DAYS: '(Tage zuvor)',
				COL_NOTIFICATION_NO: 'Meldungsnummer',
				COL_EQUIPMENT_ID: 'Geräte-ID',
				COL_FUNCTIONAL_LOC: 'Funktionaler Standort',
				COL_EQUIPMENT: 'Gerät',
				COL_DESCRIPTION: 'Beschreibung',
				COL_CREATED_BY: 'Erstellt von',
				COL_CREATED_ON: 'ERSTELLT AM',
				COL_MAINTENANCE_PLANT: 'Instandhaltungswerk',
				COL_PLAN_GROUP: 'Plangruppe',
				COL_COMPLETED_ON: 'Abgeschlossen am',
				COL_COMPLETED_BY: 'Abgeschlossen von',
				COL_COMPONENT: 'Komponente'
			},
			POWER_CURVE: {
				TITLE_PREFIX: 'Leistungskurveneinstellungen für',
				OEM: 'OEM-Leistungskurve',
				CALCULATED: 'Berechnete Leistungskurve',
				START_DATE: 'Startdatum',
				STOP_DATE: 'Enddatum',
				DATE_RANGE_ERROR: 'Das Startdatum muss vor dem Enddatum liegen.',
				ADD_COMMENT: 'Kommentar hinzufügen',
				COMMENT_ERROR: 'Bitte geben Sie einen gültigen Kommentar ein.'
			},
			FILTER_MIN_MAX: {
				TOOLTIP: 'Min-Max-Filter',
				GREATER_THAN: 'Größer als',
				LESS_THAN: 'Kleiner als'
			},
			TAG_FILTER: {
				SELECT_TAG: 'Tag auswählen',
				NO_MATCHING_TAG: 'Kein passender Tag gefunden'
			},
			LIST_CARD: {
				NO_MATCHING_TAG: 'Kein passender Tag gefunden'
			},
			LIST_XY_CARD: {
				X_AXIS: 'X-Achse',
				Y_AXIS: 'Y-Achse',
				SEARCH_X: 'X suchen...',
				SEARCH_Y: 'Y suchen...',
				NO_MATCHING_X: 'Kein passender X-Wert gefunden',
				NO_MATCHING_Y: 'Kein passender Y-Wert gefunden'
			},
			CHART: {
				TOOLTIP_DOWNLOAD_TAG: 'Tag-Daten herunterladen',
				TOOLTIP_NO_ACCESS: 'Sie haben keinen Zugriff auf die in diesem Analyseelement verwendeten Einheiten und Systeme. Daher wurde es deaktiviert.',
				TOOLTIP_REMOVE_FILTER: 'Filter entfernen',
				LOCK_X_AXIS: 'X-Achse sperren (Datum)',
				MULTI_AXIS: 'Mehrfachachse',
				TRIP_LIMIT: 'Auslösegrenze',
				ALARM_LIMIT: 'Alarmgrenze',
				THRESHOLD_LIMIT: 'Schwellenwertgrenze',
				INSTRUMENT_RANGE: 'Instrumentenbereich',
				LOCK_X_AXIS_ALERT_TOOLTIP: 'Entsperren im Alarmvergleich nicht möglich',
				TYPE_SIGNAL_VS_TIME: 'Signal vs. Zeit @ versch. Zeiten',
				TYPE_SIGNAL_VS_SIGNAL: 'Signal vs. Signal @ versch. Zeiten',
				TYPE_STATE_SIGNAL: 'Signalanalyse für Betriebszustände',
				TYPE_STATE_SIGNAL_VS_SIGNAL: 'Signal vs. Signal über Betriebszustände',
				TYPE_MULTISIGNAL: 'Mehrfachsignalanalyse über Betriebszustände',
				TYPE_MULTISIGNAL_VS_SIGNAL: 'Mehrfachsignal vs. Signal über Betriebszustände',
				TYPE_FULL_SYSTEM: 'System-/Anlagenvergleich',
				TYPE_ALERT_COMPARISON: 'Alarmvergleich'
			},
			TAG_DIALOG: {
				TITLE_PLACEHOLDER: 'Titel',
				DESC_PLACEHOLDER: 'Beschreibung',
				PLOT_TYPE_LABEL: 'Diagrammtyp',
				QUICK_PLOT: 'Schnelldiagramm',
				AXIS_TYPE_LABEL: 'Achsentyp',
				AXIS_MULTI: 'Mehrfach',
				AXIS_SINGLE: 'Einzeln'
			},
			SUMMARY: {
				LOADING: 'Daten werden verarbeitet! Bitte warten!',
				NO_DATA: 'Keine Daten vorhanden.',
				NO_RENEWABLE_ASSETS: 'Keine erneuerbaren Anlagen gefunden',
				NO_RENEWABLE_ASSETS_SUBTITLE: 'Keine Anlagen entsprechen den ausgewählten Filtern',
				NO_SYSTEMS: 'Keine Systeme gefunden',
				NO_SYSTEMS_SUBTITLE: 'Keine Systeme entsprechen den ausgewählten Filtern und dem Datumsbereich.',
				NO_DOWNTIME_DATA: 'Keine Ausfallzeitdaten verfügbar',
				NO_DOWNTIME_DATA_SUBTITLE: 'Für die ausgewählten Filter und den Datumsbereich sind keine Ausfallzeitdaten verfügbar.',
				NO_PERFORMANCE_DATA: 'Keine Leistungsdaten verfügbar',
				NO_PERFORMANCE_DATA_SUBTITLE: 'Für die ausgewählten Filter und den Datumsbereich sind keine Leistungsdaten verfügbar.',
				NO_CURTAILMENT_DATA: 'Keine Abregelungsdaten verfügbar',
				NO_CURTAILMENT_DATA_SUBTITLE: 'Für die ausgewählten Filter und den Datumsbereich sind keine Abregelungsdaten verfügbar.',
				NO_LOSS_DATA: 'Keine Verlustdaten verfügbar',
				NO_LOSS_DATA_SUBTITLE: 'Für die ausgewählten Filter und den Datumsbereich sind keine Verlustdaten verfügbar.',
				NO_MAINTENANCE_DATA: 'Keine Instandhaltungszeitdaten verfügbar',
				NO_MAINTENANCE_DATA_SUBTITLE: 'Für die ausgewählten Filter und den Datumsbereich sind keine Instandhaltungszeitdaten verfügbar.',
				NO_SOILING_LOSS_DATA: 'Keine Verschmutzungsverlustdaten verfügbar',
				NO_SOILING_LOSS_DATA_SUBTITLE: 'Für die ausgewählten Filter und den Datumsbereich sind keine Verschmutzungsverlustdaten verfügbar.',
			},
			AVAILABILITY: {
				TIME_BASED: 'Zeitbasierte Verfügbarkeit',
				ENERGY_BASED: 'Energiebasierte Verfügbarkeit',
				TARGET_SUFFIX: 'Ziel',
				TOTAL_LOSS_TITLE: 'Gesamtverlust (MWh)',
				ROW_DOWNTIME: 'Ausfallzeit (HH:MM)',
				ROW_LOST_PRODUCTION: 'Produktionsverlust (MWh)',
				ROW_LOST_REVENUE: 'Umsatzverlust',
				ROW_MTBF: 'MTBF (Mittlere Betriebsdauer zwischen Ausfällen - HH:MM)',
				ROW_MTTR: 'MTTR (Mittlere Reparaturzeit - HH:MM)',
				COL_NAME: 'Name',
				COL_VALUE: 'Wert'
			},
			PERFORMANCE: {
				LOST_GENERATION: 'Erzeugungsverlust (MWh)',
				LOST_REVENUE: 'Umsatzverlust',
				BEST_PERFORMING: 'Beste Leistung',
				WORST_PERFORMING: 'Schlechteste Leistung',
				SHOW_TOP: 'Top anzeigen:',
				TOTAL_LOSS_TITLE: 'Gesamtverlust (MWh)',
				PERF_CURVE_TITLE: 'Leistungskurve',
				WIND_ROSE_TITLE: 'Windrose'
			},
			CURTAILMENT: {
				LOST_GENERATION: 'Erzeugungsverlust (MWh)',
				LOST_REVENUE: 'Umsatzverlust',
				SHOW_TOP: 'Top anzeigen:',
				TOTAL_LOSS_TITLE: 'Gesamtverlust (MWh)'
			},
			SOILING: {
				TOTAL_LOSS_TITLE: 'Gesamtverlust (MWh)',
				SOILING_CURVE_SUFFIX: 'Verschmutzungsverlust-Kurve',
				TOOLTIP_SAVE: 'Speichern',
				TOOLTIP_CANCEL: 'Abbrechen',
				SECTION_SOILING: 'Verschmutzung',
				SECTION_TEMPERATURE: 'Temperatur',
				SECTION_OTHERS: 'Sonstige',
				REF_SETTING: 'Referenzeinstellung',
				CRS: 'CRS',
				SRS: 'SRS',
				SELECT_UNIT: 'Einheit auswählen',
				SELECT_SYSTEM: 'System auswählen',
				SELECT_ASSET: 'Asset auswählen',
				SELECT_TAG: 'Tag auswählen',
				SEARCH: 'Suche',
				SEARCH_SYSTEM: 'System suchen...',
				NO_MATCHING_UNIT: 'Keine passende Einheit gefunden',
				NO_MATCHING_SYSTEM: 'Kein passendes System gefunden',
				NO_MATCHING_ASSET: 'Kein passendes Asset gefunden',
				NO_MATCHING_TAG: 'Kein passender Tag gefunden',
				APPLY_ON: 'Anwenden auf',
				CLEANING_CYCLE: 'Reinigungszyklus',
				CLEANING_CYCLE_HINT: '(in Tagen)',
				BTN_START_EXPERIMENT: 'Experiment starten',
				TOOLTIP_FORCE_STOP: 'Laufendes Experiment erzwungen stoppen',
				TOOLTIP_UPLOAD_SOILING: 'Verschmutzungsverhältnis hochladen',
				CLEANING_UPDATE: 'Reinigungsupdate',
				TOOLTIP_UPLOAD_CLEANING: 'Reinigungsplan hochladen',
				TOOLTIP_DOWNLOAD_CLEANING: 'Reinigungsupdate-Bericht herunterladen',
				CHOOSE_DATE: 'Datum auswählen',
				DATE_HINT: 'TT.MM.JJJJ',
				BTN_UPDATE: 'Aktualisieren'
			},
			LOSS: {
				LOST_GENERATION: 'Erzeugungsverlust (MWh)',
				LOST_REVENUE: 'Umsatzverlust',
				EFFECTIVE_PR: 'Effektiver PR',
				HIGHEST_LOSS_BUCKET: 'Größter Verlustkategorie',
				LOSS_BUCKETING_TITLE: 'Verlustklassifizierung (MWh)'
			},
			MAINTENANCE: {
				CHART_TITLE: 'Wartungszeit (HH:MM)',
				BAD_ACTORS_TITLE: 'Top Bad Actors',
				NOTIFICATION_STATUS: 'Meldungsstatus',
				SHDJ_DISTRIBUTION: 'Einheitsweise SHDJ-Verteilung',
				PENDING_DEFECTS_TITLE: 'Ausstehende Mängel und Alterungsberichte',
				COL_GROUP_SECTION: 'Gruppe/Bereich',
				COL_0_30: '0 - 30 Tage',
				COL_31_90: '31 - 90 Tage',
				COL_91_180: '91 - 180 Tage',
				COL_181_365: '181 - 365 Tage',
				COL_365_500: '365 - 500 Tage',
				COL_GRAND_TOTAL: 'Gesamtsumme',
				MONTHLY_DEFECTS_PREFIX: 'Monatlicher Mängelstatus -',
				TOTAL_MTD: 'Gesamte MTD-Mängel',
				YEARLY_DEFECTS_PREFIX: 'Jährlicher Mängelstatus - GJ',
				TOTAL_YTD: 'Gesamte YTD-Mängel',
				PM_COMPLIANCE_PREFIX: 'PM-Konformitätsbericht -',
				COL_EQUIPMENT: 'Gerät',
				COL_SCHEDULED: 'Geplant',
				COL_PENDING: 'Ausstehend',
				COL_COMPLETED: 'Abgeschlossen',
				COL_COMPLIANCE: 'Konformität (%)'
			},
			MESSAGES: {
				SERVER_ERROR: 'Interner Serverfehler',
				SAVE_SUCCESS: 'Die Analyse wurde erfolgreich gespeichert.',
				UPDATE_SUCCESS: 'Die Analyse wurde aktualisiert.',
				ADD_SUCCESS: 'Die Analyse wurde hinzugefügt.',
				COPY_SUCCESS: 'Die Analyse wurde kopiert.',
				CARD_GENERATED: 'Eine neue Analysekarte wurde erfolgreich erstellt',
				POWER_CURVE_STARTED: 'Berechnung der Leistungskurve gestartet für',
				POWER_CURVE_FAILED: 'Berechnung der Leistungskurve fehlgeschlagen für'
			}
		},
		NOTIFICATION_WIZARD: {
			HEADER_TITLE: 'Benachrichtigungen',
			MARK_ALL_READ: 'Alle als gelesen markieren',
			SETTINGS: 'Einstellungen',
			TAB_ALL: 'Alle',
			TAB_UNREAD: 'Neu ungelesen',
			TAB_ASSIGNED: 'Mir zugewiesen',
			NOTIFICATIONS_SUFFIX: 'Benachrichtigungen',
			TOOLTIP_MARK_READ: 'Als gelesen markieren',
			TOOLTIP_MARK_UNREAD: 'Als ungelesen markieren',
			TOOLBAR_ITEM: 'Element',
			TOOLBAR_ITEMS: 'Elemente',
			TOOLBAR_SELECTED: 'ausgewählt',
			TOOLBAR_MARK_READ: 'Als gelesen markieren',
			TOOLBAR_MARK_UNREAD: 'Als ungelesen markieren',
			TOOLBAR_CLEAR: 'Nachrichten löschen',
			ERROR_TITLE: 'Benachrichtigungen konnten nicht geladen werden',
			ERROR_DESC: 'Beim Abrufen der Benachrichtigungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
			NOTIF_OFF_TITLE: 'Benachrichtigungen sind deaktiviert',
			NOTIF_OFF_DESC: 'Aktivieren Sie Benachrichtigungen, um hier Updates zu erhalten.',
			EMPTY_DEFAULT_TITLE: 'Keine Benachrichtigungen',
			EMPTY_DEFAULT_DESC: 'Sie haben noch keine Benachrichtigungen. Sobald Sie Benachrichtigungen erhalten, werden sie hier angezeigt.',
			EMPTY_CAUGHT_UP_TITLE: 'Sie sind auf dem neuesten Stand.',
			EMPTY_UNREAD_DESC: 'Neue Benachrichtigungen zu Alarmen und Updates erscheinen hier.',
			EMPTY_ASSIGNED_DESC: 'Ihnen zugewiesene Benachrichtigungen erscheinen hier.',
			EMPTY_ALL_TITLE: 'Noch keine Benachrichtigungen',
			EMPTY_ALL_DESC: 'Updates erscheinen hier',
			GROUP_TODAY: 'Heute',
			GROUP_YESTERDAY: 'Gestern',
			GROUP_THIS_WEEK: 'Früher diese Woche',
			GROUP_THIS_MONTH: 'Früher diesen Monat',
			GROUP_LAST_MONTH: 'Letzten Monat',
			GROUP_OLDER: 'Vormonat',
			SETTINGS_HEADER: 'Benutzereinstellungen',
			SETTINGS_TAB_NOTIFICATIONS: 'Benachrichtigungen',
			SETTINGS_TAB_AUDIBLE: 'Akustische Alarme',
			SETTINGS_COL_TYPE: 'Typ',
			SETTINGS_COL_EMAIL: 'E-Mail',
			SETTINGS_COL_PLATFORM: 'Plattform',
			SETTINGS_COL_AUDIBLE: 'Akustisch',
			SETTINGS_ALERTS_HEADER: 'Alarme',
			SETTINGS_ALERTS_DESC: 'Benachrichtigungen, die ausgelöst werden, wenn ein neuer Alarm generiert wird.',
			SETTINGS_AUDIBLE_ALERTS_DESC: 'Akustischen Alarm abspielen, wenn diese Alarme erstellt werden.',
			SETTINGS_NEW_ANOMALY: 'Neue Anomalie-Alarme',
			SETTINGS_NEW_HIGH_ANOMALY: 'Neue Alarme für hohe Anomalie',
			SETTINGS_NEW_LOW_ANOMALY: 'Neue Alarme für niedrige Anomalie',
			SETTINGS_NEW_THRESHOLD: 'Neue Schwellenwert-Alarme',
			SETTINGS_OWNERSHIP_HEADER: 'Alarm-Eigentümerschaft & Zuweisung',
			SETTINGS_OWNERSHIP_DESC: 'Benachrichtigungen zur Alarm-Verantwortung.',
			SETTINGS_ALERT_OWNER: 'Als Alarm-Eigentümer zugewiesen',
			SETTINGS_ALERT_WATCHER: 'Als Alarm-Beobachter zugewiesen',
			SETTINGS_ACTIVITY_HEADER: 'Alarm-Aktivität',
			SETTINGS_ACTIVITY_DESC: 'Legt fest, ob Benutzer nach der Zuweisung laufende Updates erhalten.',
			SETTINGS_OWNED_ALERTS: 'Updates zu eigenen Alarmen',
			SETTINGS_WATCHED_ALERTS: 'Updates zu beobachteten Alarmen',
			SETTINGS_SYSTEM_HEADER: 'Systemupdates',
			SETTINGS_SYSTEM_DESC: 'Benachrichtigungen zu KI- / Systemvorgängen.',
			SETTINGS_MODEL_RETRAINING: 'Modell-Retraining abgeschlossen',
			SETTINGS_AUDIBLE_FOOTER_NOTE: 'Der akustische Alarm ertönt einmal oder benachrichtigt in der ausgewählten Häufigkeit weiter, bis Sie auf den Alarm klicken, um die Alarmdetails anzuzeigen.',
			PDF_HEADER: 'Fallmanagement - PDF erstellt',
			PDF_GENERATED_BEFORE: 'Das Fallmanagement-PDF wurde erfolgreich erstellt.',
			PDF_DOWNLOAD_LINK: 'PDF herunterladen',
			PDF_GENERATED_AFTER: 'oder greifen Sie über den an Ihre E-Mail gesendeten Link darauf zu. Der Download-Link läuft am {{expiry}} ab.',
			PDF_LINK_EXPIRED_TOOLTIP: 'Dieser Download-Link ist abgelaufen. Erstellen Sie das PDF erneut, um es herunterzuladen.',
			ASSET_TEMPLATE_SYNC_STARTED_TITLE: 'Asset-Vorlage-Synchronisierung gestartet – {{templateName}}',
			ASSET_TEMPLATE_SYNC_COMPLETED_TITLE: 'Asset-Vorlage-Synchronisierung abgeschlossen – {{templateName}}',
			ASSET_TEMPLATE_SYNC_FAILED_TITLE: 'Asset-Vorlage-Synchronisierung fehlgeschlagen – {{templateName}}'
		},
		MAINTENANCE_OPTIMIZATION: {
			// Main component
			HEADER_TITLE: 'Wartungsoptimierung',
			TAB_RESULTS: 'Ergebnisse & Wert',
			TAB_SCHEDULES: 'PM-Pläne',
			TAB_RUN_HISTORY: 'Laufverlauf',

			// Run History
			RH_COL_SL_NO: 'Nr.',
			RH_COL_RUN_DATE: 'Laufdatum',
			RH_COL_NAME: 'Name',
			RH_COL_CREATOR: 'Ersteller',
			RH_COL_SCOPE: 'Umfang',
			RH_COL_STATUS: 'Status',
			RH_COL_TOTAL_VALUE: 'Gesamtwert',
			RH_COL_APPROVED: 'Genehmigt',
			RH_COL_ACTIONS: 'Aktionen',
			RH_VIEW: 'Ansehen',
			RH_EQUIPMENTS: 'Anlagen',
			RH_SEARCH_PLACEHOLDER: 'Läufe suchen...',
			RH_EMPTY: 'Keine Optimierungsläufe für die aktuelle Auswahl gefunden.',
			RH_STATUS_PENDING: 'Ausstehend',
			RH_STATUS_RUNNING: 'Läuft',
			RH_STATUS_PROCESSING: 'Wird verarbeitet',
			RH_STATUS_COMPLETED: 'Abgeschlossen',
			RH_STATUS_FAILED: 'Fehlgeschlagen',
			BTN_RUN_OPTIMIZATION: 'Optimierung starten',
			LAST_RUN_PREFIX: 'Letzte Optimierung:',

			// PM Schedules
			PM_DOWNLOAD_TITLE: 'Download-Optionen',
			PM_DOWNLOAD_SUBTITLE: 'Verwenden Sie die Schaltflächen unten, um PM-Pläne in einem Format zu exportieren, das in SAP oder Ihr CMMS hochgeladen werden kann:',
			PM_DOWNLOAD_ALL_TITLE: 'ALLE herunterladen (CSV)',
			PM_DOWNLOAD_ALL_DESC: 'Konsolidierte Liste aller PM-Aktivitäten',
			PM_DOWNLOAD_PER_EQ_TITLE: 'Berichte pro Gerät',
			PM_DOWNLOAD_PER_EQ_DESC: 'Gefiltert nach dem in der Hierarchie ausgewählten Asset',
			PM_DOWNLOAD_CONSOLIDATED_TITLE: 'Konsolidierte Pläne',
			PM_DOWNLOAD_CONSOLIDATED_DESC: 'Gruppiert nach neuem Intervall',
			PM_SEARCH_PLACEHOLDER: 'Suchen...',
			PM_GROUP_BY_INTERVAL: 'Gruppieren nach: Intervall',
			PM_FILTER: 'Filter',
			PM_COL_ID: 'ID',
			PM_COL_NAME: 'PM-Planname',
			PM_COL_ACCESS_CLASS: 'Zugriffsklasse',
			PM_COL_BUNDLE_NAME: 'Paketname',
			PM_COL_BUNDLE_ID: 'Paket-ID',
			PM_COL_PREV_INTERVAL: 'Vorheriges PM-Intervall',
			PM_COL_CURR_INTERVAL: 'Aktuelles PM-Intervall',
			PM_EACH: 'Alle',
			PM_DAYS: 'Tage',

			// Results & Values
			RV_TOTAL: 'Gesamt',
			RV_POTENTIAL_VALUE: 'Potenzieller Wert',
			RV_PM_SCHEDULING: 'PM-Planung',
			RV_CM_REDUCTION: 'CM-Reduktion',
			RV_FAILURE_REDUCTION: 'Ausfall- / Störungsreduktion',
			RV_BY_REC_TYPE: 'Nach Empfehlungstyp',
			RV_TOTAL_ACTIVITIES: 'Gesamte geprüfte Aktivitäten',
			RV_INCREASES: 'Erhöhungen',
			RV_DECREASES: 'Senkungen',
			RV_NO_CHANGES: 'Keine Änderungen',
			RV_REMOVE: 'Entfernen',
			RV_ADD: 'Hinzufügen',
			RV_WHERE_VALUE: 'Wo der Wert liegt',
			RV_BY_STATUS: 'Nach Status',
			RV_TOTAL_SCHEDULES: 'Gesamte Pläne',
			RV_PENDING: 'Ausstehend',
			RV_APPROVED: 'Genehmigt',
			RV_REJECTED: 'Abgelehnt',
			RV_SEARCH_PLACEHOLDER: 'Suchen...',
			RV_GROUP_BY_SYSTEM: 'Gruppieren nach: System',
			RV_FILTER: 'Filter',
			RV_COL_FREQ_REC: 'Häufigkeitsempfehlung',
			RV_COL_HIERARCHY: 'Hierarchie / PM-Namen',
			RV_COL_REC_INTERVAL: 'Empfohlenes Intervall (Tage)',
			RV_COL_SAVINGS: 'Gesamteinsparungen ($/Jahr)',
			RV_COL_PM: 'PM ($/Jahr)',
			RV_COL_CM: 'CM ($/Jahr)',
			RV_COL_FAILURE_RISK: 'Ausfallrisiko ($/Jahr)',
			RV_COL_APPROVE: 'Genehmigen / Ablehnen',
			RV_COL_PM_ID: 'PM ID',
			RV_COL_ACTIVITY: 'Aktivität',
			RV_COL_ROLE: 'Rolle',
			RV_COL_STANDALONE: 'Eigenständig',
			RV_COL_EFFECTIVE: 'Effektiv',
			RV_COL_EVIDENCE: 'Nachweis',
			RV_COL_VALUE: 'Wert',
			RV_COL_STATUS: 'Status',
			RV_BH_CURRENT: 'Aktuell',
			RV_BH_EFFECTIVE: 'Effektiv',
			RV_BH_OUTCOME: 'Ergebnis',
			RV_BH_DRIVER: 'Treiber',
			RV_BH_VALUE: 'Wert',
			RV_BH_CONFIDENCE: 'Konfidenz',
			RV_BH_STATUS: 'Status',
			RV_BH_ACTIVITIES: 'Aktivitäten',
			RV_BH_DRIVERS: 'Treiber',
			RV_BH_OVERRIDES: 'Überschreibungen',
			RV_BH_UNCHANGED: 'unverändert',
			RV_BH_NONE: 'Keine',
			RV_BH_NO_CHANGE: 'Keine Änderung',
			RV_BH_NA: 'n/a',
			RV_DEEP_DIVE: 'Detailanalyse',
			RV_BUNDLE_SUMMARY: 'Bündelzusammenfassung',
			RV_LAST_RUN: 'Letzter Lauf',
			RV_NO_RESULTS: 'Keine Optimierungsergebnisse für diese Auswahl.',
			RV_SELECT_NODE: 'Wählen Sie eine Anlage, Einheit oder ein System, um Ergebnisse anzuzeigen.',
			RV_LOADING: 'Ergebnisse werden geladen...',

			// MC Recommendation panel
			MC_PANEL_TITLE: 'Detailpanel — Empfehlung',
			MC_ASK_ROOTY: 'Rooty fragen',
			MC_APPROVE: 'Genehmigen',
			MC_REJECT: 'Ablehnen',
			MC_CURRENT_FREQ: 'Aktuelle Häufigkeit',
			MC_REC_FREQ: 'Empfohlene Häufigkeit',
			MC_SHOW: 'Anzeigen',
			MC_COMPACT: 'Kompakt',
			MC_ADVANCED: 'Erweitert',
			MC_TAB_DECISION: 'Entscheidung',
			MC_TAB_OBSERVATIONS: 'Beobachtungen',
			MC_TAB_FAILURE_MODES: 'Fehlermodi',
			MC_DECISION_TITLE: 'Entscheidung',
			MC_WHY_NOW: 'WARUM JETZT',
			MC_EXPECTED_VALUE: 'ERWARTETER WERT',
			MC_SECONDARY_ACTION: 'SEKUNDÄRE AKTION',
			MC_REC_CONFIDENCE: 'Empfehlungsvertrauen',
			MC_SAVINGS_BREAKDOWN: 'Einsparungsaufschlüsselung',
			MC_TOTAL_ANNUAL_SAVINGS: 'Gesamte jährliche Einsparungen',
			MC_PREDICTIONS: 'Prognosen',
			MC_EXPECTED_OUTCOME: 'Erwartetes Ergebnis bei Annahme der Empfehlung',
			MC_INTERVAL_SENSITIVITY: 'Intervallsensitivität (β / η)',
			MC_ANNUAL_CM_COUNT: 'Jährliche CM-Anzahl',
			MC_CURRENT_CM_COUNT: 'Aktuelle CM-Anzahl:',
			MC_PREDICTED_CM_COUNT: 'Vorhergesagte neue CM-Anzahl:',
			MC_ANNUAL_BD_COUNT: 'Jährliche Störungsanzahl',
			MC_CURRENT_BD_COUNT: 'Aktuelle Störungsanzahl:',
			MC_PREDICTED_BD_COUNT: 'Vorhergesagte neue Störungsanzahl:',
			MC_PM_FREQUENCY: 'PM-Häufigkeit',
			MC_CURRENT: 'Aktuell:',
			MC_RECOMMENDED: 'Empfohlen:',
			MC_FM_LINK: 'Fehlermodi-Registerkarte',
			MC_OBS_REACTIVE_VS_PREVENTIVE: 'Verhältnis reaktive zu präventive Kosten',
			MC_OBS_CM_TIMING: 'CM-Ereignis-Zeitanalyse',
			MC_OBS_EARLY: 'Früh',
			MC_OBS_MID: 'Mitte',
			MC_OBS_LATE: 'Spät',
			MC_OBS_POST_PM: 'Post-PM-Wiederholung',
			MC_OBS_EVIDENCE_LOG: 'Vollständiges Beweisprotokoll öffnen →',
			MC_FM_SERVED_BY: 'von diesem PM bedient',
			MC_FM_SORT: 'Sortieren',
			MC_FM_BY_ROLE: 'Nach Rolle',
			MC_FM_EXPAND_ALL: 'Alle erweitern',
			MC_FM_PRIMARY: 'Primär',
			MC_FM_SUPPORTING: 'Unterstützend',
			MC_FM_INCIDENTAL: 'Beiläufig',
			MC_FM_AGG_B: 'Aggregat B',
			MC_FM_CM_COUNT: 'CM-Anzahl /Jahr',
			MC_FM_BREAKDOWNS: 'Störungen / Jahr',
			MC_FM_DIAGNOSIS: 'Diagnose',
			MC_FM_TIMING: 'Zeitplanung',
			MC_FM_SENSITIVITY: 'Sensitivität (β)',
			MC_FM_IMPACT: 'Auswirkung',
			MC_FM_EVENTS: 'Ereignisse',
			MC_FM_DATE_COL: 'Datum',
			MC_FM_EVENT_COL: 'Ereignis',
			MC_FM_COST_COL: 'Kosten',
			MC_FM_CLASS_COL: 'Klasse',
			MC_TAG_INCREASE_FREQ: 'Frequenz erhöhen',
			MC_TAG_TIMING: 'zeitgesteuert',
			MC_TAG_CASE2: 'Fall 2',
			MC_TAG_CBM: '+ CBM-Sicherheitsnetz',
			MCB_OPEN_EVIDENCE_LOG: 'Nachweisprotokoll öffnen',
			MCB_DECISION_STANDALONE: 'Eigenständige Empfehlung',
			MCB_DECISION_EFFECTIVE: 'Effektive Bündelempfehlung',
			MCB_EFFECTIVE_IS_STANDALONE: 'Das eigenständige Ergebnis ist auch das effektive Ergebnis',
			MCB_EXPECTED_IMPACT: 'Erwartete Auswirkung',
			MCB_EFFECTIVE_BUNDLE_RESULT: 'Effektives Bündelergebnis',
			MCB_PM_COST: 'PM-Kosten',
			MCB_PM_COST_SUB: 'Zusätzliche jährliche PM-Ausgaben',
			MCB_CM_SAVINGS: 'CM-Einsparungen',
			MCB_CM_SAVINGS_SUB: 'Erwartete jährliche Reduzierung',
			MCB_BD_SAVINGS: 'Ausfall-Einsparungen',
			MCB_BD_SAVINGS_SUB: 'Erwartete jährliche Reduzierung',
			MCB_NET_VALUE: 'Jährlicher Nettowert',
			MCB_NET_VALUE_SUB: 'Nach Bündelweitergabe',
			MCB_CONFIDENCE: 'Konfidenz',
			MCB_DRIVER_BASED: 'Treiberbasiert',
			MCB_WHY: 'Begründung dieser Empfehlung',
			MCB_ADVANCED_PENDING: 'Erweiterte Details folgen in Kürze.',
			MCB_OBS_WHAT: 'Was die Engine beobachtet hat',
			MCB_OBS_ECONOMIC: 'Wirtschaftliche Prüfung',
			MCB_OBS_TIMING: 'Zeitliche Verteilung',
			MCB_OBS_POSTPM: 'Wiederauftreten nach PM',
			MCB_TIMING_DISTRIBUTION: 'Zeitliche Verteilung',
			MCB_EARLY: 'Früh',
			MCB_MIDDLE: 'Mitte',
			MCB_LATE: 'Spät',
			MCB_FM_BUILDUP: 'Fehlermodus-Aufbau',
			MCB_FM_BUILDUP_SUB: 'Kompakt zeigt die Schlussfolgerung. Erweitert zeigt Diagnose, Vorhersage, Konfidenz und Nachweisverlauf für jeden FM.',
			MCB_DETAILS: 'Details',
			MCB_FM_DIAGNOSIS: 'Diagnose',
			MCB_FM_EVIDENCE: 'Nachweis',
			MCB_FM_TIMING: 'Zeitpunkt',
			MCB_FM_CONTRIBUTION: 'Beitrag',
			MCB_FM_STANDALONE: 'Eigenständig',
			MCB_FM_EFFECTIVE: 'Effektiv',
			MCB_FM_ROUTE: 'Route',
			MCB_FM_INTERVAL_CONTRIB: 'Intervallbeitrag',
			MCB_FM_VALUE: 'Wert',
			MCB_FM_STATUS: 'Status',
			MCB_FM_ADMIN_INTERPRETATION: 'Admin-Interpretation',
			MCB_FM_INTERVAL_DRIVER: 'Intervalltreiber',
			MCB_FM_OVERRIDDEN: 'Überschriebener FM',
			MCB_FM_NON_INTERVAL: 'Nicht-Intervall',
			MCB_STANDALONE_NOT_REALIZED: 'Die eigenständige {{code}}-Einsparung wird nicht realisiert und darf nicht zu Anlagen- oder Portfoliosummen addiert werden.',
			MCB_CONF_DATA_SUFFICIENCY: 'Datenausreichung',
			MCB_CONF_TIMING_QUALITY: 'Zeitqualität',
			MCB_CONF_MAPPING_QUALITY: 'Zuordnungsqualität',
			MCB_CONF_PRIOR_CONFIRMATION: 'Prior-Bestätigung',
			MCB_OBS_ACTIONABILITY: 'Umsetzbarkeit',
			MCB_OBS_CONDITION_MODIFIER: 'Zustandsmodifikator',
			MCB_OBS_DATA_GATE: 'Datentor',
			MCB_PRED_DETAILS: 'Vorhersagedetails',
			MCB_PRED_B_BASE: 'B-Basis',
			MCB_PRED_ASSET_MODIFIER: 'Asset-Modifikator',
			MCB_PRED_B_OPTIMIZATION: 'B-Optimierung',
			MCB_PRED_CM: 'CM-Vorhersage',
			MCB_PRED_BD: 'BD-Vorhersage',
			MCB_D_SEC_A: 'A. Datentor & Klassifizierung',
			MCB_D_SEC_B: 'B. Zeitmuster',
			MCB_D_SEC_C: 'C. Belastung, Zustand & Umsetzbarkeit',
			MCB_D_SEC_D: 'D. Wirtschaftliche Prüfung & Diagnose',
			MCB_D_SEC_E: 'E. B-Aufbau',
			MCB_D_SEC_F: 'F. Vorhersage & Wert',
			MCB_D_SEC_G: 'G. Ereignisnachweis',
			MCB_D_ROUTE: 'Route',
			MCB_D_PM_CYCLES: 'PM-Zyklen',
			MCB_D_QUALIFYING_EVENTS: 'Qualifizierende Ereignisse',
			MCB_D_MAPPING_CONFIDENCE: 'Zuordnungskonfidenz',
			MCB_D_MEAN_MX: 'Mittelwert Mx',
			MCB_D_SPREAD: 'Streuung Σx',
			MCB_D_EML: 'E/M/L',
			MCB_D_POSTPM: 'PostPM',
			MCB_D_RWCM_RAW: 'RWCM roh',
			MCB_D_EFF_CM_BURDEN: 'Effektive CM-Belastung',
			MCB_D_HM: 'Hm',
			MCB_D_GM: 'Gm',
			MCB_D_PM_BURDEN: 'PM-Belastung',
			MCB_D_CM_BD_BURDEN: 'CM + BD Belastung',
			MCB_D_RA_COST: 'Ra-Kosten',
			MCB_D_DIAGNOSIS: 'Diagnose',
			MCB_D_B_BASE: 'B-Basis',
			MCB_D_DIRECTION: 'Richtung',
			MCB_D_CONCENTRATION: 'Konzentration',
			MCB_D_B_OPT: 'B-Opt',
			MCB_D_INTERVAL: 'Intervall',
			MCB_D_CM_PREDICTION: 'CM-Vorhersage',
			MCB_D_STANDALONE_NET: 'Eigenständiger Netto',
			MCB_D_EFF_BUNDLE_NET: 'Effektiver Bündel-Netto',
			MCB_D_COL_EVENT: 'Ereignis',
			MCB_D_COL_DATE: 'Datum',
			MCB_D_COL_CLASS: 'Klasse',
			MCB_D_COL_BD: 'BD',
			MCB_D_COL_XE: 'x<sub>e</sub>',
			MCB_D_COL_COST: 'Kosten',

			// Run Configuration Dialog
			RC_TITLE: 'Ausführungskonfiguration',
			RC_TAB_SCOPE: 'Umfang',
			RC_TAB_CONFIGURE: 'Konfigurieren',
			RC_TAB_IMPORT: 'Daten importieren',
			RC_TAB_DATA_QC: 'Daten-QC',
			RC_TAB_MAPPING: 'Zuordnung',
			RC_SAVE: 'Speichern',
			RC_CANCEL: 'Abbrechen',
			RC_PREVIOUS: 'Zurück',
			RC_NEXT: 'Weiter',
			RC_RUN: 'Ausführen',
			RC_CONFIGURE_TITLE: 'Analyse konfigurieren',
			RC_CONFIGURE_DESC: 'Analyseprofil, Schwellenwerte und Abstimmungsparameter festlegen. Die meisten Benutzer sollten ein Profil auswählen und nur die Hauptparameter anpassen. Erweiterte Parameter steuern das interne Algorithmusverhalten.',
			RC_ASSET_CLASS_TITLE: 'Asset-Klassen-Überschreibungen',
			RC_ASSET_CLASS_DESC: 'Klassen-spezifische A/B/C-Eingaben für Risikobestandsparameter',
			RC_ANALYSIS_WINDOW_TITLE: 'Analysefenster',
			RC_ANALYSIS_WINDOW_DESC: 'Definieren Sie den Zeitraum für die CMMS-Datenanalyse',
			RC_DURATION: 'Dauer',
			RC_INITIAL_DATE: 'Startdatum',
			RC_END_DATE: 'Enddatum',
			RC_ANALYSIS_PERIOD_PREFIX: 'Analysezeitraum:',
			RC_MONTHS: 'Monate',
			RC_SAP_NOTIFICATIONS: 'SAP-Benachrichtigungen:',
			RC_FETCHING: 'Wird abgerufen...',
			RC_RECORDS: 'Datensätze',
			RC_ANALYSIS_PROFILE_TITLE: 'Analyseprofil',
			RC_ANALYSIS_PROFILE_DESC: 'Setzt alle Parameter auf vorkalibrierten Standardwerten. Sie können einzelne Werte unten überschreiben.',
			RC_DATA_SUFFICIENCY_TITLE: 'Anforderungen an die Datenzulänglichkeit',
			RC_DATA_SUFFICIENCY_DESC: 'Wie viele Belege werden benötigt, bevor der Algorithmus handelt',
			RC_MIN_PM_CYCLES: 'Minimale PM-Zyklen',
			RC_MIN_FM_EVENTS: 'Minimale FM-Ereignisse',
			RC_RECENCY_HALF_LIFE: 'Aktualitäts-Halbwertszeit (h)',
			RC_POST_PM_WINDOW: 'Post-PM-Fenster (d)',
			RC_CYCLES: 'Zyklen',
			RC_RESET_TO_BASE: 'Auf Basis zurücksetzen',
			RC_PM_CM_RATIO_TITLE: 'PM/CM-Verhältnisschwellenwerte (Ra)',
			RC_PM_CM_RATIO_DESC: 'Wann sind die PM-Ausgaben zu hoch oder zu niedrig im Verhältnis zur Fehlerlast? Beide Verhältnisse werden immer berechnet und gemeldet.',
			RC_PRIMARY_RATIO_LABEL: 'Primäres Verhältnis für die Diagnoselogik',
			RC_OVER_MAINTAINED: 'Übermäßig gewartet (Fall 1)',
			RC_UNDER_MAINTAINED: 'Unzureichend gewartet (Fall 2)',
			RC_INTERVAL_ADJ_TITLE: 'Intervalleinstellungslimits',
			RC_INTERVAL_ADJ_DESC: 'Maximale Intervallveränderung pro Empfehlungszyklus. Separate Limits für Verlängerung und Verkürzung.',
			RC_INTERVAL_ROUNDING: 'Intervallrundung',
			RC_ROUND_TO: 'Runden auf',
			RC_DIRECTION: 'Richtung',
			RC_ADJ_MODE: 'Einstellungsmodus: Prozentsatz',
			RC_ADVANCED_PARAMS_TITLE: 'Erweiterte Parameter',
			RC_ADVANCED_PARAMS_DESC: 'Interne Algorithmusabstimmung — Zeitanalyse, Routing, Sensitivität, Vertauensebenen',
			RC_ADVANCED_WARNING: 'Diese Parameter steuern die interne Signalverarbeitung. Änderungen ohne Verständnis der Formeln können zu irreführenden Ergebnissen führen. Der Profilselektor oben legt für jeden sinnvolle Standardwerte fest. Nur überschreiben, wenn Sie einen bestimmten Grund haben.',
			RC_PARAM_COL_PARAM: 'Parameter',
			RC_PARAM_COL_DESC: 'Beschreibung',
			RC_PARAM_COL_EFFECT: 'AUSWIRKUNG',
			RC_PARAM_COL_VALUE: 'Wert',
			RC_GOAL_SEEKER_TITLE: 'Zielsuche-Modus',
			RC_GOAL_SEEKER_DESC: 'Optimieren, um ein bestimmtes Budgetreduktionsziel zu erreichen',
			RC_GOAL_SEEKER_CURRENT: 'Aktuell',
			RC_GOAL_SEEKER_TARGET: 'Zielreduktion:',
			RC_CONSTRAINTS: 'Einschränkungen',
			RC_EXCLUDE_CRITICALITY: 'Asset-Kritikalitäten ausschließen',
			RC_EXCLUDE_EQ_TYPES: 'Gerätetypen ausschließen',
			RC_SCOPE_TITLE: 'Umfang',
			RC_SCOPE_DESC: 'Definieren Sie den Umfang des Optimierungslaufs.',
			RC_IMPORT_TITLE: 'Daten importieren',
			RC_IMPORT_DESC: 'SAP-Benachrichtigungen für das ausgewählte System im konfigurierten Analysezeitraum.',
			RC_PM_EVENTS: 'PM-Ereignisse',
			RC_CM_EVENTS: 'CM-Ereignisse',
			RC_FAILURE_EVENTS: 'Ausfallereignisse',
			RC_NO_RECORDS: 'Keine Datensätze für diesen Ereignistyp im ausgewählten Fenster gefunden',
			RC_COL_NOTIFICATION: 'Benachrichtigung',
			RC_COL_EQUIPMENT: 'Gerät',
			RC_COL_DESCRIPTION: 'Beschreibung',
			RC_COL_TYPE: 'Typ',
			RC_COL_CREATED_ON: 'Erstellt am',
			RC_COL_COMPLETED_ON: 'Abgeschlossen am',
			RC_COL_PLAN_GROUP: 'Plangruppe',
			RC_DATA_QC_TITLE: 'Daten-QC',
			RC_DATA_QC_DESC: 'Datenqualitätsprüfungen überprüfen.',
			RC_MAPPING_TITLE: 'Zuordnung',
			RC_MAPPING_DESC: 'CM-FM-Zuordnung konfigurieren.',
			RC_MAPPING_GROUP_BY: 'Gruppieren nach',
			RC_MAPPING_GROUP_FM: 'Fehlerart',
			RC_MAPPING_GROUP_PREVENTABILITY: 'Vermeidbarkeit',
			RC_MAPPING_SEARCH_PLACEHOLDER: 'Meldung, Auftrag, Anlage, Beschreibung suchen',
			RC_MAPPING_LOW_CONFIDENCE: 'Geringe Konfidenz',
			RC_MAPPING_EDITED: 'Bearbeitet',
			RC_MAPPING_REGENERATE: 'Neu generieren',
			RC_MAPPING_DOWNLOAD: 'Herunterladen',
			RC_MAPPING_UPLOAD: 'Hochladen',
			RC_MAPPING_RESET_ALL: 'Alles zurücksetzen',
			RC_MAPPING_COL_ORDER: 'Auftrag #',
			RC_MAPPING_COL_EQUIPMENT_ID: 'Anlagen-ID',
			RC_MAPPING_COL_WO_DESC: 'Auftragsbeschreibung',
			RC_MAPPING_COL_WO_TYPE: 'Auftragstyp',
			RC_MAPPING_COL_MAPPED_FM: 'Zugeordnete Fehlerart',
			RC_MAPPING_COL_PREVENTABILITY: 'Vermeidbarkeit',
			RC_MAPPING_EVENT: 'Ereignis',
			RC_MAPPING_EVENTS: 'Ereignisse',
			RC_MAPPING_AVG_FM_CONF: 'Ø FM-Konfidenz',
			RC_MAPPING_AVG_PREV_CONF: 'Ø Vermeidb.-Konfidenz',
			RC_MAPPING_NO_RECORDS: 'Keine CM/BD-Meldungen für die Zuordnung verfügbar',
			RC_MAPPING_NO_FILTERED_RESULTS: 'Keine Zuordnungen entsprechen den aktuellen Filtern',
			RC_MAPPING_GENERATING: 'CM/Ausfallereignisse werden Fehlerarten zugeordnet...',
			RC_MAPPING_GENERATION_ERROR: 'Die CM/BD-zu-Fehlerart-Zuordnung konnte nicht generiert werden.',
			RC_MAPPING_UNMAPPED: 'Nicht zugeordnet',
			RC_MAPPING_SYMPTOM_ONLY: 'Nur Symptom',
			RC_MAPPING_SYMPTOM_ONLY_TOOLTIP: 'Konnte keiner Grundursachen-Fehlerart zugeordnet werden — von der Optimierungsberechnung ausgeschlossen.',
			RC_MAPPING_UNMAPPED_CONF_TOOLTIP: 'Konfidenz in die Feststellung "keine Übereinstimmung" selbst, nicht in eine bestimmte Fehlerart.',
			RC_MAPPING_NO_RATIONALE: 'Keine Begründung angegeben.',
			RC_MAPPING_DETAIL_IDENTITY_SOURCE: 'Identität & Quelle',
			RC_MAPPING_DETAIL_WO_CONTENT: 'Auftragsinhalt',
			RC_MAPPING_DETAIL_DURATION: 'Dauer',
			RC_MAPPING_DETAIL_FM_MAPPING: 'FM-Zuordnung',
			RC_MAPPING_DETAIL_PREVENTABILITY: 'Vermeidbarkeit',
			RC_MAPPING_DETAIL_AUDIT: 'Prüfprotokoll',
			RC_MAPPING_DETAIL_EVENT_CLASS: 'Auftragsart / Ereignisklasse',
			RC_MAPPING_DETAIL_SCHED_START: 'Geplanter Beginn',
			RC_MAPPING_DETAIL_SCHED_FINISH: 'Geplantes Ende',
			RC_MAPPING_DETAIL_ACTIVITY_CODE: 'Tätigkeitscode',
			RC_MAPPING_DETAIL_DAMAGE_CODE: 'Schadenscode',
			RC_MAPPING_DETAIL_CAUSE_CODE: 'Ursachencode',
			RC_MAPPING_DETAIL_MATERIAL_COST: 'Materialkosten',
			RC_MAPPING_DETAIL_PERMIT_ISSUED: 'Erlaubnisschein ausgestellt',
			RC_MAPPING_DETAIL_PERMIT_CLOSED: 'Erlaubnisschein geschlossen',
			RC_MAPPING_DETAIL_CM_DURATION: 'CM-Dauer (h)',
			RC_MAPPING_DETAIL_DURATION_SOURCE: 'Dauerquelle',
			RC_MAPPING_DETAIL_FM_ID_NAME: 'FM-ID / Name',
			RC_MAPPING_DETAIL_FM_TYPE: 'FM-Typ',
			RC_MAPPING_DETAIL_FAILURE_MODE_TYPE: 'Fehlerart-Typ',
			RC_MAPPING_DETAIL_CONFIDENCE: 'Konfidenz',
			RC_MAPPING_DETAIL_SOURCE: 'Quelle',
			RC_MAPPING_DETAIL_RE_ATTRIBUTED_FROM: 'Neu zugeordnet von',
			RC_MAPPING_DETAIL_SYMPTOM_ONLY: 'Nur Symptom',
			RC_MAPPING_DETAIL_RATIONALE: 'Begründung',
			RC_MAPPING_DETAIL_CLASS: 'Klasse',
			RC_MAPPING_DETAIL_KEY_SIGNALS: 'Schlüsselsignale',
			RC_MAPPING_DETAIL_EDITED_BY: 'Bearbeitet von',
			RC_MAPPING_DETAIL_EDITED_AT: 'Bearbeitet am',
			RC_MAPPING_DETAIL_FM_AGENT_RUN: 'FM-Agentenlauf',
			RC_MAPPING_DETAIL_PREVENTABILITY_AGENT_RUN: 'Vermeidbarkeits-Agentenlauf',
			RC_MAPPING_DETAIL_EXISTING: 'Vorhanden',
			RC_MAPPING_DETAIL_NOT_AVAILABLE: 'Nicht verfügbar',
			RC_MAPPING_REGEN_CONFIRM_TITLE: 'Zuordnung neu generieren?',
			RC_MAPPING_REGEN_CONFIRM_MESSAGE: '{{count}} manuell bearbeitete Zeile(n) werden neu generiert, wobei Ihre Korrekturen als Orientierung für den neuen Lauf dienen.',

			// Select option labels
			OPT_6_MONTHS: '6 Monate',
			OPT_12_MONTHS: '12 Monate',
			OPT_15_MONTHS: '15 Monate',
			OPT_24_MONTHS: '24 Monate',
			OPT_36_MONTHS: '36 Monate',
			OPT_1_CYCLE: '1 Zyklus (Aggressiv)',
			OPT_2_CYCLES: '2 Zyklen (Basis)',
			OPT_3_CYCLES: '3 Zyklen (Konservativ)',
			OPT_WEEKLY: 'Wöchentlich (7 Tage)',
			OPT_BIWEEKLY: 'Zweiwöchentlich (14 Tage)',
			OPT_MONTHLY: 'Monatlich (30 Tage)',
			OPT_NEAREST: 'Nächste',
			OPT_UP: 'Auf',
			OPT_DOWN: 'Ab',
			OPT_CRIT_A: 'A (Kritisch)',
			OPT_CRIT_B: 'B (Wichtig)',
			OPT_CRIT_C: 'C (Standard)',
			OPT_CRIT_D: 'D (Niedrig)',
			OPT_PROFILE_BASE_NAME: 'Basis',
			OPT_PROFILE_BASE_SUBTITLE: 'Ausgewogen, Standard',
			OPT_PROFILE_CONSERVATIVE_NAME: 'Konservativ',
			OPT_PROFILE_CONSERVATIVE_SUBTITLE: 'Weniger Empfehlungen, höheres Vertrauen',
			OPT_PROFILE_AGGRESSIVE_NAME: 'Aggressiv',
			OPT_PROFILE_AGGRESSIVE_SUBTITLE: 'Mehr Empfehlungen, höhere potenzielle Einsparungen',
			OPT_PCT_SHORTER_10: '10% kürzer',
			OPT_PCT_SHORTER_20: '20% kürzer',
			OPT_PCT_SHORTER_25: '25% kürzer',
			OPT_PCT_SHORTER_50: '50% kürzer',
			OPT_PCT_LONGER_10: '10% länger',
			OPT_PCT_LONGER_20: '20% länger',
			OPT_PCT_LONGER_25: '25% länger',
			OPT_PCT_LONGER_50: '50% länger'
		},
		USER_MANAGEMENT: {
			FORM_ERROR: 'Ups! Bitte einige Felder anpassen und erneut versuchen.',
			CANCEL: 'Abbrechen',
			SAVE: 'Speichern',
			CANCEL_CHANGES: 'Änderungen abbrechen',
			SAVE_CHANGES: 'Änderungen speichern',
			NO_RECORDS: 'Keine Einträge gefunden',
			PLEASE_WAIT: 'Bitte warten....',
			SEARCH: 'Suchen',
			ACTIONS: 'Aktionen',
			NAME: 'Name',
			EMAIL: 'E-Mail',
			PHONE: 'Telefon',
			FACILITY: 'Anlage',
			UNITS: 'Einheiten',
			SYSTEMS: 'Systeme',
			SYSTEM: 'System',
			UNIT: 'Einheit',
			USER: 'Benutzer',
			SELECT_FACILITY: 'Anlage auswählen',
			SELECT_FACILITIES: 'Anlagen auswählen',
			SELECT_UNITS: 'Einheiten auswählen',
			SELECT_SYSTEMS: 'Systeme auswählen',
			SELECT_SYSTEM: 'System auswählen',
			SELECT_UNIT: 'Einheit auswählen',
			SELECT_USER: 'Benutzer auswählen',
			SEARCH_UNIT: 'Einheit suchen...',
			NO_MATCHING_UNIT: 'Keine passende Einheit gefunden',
			SEARCH_SYSTEM: 'System suchen...',
			NO_MATCHING_SYSTEM: 'Kein passendes System gefunden',
			ROLES: {
				LIST_TITLE: 'Rollenliste',
				NEW_ROLE: 'Neue Rolle',
				CREATE_ROLE_TOOLTIP: 'Neue Rolle erstellen',
				SEARCH_USER: 'Benutzer suchen',
				FETCH_SELECTED: 'Ausgewählte abrufen',
				FETCH_SELECTED_TOOLTIP: 'Ausgewählte Rollen abrufen',
				COL_TITLE: 'Titel',
				VIEW_ROLE: 'Anzeigen',
				EDIT_ROLE: 'Bearbeiten',
				ROLE_SUFFIX: 'Rolle',
				DELETE_ROLE: 'Rolle löschen',
				PERMISSIONS_HEADING: 'Berechtigungen:',
				ENTER_TITLE: 'Titel eingeben',
				TITLE_REQUIRED: 'Titel ist',
				TITLE_REQUIRED_STRONG: 'erforderlich',
				TITLE_HINT: 'Bitte eingeben',
				TITLE_HINT_STRONG: 'Titel',
			},
			USERS: {
				TAB_USERS: 'Benutzer',
				TAB_USER_GROUPS: 'Benutzergruppen',
				USER_LIST: 'Benutzerliste',
				FILTERED_USER_LIST: 'Gefilterte Benutzerliste',
				SHOW_DEACTIVATED: 'Deaktivierte anzeigen',
				DOWNLOAD_TOOLTIP: 'Benutzerliste herunterladen',
				DOWNLOAD: 'Herunterladen',
				NEW_USER: 'Neuer Benutzer',
				NEW_USER_TOOLTIP: 'Neuen Benutzer erstellen',
				UPLOAD_USER: 'Benutzer hochladen',
				UPLOAD_USER_TOOLTIP: 'Mehrere Benutzer erstellen',
				SEARCH_USER: 'Benutzer suchen',
				COL_SL_NO: 'Lfd. Nr.',
				COL_USERNAME: 'Benutzername',
				COL_EMAIL: 'E-Mail',
				COL_NAME: 'Name',
				COL_ROLES: 'Rollen',
				COL_ADMIN: 'Admin',
				COL_ENTERPRISE_ADMIN: 'Unternehmensadmin',
				COL_PHONE: 'Telefon',
				COL_LAST_ACTIVE: 'Zuletzt aktiv',
				COL_STATUS: 'Status',
				STATUS_ACTIVE: 'Aktiv',
				STATUS_DEACTIVATED: 'Deaktiviert',
				EDIT_USER: 'Benutzer bearbeiten',
				DELETE_USER: 'Benutzer löschen',
			},
			USER_GROUPS: {
				TITLE: 'Benutzergruppen',
				ADD_TOOLTIP: 'Benutzergruppe hinzufügen',
				NEW_GROUP: 'Neue Benutzergruppe',
				COL_SL_NO: 'Lfd. Nr.',
				EDIT_TOOLTIP: 'Benutzer bearbeiten',
				DELETE_TOOLTIP: 'Benutzer löschen',
				NAME_REQUIRED: 'Name ist',
				NAME_REQUIRED_STRONG: 'erforderlich',
				NAME_HINT: 'Bitte eingeben',
				NAME_HINT_STRONG: 'Name',
				NO_USER_GROUPS: 'Noch keine Benutzergruppen erstellt',
				CREATE_GROUP_GET_STARTED: 'Erstellen Sie eine neue Benutzergruppe, um loszulegen',
			},
			USER_EDIT: {
				USER_INFO_HEADING: 'Benutzerinformationen',
				SYSTEM_ACCESS_HEADING: 'Systemzugriff',
				FACILITY_ADMIN_HEADING: 'Anlagen-Admin-Zugriff',
				MODULE_ACCESS_HEADING: 'Modulzugriff',
				EMAIL_LABEL: 'E-Mail',
				EMAIL_HINT: 'E-Mail eingeben',
				PASSWORD_LABEL: 'Passwort',
				PASSWORD_HINT: '(Min. 8 Zeichen, mind. ein Sonderzeichen, ein Großbuchstabe & eine Zahl)',
				PASSWORD_REQUIRED: 'Passwort ist',
				PASSWORD_REQUIRED_STRONG: 'erforderlich',
				NAME_LABEL: 'Name',
				NAME_HINT: 'Name eingeben',
				PHONE_LABEL: 'Telefon',
				PHONE_HINT: 'Telefon eingeben',
				PHONE_REQUIRED: 'Telefonnr. ist',
				PHONE_REQUIRED_STRONG: 'erforderlich',
				ENTERPRISE_ADMIN: 'Unternehmensadmin',
				OPT_WHATSAPP: 'WhatsApp aktivieren',
				INTERNAL: 'Intern',
				MODEL_RETRAINING: 'Modell-Nachtraining',
				FACILITIES_LABEL: 'Anlagen',
				SELECT_ALL: 'Alle auswählen',
				MODULE_LABEL: 'Modul',
				SELECT_MODULES_HINT: 'Module auswählen',
				SEARCH_MODULES: 'Module suchen...',
				NO_MATCHING_MODULE: 'Kein passendes Modul gefunden',
				MODULE_REQUIRED: 'Mindestens ein Modul muss ausgewählt werden.',
				SAVE_TOOLTIP: 'Speichern',
				CANCEL_TOOLTIP: 'Abbrechen',
			},
			UPLOAD_USERS: {
				TITLE: 'Benutzerliste hochladen',
				SELECT_CSV: 'CSV-Datei auswählen',
				CSV_REQUIRED: 'CSV-Datei ist',
				CSV_REQUIRED_STRONG: 'erforderlich',
				SELECT_FILE: 'Datei auswählen',
				DOWNLOAD_FORMAT_TOOLTIP: 'CSV-Format herunterladen',
				SUBMIT: 'Einreichen',
			},
			USER_POPUP: {
				EMAIL_REQUIRED: 'E-Mail ist',
				EMAIL_REQUIRED_STRONG: 'erforderlich',
				EMAIL_HINT: 'Bitte eingeben',
				EMAIL_HINT_STRONG: 'E-Mail',
				PASSWORD_REQUIRED: 'Passwort ist',
				PASSWORD_REQUIRED_STRONG: 'erforderlich',
				PASSWORD_HINT: 'Eingeben',
				PASSWORD_HINT_STRONG: 'Passwort',
				NAME_REQUIRED: 'Name ist',
				NAME_REQUIRED_STRONG: 'erforderlich',
				NAME_HINT: 'Eingeben',
				NAME_HINT_STRONG: 'Name',
				PHONE_REQUIRED: 'Telefonnr. ist',
				PHONE_REQUIRED_STRONG: 'erforderlich',
				PHONE_HINT: 'Bitte eingeben',
				PHONE_HINT_STRONG: 'Telefon',
				FACILITY_HINT: 'Auswählen',
				SYSTEM_HINT: 'Auswählen',
				SYSTEMS_PLACEHOLDER: 'Systeme',
				SYSTEM_HINT_STRONG: 'System',
				FACILITY_HINT_STRONG: 'Anlage',
			},
			CONFIRMATION: {
				REASON_REQUIRED: 'Grund ist erforderlich.',
			},
			USER_ROLES: {
				SELECT_ROLE: 'Rolle auswählen',
				ASSIGN_TOOLTIP: 'Rolle zuweisen',
				ASSIGN: 'Zuweisen',
				ASSIGNED_ROLES: 'Zugewiesene Rollen:',
				REMOVE_TOOLTIP: 'Rolle entfernen',
			},
			ADDRESS: {
				FORM_ERROR: 'Ups! Bitte einige Felder anpassen und erneut versuchen.',
				ADDRESS_LINE: 'Adresszeile eingeben',
				ADDRESS_LINE_REQUIRED: 'Adresszeile ist',
				ADDRESS_LINE_REQUIRED_STRONG: 'erforderlich',
				ADDRESS_LINE_HINT: 'Bitte eingeben',
				ADDRESS_LINE_HINT_STRONG: 'Adresszeile',
				CITY: 'Stadt',
				CITY_REQUIRED: 'Stadt ist',
				CITY_REQUIRED_STRONG: 'erforderlich',
				CITY_HINT: 'Bitte eingeben',
				CITY_HINT_STRONG: 'Stadt',
				STATE: 'Bundesland eingeben',
				STATE_REQUIRED: 'Bundesland ist',
				STATE_REQUIRED_STRONG: 'erforderlich',
				STATE_HINT: 'Bitte eingeben',
				STATE_HINT_STRONG: 'Bundesland',
				POSTCODE: 'Postleitzahl eingeben',
				POSTCODE_REQUIRED: 'Postleitzahl ist',
				POSTCODE_REQUIRED_STRONG: 'erforderlich',
				POSTCODE_HINT: 'Bitte eingeben',
				POSTCODE_HINT_STRONG: 'Postleitzahl',
			},
			SOCIAL: {
				FORM_ERROR: 'Ups! Bitte einige Felder anpassen und erneut versuchen.',
				LINKEDIN: 'LinkedIn-Adresse eingeben',
				LINKEDIN_HINT: 'Bitte eingeben',
				LINKEDIN_HINT_STRONG: 'LinkedIn',
				FACEBOOK: 'Facebook-Adresse eingeben',
				FACEBOOK_HINT: 'Bitte eingeben',
				FACEBOOK_HINT_STRONG: 'Facebook',
				TWITTER: 'Twitter-Adresse eingeben',
				TWITTER_HINT: 'Bitte eingeben',
				TWITTER_HINT_STRONG: 'Twitter',
				INSTAGRAM: 'Instagram-Adresse eingeben',
				INSTAGRAM_HINT: 'Bitte eingeben',
				INSTAGRAM_HINT_STRONG: 'Instagram',
				ADDRESS_SUFFIX: 'Adresse',
			},
			CHANGE_PASSWORD: {
				FORM_ERROR: 'Ups! Passwörter stimmen nicht überein.',
				PASSWORD: 'Passwort eingeben',
				PASSWORD_REQUIRED: 'Passwort ist',
				PASSWORD_REQUIRED_STRONG: 'erforderlich',
				PASSWORD_HINT: 'Bitte eingeben',
				PASSWORD_HINT_STRONG: 'Passwort',
				CONFIRM_PASSWORD: 'Passwort bestätigen',
				CONFIRM_REQUIRED: 'Bestätigung ist',
				CONFIRM_REQUIRED_STRONG: 'erforderlich',
				CONFIRM_HINT: 'Bitte bestätigen',
				CONFIRM_HINT_STRONG: 'Passwort',
				CHANGE_BUTTON: 'Passwort ändern',
				SAVE_CHANGES: 'Änderungen speichern',
			},
		},
		SYSTEM_VIEW: {
			PARTS: 'TEILE',
			ACTIVE: 'AKTIV',
			SYSTEM: 'System',
			SEARCH_SYSTEM: 'System suchen...',
			NO_MATCHING_SYSTEM: 'Kein passendes System gefunden',
			OPEN_ALERTS: 'OFFENE WARNUNGEN',
			ACTIVE_ALERTS: 'AKTIVE WARNUNGEN',
			UNACK_ALERTS: 'UNBEST. WARNUNGEN',
			RELIABILITY: 'ZUVERLÄSSIGKEIT',
			MEAN_TIME_BETWEEN_ALERTS: 'MITTLERE ZEIT ZWISCHEN WARNUNGEN',
			UPTIME: 'VERFÜGBARKEIT',
			DAYS: 'Tage',
			PERFORMANCE_CURVES: 'LEISTUNGSKURVEN',
			OPEN_IN_NEW_TAB: 'In neuem Tab öffnen',
			TAB_ANOMALY: 'Anomalie',
			TAB_SYSTEM_DETAILS: 'Systemdetails',
			TAB_DATA_QUALITY: 'Datenqualität',
			TAB_PERFORMANCE: 'Leistung',
			CLEAR_SIMULATION: 'Simulation löschen',
			SIMULATION: 'Simulation',
			CLICK_TO_START_PREDICTION: 'Klicken, um Prognose zu starten',
			PREDICTION_RUNNING: 'Prognose läuft',
			NO_OF_DAYS: 'Anzahl der Tage',
			OK: 'Ok',
			RESET: 'Zurücksetzen',
			RETRAINING: 'Nachtraining',
			MORE: 'Mehr',
			TAGS: 'Tags',
			SEARCH_TAG: 'Tag suchen...',
			NO_MATCHING_TAG: 'Kein passender Tag gefunden',
			ASSET_LABEL: 'Asset:',
			NAME_LABEL: 'Name:',
			TAG_ID_LABEL: 'Tag-ID:',
			CANCEL: 'Abbrechen',
			ASSETS: 'ASSETS',
			SEARCH_ASSET: 'Asset suchen...',
			NO_MATCHING_ASSET: 'Kein passendes Asset gefunden',
			RESET_ASSET_SELECTION: 'Asset-Auswahl zurücksetzen',
			DATA_QUALITY: {
				SEARCH_TAG: 'Tag suchen',
				DOWNLOAD_TOOLTIP: 'Datenqualitätsbericht für Tags herunterladen',
				DOWNLOAD: 'Herunterladen',
				COL_TAG_NAME: 'Tag-Name',
				COL_MISSING_DATA: 'Fehlende Daten',
				COL_FLAT_LINE: 'Flache Linie',
				COL_OUTLIER: 'Ausreißer',
				COL_OUT_OF_RANGE: 'Außerhalb des Bereichs',
				COL_TOTAL_INVALID_DATA: 'Gesamt ungültige Daten',
				COL_ACTIONS: 'Aktionen',
				MORE_ACTIONS: 'Weitere Aktionen',
				NO_RECORDS: 'Für den ausgewählten Zeitraum wurden keine Datenqualitätsereignisse gefunden',
				LOADING: 'Wird geladen...',
				SHUTDOWN_TAG: 'Abschalt-Tag',
				TRIP: 'Auslösung',
				TRIP_LIMIT: 'Auslösegrenze',
				ALARM: 'Alarm',
				ALARM_LIMIT: 'Alarmgrenze',
				THRESHOLD: 'Schwellenwert',
				THRESHOLD_LIMIT: 'Schwellenwertgrenze',
				INSTRUMENT: 'Instrument',
				INSTRUMENT_RANGE: 'Instrumentenbereich',
			},
			SYSTEM_DETAILS: {
				NO_IMAGE_FOUND: 'Kein Bild gefunden',
				ASSET_DETAILS: 'Asset-Details',
				CURRENT_ALERTS_EQUIPMENT: 'Aktuelle Warnungen/Gerät',
				EQUIPMENT_DISTRIBUTION: 'Geräteweise Verteilung',
				TOP_FAILURE_MODES: 'Top-Fehlermodi pro Gerät',
				CUSTOM_INPUTS: 'Benutzerdefinierte Eingaben',
				SELECT_TAG: 'Tag auswählen',
				UPDATE: 'Aktualisieren',
				SPECIFY_VALUE: 'Wert angeben',
				TIMESTAMP: 'Zeitstempel',
				LAB_DATA: 'Labordaten',
				NO_DATA_FOUND: 'Keine Daten gefunden',
			},
			ALERT_SETTINGS: {
				TITLE: 'Warnungseinstellungen',
				CANCEL: 'Abbrechen',
				FAILURE_MODE: 'Fehlermodus',
				AGGREGATED_ANOMALY_SCORE: 'Aggregierter Anomalie-Score',
				INSTRUMENT_HEALTH: 'Instrumentengesundheit/Datenqualität',
				FLATLINE: '1: Flachlinie',
				MISSING_DATA: '2: Fehlende Daten',
				OUT_OF_RANGE: '3: Außerhalb des Bereichs',
				OUTLIERS: '4: Ausreißer',
			},
			DIAGNOSTICS: {
				TITLE: 'Systemdiagnostik',
				CANCEL: 'Abbrechen',
				ROOT_CAUSE_ICON_ALT: 'Ursachensymbol',
				NOT_GENERATED_YET: 'Sie haben noch keine Systemdiagnostik erstellt.',
				RUN_TO_PROCEED: 'Bitte führen Sie die Diagnostik durch, um fortzufahren.',
				GENERATION_FAILED: 'Die letzte Systemdiagnostik-Generierung ist fehlgeschlagen.',
				RUN_AGAIN: 'Bitte führen Sie die Diagnostik erneut durch, um fortzufahren.',
				GENERATE_NOW: 'Jetzt generieren',
				REGENERATE: 'Neu generieren',
				FAILED_AT: 'Systemdiagnostik-Generierung fehlgeschlagen am',
				LAST_GENERATED: 'Zuletzt generiert',
				GENERATING: 'Systemdiagnostik wird generiert',
				SEVERITY: 'Schweregrad:',
				ISSUE: 'Problem:',
				IMPACT: 'Auswirkung:',
				ACTION: 'Aktion:',
				PRIORITY: 'Priorität:',
			},
			PERFORMANCE_CURVE: {
				TAG: 'Tag',
				FILTER_TAG_VALUE: 'Tag-Wert filtern',
				SEARCH_TAG: 'Tag suchen...',
				NO_TAG_FOUND: 'Kein Tag gefunden',
				GREATER_THAN: 'Größer als',
				LESS_THAN: 'Kleiner als',
				OK: 'Ok',
				DATE_RANGE: 'Datumsbereich',
				START_DATE: 'Startdatum',
				END_DATE: 'Enddatum',
				SELECT: 'Auswählen',
			},
		},
		PLATFORM_CONFIGURATION: {
			HEADER_TITLE: 'Plattformkonfiguration',
			TABS: {
				ORGANISATION_SETUP: 'Organisationseinrichtung',
				ASSET_REGISTRY: 'Anlagenregister',
				MODULE_HIERARCHY: 'Modulhierarchie',
				PROPERTY_TEMPLATES: 'Eigenschaftsvorlagen',
			},
			COMING_SOON: 'Demnächst verfügbar',
		},
		CUSTOMER_SETUP: {
			TABS: {
				CLIENT_SETUP: 'Organisationsdetails',
				FACILITY_SETUP: 'Anlagen',
				PLANT_ECONOMICS: 'Wirtschaftliche Parameter',
			},
			COMMON: {
				SAVE_CHANGES: 'Änderungen speichern',
				CANCEL: 'Abbrechen',
				CONFIRM: 'Bestätigen',
				EDIT: 'Bearbeiten',
				DELETE: 'Löschen',
				LOADING: 'Laden...',
				SEARCH: 'Suchen...',
				CLOSE: 'Schließen',
				SAVED_SUCCESSFULLY: 'Erfolgreich gespeichert',
				ERROR_SAVING: 'Fehler beim Speichern der Änderungen',
				TIMEZONE: 'Zeitzone',
				LATITUDE: 'Breitengrad',
				LONGITUDE: 'Längengrad',
				SELECT_TIMEZONE: 'Zeitzone auswählen',
			},
			CLIENT: {
				TITLE: 'Organisationsdetails',
				SUBTITLE: 'Organisationsdetails konfigurieren',
				LOGO: 'Logo',
				UPLOAD_LOGO: 'Logo hochladen',
				HQ_ADDRESS: 'Hauptsitz-Adresse',
				ENTERPRISE_NAME: 'Unternehmensname',
				INDUSTRY_SECTOR: 'Industriesektor',
				STREET_ADDRESS: 'Straßenadresse',
				CITY: 'Stadt',
				STATE: 'Bundesland',
				COUNTRY: 'Land',
				ZIP_CODE: 'Postleitzahl',
				ZOOM_LEVEL: 'Zoomstufe',
				BUSINESS: 'Unternehmen',
				NOTES: 'Anmerkungen',
				SELECT_INDUSTRY_SECTOR: 'Industriesektor auswählen',
				PLACEHOLDER_BUSINESS: 'Bitte Unternehmensdetails eingeben',
				PLACEHOLDER_NOTES: 'Bitte Anmerkungen eingeben',
			},
			FACILITY: {
				TITLE: 'Anlagen',
				SUBTITLE: 'Standorte und Parameter der Anlage definieren',
				ADD_FACILITY: 'Anlage hinzufügen',
				GROUP_BY: 'Gruppieren nach',
				COL_NAME: 'Name',
				COL_LOCATION: 'Standort',
				COL_CAPACITY: 'Kapazität (MW)',
				COL_REGION: 'Region',
				COL_INDUSTRY: 'Industrie',
				NO_FACILITIES_SEARCH: 'Keine Anlagen gefunden.',
				TRY_ADJUSTING: 'Versuchen Sie, Ihre Suchanfrage anzupassen.',
				NO_FACILITIES_YET: 'Noch keine Anlagen eingerichtet.',
				CLICK_TO_GET_STARTED: "Klicken Sie auf 'Anlage hinzufügen', um zu beginnen.",
				DELETE_TITLE: 'Anlage löschen',
				DELETE_DESCRIPTION: 'Sind Sie sicher, dass Sie die Anlage "{{name}}" dauerhaft löschen möchten?',
				DELETE_WAIT: 'Anlage wird gelöscht...',
				DELETED_SUCCESS: 'Anlage erfolgreich gelöscht',
				DELETE_ERROR: 'Fehler beim Löschen der Anlage',
			},
			ADD_FACILITY_DIALOG: {
				TITLE_ADD: 'Anlage hinzufügen',
				TITLE_EDIT: 'Anlage bearbeiten',
				UPDATED_SUCCESS: 'Anlage erfolgreich aktualisiert',
				UPDATE_ERROR: 'Fehler beim Aktualisieren der Anlage',
				CREATED_SUCCESS: 'Anlage erfolgreich erstellt',
				CREATE_ERROR: 'Fehler beim Erstellen der Anlage',
				FACILITY_NAME: 'Anlagenname',
				FACILITY_CODE: 'Anlagencode',
				LOCATION: 'Standort',
				REGION: 'Region',
				CURRENCY: 'Währung',
				INSTALLED_CAPACITY: 'Installierte Kapazität (MW)',
				INDUSTRY: 'Industrie',
				GIS_LOCATION: 'GIS-Standort',
				PLACEHOLDER_FACILITY_NAME: 'Anlagenname',
				PLACEHOLDER_LOCATION: 'Stadt, Bundesland',
				SELECT_REGION: 'Region auswählen',
				SELECT_CURRENCY: 'Währung auswählen',
				SELECT_INDUSTRY: 'Industrie auswählen',
			},
			FACILITY_FORM: {
				TAB_FACILITY_INFO: 'Anlageninformationen',
				TAB_HISTORIAN_INFO: 'Historian-Informationen',
				TAB_SAP_INFO: 'SAP-Informationen',
				ENTERPRISE: 'Unternehmen',
				ADDRESS: 'Adresse',
				CITY: 'Stadt',
				STATE: 'Bundesland',
				COUNTRY: 'Land',
				ZIP: 'PLZ',
				ZOOM_LEVEL: 'Zoomstufe',
				APPLICATION: 'Anwendung',
				NOTES: 'Notizen',
				CUSTOMER_ADVOCATE: 'Kundenbetreuer',
				HISTORIAN_TYPE: 'Historian-Typ',
				ACCESS_METHOD: 'Zugriffsmethode',
				ACCESS_URL: 'Zugriffs-URL',
				RESOURCE_URL: 'Ressourcen-URL',
				DATA_FETCH_SETTINGS: 'Datenabruf-Einstellungen',
				FORWARD_AGGREGATE: 'Aggregat weiterleiten',
				FETCH_RATE: 'Abrufrate',
				FETCH_RATE_UNIT: 'Abrufrate-Einheit',
				ENABLE_SAMPLING: 'Sampling aktivieren',
				SAMPLING_RATE: 'Sampling-Rate',
				SAMPLING_RATE_UNIT: 'Sampling-Rate-Einheit',
				PREDICTION_SETTINGS: 'Prognose-Einstellungen',
				PREDICTION_RATE: 'Prognoserate',
				PREDICTION_RATE_UNIT: 'Prognoserate-Einheit',
				DQ_ALERTS: 'Datenqualitätswarnungen',
				START_DELAY: 'Startverzögerung (in Std.)',
				END_DELAY: 'Endverzögerung (in Std.)',
				FUNCTIONAL_LOC_MAPPING: 'Funktionsort/Ausrüstungs-ID-Zuordnung',
				UPLOAD_FUNCTIONAL_LOC: 'Funktionsort/Ausrüstungs-ID-Daten hochladen',
				DOWNLOAD_FUNCTIONAL_LOC: 'Funktionsort/Ausrüstungs-ID-Zuordnung herunterladen',
				SAP_DATA: 'SAP-Daten',
				UPLOAD_SAP_DATA: 'SAP-Daten hochladen',
				DOWNLOAD_SAP_FORMAT: 'SAP-Datenformat herunterladen',
				UPDATE_SAP_DATA: 'SAP-Genehmigungsdaten-Aktualisierung',
				UPLOAD_UPDATE_SAP_DATA: 'SAP-Genehmigungsdaten-Aktualisierung hochladen',
				DOWNLOAD_UPDATE_SAP_FORMAT: 'SAP-Genehmigungsdaten-Aktualisierungsformat herunterladen',
				CMMS_WRITE_INTEGRATION: 'CMMS-Schreibintegration',
				CMMS_LAST_DATA_PULL: 'CMMS Letzter Datenabruf',
				IP_ADDRESS: 'IP-Adresse',
				USER_NAME: 'Benutzername',
				PASSWORD: 'Passwort',
				TEST: 'Test',
				TEST_WRITE_INTEGRATION: 'Schreibintegration testen',
			},
			PLANT_ECONOMICS: {
				TITLE: 'Wirtschaftliche Parameter',
				SUBTITLE: 'Wirtschaftliche Faktoren und Kostenparameter einrichten',
				SELECT_FACILITY_MSG: 'Bitte wählen Sie eine Anlage aus, um deren wirtschaftliche Parameter zu verwalten.',
				SECTION_TITLE: 'Parameter der Produktionswirtschaft',
				CHOOSE_FACILITY: 'Anlage auswählen...',
				PRODUCTION_DETAILS: 'Produktionsdetails',
				LABOR_SALARY: 'Arbeitsgehaltsparameter (pro Stunde)',
				UPDATED_SUCCESS: 'Werksökonomie erfolgreich aktualisiert',
				UPDATE_ERROR: 'Fehler beim Aktualisieren der Werksökonomie',
				COST_PER_UNIT: 'Kosten/Produktionseinheit',
				CAPACITY_HOUR: 'Kapazität/Stunde (z.B. MWh)',
				REVENUE_HOUR: 'Umsatz/Stunde',
				MARGIN_PERCENT: 'Marge (%)',
				OTHER_COSTS: 'Sonstige fixe Leerlaufkosten',
				TECHNICIAN: 'Techniker',
				HELPER: 'Helfer',
				SUPERVISOR: 'Aufseher',
				MANAGER: 'Manager',
			},
		},
		MODEL_EXPLAIN: {
			TITLE: 'Tags erklären',
			SELECTED_TAG: 'Ausgewählter Tag',
			CAUSAL_TAGS: 'Ursächliche Tags',
			TAG_SINGULAR: 'Tag',
			TAG_PLURAL: 'Tags',
			CONTRIBUTOR_SCORE: 'Score',
			NO_CONTRIBUTORS: 'Für diesen Zeitstempel wurden keine beitragenden Tags gefunden.',
			LOADING_CAUSAL_TAGS: 'Ursächliche Tags werden geladen...',
			CLOSE: 'Schließen',
			ASSET: 'Asset',
			FULLSCREEN: 'Vollbild',
			EXIT_FULLSCREEN: 'Vollbild beenden',
			EXPAND: 'Erweitern',
			COLLAPSE: 'Einklappen',
			EXPLAIN: 'Erklären',
		},
		FILE_PREVIEW: {
			LOADING_REPORT: "Bericht wird geladen…",
			REPORT_IN_PROGRESS: "Der Bericht wird gerade erstellt. Bitte kommen Sie in 5 Minuten wieder.",
			REPORT_FAILED: "Der Bericht konnte nicht erstellt werden. Bitte teilen Sie ihn erneut.",
		},
		ALERT_V2: {
			FORECAST: {
				TTF_SHORT: 'TTF',
				TTI_SHORT: 'TTI',
				DETAILS: '{{kind}}-Details',
				NO_VALUES: 'Keine gültigen {{kind}}-Werte verfügbar.',
				ON_DEMAND_NO_FORECAST: 'Für den ausgewählten Zeitpunkt ist keine Prognose verfügbar. Ziehen Sie die Markierung auf einen anderen Zeitpunkt und versuchen Sie es erneut.',
				MIN: 'Min =',
				CURRENT_VALUE: 'Aktueller Wert',
				VS_BASELINE: 'ggü. Basislinie',
				ACTIVE_DURATION: 'Aktive Dauer',
				SAMPLE_DENSITY: 'Stichprobendichte',
				FORECAST: 'Prognose {{kind}} =',
				TTF: {
					ALERT: {
						TITLE: 'TTF auf Alarmebene',
						DESCRIPTION: 'TTF = min (TTF jedes beitragenden Tags). Die früheste prognostizierte Überschreitung bestimmt den unten angezeigten aggregierten Wert.',
					},
					ALERT_LIST: {
						TITLE: 'TTF auf Alarmebene',
						DESCRIPTION: 'TTF = min (TTF jedes Fehlermodus). Die früheste prognostizierte Überschreitung bestimmt den unten angezeigten aggregierten Wert.',
					},
					FAILURE_MODE: {
						TITLE: 'TTF des Fehlermodus',
						DESCRIPTION: 'TTF = min (TTF jedes beitragenden Tags). Die früheste prognostizierte Überschreitung bestimmt den unten angezeigten aggregierten Wert',
					},
					TAG: {
						TITLE: 'Tag-Ebene TTF',
						DESCRIPTION: 'Prognose der Tage, bis der projizierte Wert des Tags seinen Betriebsgrenzwert überschreitet, basierend auf der jüngsten, fortgeschriebenen Änderungsrate.',
					},
				},
				TTI: {
					ALERT: {
						TITLE: 'Zeit bis zum Eingriff – Alarmebene',
						DESCRIPTION: 'Die früheste Eingriffsprognose dieses Alarms über die überwachten Leistungsverschlechterungs-Kennzahlen hinweg.',
					},
					ALERT_LIST: {
						TITLE: 'Zeit bis zum Eingriff – Alarmebene',
						DESCRIPTION: 'Die früheste Eingriffsprognose unter den Fehlermodi dieses Alarms.',
					},
					FAILURE_MODE: {
						TITLE: 'Fehlermodus — Zeit bis zum Eingriff',
						DESCRIPTION: 'Frühester prognostizierter betrieblicher Eingriff auf Basis der diesem Fehlermodus zugeordneten Leistungsindikatoren.',
					},
					TAG: {
						TITLE: 'Tag-Ebene — Zeit bis zum Eingriff',
						DESCRIPTION: 'Frühester vorhergesagter betrieblicher Eingriff für diesen Tag.',
					},
				},
			},
			DQ_SETTINGS: {
				TITLE: "Datenqualitätseinstellungen",
				DETECTION_TITLE: "Datenqualitätserkennung",
				ALERT_GEN_TITLE: "Datenqualitätsalarmgenerierung",
				ALERT_GEN_DESC: "Wählen Sie aus, welche erkannten DQ-Probleme Alarme generieren sollen. Das Ausschalten der Alarmgenerierung stoppt die DQ-Berechnung nicht.",
				FLATLINE_DETECTION: "Nulllinienerkennung",
				MISSING_DATA_DETECTION: "Fehlende Datenerkennung",
				OUTLIER_DETECTION: "Ausreißererkennung",
				OUT_OF_RANGE_DETECTION: "Bereichsüberschreitungserkennung",
				ERRATIC_DETECTION: "Unregelmäßigkeitserkennung",
				FLATLINE_ALERT: "Nulllinienalarm",
				MISSING_DATA_ALERT: "Fehlende Daten-Alarm",
				OUTLIER_ALERT: "Ausreißeralarm",
				OUT_OF_RANGE_ALERT: "Bereichsüberschreitungsalarm",
				ERRATIC_ALERT: "Unregelmäßigkeitsalarm",
				CLOSE_TOOLTIP: "Schließen"
			},
			DETAIL: {
				NO_DATA_URL: "Keine Daten für die angegebene URL gefunden.",
				NO_DATA_URL_DESC: "Bitte überprüfen Sie die eingegebene URL und versuchen Sie es erneut.",
				FAILURE_MODES: "Fehlermodi",
				SEARCH: "Suchen...",
				SORT_FAILURE_SCORE: "Nach Fehlerwert sortieren",
				SORT_CREATION_DATE: "Nach Erstellungsdatum sortieren",
				OTHER_ACTIVE_ALERTS: "Andere aktive Alarme",
				NEW_FAILURE: "Neuer Fehler hinzugefügt",
				ALERT_TITLE_PLACEHOLDER: "Alarmtitel",
				SEARCH_OWNER: "Eigentümer suchen...",
				SEARCH_WATCHERS: "Beobachter suchen..",
				ASSIGN_OWNER: "Eigentümer zuweisen",
				ADD_WATCHERS: "Beobachter hinzufügen",
				VERSION_HISTORY: "Versionsverlauf",
				COPY_LINK: "Alarmlink kopieren",
				BOOKMARK: "Alarm bookmarken",
				REMOVE_BOOKMARK: "Lesezeichen entfernen",
				FETCHING_SYSTEM_DETAILS: "Systemdetails werden abgerufen",
				RESTORE_VERSION: "Version wiederherstellen",
				CANNOT_DELETE_VERSION: "Versionen können nicht gelöscht werden, während RCA läuft",
				DELETE_VERSION: "Version löschen",
				EDIT: "Bearbeiten",
				CLOSE: "Schließen",
				DOWNLOAD: "Herunterladen",
				SHARE: "Teilen",
				ANOMALY_SCORE: "Anomaliebewertung",
				TIMELINE: "Zeitachse",
				VERSIONS: "Versionen",
				NO_DATA_AVAILABLE: "Keine Daten verfügbar",
				EXPORT_REPORT: "Bericht exportieren",
				TIME_TO_FAILURE_IN: "Zeit bis zum Ausfall in {{unit}}",
				TIME_TO_INTERVENTION_IN: "Zeit bis zum Eingriff in {{unit}}",
				SWITCH_TO_FM_VIEW: 'Zur FM-Ansicht wechseln',
				SWITCH_TO_RCA_VIEW: 'Zur RCA-Ansicht wechseln',
				CREATED_ON: 'Erstellt am',
				MENU_CREATED_ON: 'Erstellt am',
				STATE: 'Status',
				DUE_DATE: 'Fälligkeitsdatum',
				STATUS: 'Status',
				OWNER: 'Eigentümer',
				WATCHERS: 'Beobachter',
				WATCHER: 'Beobachter',
				LAST_RUN_PREFIX: 'Letzter Lauf:',
				MENU_LAST_RUN: 'Letzter Lauf',
				RUN_NOW: 'Jetzt ausführen',
				MENU_RUN_NOW: 'Jetzt ausführen',
				MORE: 'Mehr',
				REPORT_ISSUE: 'Problem melden',
				NAV: {
					THRESHOLD: 'Schwellenwert',
					DATA_QUALITY: 'Datenqualität',
					ACTIVITY_LOGS: 'Aktivitätsprotokolle',
					DISCUSSION: 'Diskussion',
					ANALYSIS_VIEWS: 'Analyse & Ansichten',
					RETRAIN_MODEL: 'Modell neu trainieren',
					FEEDBACK: 'Feedback',
					DISPLAY_TAGS: 'Tags anzeigen',
					PREFERRED_SETTINGS: 'Bevorzugte Einstellungen',
					DOCUMENTS: 'Dokumente',
					WORK_ORDERS: 'Arbeitsaufträge',
					ROOT_CAUSE_ANALYSIS: 'Ursachenanalyse',
				},
				TAGS_TOOLTIP: "Tags",
				TIME_TO_TRIP: "Zeit bis zum Ausfall",
				DAYS: "Tage",
				CMMS_NUMBER: "CMMS-Nummer",
				STACKED_VIEW: "Gestapelte Ansicht",
				OVERLAY_VIEW: "Überlagerungsansicht",
				GRID_VIEW: "Rasteransicht",
				NO_RECOMMENDATIONS: "Keine Empfehlungen vorhanden",
				RECOMMENDATIONS: "Empfehlungen",
				RECOMMENDATION_POPUP: {
					ADD_PLACEHOLDER: "Empfehlung hinzufügen",
					ADD: "Hinzufügen",
					CANCEL: "Abbrechen",
					UPDATE: "Aktualisieren",
					EMPTY_TITLE: "Keine Empfehlungen verfügbar",
					EMPTY_HINT: "Fügen Sie eine Empfehlung hinzu, um sie hier anzuzeigen.",
				},
				SEARCH_CATEGORY: "Kategorie suchen...",
				NO_CATEGORY: "Keine passende Kategorie gefunden",
				SELECT_CATEGORY: "Kategorie auswählen",
				SEARCH_COMPONENT: "Komponente suchen...",
				NO_COMPONENT: "Keine passende Komponente gefunden",
				SELECT_COMPONENT: "Komponente auswählen",
				SEARCH_ERROR: "Fehler suchen...",
				NO_ERROR_FOUND: "Kein passender Fehler gefunden",
				SELECT_ERROR: "Fehler auswählen",
				ALERT_DETAILS_TITLE: "Alarmdetails",
				EMPTY_DATA_ALT: "Keine Daten",
				NO_OPEN_FAILURE_MODES: "Keine offenen Fehlermodi.",
				RELATED_ALERTS: "Zugehörige Alarme",
				TOP_CONTRIBUTING_TAGS: "Wichtigste Beitragende Tags zum Anomalie-Score",
				NO_TAGS_TO_DISPLAY: "Keine Tags anzuzeigen.",
				NO_DATA_ALT: "Keine Daten",
				SELECT_FM_OR_ADD_TAGS: "Wählen Sie einen Fehlermodus oder fügen Sie Tags hinzu, um Diagramme anzuzeigen.",
				BREAKDOWN_CATEGORY_LABEL: "Ausfallkategorie",
				BREAKDOWN_COMPONENT_LABEL: "Ausfallkomponente",
				BREAKDOWN_ERROR_LABEL: "Fehler",
				SAVE: "Speichern",
				FILTER_TAGS: "Tags filtern",
				NO_MATCHING_RESULT: "Kein passendes Ergebnis",
				START_TYPING: "Beginnen Sie zu tippen, um passende Tags zu sehen.",
				NO_MATCHING_RESULTS: "Keine passenden Ergebnisse",
				CLOSE_TOOLTIP: "Schließen",
				EDIT_DISABLED: "Sie befinden sich im Nur-Lese-Modus für diese Anlage",
				MULTI_SELECT_DISABLED: "Nur der Alarm-Eigentümer kann mehrere Fehlermodi auswählen",
				SPLIT_MERGE_OWNER: "Nur ein Eigentümer des Alarms kann Fehlermodi trennen.",
				SPLIT_MERGE_STATUS: "Nur Alarme mit bestimmten Status können getrennt oder zusammengeführt werden.",
				SPLIT_MERGE_APPROVED: "Nur genehmigte oder nicht bearbeitete Fehlermodi können in einen neuen Alarm getrennt oder mit einem bestehenden zusammengeführt werden.",
				SPLIT_MERGE_ACTION: "Fehlermodi in einen neuen Alarm verschieben oder mit einem vorhandenen zusammenführen.",
				SPLIT_MERGE_IN_PROGRESS: "Für diesen Alarm läuft gerade ein Trenn- oder Zusammenführungsvorgang. Bitte warten Sie, bis er abgeschlossen ist.",
				SPLIT_MERGE_DISMISS: "Schließen",
				TITLE_EMPTY: "Bitte geben Sie einen Titel ein.",
				TITLE_TOO_LONG: "Der Titel darf 60 Zeichen nicht überschreiten.",
				MAINTENANCE_RECORDS_DIALOG: "Vorhandene Wartungsaufzeichnungen erkannt.<br>Möchten Sie diese löschen, um mit dem Neulernen fortzufahren?",
				FAILURE_DELETED: "Fehlermodus \"{{name}}\" erfolgreich gelöscht",
				FAILURE_DELETE_ERROR: "Beim Löschen von \"{{name}}\" ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
				FAILURE_ADDED: "Fehlermodus \"{{name}}\" erfolgreich hinzugefügt",
				USED_IN_MODEL: "Im Modell und berechneten Tag verwendet",
				ONGOING: "Laufend",
				FAILURE_TIMELINE: {
					TITLE: "Zeitachse von \"{{name}}\"",
					SORT_BY: "Sortieren nach",
					SORT_TIMELINE: "Zeitachse",
					SORT_ASSETS: "Assets",
					LIMIT_TO_SYSTEM: "Ergebnisse auf dieses System beschränken",
					ASSET: "Asset",
					REASON: "Grund",
					RECOMMENDATIONS: "Empfehlungen",
					NOT_AVAILABLE: "NA",
					NO_DATA: "Keine Daten gefunden.",
					MENU_LABEL: "Fehler-Zeitachse",
				},
			},
			RCA: {
				CREATE_WORK_ORDER: "Arbeitsauftrag erstellen",
				GENERATING: "Grundursachenanalyse wird erstellt",
				GENERATE: "Grundursachenanalyse erstellen",
				PERCENT_COMPLETED: "% abgeschlossen",
				GO_BACK: "Zurück",
				RUN_NOW: "Jetzt ausführen",
				CANCEL: "Abbrechen",
				NOTIFY_ME: "Benachrichtigen",
				ALREADY_IN_PROGRESS: "RCA-Generierung läuft bereits",
				RERUN: "Erneut ausführen",
				VIEW_TRACES: "Traces anzeigen",
				TITLE: "Grundursachenanalyse",
				HYPOTHESES: "Hypothesen",
				COMMENTS: "Kommentare",
				EVIDENCE_POINTS: "Beweispunkte",
				DISCUSSION_TOOLTIP: "Für interne Diskussionen mit Ihrem Team",
				APPROVED: "Genehmigt",
				APPROVE: "Genehmigen",
				EDIT: "Bearbeiten",
				RELEARNED: "Neu gelernt",
				RELEARN: "Neu lernen",
				SUSPECTED_CAUSE: "Vermutete Ursache",
				CAUSAL_CHAIN: "Kausalkette",
				STEPS: "Schritte",
				RECOMMENDATIONS: "Empfehlungen",
				CHART_TAGS: "Diagramm-Tags",
				EXPORT_AS_PDF: "Als PDF exportieren",
				PROPOSED_EVIDENCE: "Vorgeschlagene Belege",
				ADD_TO_EVIDENCE: "Als Beleg hinzufügen",
				EVIDENCE_ADDED_BY: "Hinzugefügt am {{date}} um {{time}} von {{user}}",
				EVIDENCE_ADDED: "Hinzugefügt am {{date}} um {{time}}",
				ALREADY_ADDED: "Bereits als Beleg hinzugefügt",
				DRAG_TO_REORDER: "Zum Neuanordnen klicken und ziehen",
				TABS: {
					TAGS: "Tags",
					WORK_ORDERS: "Arbeitsaufträge",
					DOCUMENTS: "Dokumente",
					SYSTEM_DETAILS: "Systemdetails",
				},
				EMPTY: {
					NO_TAGS_EVIDENCE: "Keine Tags als Beleg hinzugefügt",
					NO_TAGS_EVIDENCE_DESC: "Tag-Diagramme und Details erscheinen hier, wenn Tags als Belege vorgeschlagen werden.",
					NO_WORK_ORDERS: "Keine Arbeitsaufträge verknüpft",
					NO_WORK_ORDERS_DESC: "Arbeitsaufträge erscheinen hier, wenn Wartungsaufzeichnungen mit dieser Grundursache verknüpft werden.",
					NO_DOCUMENT_EVIDENCE: "Kein Dokumentenbeleg",
					NO_DOCUMENT_EVIDENCE_DESC: "Fügen Sie ein vorhandenes Dokument hinzu oder laden Sie ein neues hoch.",
					UPLOAD_NEW_DOCUMENT: "Neues Dokument hochladen",
					NO_PROPOSED_EVIDENCE: "Noch keine vorgeschlagenen Belege",
					NO_PROPOSED_EVIDENCE_DESC: "Fügen Sie Tags, Arbeitsaufträge, Dokumente oder P&ID-Referenzen hinzu.",
					NO_TAGS_LINKED: "Keine Tags verknüpft",
					NO_TAGS_LINKED_DESC: "Tag-Diagramme erscheinen hier, wenn Tags zu dieser Hypothese hinzugefügt werden.",
					SELECT_TAG_HEADING: "Keine Tags ausgewählt",
					SELECT_TAG_DESC: "Klicken Sie links auf einen Tag in der Hypothese oder ziehen Sie Tags hierher, um deren Diagramme anzuzeigen.",
					NO_DOCUMENTS: "Keine Dokumente verfügbar",
					NO_DOCUMENTS_DESC: "Technische Handbücher, Berichte und PDFs erscheinen hier, wenn sie verknüpft werden.",
					NO_SYSTEM_DETAILS: "Keine Systemdetails verfügbar",
					NO_SYSTEM_DETAILS_DESC: "P&IDs, Systemspezifikationen und technische Details erscheinen hier, wenn Anlagendaten verknüpft werden.",
				},
				WO: {
					WORK_ORDER: "Arbeitsauftrag",
					MANUALLY_ADDED: "Manuell hinzugefügt",
					DESCRIPTION: "Beschreibung",
					NOTIFICATION_NO: "Benachrichtigungs-Nr.",
					TYPE: "Typ",
					EQUIPMENT: "Anlage",
					PLANNING_GROUP: "Planungsgruppe",
					STATUS: "Status",
					USER_STATUS: "Benutzerstatus",
					CREATED_BY: "Erstellt von",
					COMPLETED_BY: "Abgeschlossen von",
					CREATED_ON: "Erstellt am",
					COMPLETED_ON: "Abgeschlossen am",
					CAUSE: "Ursache",
					CAUSE_DESC: "Ursachenbeschr.",
					ACTIVITY_GROUP: "Aktivitätsgruppe",
					ACTIVITY_DESC: "Aktivitätsbeschr.",
					SEE_LESS: "Weniger anzeigen",
					SEE_MORE: "Mehr anzeigen",
					ADDED_WITH_ROOTY: "Mit {{name}} hinzugefügt",
					ADDED_MANUALLY: "Manuell hinzugefügt",
				},
				PDF: {
					ALERT_REPORT: "Alarmbericht",
					HYPOTHESIS: "Hypothese",
					TITLE_LABEL: "Titel",
					SYSTEM: "System",
					TYPE: "Typ",
					CREATED_ON: "Erstellt am",
					OWNER: "Eigentümer",
					STATE: "Zustand",
					DUE_DATE: "Fälligkeitsdatum",
					STATUS: "Status",
					WATCHERS: "Beobachter",
					HYPOTHESES_PREFIX: "Hypothesen",
					PAGE: "Seite",
					ZOOM: "Zoom:",
					SIZE: "Größe:",
				},
				FEEDBACK: {
					APPROVE_HEADER: "Hypothesen genehmigen",
					RELEARN_HEADER: "Hypothesen neu lernen",
					COMMENT_PLACEHOLDER: "Feedback oder Notizen hinzufügen...",
					REVISION_INFO: "Für Revision erforderlich",
				},
				SNACKBAR: {
					REPORT_QUEUED: "Bericht angefordert. Wir senden einen Download-Link an {{email}}, sobald er bereit ist.",
					RCA_COMPLETED: "RCA-Generierung erfolgreich abgeschlossen.",
					RCA_NOTIFY: "Sie werden benachrichtigt, sobald die RCA abgeschlossen ist.",
					RCA_FAILED: "RCA-Generierung fehlgeschlagen.",
					REPORT_REQUEST_FAILED: "Bericht konnte nicht angefordert werden. Bitte versuchen Sie es erneut.",
					REMOVE_WO_ERROR: "Fehler beim Entfernen des Arbeitsauftrags aus den Belegen.",
					NO_RCA_DATA_AVAILABLE: "Keine RCA-Daten verfügbar. Bitte führen Sie eine RCA aus, um Erkenntnisse zu generieren.",
				},
				POPUP: {
					APPROVE_HYPOTHESES: "Hypothesen genehmigen",
					APPROVE_CAUSAL: "Kausalkettenschritt genehmigen",
					APPROVE_RECOMMENDATION: "Empfehlung genehmigen",
					RELEARN_HYPOTHESES: "Hypothesen neu lernen",
					RELEARN_CAUSAL: "Kausalkettenschritt neu lernen",
					RELEARN_RECOMMENDATION: "Empfehlung neu lernen",
				},
				DIALOG: {
				ADD_TAG_EVIDENCE: "Diesen Tag als vorgeschlagenen Beleg hinzufügen?",
				ADD_DOCS_EVIDENCE: "{{count}} Dokument(e) als vorgeschlagene Belege hinzufügen?",
				ADD_WOS_EVIDENCE: "Diesen Arbeitsauftrag als Beleg hinzufügen?",
				REMOVE_RC_EVIDENCE_DESC: "Diesen Grundursachen-Beleg entfernen? Dies kann nicht rückgängig gemacht werden.",
					REMOVE_EVIDENCE_TITLE: "Bestätigung",
					REMOVE_EVIDENCE_DESC: "Diesen Beleg entfernen? Dies kann nicht rückgängig gemacht werden.",
					ERROR_TITLE: "Fehler!",
					OK: "OK",
					CONFIRM: "Bestätigen",
					CANCEL: "Abbrechen",
					EVIDENCE_LOCKED: "RCA-Belege können nicht in den Bereich 'Vorgeschlagene Belege' verschoben werden.",
				},
				EVIDENCE_CONTEXT: {
					ADD_TITLE: "Kontext für diesen Beleg hinzufügen",
					EDIT_TITLE: "Kontext für diesen Beleg bearbeiten",
					CLOSE: "Schließen",
					SUBTITLE: "Helfen Sie RCA zu verstehen, warum dieser Beleg relevant ist und wie er im nächsten Durchlauf verwendet werden soll.",
					FIELD_LABEL: "Warum ist dieser Beleg relevant?",
					FIELD_LABEL_OPTIONAL: "Warum ist dieser Beleg relevant? (Optional)",
					FIELD_PLACEHOLDER: "Z. B.: Dieser Arbeitsauftrag erwähnt eine Dichtungsleckage vor dem Pumpenausfall.",
					FIELD_ERROR: "Bitte geben Sie einen Kontext an, um fortzufahren",
					CANCEL: "Abbrechen",
					UPDATE_CONTEXT: "Kontext aktualisieren",
					ADD_EVIDENCE: "Beleg hinzufügen",
					ABORT_TITLE: "Beleg wird nicht hinzugefügt",
					ABORT_DESC: "RCA benötigt eine kurze Beschreibung, um zu verstehen, wie dieser Beleg verwendet werden soll. Wenn Sie jetzt abbrechen, wird dieser Beleg im nächsten RCA-Durchlauf nicht berücksichtigt.",
					ABORT_CANCEL: "Beleghinzufügung abbrechen",
					ABORT_GO_BACK: "Zurück",
				},
			},
			METRICS2: {
				PENDING_DEFECT: "Ausstehender Defekt",
			},
			METRICS: {
				HEALTH_SCORE: "Zustandsbewertung",
				TOTAL_ALERTS: "Warnungen gesamt",
				UNACKNOWLEDGED: "Nicht bestätigt",
				REVIEWING: "In Prüfung",
				PENDING: "Ausstehend",
				UNKNOWN: "Unbekannt",
			},
			OVERVIEW: {
				SYSTEM_OVERVIEW: "Systemübersicht",
				SYSTEM_HEALTH_INDICATORS: "Systemzustandsindikatoren",
				PRIORITY_ACTIONS: "Prioritäre Maßnahmen",
				PRIORITY_TOOLTIP: "Was jetzt Ihre Aufmerksamkeit erfordert. Anomalie-Warnungen, die nicht bestätigt und ausstehend - Defekt gemeldet sind.",
				NO_PRIORITY_ACTIONS: "Keine prioritären Maßnahmen",
				ALL_CAUGHT_UP: "Alles erledigt - nichts erfordert sofortige Aufmerksamkeit ",
				MONITORING_TRACKING: "Überwachung & Verfolgung",
				MONITORING_TOOLTIP: "Verfolgte Elemente mit niedrigerer Priorität. Anomalie-Warnungen mit Status In Bearbeitung und Unter Beobachtung.",
				IN_PROCESS: "In Bearbeitung",
				ON_WATCH: "Unter Beobachtung",
				RUNNING_STATE: "Betriebszustand",
				AT_RISK: "Gefährdet",
				REVIEW: "Überprüfen",
				HEALTHY: "Gesund",
				CURRENT: "Aktuell",
				THRESHOLD: "Schwellenwert",
				NO_DATA_FOUND: "Keine Daten gefunden",
				VIEW_ALL: "Alle anzeigen →",
				NO_ALERTS_ARE: "Keine Warnungen sind {{title}}",
				NO_DATA: "Keine Daten",
			},
			TABLE: {
				HEADERS: {
					STATUS: "Status",
					ALERT_NAME: "Warnungsname",
					SYSTEM_NAME: "Systemname",
					TYPE: "Typ",
					LOSS: "Verlust (kWh)",
					START: "Start",
					STOP: "Stopp",
					DURATION: "Dauer",
					LAST_ACTIVE: "Zuletzt aktiv",
					CREATED_ON: "Erstellt am",
					STATE: "Zustand",
					OWNER: "Eigentümer",
					WATCHERS: "Beobachter",
					FORECAST: "Prognose",
					CATCH: "Catch",
					UPPER_LIMIT: "Obergrenze",
					VALUE: "Wert",
					LOWER_LIMIT: "Untergrenze",
					LAST_SYSTEM_UPDATE: "Letzte Systemaktualisierung",
					LAST_USER_UPDATE: "Letzte Benutzeraktualisierung",
					DISCUSSION: "Diskussion",
					TOTAL_VALUE: "Gesamtwert",
					RELIABILITY_SAVING: "Zuverlässigkeitseinsparung",
					MAINTENANCE_SAVING: "Wartungseinsparung",
					PERFORMANCE_SAVING: "Leistungseinsparung",
					ALERT_DRIVEN_MAINTENANCE: "Warnungsgesteuerte Wartung",
				},
				NEW_FAILURE_ADDED: "Neuer Fehlermodus hinzugefügt",
				TIME_TO_TRIP_DAYS: "Zeit bis zum Ausfall {{n}} Tage",
				OPEN_IN_NEW_TAB: "In neuem Tab öffnen",
				RCA_AVAILABLE: "Ursachenanalyse verfügbar",
				ASSIGN_OWNER: "Eigentümer zuweisen",
				ADD_WATCHERS: "Beobachter hinzufügen",
				SEARCH_OWNER: "Eigentümer suchen...",
				SEARCH_WATCHERS: "Beobachter suchen...",
				NO_APPROVED_FM: "Keine genehmigten Fehlermodi gefunden",
				EXTRA_MORE: "+ {{count}} weitere",
				CUSTOMIZE_COLUMNS: "Spalten anpassen",
				BOOKMARK_ALERT: "Warnung als Lesezeichen",
				REMOVE_BOOKMARK: "Lesezeichen entfernen",
				VIEW_ONLY_MODE: "Sie befinden sich im Nur-Lese-Modus für diese Anlage",
				SYSTEM_TOOLTIP: "System: {{system}}\nEinheit: {{unit}}\nAnlage: {{facility}}",
			},
			UTILS: {
				STATUS: {
					UNACK: "Nicht bestätigt",
					IN_PROCESS: "In Bearbeitung",
					ON_WATCH: "Unter Beobachtung",
					PENDING_DEFECT: "Ausstehend - Defekt gemeldet",
					CLOSED_MAINT_DEFERRED: "Geschlossen - Wartung verschoben",
					CLOSED_NO_ACTION: "Geschlossen - Keine Maßnahme geplant",
					CLOSED_RESOLVED: "Geschlossen - Behoben",
					REJECTED: "Abgelehnt",
				},
				STATE: {
					TENTATIVE: "Vorläufig",
					ACTIVE: "Aktiv",
					RETURNED_TO_NORMAL: "Zurück zum Normalzustand",
					CLOSED: "Geschlossen",
					NOISE_DISCARDED: "Rauschen/Verworfen",
				},
				TYPE: {
					H_ANOMALY: "H. Anomalie",
					L_ANOMALY: "N. Anomalie",
					DATA_QUALITY: "Datenqualität",
					USER_REPORTED: "Benutzergemeldet",
					THRESHOLD: "Schwellenwert",
					DIAGNOSIS: "Diagnose",
					DIGITAL: "Digital",
				},
				SUBTYPE: {
					OUTLIER: "Ausreißer",
					OUT_OF_RANGE: "Außerhalb des Bereichs",
					FLATLINE: "Flatline",
					MISSING: "Fehlend",
					UNKNOWN: "Unbekannt",
					PAINT_BRUSHING: "Paint Brushing",
				},
				THRESHOLD_ALERT: "Schwellenwert-Warnung",
				DATA_QUALITY_ALERT: "Datenqualitäts-Warnung",
				TITLE_TOOLTIP: "Titel: {{title}}",
				TITLE_ID_TOOLTIP: "Titel: {{title}}\nWarnungs-ID: {{id}}",
				DAYS: "{{n}} Tage",
				HOURS: "{{n}} Stunden",
				DAYS_SHORT: "{{n}}T",
				HOURS_SHORT: "{{n}}Std",
				POTENTIAL: "(Potenziell)",
			},
			DOC_PREVIEW: {
				PREVIEW_DOCUMENT: "Dokument-Vorschau",
				CLOSE: "Schließen",
				DOWNLOAD_FILE: "Datei herunterladen",
			},
			LIST: {
				ALERTS_COUNT: "{{count}} Warnungen",
				SHOW_MORE_ALERTS: "{{count}} weitere Warnungen anzeigen",
				COLUMN_SAVED: "Spaltenansicht wurde gespeichert",
				SOMETHING_WENT_WRONG: "Etwas ist schiefgelaufen, bitte versuchen Sie es erneut",
				TAKES_FEW_SECONDS: "Dies kann einige Sekunden dauern...",
				BULK_RESULT: "{{msg}} für {{success}} von {{total}} Warnungen.",
				STATUS_CLOSED_NO_ACTION: "Status auf „Geschlossen – Keine Maßnahme geplant“ gesetzt",
				ACTION_UPDATED: "{{action}} aktualisiert",
				ACTION_STATUS: "Status",
				ACTION_BOOKMARK: "Lesezeichen",
				ACTION_SUBSCRIBERS: "Abonnenten",
			},
			DIALOG: {
				ADD_COMMENT: "Kommentar hinzufügen*",
				COMMENT_REQUIRED: "Bitte fügen Sie einen Kommentar hinzu, um fortzufahren",
				ADD_A_REASON: "Grund hinzufügen",
				SELECTED_FAILURE_MODES: "Ausgewählte Fehlermodi",
				SELECT_ALL: "Alle auswählen",
				CANCEL: "Abbrechen",
				CLOSE: "Schließen",
				ADD: "Hinzufügen",
				OK: "Ok",
				MARK_AS_CATCH: "Als erfasst markieren",
			},
			APPROVE: {
				TITLE: "Fehlermodus genehmigen",
				EDIT_TITLE: "Bearbeiten - Fehlermodus genehmigen",
				RECOMMENDATIONS_FOR: "Empfehlungen für {{name}}",
				ADD_RECOMMENDATION_PLACEHOLDER: "Empfehlung hinzufügen...",
				APPROVE: "Genehmigen",
				UPDATE: "Aktualisieren",
			},
			RELEARN: {
				TITLE: "Fehlermodus neu erlernen",
				RELEARN: "Neu erlernen",
			},
			BULK_UPDATE: {
				PROCESSING: "Wird verarbeitet",
				COMPLETED: "Massenaktualisierung abgeschlossen!",
				DOWNLOAD_REPORT: "Bericht herunterladen",
				SELECT_DUE_DATE: "Fälligkeitsdatum auswählen",
				DUE_DATE_HINT: "Das Fälligkeitsdatum ist standardmäßig 28 Tage ab heute und kann bei Bedarf angepasst werden.",
				DUE_DATE_TOOLTIP: "Wählen Sie ein Fälligkeitsdatum für die ausgewählte Warnung",
				UPDATED_SUCCESSFULLY: "Erfolgreich aktualisiert",
				UPDATE_FAILED: "Aktualisierung fehlgeschlagen",
				SHOWING: "{{shown}}/{{total}} werden angezeigt",
			},
			SPLIT_MERGE: {
				TITLE: "Fehlermodus aufteilen/zusammenführen",
				SUBTITLE: "Verschieben Sie genehmigte oder nicht bearbeitete Fehlermodi in eine neue Warnung oder führen Sie sie mit einer bestehenden Warnung zusammen.",
				APPROVED: "Genehmigt",
				APPROVED_ON: "Genehmigt am {{date}}",
				APPROVED_FAILURE_MODES: "Genehmigte Fehlermodi",
				FAILURE_MODES: "Fehlermodi",
				TAB_CREATE: "Neue Warnung erstellen",
				TAB_MERGE: "Mit bestehender zusammenführen",
				ALERT_TITLE: "Warnungstitel",
				SYSTEM: "System",
				UNIT: "Einheit",
				SEVERITY: "Schweregrad",
				SELECT_SEVERITY: "Schweregrad auswählen",
				OWNER: "Eigentümer",
				CREATED_ON: "Erstellt am",
				STATUS: "Status",
				SELECT_TARGET_ALERT: "Zielwarnung auswählen",
				SEARCH_PLACEHOLDER: "Suchen...",
				LOADING: "Wird geladen...",
				NOT_OWNER_MESSAGE: "Sie sind nicht der Eigentümer der Warnung mit dem Status „In Bearbeitung“, „Unter Beobachtung“, „Keine Maßnahme geplant“ oder „Ausstehender Defekt gemeldet“.",
				PROCESSING_TOOLTIP: "Wird verarbeitet, bitte warten!",
				PROCESSING: "Wird verarbeitet...",
				SUBMIT_CREATE: "Neue Warnung erstellen",
				SUBMIT_MERGE: "Mit Warnung zusammenführen",
				VIEW_CREATE: "Neue Warnung öffnen",
				VIEW_MERGE: "Warnung öffnen",
				GO_BACK: "Zurück",
				SUCCESS_CREATE: "Neue Warnung erfolgreich erstellt.",
				SUCCESS_MERGE: "Erfolgreich mit der bestehenden Warnung zusammengeführt.",
				FAILED_CREATE: "Die Warnungserstellung war nicht erfolgreich. Bitte versuchen Sie es erneut.",
				FAILED_MERGE: "Warnungszusammenführung fehlgeschlagen. Bitte versuchen Sie es erneut.",
				PENDING: "Anfrage in Warteschlange. Sie wird nach Abschluss des aktuellen Vorhersage-Batches verarbeitet.",
				CONFLICT: "Für diese Warnung wird bereits eine Aufteilungs-/Zusammenführungsanfrage bearbeitet.",
				CONFLICT_DESTINATION: "Für die Zielwarnung wird bereits eine Aufteilungs-/Zusammenführungsanfrage bearbeitet.",
				TITLE_PLACEHOLDER_EXAMPLE: 'CESR-C-20250807-IPNK',
				SYSTEM_PLACEHOLDER_EXAMPLE: 'GAS TURBINE TRAIN D',
				UNIT_PLACEHOLDER_EXAMPLE: 'COGEN',
				OWNER_PLACEHOLDER_EXAMPLE: 'Ronald Richards',
				CREATED_ON_PLACEHOLDER_EXAMPLE: '25. Aug. 2025',
			},
			FILTER: {
				FILTER_BY: "Filtern nach",
				SEARCH_BY_ALERT_NAME: "Nach Warnungsname suchen...",
				CLEAR_SEARCH: "Suche löschen",
				STATE: "Zustand",
				ANOMALY: "Anomalie",
				ACTIVE: "Aktiv",
				RETURNED_TO_NORMAL: "Zurück zum Normalzustand",
				OTHER_ALERT_TYPES: "Andere Warnungstypen",
				CATCH: "Catch",
				TRUE: "Wahr",
				FALSE: "Falsch",
				AGENTS: "Agenten",
				HAS_RCA: "Mit Ursachenanalyse",
				NO_RCA: "Ohne Ursachenanalyse",
				BOOKMARK_AND_CASES: "Lesezeichen und Fälle",
				ONLY_TRACKED_CASES: "Nur Warnungen mit verfolgten Fällen",
				DIAGNOSIS_CONDITIONS: "Diagnosebedingungen",
				TRIP_BREAKDOWN: "Auslösung/Ausfall",
				UNDER_PERFORMANCE: "Unterleistung",
				SMB_DOWN: "SMB ausgefallen",
				SMB_UNDER_PERF: "SMB Unterleistung",
				CURTAILMENT: "Drosselung",
				OUT_OF_ENV_SCOPE: "Außerhalb des Umgebungsbereichs",
				DATA_QUALITY_TYPE: "Datenqualitätstyp",
				OUTLIER: "Ausreißer",
				OUT_OF_RANGE: "Außerhalb des Bereichs",
				FLATLINE: "Flatline",
				MISSING: "Fehlend",
				TAG_STATUS: "Tag-Status",
				TAG_STATUS_INFO: "Gilt nur für DQ-Warnungen",
				USED_IN_MODEL: "Im Modell verwendet",
				DROPPED_TAGS: "Verworfene Tags",
				WATCHERS: "Beobachter",
				SEARCH_PLACEHOLDER: "Zum Suchen tippen",
				CLEAR_ALL: "Alle löschen",
			},
			COLUMNS: {
				NUMBER: "Nummer",
				ALERT_NAME: "Warnungsname",
				STATUS: "Status",
				SYSTEM: "System",
				TYPE: "Typ",
				DATE: "Datum",
				CREATED_ON: "Erstellt am",
				STATE: "Zustand",
				OWNER: "Eigentümer",
				WATCHERS: "Beobachter",
				CATCH: "Catch",
				FORECAST: "Prognose",
				UPPER_LIMIT: "Obergrenze",
				VALUE: "Wert",
				LOWER_LIMIT: "Untergrenze",
				LAST_SYSTEM_UPDATE: "Letzte Systemaktualisierung",
				LAST_USER_UPDATE: "Letzte Benutzeraktualisierung",
				TOTAL_VALUE: "Gesamtwert",
				RELIABILITY_SAVINGS: "Zuverlässigkeitseinsparungen",
				MAINTENANCE_SAVINGS: "Wartungseinsparungen",
				PERFORMANCE_SAVINGS: "Leistungseinsparungen",
				ALERT_DRIVEN_MAINTENANCE: "Warnungsgesteuerte Wartung",
				DISCUSSION: "Diskussion",
				LOSS: "Verlust (kWh)",
				START: "Start",
				STOP: "Stopp",
				DURATION: "Dauer",
			},
			NO_ALERTS: {
				TITLE: "Keine Warnungen gefunden",
				SUBTITLE: "Ändern Sie die Filter oder den Datumsbereich, um Ergebnisse anzuzeigen",
			},
			COLUMN_CONFIG: {
				SHOW_COLUMNS: "Spalten anzeigen",
				SEARCH_PLACEHOLDER: "Zum Suchen tippen",
				SELECT_ALL: "Alle auswählen",
				RESET_TO_DEFAULT: "Auf Standard zurücksetzen",
			},
			PAGE_TITLE: "Warnungen",
			OVERVIEW_TAB: "Übersicht",
			SEARCH_PLACEHOLDER: "Suchen...",
			NO_MATCHING_RESULTS: "Keine passenden Ergebnisse",
			SEARCH_OWNER_PLACEHOLDER: "Eigentümer suchen...",
			SELECT_OWNERS: "Eigentümer auswählen",
			ALL_STATUSES: "Alle Status",
			STATUS_FILTER: "Statusfilter",
			CHOOSE_STATUSES: "Anzuzeigende Status auswählen",
			FILTERS: "Filter",
			GROUP_BY: "Gruppieren nach",
			MORE: "Mehr",
			SELECT_ALERTS_FOR_CASE: "Wählen Sie die Warnung(en) aus, die Sie in diesem Fall markieren möchten",
			SHOWING_RESULTS_FOR: 'Ergebnisse anzeigen für "{{term}}"',
			CHIP: {
				THRESHOLD: "Schwellenwert",
				HIGH_ANOMALY_SHORT: "H. Anomalie",
				LOW_ANOMALY_SHORT: "N. Anomalie",
				DATA_QUALITY: "Datenqualität",
				DIAGNOSIS: "Diagnose",
			},
			TYPE: {
				THRESHOLD: "Schwellenwert",
				HIGH_ANOMALY: "Hohe Anomalie",
				LOW_ANOMALY: "Niedrige Anomalie",
				DATA_QUALITY: "Datenqualität",
				DIAGNOSIS: "Diagnose",
			},
			AUTO_REFRESH: {
				LABEL: "Automatisch aktualisieren",
				OFF: "Aus",
				LIVE: "Live",
				MIN_5: "5 Minuten",
				MIN_15: "15 Minuten",
				MIN_30: "30 Minuten",
				HOUR_1: "1 Stunde",
			},
			MORE_MENU: {
				EXPORT_DATA: "Daten exportieren",
				EXPAND_ALL_GROUPED: "Alle gruppierten Elemente erweitern",
				COLLAPSE_ALL_GROUPED: "Alle gruppierten Elemente einklappen",
				EXPAND_ALL_WITHIN_GROUP: "Alle Elemente in der Gruppe erweitern",
				COLLAPSE_ALL_WITHIN_GROUP: "Alle Elemente in der Gruppe einklappen",
				SWITCH_TO_CLASSIC: "Zur klassischen Ansicht wechseln",
			},
			TOOLTIP: {
				TYPE_NEW_EVENTS: "{{type}} neue Ereignisse",
				TYPE_ALERTS: "{{count}} {{type}}-Warnungen",
				COUNT_NEW_EVENTS: "{{count}} neue Ereignisse",
				COUNT_TYPE_NEW_EVENTS: "{{count}} {{type}} neue Ereignisse",
				SYSTEM_OPEN_ALERTS: "System: {{name}}\nOffene Warnungen: {{count}}",
				UNIT_OPEN_ALERTS: "Einheit: {{name}}\nOffene Warnungen: {{count}}",
				FACILITY_OPEN_ALERTS: "Anlage: {{name}}\nOffene Warnungen: {{count}}",
				EDIT_DISABLED_CLOSED: "Bearbeitungsaktionen sind für geschlossene/abgelehnte Alarme deaktiviert."
			},
		},
		MODEL_WIZARD: {
		NO_CUSTOMER_TAGS_AVAILABLE: 'Keine Kunden-Tags verfügbar',
		MAP_CUSTOMER_TAGS_CONTENT: 'Fügen Sie Kunden-Tags hinzu oder importieren Sie diese, um sie den Asset-Tags zuzuordnen.',
		SYSTEM_SUMMARY: {
			TITLE: "Technische Systemzusammenfassung",
			GENERATE: "Zusammenfassung generieren",
			PLACEHOLDER: "Geben Sie eine detaillierte technische Zusammenfassung des Systems an oder generieren Sie eine aus verfügbaren Dokumenten und verbundenen Systemen.",
			HELPER: "Sie können die generierte Zusammenfassung bearbeiten oder manuell verfassen.",
			DRAWER_TITLE: "Technische Systemzusammenfassung generieren",
			SOURCE_DOCS: "Quelldokumente",
			SOURCE_DOCS_DESC: "Wählen Sie Dokumente aus, die Systemdesign, Betrieb, Steuerungslogik oder Geräteverhalten erläutern.",
			DOCS_SELECTED: "Dokumente ausgewählt",
			SELECT_DOCUMENTS: "Dokumente auswählen",
			UPLOAD_TITLE: "Unterstützende Dokumente hochladen",
			UPLOAD_DESC: "Laden Sie zusätzliche Dateien hoch, die im Dokumentenmanager noch nicht verfügbar sind.",
			UPLOAD_FAILED: "Upload fehlgeschlagen",
			VIEW_FILE: "Datei anzeigen",
			PROCESSING: "Wird verarbeitet...",
			COMPLETED: "Abgeschlossen",
			FAILED: "Fehlgeschlagen",
			DUPLICATE_UPLOAD: "„{{name}}“ ist bereits hinzugefügt – doppelter Upload übersprungen.",
			ALREADY_UPLOADED_USED: "„{{name}}“ wurde bereits hochgeladen und für das Training verwendet.",
			CONNECTED_SYSTEMS: "Verbundene Systeme",
			CONNECTED_DESC: "Fügen Sie vor-, nachgelagerte oder parallele Systeme hinzu, die das Verhalten dieses Systems beeinflussen.",
			UPSTREAM: "Vorgelagerte Systeme",
			SELECT_UPSTREAM: "Vorgelagerte Systeme auswählen",
			DOWNSTREAM: "Nachgelagerte Systeme",
			SELECT_DOWNSTREAM: "Nachgelagerte Systeme auswählen",
			PARALLEL: "Parallele Systeme",
			SELECT_PARALLEL: "Parallele Systeme auswählen",
			SEARCH_SYSTEM: "System suchen",
			SEARCH_FACILITY: "Anlage suchen",
			SEARCH_UNIT: "Einheit suchen",
			NO_SYSTEMS: "Keine Systeme gefunden",
			OPTIONAL_META: "Optionale Systemmetadaten",
			OPTIONAL_META_DESC: "Optionale Angaben können die Qualität der generierten technischen Zusammenfassung verbessern.",
			PRIMARY_COMPONENT: "Hauptkomponente",
			FLUID_MEDIUM: "Fluid / Medium",
			CRITICAL_CONTROL_NODES: "Kritische Steuerungsknoten",
			AUXILIARY_SYSTEMS: "Hilfssysteme",
			DIAG_UPSTREAM: "Diagnosemarker – Vorgelagerter Ausfall",
			DIAG_DOWNSTREAM: "Diagnosemarker – Nachgelagerter Ausfall",
			ADDITIONAL_CONTEXT: "Zusätzlichen Kontext hinzufügen",
			OPTIONAL: "Optional",
			DOCUMENTS_COUNT: "Dokumente",
			CONNECTED_COUNT: "verbundene Systeme",
			VIEW_SOURCES: "Quellen anzeigen",
			VIEW_SOURCES_DESC: "Dokumente und verbundene Systeme, die zur Erstellung dieser Beschreibung verwendet wurden.",
			NO_DOCS_USED: "Für diese Beschreibung wurden keine Dokumente verwendet.",
			NO_SYSTEMS_USED: "Für diese Beschreibung wurden keine verbundenen Systeme verwendet.",
			NO_SOURCES: "Keine Quellen verfügbar",
			NO_SOURCES_DESC: "Für diese Beschreibung wurden keine Dokumente oder verbundenen Systeme verwendet.",
			REGENERATE: "Neu generieren",
			CLICK_TO_EDIT: "Zum Bearbeiten klicken",
			GENERATION_STARTED: "Systembeschreibung wird generiert … dies kann einen Moment dauern.",
			ALREADY_IN_PROGRESS: "Für dieses System wird bereits eine Systembeschreibung generiert. Bitte warten Sie, bis der Vorgang abgeschlossen ist, bevor Sie neu generieren.",
			GENERATION_FAILED: "Generierung der Systembeschreibung fehlgeschlagen.",
			GENERATION_FAILED_TEXT: "Systemgenerierung fehlgeschlagen.",
			LAST_UPDATED: "Zuletzt aktualisiert",
			BY: "von",
			DOCUMENTS: "Dokumente",
			SELECT_DOCS_TITLE: "Quelldokumente auswählen",
			SELECT_DOCS_DESC: "Wählen Sie Dokumente auf Anlagen-, Einheiten- oder Systemebene aus, die Systemdesign, Betrieb, Steuerungslogik oder Geräteverhalten erläutern.",
			DOCUMENT_SCOPE: "Dokumentbereich",
			SCOPE_FACILITY: "Anlage",
			SCOPE_UNIT: "Einheit",
			SCOPE_SYSTEM: "System",
			SEARCH_SCOPE_FACILITY: "Anlage suchen",
			SEARCH_SCOPE_UNIT: "Anlage, Einheit suchen",
			SEARCH_SCOPE_SYSTEM: "Anlage, Einheit, System suchen",
			SEARCH_SCOPE: "Bereich suchen",
			NO_SCOPES: "Keine passenden Bereiche gefunden. Versuchen Sie ein anderes Stichwort.",
			ALL_TYPES: "Alle Typen",
			SEARCH_DOCS: "Dokumente suchen...",
			UPDATED: "Aktualisiert",
			NO_DOCS_TITLE: "Keine Dokumente gefunden",
			NO_DOCS_DESC: "Keine passenden Dokumente verfügbar. Ändern Sie die Filter.",
			LOADING_MORE: "Weitere Dokumente werden geladen...",
			SELECTED_DOCS: "Ausgewählte Dokumente",
			ADD: "Hinzufügen",
			DOCUMENTS_WORD: "Dokumente",
			ADD_DOCUMENTS: "Dokumente hinzufügen",
			CANCEL: "Abbrechen",
			REGENERATE_CONFIRM_TITLE: "Systembeschreibung neu generieren?",
			REGENERATE_CONFIRM_MESSAGE: "Beim Neugenerieren wird die aktuelle Systembeschreibung durch eine neu generierte ersetzt. Diese Aktion kann nicht rückgängig gemacht werden.",
		},
			ESCALATION_CONFIG: {
				TITLE: "Eskalationskonfiguration",
				DELAY_LABEL: "Eskalationsverzögerung (in Tagen)",
				LEVEL_LABEL: "Stufe",
				LEVEL_PLACEHOLDER: "Stufe eingeben",
				SELECT_USERS: "Benutzer auswählen",
				SEARCH_USERS_PLACEHOLDER: "Nach E-Mail-IDs suchen",
				NO_MATCHING_EMAIL: "Keine passende E-Mail-ID gefunden",
				EMAILS_LABEL: "Durch Kommas getrennte E-Mail-IDs hinzufügen",
				EMAILS_PLACEHOLDER: "abc@gmail.com, def@gmail.com",
				ADD_LEVEL: "+ Stufe hinzufügen",
				ADD_LEVEL_TOOLTIP: "Stufe hinzufügen",
				REMOVE_TOOLTIP: "Entfernen",
				CONFIG_TYPE_UNIT: "Einheitskonfiguration verwenden",
				CONFIG_TYPE_CUSTOM: "Benutzerdefinierte Konfiguration verwenden",
				CONFIG_TYPE_NONE: "Keine Eskalationskonfiguration",
			},
			NO_ASSET_TAGS_FOUND: 'Keine Anlagentags verfügbar',
			NO_MAPPED_TAGS_FOUND: 'Keine zugeordneten Tags verfügbar',
		ASSET_INFORMATION: "Anlageninformationen",
		NO_ASSET_FOUND: "Keine Anlage gefunden",
		EQUIPMENT: "Anlage",
		TEMPLATE: "Vorlage",
		APPLICATION: "Anwendung",
		INDUSTRY: "Branche",
		CONFIGURATION_COL: "Konfiguration",
		MODEL_CONFIGURATION: "Modellkonfiguration",
		MODELING_TECHNIQUE: "Modellierungsmethode",
		SCALER: "Skalierer",
		SMOOTHING: "Glättung",
		SELECT_SMOOTHING_FUNCTION: "Glättungsfunktion auswählen",
		SMOOTHING_FUNCTION: "Glättungsfunktion",
		WINDOW_SIZE: "Fenstergröße",
		IN_HOURS: "in Stunden",
		IN_DAYS: "(in Tagen)",
		SIGMA: "Sigma",
		POLYNOMIAL_ORDER: "Polynomgrad",
		VALUE_REQUIRED: "Wert ist erforderlich",
		VALUE_MIN_1: "Wert muss größer oder gleich 1 sein",
		NONE: "Keine",
		ANOMALY_SCORE_CALC_METHOD: "Berechnungsmethode des Anomalie-Scores",
		ANOMALY_CALC_DEFAULT: "Standard (RMS aller Tags)",
		ANOMALY_CALC_NEW: "Neu (Summe der RMS der Anlagen-Tags)",
		PREDICTION_TIME_PERIOD: "Vorhersagezeitraum",
		TRAINING_TIME_PERIOD: "Trainingszeitraum",
		CALENDAR_SELECTION: "Kalenderauswahl",
		CHART_BASED_SELECTION: "Diagrammbasierte Auswahl",
		START_TIME: "Startzeit",
		END_TIME: "Endzeit",
		START_TIME_REQUIRED: "Startzeit ist erforderlich",
		END_TIME_REQUIRED: "Endzeit ist erforderlich",
		STARTUP_TRAINING_BUFFER: "Anlauf-Trainingspuffer",
		SHUTDOWN_TRAINING_BUFFER: "Abschalt-Trainingspuffer",
		TRAINING_BUFFER_GROUP: "Trainingspuffer",
		TRAINING_BUFFER_STARTUP_SHORT: "Anlauf (in Tagen)",
		TRAINING_BUFFER_SHUTDOWN_SHORT: "Abschaltung (in Tagen)",
		TRAINING_CONDITIONS: "Trainingsbedingungen",
		METHOD1_RANGE_FILTER: "Methode 1: Bereichsfilter",
		METHOD2_CONDITION_FILTER: "Methode 2: Bedingungsfilter",
		LOAD_TAG: "Last-Tag",
		REFERENCE_TAG: "Referenz-Tag",
		NUM_OF_BINS: "Anzahl der Bins",
		QUANTILE_CONDITION: "Quantilbedingung",
		LESS_THAN: "Kleiner als",
		GREATER_THAN: "Größer als",
		EQUAL_TO: "Gleich",
		VALUE: "Wert",
		TAG: "Tag",
		MIN: "Min",
		MAX: "Max",
		CONDITION: "Bedingung",
		AND: "Und",
		OR: "Oder",
		ADD: "Hinzufügen",
		CLOSE: "Schließen",
		ADD_NOTE: "Notiz hinzufügen",
		VIEW_NOTE: "Notiz anzeigen",
		VIEW_EDIT_NOTE: "Notiz anzeigen/bearbeiten",
		NOTE_FOR_DATE_RANGE: "für Datumsbereich {{range}}",
		ENTER_NOTES: "Notizen hier eingeben",
		SEARCH_TAGS: "Tags suchen...",
		NO_MATCHING_TAGS: "Keine passenden Tags gefunden",
		SELECT_TRAINING_REGIONS: "Trainingsbereiche automatisch auswählen",
		ADD_TRAINING_RANGE: "Trainingsbereich hinzufügen",
		DELETE_TRAINING_RANGE: "Trainingsbereich löschen",
		NAME: "Name",
		TAG_ID: "Tag-ID",
		UNIT_SETUP: "Einheiteneinrichtung",
		SCHEMATIC: "Schema",
		EQUIPMENT_LIST: "Anlagenliste",
		UNITS: 'Einheiten',
		CAPACITY: 'Kapazität',
		SYSTEM_INFORMATION: 'Systeminformationen',
		DESCRIPTION: 'Beschreibung',
		CRITICALITY: 'Kritikalität',
		COMMENTS: 'Kommentare',
		SEARCH: 'Suche',
		NO_UNIT_FOUND: 'Keine Einheit gefunden',
		NO_SYSTEM_FOUND: 'Kein System gefunden',
		CUSTOMER: 'Kunde',
		FACILITY: 'Anlage',
		UNIT: 'Einheit',
		SYSTEM: 'System',
		ORIGINAL_AUTHOR: 'Ursprünglicher Autor',
		TRAINING_DATASET: 'Trainingsdatensatz',
		VALIDATION_LOSS: 'Validierungsverlust',
		LAST_DEPLOYED: 'Zuletzt bereitgestellt',
		ON: 'Ein',
		SELECTED_VERSION: 'Ausgewählte Version',
		DEPLOYED_PERIOD: 'Bereitstellungszeitraum',
		STATUS: 'Status',
		MARK_AS_IMPORTANT: 'Als wichtig markieren',
		DISABLE: 'Deaktivieren',
		DELETE: 'Löschen',
		DELETE_VERSION_TOOLTIP: 'Version löschen',
		TAB_FACILITY_SETUP: 'Anlageneinrichtung',
		TAB_TAG_MAPPING: 'Tag-Zuordnung',
		TAB_DATA_SYNC: 'Datensynchronisierung',
		TAB_DATA_IMPORT: 'Datenimport & Verarbeitung',
		TAG_MAPPING_REQUIRED_TOOLTIP: 'Die Tag-Zuordnung muss abgeschlossen werden, dann wird diese Registerkarte aktiviert.',
		TAB_MODEL_BUILDING: 'Modellerstellung',
		RECALCULATING_TOOLTIP: 'Neuberechnung läuft',
		CUSTOMER_TAG_LIST: 'Kunden-Tag-Liste',
		TAGS_BTN: 'Tags',
		MODEL_BUILDING_CONFIG_TOOLTIP: 'Konfiguration des Modellerstellungsschritts',
		TAGS_TO_BE_MAPPED: 'Zu mappende Tags',
		UPLOAD_SYSTEM_TAGS: 'System-Tags hochladen',
		DOWNLOAD_FACILITY_TAGS: 'Anlagen-Tags herunterladen',
		ASSETS_PLACEHOLDER: 'ANLAGEN',
		SEARCH_IN_ALL_FIELDS: 'In allen Feldern suchen',
		COL_NAME: 'Name',
		COL_DESCRIPTION: 'Beschreibung',
		COL_UNIT: 'Einheit',
		CUSTOMER_TAGS: 'Kunden-Tags',
		UPLOAD_TAGS_TOOLTIP: 'Tags hochladen',
		DOWNLOAD_TAGS_TOOLTIP: 'Tags herunterladen',
		TAG_MAPPING_NO_ASSET_TOOLTIP: 'Mindestens 1 Asset muss erstellt werden, um Tag-Mapping durchzuführen',
		MAP_SELECTED: 'Ausgewählte mappen',
		IMPORT_WO_MAPPING: 'WO-Zuordnung importieren',
		TAGS_MAPPED: 'Gemappte Tags',
		SAVE_CHANGES: 'Änderungen speichern',
		UNMAP_SELECTED: 'Auswahl entmappen',
		UNMAPPED_TAGS: 'Nicht gemappte Tags',
		COL_TAG_NAME: 'Tag-Name',
		COL_ASSET: 'Anlage',
		COL_TAG_ID: 'Tag-ID',
		COL_THRESHOLD_HIGH: 'Schwellenwert Hoch',
		COL_THRESHOLD_LOW: 'Schwellenwert Niedrig',
		COL_TRIP_HIGH: 'Auslösung Hoch',
		COL_TRIP_LOW: 'Auslösung Niedrig',
		COL_ALARM_HIGH: 'Alarm Hoch',
		COL_ALARM_LOW: 'Alarm Niedrig',
		COL_DIRECTIONALITY: 'Direktionalität',
		COL_FLATLINE_DETECTION: 'Flachlinien-Erkennung',
		COL_MISSING_DATA_DETECTION: 'Erkennung fehlender Daten',
		COL_OUTLIER_DETECTION: 'Ausreißer-Erkennung',
		COL_RANGE_DETECTION: 'Bereichserkennung',
		COL_FLATLINE_ALERT_GENERATION: 'Flatline-Alarmgenerierung',
		COL_MISSING_DATA_ALERT_GENERATION: 'Alarmgenerierung für fehlende Daten',
		COL_OUTLIER_ALERT_GENERATION: 'Ausreißer-Alarmgenerierung',
		COL_RANGE_ALERT_GENERATION: 'Bereichs-Alarmgenerierung',
		COL_ATTENTION: 'Aufmerksamkeit',
		COL_THRESHOLD_NOTIFICATION: 'Schwellenwert-Benachrichtigung',
		COL_KPI: 'KPI',
		SHOW_COLUMNS_TOOLTIP: 'Spalten anzeigen',
		VIEW_CHANGES_TOOLTIP: 'Änderungen anzeigen',
		EDIT_TAG_TOOLTIP: 'Tag bearbeiten',
		VIEW_PIDS_TOOLTIP: 'PIDs anzeigen',
		IN_PROGRESS: 'In Bearbeitung',
		CORRECT_RECORDS_MSG: 'Bitte korrigieren Sie Datensätze mit Fehlern und laden Sie sie erneut hoch.',
		DOWNLOAD_ERROR_RECORDS: 'Fehlerdatensätze herunterladen',
		RELEVANT_INFORMATION: 'Relevante Informationen',
		PIDS_PANEL: 'P&IDs',
		IMAGES_PANEL: 'Bilder',
		TEST_REPORTS_PANEL: 'Testberichte',
		PROCEDURES_PANEL: 'Verfahren',
		TAG_DATA: 'Tag-Daten',
		SEARCH_TAG: 'Tag suchen',
		SEARCH_ASSET: 'Anlage suchen',
		EXPORT_DQ_METRICS_TOOLTIP: 'DQ-Metriken exportieren',
		EXPORT: 'Exportieren',
		TAG_SELECTION_PLACEHOLDER: 'Tag-Auswahl',
		PREPROCESSING_STATS_PLACEHOLDER: 'Vorverarbeitungsstatistiken',
		TAG_MAPPING_PLACEHOLDER: 'Tag-Zuordnung',
		TAG_TYPE_PLACEHOLDER: 'Tag-Typ',
		OPERATING_REGION_PLACEHOLDER: 'Betriebsbereich',
		COL_PLOT: 'Grafik',
		COL_CORR: 'Korr.',
		COL_MODEL: 'Modell',
		COL_TAGS: 'Tags',
		SHUTDOWN_TAG_TOOLTIP: 'Abschalt-Tag',
		COL_MAX: 'Max',
		COL_MIN: 'Min',
		COL_STD_DEV: 'Std. Abw.',
		COL_AGGREGATE_TAG: 'Aggregierter Tag',
		COL_MEAN_SHIFT: 'Mittelwertverschiebung',
		COL_VARIANCE: 'Varianz',
		COL_MEAN: 'Mittelwert',
		COL_DEVIATION_SCORE: 'Abweichungswert',
		COL_OP_UPPER: 'Betr. Oben',
		COL_OP_LOWER: 'Betr. Unten',
		COL_NANS: 'NaNs',
		COL_OUTLIERS: 'Ausreißer',
		COL_FLATLINE: 'Flachlinie',
		COL_OUT_OF_RANGE: 'Außerhalb des Bereichs',
		COL_TOTAL_INVALID_DATA: 'Gesamt ungültige Daten',
		NO_RECORDS_FOUND: 'Keine Datensätze gefunden',
		NO_DATA_AVAILABLE_SYSTEM: 'Keine Daten für das ausgewählte System verfügbar. Neue Daten abrufen oder hochladen',
		CHOOSE_MODEL_VERSION_MSG: 'Wählen Sie eine Modellversion aus, um Tag-Grafiken anzuzeigen',
		SELECT_PLOT_CHECKBOX_MSG: 'Aktivieren Sie das Plot-Kontrollkästchen eines Tags, um den Graphen anzuzeigen',
		TAG_CORRELATION_TITLE: 'Tag-Korrelation',
		TAG_CORRELATION_CONDITION_PLACEHOLDER: 'Tag-Korrelationsbedingung',
		CORR_GREATER_THAN_OPTION: 'Tags mit Korrelationen größer als anzeigen',
		CORR_LESS_THAN_OPTION: 'Tags mit Korrelationen kleiner als anzeigen',
		CORR_VALUE_PLACEHOLDER: 'Korrelationswert',
		SELECT_RANGE_LABEL: 'Bereich auswählen',
		SELECT_RANGE_TOOLTIP: 'Ziehen Sie über das Diagramm, um einen Datumsbereich auszuwählen',
		REMOVE_RANGE_LABEL: 'Bereich entfernen',
		REMOVE_RANGE_TOOLTIP: 'Ziehen Sie über das Diagramm, um einen Datumsbereich von der Modellierung auszuschließen',
		SYSTEM_DATA_FILTER_LABEL: 'Systemdatenfilter',
		SELECTED_DATE_RANGES_LABEL: 'Ausgewählte Datumsbereiche:',
		CONFIRM_SELECTION: 'Auswahl bestätigen',
		REMOVED_DATE_RANGES_LABEL: 'Entfernte Datumsbereiche:',
		EDIT_MODEL_TITLE: 'Modell bearbeiten',
		FORM_ERROR_MSG: 'Ups! Bitte ändern Sie einige Angaben und versuchen Sie es erneut.',
		OP_LOWER_PLACEHOLDER: 'Betr. Unten',
		OP_UPPER_PLACEHOLDER: 'Betr. Oben',
		REQUIRED: 'Erforderlich',
		CANCEL_CHANGES_TOOLTIP: 'Änderungen abbrechen',
		CANCEL: 'Abbrechen',
		SAVE_DATA_TOOLTIP: 'Daten speichern',
		SAVE: 'Speichern',
		SIMULATION: 'Simulation',
		SHOW_FAILURE_INFO: 'Fehlerinfo anzeigen',
		OK: 'Ok',
		RESET_ASSET_SELECTION_TOOLTIP: 'Anlagenauswahl zurücksetzen',
		CLOSE_CROSSHAIR_TOOLTIP: 'Fadenkreuz schließen',
		CROSSHAIR: 'Fadenkreuz',
		LOADING: 'Laden...',
		NO_FAILURE_MODE_FOUND: 'Kein Fehlermodus gefunden.',
		MODEL_PARAMETERS_PANEL: 'Modellparameter',
		BOILER_HEALTH_PANEL: 'Kesselsgesundheit',
		ALERT_PARAMETERS_PANEL: 'Alarmparameter',
		FAILURE_PARAMETERS_PANEL: 'Fehlerparameter',
		APPLY_SOURCE_VERSION_FEEDBACK: 'Quellversion-Feedback anwenden',
		COMMENT_PLACEHOLDER: 'Kommentar',
		SAVE_MODEL: 'Modell speichern',
		SAVE_MODEL_TOOLTIP: 'Modell speichern',
		RESAVE: 'Neu speichern',
		RESAVE_TOOLTIP: 'Modell neu speichern',
		DEPLOY_MODEL_TOOLTIP: 'Modell bereitstellen',
		DEPLOY_TAG_UNMAPPED_TOOLTIP: 'Bereitstellung ist nicht zulässig, da das Modell {{version}} Tag(s) enthält, die im System nicht mehr zugeordnet sind',
		DEPLOY: 'Bereitstellen',
		GO_LIVE_CSV_TOOLTIP: 'Live gehen mit CSV-Streaming/Historian',
		GO_LIVE: 'LIVE GEHEN',
		GO_LIVE_OPTIONS_TITLE: 'Live-Optionen',
		DATA_SOURCE_TYPE_PLACEHOLDER: 'Datenquellentyp',
		HISTORIAN_OPTION: 'Historian',
		START_PREDICTION_FROM: 'Vorhersage starten ab',
		FROM_DATE_REQUIRED: 'Von-Datum ist',
		GO_LIVE_BTN: 'Live gehen',
		GO_LIVE_TOOLTIP: 'Live gehen',
		THRESHOLD_PLACEHOLDER: 'Schwellenwert',
		AUTOMATIC_OPTION: 'Automatisch',
		MANUAL_OPTION: 'Manuell',
		RISK_PROFILE_PLACEHOLDER: 'Risikoprofil',
		CREATE_CONDITION: 'Bedingung erstellen',
		RETURN_CONDITION: 'Rückgabebedingung',
		EXCEED_FOR_PLACEHOLDER: 'Überschreiten für',
		OUT_OF_PLACEHOLDER: 'Von',
		DOWN_FOR_PLACEHOLDER: 'Runter für',
		ALARM_THRESHOLD_PLACEHOLDER: 'Alarmschwellenwert',
		ADD_TOOLTIP: 'Hinzufügen',
		GENERATE_ALERT_TOOLTIP: 'Alarm generieren',
		UPDATE: 'Aktualisieren',
		SELECT_DATE_PLACEHOLDER: 'Datum auswählen',
		DATE_REQUIRED_ERROR: 'Datum ist',
		HEALTH_PLACEHOLDER: 'Gesundheit',
		REMOVE_TOOLTIP: 'Entfernen',
		GENERATE_BOILER_HEALTH_TOOLTIP: 'Kesselsgesundheit generieren',
		ANOMALY_WT_THRESHOLD_PLACEHOLDER: 'Anomalie-Gew. Schwellenwert',
		LOW_OPTION: 'Niedrig',
		MEDIUM_OPTION: 'Mittel',
		HIGH_OPTION: 'Hoch',
		CUTOFF_PARTIAL_MATCH: 'Grenzwert für teilweise Übereinstimmung',
		IN_PERCENTAGE_HINT: 'in Prozent',
		CUTOFF_FULL_MATCH: 'Grenzwert für vollständige Übereinstimmung',
		UPDATE_FAILURE_TOOLTIP: 'Fehler aktualisieren',
		START_DELAY_PLACEHOLDER: 'Startverzögerung',
		NO_OF_HOURS_HINT: '(Anzahl Stunden)',
		END_DELAY_PLACEHOLDER: 'Endverzögerung',
		GROUPING: 'Gruppierung',
		DOWN_CONDITION_PLACEHOLDER: 'Absenkbedingung',
		ANOMALY_SCORE_THRESHOLD: 'Anomalie-Score-Schwellenwert',
		FILTER_FAILURE_PLACEHOLDER: 'Fehler filtern',
		VALUE_BETWEEN_0_1: 'Wert zwischen 0 & 1 eingeben',
		FEEDBACKS: 'Feedbacks',
		LIVE_FEEDBACKS: 'Live-Feedbacks',
		PREVIOUS_FEEDBACKS: 'Frühere Feedbacks',
		BAND_LEARNING_BEHAVIOUR: 'Bandlernverhalten',
		CONSERVATIVE: 'Konservativ',
		CONSERVATIVE_TOOLTIP: 'Erstellt engere Bänder um den ausgewählten Trainingsbereich',
		MODERATE: 'Moderat',
		MODERATE_TOOLTIP: 'Erstellt ausgewogene Bänder um den ausgewählten Trainingsbereich',
		AGGRESSIVE: 'Aggressiv',
		AGGRESSIVE_TOOLTIP: 'Erstellt breitere Bänder um den ausgewählten Trainingsbereich',
		UPDATE_FEEDBACK: 'Feedback aktualisieren',
		UPDATE_PARAMETERS_TOOLTIP: 'Parameter aktualisieren',
		DATA_IMPORT_PANEL: 'Datenimport',
		PRE_PROCESSING_PANEL: 'Vorverarbeitung',
		CSV_OPTION: 'CSV',
		UPLOADED_CSV_OPTION: 'Hochgeladenes CSV',
		SELECT_SOURCE_HINT: 'Quelle für den Datenimport auswählen',
		SAMPLING_RATE_PLACEHOLDER: 'Abtastrate',
		SAMPLING_RATE_REQUIRED: 'Abtastrate',
		IN_MINUTES_HINT: '(in Minuten)',
		SELECT_CSV_FILE_PLACEHOLDER: 'CSV-Datei auswählen',
		CSV_FILE_REQUIRED: 'CSV-Datei ist',
		SELECT_FILE_BTN: 'Datei auswählen',
		DATA_SYNC_MORE_DATA_TOOLTIP: 'Um mehr Daten zu erhalten, gehen Sie zur Datensynchronisierungs-Registerkarte und stellen Sie eine Datenabrufanforderung.',
		DATA_SET_NAME_PLACEHOLDER: 'Datensatzname',
		IMPORT_TOOLTIP: 'Importieren',
		IMPORT_DATA: 'Daten importieren',
		STATE_IDENTIFICATION_PANEL: 'Zustandsidentifikation',
		EXCLUDE_REGION_PANEL: 'Region ausschließen',
		PRE_PROCESSING_CONFIG_PANEL: 'Vorverarbeitungskonfiguration',
		MODEL_TAG_SELECTION_PANEL: 'Modell-Tag-Auswahl',
		PROCESS_TOOLTIP: 'Verarbeiten',
		PROCESS_DATA: 'Daten verarbeiten',
		SHUTDOWN_TAG_PLACEHOLDER: 'Abschalt-Tag',
		CONDITION_PLACEHOLDER: 'Bedingung',
		LESS_THAN_OPTION: 'Weniger als',
		GREATER_THAN_OPTION: 'Größer als',
		EQUAL_TO_OPTION: 'Gleich',
		VALUE_PLACEHOLDER: 'Wert',
		SHUTDOWN_CONDITION_PLACEHOLDER: 'Abschaltbedingung',
		AND_OPTION: 'Und',
		OR_OPTION: 'Oder',
		SHUTDOWN_SPAN_PLACEHOLDER: 'Abschaltdauer',
		IN_HOURS_HINT: '(in Stunden)',
		SHUTDOWN_TRANSITION_PLACEHOLDER: 'Abschaltübergang',
		STARTUP_TRANSITION_PLACEHOLDER: 'Anlaufübergang',
		EXCLUDE_REGION_TAG_PLACEHOLDER: 'Ausschlussbereichs-Tag',
		EXCLUDE_CONDITION_PLACEHOLDER: 'Ausschlussbedingung',
		OUTLIER_DETECTION_METHOD: 'Ausreißererkennungsmethode',
		OUTLIER_DETECTION_THRESHOLD: 'Ausreißererkennungsschwellenwert',
		SIGMA_HINT: 'Sigma',
		INTERPOLATION_METHOD: 'Interpolationsmethode',
		INTERPOLATION_CONFIG: 'Interpolationskonfiguration',
		FLATLINE_THRESHOLD_TIME: 'Flachlinienschwellenwertzeit',
		FLATLINE_TIME_BASE: 'Flachlinien-Zeitbasis',
		HOURS_OPTION: 'Stunden',
		MINUTES_OPTION: 'Minuten',
		SECONDS_OPTION: 'Sekunden',
		CROSS_CORRELATION: 'Kreuzkorrelation',
		// pre-processing-configuration-form: row group titles + short field labels
		OUTLIER_DETECTION_GROUP: 'Ausreißererkennung',
		INTERPOLATION_GROUP: 'Interpolation',
		FLATLINE_GROUP: 'Flachlinie',
		LABEL_METHOD: 'Methode',
		LABEL_THRESHOLD: 'Schwellenwert',
		LABEL_CONFIGURATION: 'Konfiguration',
		FLATLINE_DETECTION_SHORT: 'Erkennung',
		FLATLINE_THRESHOLD_TIME_SHORT: 'Schwellenwertzeit',
		FLATLINE_TIME_BASE_SHORT: 'Zeitbasis',
		DATA_DENSITY_THRESHOLD: 'Datendichte-Schwellenwert für Tag-Auswahl',
		DATA_DENSITY_REQUIRED: 'Datendichte-Schwellenwert ist',
		GLOBAL_PREPROCESSING: 'Globale Vorverarbeitung',
		RANGE_PREPROCESSING: 'Bereichsvorverarbeitung',
		DENSITY_HINT: 'Dichte',
		REFRESH_TABLE_DATA_TOOLTIP: 'Tabellendaten aktualisieren',
		LAST_DATA_PULL_LABEL: 'Letzter Datenabruf:',
		UPLOAD_CSV_TOOLTIP: 'CSV hochladen',
		NO_RAW_TAGS_TOOLTIP: 'Es gibt keine Rohdaten-Tags in diesem System, daher kann keine Datei hochgeladen werden',
		UPLOAD_BTN: 'Hochladen',
		ANOTHER_PROCESS_RUNNING_TOOLTIP: 'Ein anderer Prozess läuft',
		NO_RAW_TAG_MAPPED_TOOLTIP: 'Kein Rohdaten-Tag ist mit diesem System verknüpft',
		NEW_DATA_PULL_REQUEST: 'Neue Datenabrufanforderung',
		ADD_NEW_DATA_PULL_TOOLTIP: 'Neue Datenabrufanforderung hinzufügen',
		DELETE_SYSTEM_DATA_TOOLTIP: 'Systemdaten löschen',
		STOP_DATA_PULL_TOOLTIP: 'Datenabruf stoppen',
		COL_SERIAL_NO: 'Nr.',
		COL_DATA_REQUESTED_FOR: 'Daten angefordert für',
		COL_REQUESTED_ON: 'Angefordert am',
		COL_ACCESS_METHOD: 'Zugriffsmethode',
		COL_REQUEST_TYPE: 'Anforderungstyp',
		COL_FILE_NAME: 'Dateiname',
		COL_PULLED_BY: 'Abgerufen von',
		COL_DATA_RECEIVED: 'Empfangene Daten',
		COL_ACTIONS: 'Aktionen',
		DATA_REPULL_TOOLTIP: 'Daten erneut abrufen',
		TAG_PULL_REQUEST: 'Tag-Abrufanforderung',
		COL_VALUE: 'Wert',
		COL_MISSING: 'Fehlend',
		COL_OUTLIER: 'Ausreißer',
		TRIP_LIMIT_TOOLTIP: 'Auslöselimit',
		TRIP_LABEL: 'Auslösung',
		ALARM_LIMIT_TOOLTIP: 'Alarmlimit',
		ALARM_LABEL: 'Alarm',
		THRESHOLD_LIMIT_TOOLTIP: 'Schwellenwertlimit',
		THRESHOLD_LABEL: 'Schwellenwert',
		INSTRUMENT_RANGE_TOOLTIP: 'Instrumentenbereich',
		INSTRUMENT_LABEL: 'Instrument',
		HIGH_LABEL: 'Hoch:',
		LOW_LABEL: 'Niedrig:',
		AVG_LABEL: 'Durchschn.:',
		DATA_PULL_REQUEST: 'Datenabrufanforderung',
		SELECT_TAGS_PLACEHOLDER: 'Tags auswählen',
		FROM_DATE_PLACEHOLDER: 'Von-Datum',
		SELECT_FROM_DATE_HINT: 'Von-Datum',
		TO_DATE_PLACEHOLDER: 'Bis-Datum',
		TO_DATE_REQUIRED: 'Bis-Datum ist',
		SELECT_TO_DATE_HINT: 'Bis-Datum',
		PULL_DATA_TOOLTIP: 'Daten abrufen',
		PULL_DATA: 'Daten abrufen',
		STATUS_PANEL: {
			SUMMARY: 'Zusammenfassung',
			TAG_SUMMARY: 'Tag-Zusammenfassung',
			RECORDS: 'Datensätze',
			TOTAL_TAGS: 'Tags gesamt',
			TAGS_IN_MODEL: 'Tags im Modell',
			TAGS_MAPPED_TO_FM: 'Tags mit Fehlermodus',
			TAGS_WITH_NO_FM: 'Tags ohne Fehlermodus',
			PROCESSING_TIME: 'Verarbeitungszeit',
			TRAINING_TIME: 'Trainingszeit',
			TOTAL_TAGS_DROPPED: 'Entfernte Tags gesamt',
			ALERTS_GENERATED: 'Erzeugte Alarme',
			PRECISION_PREVIOUS: 'Vorherige Präzision',
			PRECISION_CURRENT: 'Aktuelle Präzision',
			PHASE_DATA_IMPORT: 'Datenimport',
			PHASE_PREPROCESSING: 'Datenvorverarbeitung',
			PHASE_MODELING: 'Modellierung',
			PHASE_ALERT_FEEDBACK: 'Alarm-Feedback',
			PHASE_READY_TO_DEPLOY: 'Bereit zur Bereitstellung',
			DROPPED_TAGS: 'Entfernte Tags',
			CALCULATED_TAGS_DROPPED: 'Entfernte berechnete Tags',
			RAW_TAGS_DROPPED: 'Entfernte Roh-Tags',
			TAGS_DROPPED_PREPROCESSING: 'In Vorverarbeitung entfernt',
			TAGS_DROPPED_MANUALLY: 'Manuell entfernt',
			HIGH_DEVIATION_TAGS: 'Tags mit hoher Abweichung',
			EXPORT: 'Exportieren',
			COL_TAG_NAME: 'Tag-Name',
			COL_TAG_ID: 'Tag-ID',
			COL_DESCRIPTION: 'Beschreibung',
			COL_UNIT: 'Einheit',
			COL_CALCULATED: 'Berechnet',
			COL_DROPPED_DUE_TO: 'Entfernt wegen',
			COL_REASON: 'Grund',
			YES: 'Ja',
			NO: 'Nein',
			DROPPED_DUE_IMPORT: 'Import',
			DROPPED_DUE_PREPROCESSING: 'Vorverarbeitung',
			DROPPED_DUE_MANUAL: 'Manuell',
			DROPPED_DUE_UNKNOWN: '—',
			NO_TAGS_DROPPED: 'Noch keine Tags entfernt',
			NO_HIGH_DEVIATION: 'Modellbildung ausführen, um Tags mit hoher Abweichung zu füllen',
			NO_HIGH_DEVIATION_EMPTY: 'Keine Tags mit hoher Abweichung gefunden',

			PHASE_DEPLOYED: 'Bereitgestellt',
			DROPPED_DUE_CALCULATED: 'Berechnet',
			STEP_STATUS: 'Status',
			STEP_STATUS_COMPLETED: 'Abgeschlossen',
			STEP_PREPROCESSING_TIME: 'Vorverarbeitungszeit',
			STEP_TRAINING_TIME: 'Trainingszeit',
			STEP_PREDICTION_TIME: 'Vorhersagezeit',
			STEP_ALERTS_GENERATED: 'Erzeugte Alarme',
			STEP_PRECISION_CURRENT: 'Aktuelle Präzision',
			STEP_PRECISION_PREVIOUS: 'Vorherige Präzision',
			REASON_UNSELECTED_FROM_MODEL: 'Aus Modell abgewählt',
			REASON_INVALID_DATA: '{{percent}}% ungültige Daten',
			STEP_SECONDS_VALUE: '{{value}} Sek.',
		},
		UPLOAD_CSV_TITLE: 'CSV hochladen',
		},
		CASES: {
			WORK_ORDER: {
				CREATE_TITLE: 'Arbeitsauftragsmeldung erstellen',
				CREATE_DESC: 'Eine Arbeitsauftragsmeldung für diesen Fall erstellen',
				DESCRIPTION: 'Beschreibung',
				DESCRIPTION_PLACEHOLDER: 'Auszuführende Arbeiten beschreiben (Pflichtfeld)',
				DESCRIPTION_REQUIRED: 'Beschreibung ist erforderlich',
				PRIORITY: 'Priorität',
				DUE_DATE: 'Fälligkeitsdatum',
				ASSIGNED_TO: 'Zugewiesen an',
				ESTIMATED_HOURS: 'Geschätzte Stunden',
				HOURS_PLACEHOLDER: 'Stunden eingeben',
				CANCEL: 'Abbrechen',
				CONFIRM: 'Bestätigen',
				UNASSIGNED: 'Nicht zugewiesen',
				CREATED: 'Arbeitsauftrag {{number}} erstellt',
				CREATED_PLAIN: 'Arbeitsauftrag erstellt',
				FAILED: 'Arbeitsauftrag konnte nicht erstellt werden',
				CREATE_BUTTON: 'Arbeitsauftrag erstellen',
				NONE_YET: 'Noch kein Arbeitsauftrag',
				VIEW_TITLE: 'Arbeitsauftrag {{number}}',
				VIEW_SUB: 'Aus diesem Fall erstellter Arbeitsauftrag',
				CREATED_BY: 'Erstellt von {{name}}',
			},
			TRIAGE: {
				FROM_TRIAGE: 'Fall aus der Alarm-Triage',
				FROM_TRIAGE_DESC: 'Die Alarme dieses Falls liegen in der Alarm-Triage; dort sind Telemetrie und Nachweise zu sehen',
				HIERARCHY: 'Alarm-Triage-Hierarchie',
				NO_FLOC: 'Kein Technischer Platz',
				ALERTS: 'Triage-Alarme',
				ADD_ALERTS: 'Alarme hinzufügen',
				ADD_ALERTS_TIP: 'Triage-Alarme suchen und diesem Fall hinzufügen',
				AUTO_FIND: 'Automatisch finden',
				AUTO_FIND_TIP: 'Alarme, die mit den Alarmen dieses Falls gebündelt sind oder um das Ereignis am selben TP liegen',
				AUTO_FIND_DESC: 'Batch-Gruppe oder gleicher TP im Zeitfenster um den Quellalarm',
				EVENT_START: 'Ereignisbeginn',
				VIA_SOURCE: 'Quelle',
				VIA_MANUAL: 'Hinzugefügt',
				VIA_AUTO: 'Automatisch gefunden',
				ALERT_MISSING: 'Nicht mehr in der Triage-Warteschlange',
				OPEN_TRIAGE: 'In Alarm-Triage öffnen',
				REMOVE_ALERT: 'Aus Fall entfernen',
				SEARCH_PLACEHOLDER: 'Nach Alarm-ID, Tag, Name oder TP suchen…',
				SEARCHING: 'Suche…',
				NO_MATCH: 'Keine passenden Alarme',
				ADD: 'Hinzufügen',
				NO_SUGGESTIONS: 'Keine weiteren Alarme in diesem Fenster',
				REASON_GROUP: 'Gleiche Batch-Gruppe',
				REASON_FLOC: 'Gleicher TP innerhalb ±{{hours}} h',
				SELECT_ALL: 'Alle auswählen',
				ADD_SELECTED: 'Auswahl hinzufügen ({{count}})',
				EVIDENCE: 'Nachweise',
				KIND_FACT: 'Fakten',
				KIND_TAG: 'Tags',
				KIND_MAINTENANCE: 'Instandhaltung',
				KIND_REPORT: 'Berichte',
				KIND_NOTE: 'Notizen',
				NO_EVIDENCE: 'Noch keine Nachweise',
				REMOVE_EVIDENCE: 'Nachweis entfernen',
				ADD_EVIDENCE_PLACEHOLDER: 'Zu {{kind}} hinzufügen…',
				BY_AGENT: 'Triage-Agent',
				BY_ENGINEER: 'Ingenieur',
				ALERT_REMOVED: 'Alarm aus dem Fall entfernt',
				ALERTS_ADDED: '{{count}} Alarm(e) hinzugefügt',
				EVIDENCE_ADDED: 'Nachweis hinzugefügt',
				EVIDENCE_REMOVED: 'Nachweis entfernt',
				ACTION_FAILED: 'Die Aktion ist fehlgeschlagen',
				HIERARCHY_SOURCE: 'Hierarchie',
				SOURCE_TRIAGE: 'Alarm-Triage',
				SOURCE_PLATFORM: 'Plattformsysteme',
				SELECT_FLOC: 'Technischer Platz',
				ROOT: 'Alle',
				FLOC_SEARCH: 'TP-Code oder Namen suchen…',
				FLOC_REQUIRED: 'Technischen Platz auswählen',
				NO_CHILDREN: 'Keine unteren Ebenen',
				RELATED_TRIAGE_ALERTS: 'Triage-Alarme (optional)',
				SELECT_ALERTS: 'Alarm(e) auswählen',
			},
			SELECT_STATUS: 'Status auswählen',
			SELECT_CATEGORY: 'Kategorie auswählen',
			UNASSIGNED: 'Nicht zugewiesen',
			UNKNOWN_CREATOR: 'Unbekannter Ersteller',
			ALL_CASES: 'Alle Fälle',
			CREATE_CASE: 'Fall erstellen',
			CASE_MANAGEMENT: 'Fallmanagement',
			UNKNOWN: 'Unbekannt',
			UNCATEGORIZED: 'Unkategorisiert',
			TITLE: 'Fälle',
			SEARCH_PLACEHOLDER: 'Suchen...',
			NO_MATCHING_RESULTS: 'Keine übereinstimmenden Ergebnisse',
			SEARCH_OWNER_PLACEHOLDER: 'Inhaber suchen...',
			SEARCH_WATCHERS_PLACEHOLDER: 'Beobachter suchen...',
			SELECT_OWNERS: 'Inhaber auswählen',
			FILTERS: 'Filter',
			GROUP_BY: 'Gruppieren nach',
			MORE: 'mehr',
			CASES_COUNT: '{{count}} Fälle',
			NO_CASES_FOUND: 'Keine Fälle verfügbar',
			CHECK_FILTERS_DATE_RANGE: 'Ändern Sie die Filter oder den Datumsbereich, um Ergebnisse anzuzeigen',
			CHIP: {
				OPEN: 'Offen',
				PENDING: 'Ausstehend',
				CLOSED: 'Geschlossen',
			},
			GROUP_BY_OPTION: {
				NONE: 'Keine',
				STATUS: 'Status',
				CATEGORY: 'Kategorie',
				SYSTEM: 'System',
				OWNER: 'Inhaber',
				CREATOR: 'Ersteller'
			},
			STATUS_OPTION: {
				1: 'Benachrichtigung an den Kunden',
				2: 'Benachrichtigung an den Standort',
				3: 'Standortuntersuchung',
				4: 'Ausstehende Wartung',
				5: 'Aufgeschobene Wartung',
				6: 'Ausstehende Abschaltung',
				7: 'Fall gelöst',
				8: 'Keine Maßnahme erforderlich'
			},
			CATEGORY_OPTION: {
				1: 'Zuverlässigkeit',
				2: 'Prozess',
				3: 'Instrumentierung',
				4: 'Mechanisch',
				5: 'Elektrisch',
				6: 'Inbetriebnahme/Abschaltung',
				7: 'Andere'
			},
			COLUMNS: {
				SELECT: 'Auswählen',
				NUMBER: 'Nummer',
				CASE_ID: 'Fall-ID',
				CASE_NAME: 'Fallname',
				SYSTEM_NAME: 'Systemname',
				ALERT_NAME: 'Alarmname',
				CATEGORY: 'Kategorie',
				STATUS: 'Status',
				CATCH: 'Catch',
				SOURCE: 'Quelle',
				OWNER: 'Inhaber',
				WATCHERS: 'Beobachter',
				CREATED_BY: 'Erstellt von',
				CREATED_ON: 'Erstellt am',
				SYSTEM_ANALYSIS: 'Systemanalyse & -interpretation',
				DUE_DATE: 'Fälligkeitsdatum',
				ESTIMATED_VALUE: 'Geschätzter Wert',
				AGREED_VALUE: 'Vereinbarter Wert',
				LAST_MODIFIED: 'Zuletzt geändert',
				RCH: 'Grundursachenhypothese',
				FEEDBACK_OUTCOME: 'Feedback & Ergebnis',
				WORK_ORDER: 'Arbeitsauftrag',
				POTENTIAL_IMPACT: 'Potenzielle Auswirkung',
			},
			MANAGEMENT: {
				FAILURE_MODE: 'Fehlermodus',
				SELECTED_VIEW: 'Ausgewählte Ansicht',
				USER_PREFERENCE_SETTINGS: 'Benutzereinstellungen',
				CASES_LAYOUT: 'Fälle-Layout',
				SIMPLIFIED: 'Vereinfacht',
				ADVANCED_DEFAULT: 'Erweitert (Standard)',
				LINKED_ALERT_REMOVED: 'Verknüpfter Alarm entfernt',
				LINKED_ALERT_REMOVED_DESC: 'Der verknüpfte Alarm dieses Falls ist nicht mehr verfügbar',
				LINK_NEW_ALERT: 'Neuen Alarm verknüpfen',
				DRAG_TO_REORDER: 'Click and drag to reorder',
				NO_TAGS_AVAILABLE_FOR_FM: 'Keine Tags für diesen Fehlermodus verfügbar.',
				NO_TAGS_AVAILABLE_FOR_ALERT: 'Keine Tags für diesen Alarm verfügbar.',
				NO_TAGS_ADDED: 'Keine Tags hinzugefügt',
				ADD_TAGS_FROM_DISPLAY_TAGS: 'Verwenden Sie das Panel „Tags anzeigen“ rechts, um diesem Fall Tags hinzuzufügen',
				VIEW_SETTINGS: 'Ansichtseinstellungen',
				DISPLAY_TAGS: 'Tags anzeigen',
				ASSET: 'Asset',
				SELECT_STATUS: 'Status auswählen',
				SELECT_CATEGORY: 'Kategorie auswählen',
				SEARCH_OWNER: 'Besitzer suchen...',
				SEARCH_WATCHERS: 'Beobachter suchen...',
			},
			TOOLTIP: {
				OPEN_IN_NEW_TAB: 'In neuem Tab öffnen',
				CUSTOMIZE_COLUMNS: 'Spalten anpassen',
				ONLY_OWNER_CATCH_TOOLTIP: 'Nur der Fallinhaber kann dies als Catch markieren',
				ONLY_OWNER_EDIT_TOOLTIP: 'Nur der Fallinhaber oder Ersteller kann dies ändern',
				MARKED_AS_CATCH_TOOLTIP: 'Als Catch markiert. Zum Aktualisieren Falldetails öffnen.',
				NOT_MARKED_AS_CATCH_TOOLTIP: 'Nicht als Catch markiert. Zum Ändern die Falldetails öffnen.',
				OPEN_CASE: '{{count}} offener Fall',
				OPEN_CASES: '{{count}} offene Fälle',
				PENDING_CASE: '{{count}} ausstehender Fall',
				PENDING_CASES: '{{count}} ausstehende Fälle',
				OPEN_TOOLTIP: 'Offene Fälle (beinhaltet):\nBenachrichtigung an den Kunden\nBenachrichtigung an den Standort\nStandortuntersuchung',
				PENDING_TOOLTIP: 'Ausstehende Maßnahme (beinhaltet):\nAusstehende Wartung\nAufgeschobene Wartung\nAusstehende Abschaltung',
				CLOSED_TOOLTIP: 'Geschlossene Fälle (beinhaltet):\nFall gelöst\nKeine Maßnahme erforderlich'
			},
			COMMON_DIALOG: {
				SELECT_ALL: 'Alle auswählen',
				REPORT_PDF_FILE_NAME: 'Berichts-PDF-Dateiname',
				INCLUDE_EVIDENCE_ATTACHMENTS: 'Beweisanhänge einschließen',
				GENERATING_REPORT_FOR: 'Sie erstellen einen Bericht für {{count}} verfolgte Fälle',
				SELECT_FMS_TIMELINE: 'Wählen Sie Fehlermodi aus der Zeitleiste aus, um sie dem Fall hinzuzufügen.',
				SELECT_FMS_FOR_RECOMMENDATIONS: 'Fehlermodi für Empfehlungen auswählen',
				RECOMMENDATIONS_FOR: 'Empfehlungen für {{name}}',
				NO_RECS_FOR_FM: 'Keine Empfehlungen für diesen Fehlermodus.',
				NO_OPEN_FMS: 'Keine offenen Fehlermodi.',
				NO_FMS_SELECTED: 'Keine Fehlermodi ausgewählt. Wählen Sie einen oder mehrere aus, um fortzufahren.',
				FMS_SELECTED: '{{count}} Fehlermodus/-modi ausgewählt',
				SELECT_FMS_TO_CONTINUE: 'Wählen Sie mindestens einen Fehlermodus aus, um fortzufahren',
				SELECT_RECS_TO_CONTINUE: 'Wählen Sie mindestens eine Empfehlung aus, um fortzufahren',
				SELECT_ANALYSIS_TO_CONTINUE: 'Wählen Sie mindestens eine Analyse aus, um fortzufahren',
				SELECT_VIEW_TO_CONTINUE: 'Wählen Sie mindestens eine Ansicht aus, um fortzufahren',
				SELECT_ITEM_TO_CONTINUE: 'Wählen Sie mindestens ein Element aus, um fortzufahren',
				ADD_SELECTED_RECOMMENDATIONS: 'Ausgewählte Empfehlungen hinzufügen',
				ADD_SELECTED_ANALYSIS: 'Ausgewählte Analyse hinzufügen',
				ADD_SELECTED_VIEWS: 'Ausgewählte Ansichten hinzufügen',
				ADD_SELECTED_FAILURE_MODES: 'Ausgewählte Fehlermodi hinzufügen',
			},
			FILTER: {
				FILTER_BY: 'Filtern nach',
				SEARCH_PLACEHOLDER: 'Nach Name oder ID suchen...',
				STATUS: 'Status',
				CATEGORY: 'Kategorie',
				CATCH: 'Catch',
				CREATED_BY: 'Erstellt von',
				WATCHERS: 'Beobachter',
				CLEAR_ALL: 'Alles löschen'
			},
			DETAILS: {
				CASE_NARRATIVE: 'Fallbeschreibung',
				SYSTEM_ANALYSIS: 'Systemanalyse & -interpretation',
				RCH: 'Grundursachenhypothese',
				POTENTIAL_IMPACT: 'Potenzielle Auswirkung',
				PROPOSED_ACTIONS: 'Vorgeschlagene Maßnahmen',
				FEEDBACK_OUTCOME: 'Feedback & Ergebnis',
				WORK_ORDER: 'Arbeitsauftrag',
				MARK_AS_CATCH: 'Als Catch markieren',
				SYSTEM_ANALYSIS_PLACEHOLDER: 'Zusammenfassung der Beobachtungen, des Beginns und des aktuellen Betriebszustands...',
				RCH_PLACEHOLDER: 'Beschreiben Sie die vermutete oder bestätigte Grundursache. Verknüpfen Sie sie mit FMs oder Ereignissen, falls relevant...',
				TAG_RELATED_FAILURE_MODES: 'Tag-bezogene Fehlermodi',
				ADD_FAILURE_MODES_TOOLTIP: 'Fehlermodi hinzufügen',
				ADD_FMS: 'FMs hinzufügen',
				RECOMMENDED_ACTIONS: 'Empfohlene Maßnahme(n)',
				ADD_SELECTED: 'Auswahl hinzufügen',
				ADD_SELECTED_RECOMMENDATIONS_TOOLTIP: 'Ausgewählte Empfehlungen hinzufügen',
				ADD_RECOMMENDATIONS_TOOLTIP: 'Empfehlungen hinzufügen',
				ADD_MORE: 'Mehr hinzufügen',
				ADD_MORE_RECOMMENDATIONS_TOOLTIP: 'Weitere Empfehlungen hinzufügen',
				PROPOSED_ACTIONS_PLACEHOLDER: 'Vorgeschlagene Maßnahmen, Zeitpläne, Risiko bei Nichtausführung...',
				POTENTIAL_IMPACT_PLACEHOLDER: 'Beschreiben Sie die potenziellen geschäftlichen/betrieblichen Auswirkungen (z. B. Ausfallrisiko, Qualitätsverlust, Sicherheit, Kosten)...',
				FEEDBACK_OUTCOME_PLACEHOLDER: 'Notizen vom Standort, umgesetzte Maßnahmen, gelernte Lektionen...',
				WORK_ORDER_PLACEHOLDER: 'z. B. WO-2026-001248 (Geben Sie die Arbeitsauftragsnummer oder Referenz aus Ihrem Wartungssystem ein.)',
				CANCEL: 'Abbrechen',
				SAVE: 'Speichern',
				EVIDENCE_ATTACHMENTS: 'Nachweise und Anhänge',
				SAVED_ANALYSIS: 'Gespeicherte Analysen',
				NO_SAVED_ANALYSIS_AVAILABLE: 'Keine gespeicherten Analysen verfügbar',
				ADD_SAVED_ANALYSIS: 'Gespeicherte Analyse hinzufügen',
				ADD_ANALYSIS: 'Analyse hinzufügen',
				LINK_ALERT_TO_ADD_ANALYSIS: 'Markieren Sie einen verknüpften Alarm mit gespeicherter Analyse, um sie hier hinzuzufügen',
				SAVED_VIEWS: 'Gespeicherte Ansichten',
				ONLY_OWNERS_SAVE_TAG_VIEWS: 'Nur der Alarm-Inhaber oder Fall-Inhaber kann Tag-Ansichten speichern oder ändern.',
				SAVE_CURRENT_TAG_VIEW: 'Aktuelle Tag-Ansicht speichern',
				SAVE_CURRENT_VIEW: 'Aktuelle Ansicht speichern',
				NO_SAVED_VIEWS_AVAILABLE: 'Keine gespeicherten Ansichten verfügbar',
				ADD_SAVED_VIEWS: 'Gespeicherte Ansichten hinzufügen',
				ADD_VIEW: 'Ansicht hinzufügen',
				LINK_ALERT_TO_ADD_VIEWS: 'Markieren Sie einen verknüpften Alarm mit gespeicherten Ansichten, um sie hier hinzuzufügen',
				TAG_RELATED_ALERTS: 'Tag-bezogene Warnungen',
				ADD_ALERTS: 'Warnungen hinzufügen',
				UPLOAD_EVIDENCES: 'Nachweise hochladen',
				UPLOAD_PLACEHOLDER: 'Nachweis anhängen, per Drag & Drop verschieben oder einfügen...',
				VALUE_IMPACT: 'Wertauswirkung',
				VALUE_CALCULATION_INPUTS: 'Eingaben zur Wertberechnung',
				LIKELIHOOD: 'Wahrscheinlichkeit (%)',
				IMPACT: 'Auswirkung',
				LIKELIHOOD_IMPACT_MATRIX: 'Wahrscheinlichkeits-Auswirkungs-Matrix',
				SAVINGS: 'Einsparungen',
				CONTRIBUTION_FACTOR: 'Beitragsfaktor',
				ESTIMATED_VALUE: 'Geschätzter Wert (USD)',
				AGREED_VALUE: 'Vereinbarter Wert (USD)',
				TOTAL_PRODUCTION_LOST: 'Gesamter Produktionsverlust (KBOE)',
				TOTAL_FLARING_AVOIDED: 'Vermiedene Abfackelung (MT CO2)',
				PRODUCTIVITY: 'Produktivität (Stunden)',
				EMISSIONS: 'Emissionen (Tonnen)',
				SELECT_VALUE: 'Wert auswählen',
				ENTER_VALUE: 'Wert eingeben',
				EXPORT_AS_PDF: 'Als PDF exportieren',
				SAVE_CASE_FIRST: 'Bitte speichern Sie zuerst den Fall',
				GENERATE_PDF: 'PDF generieren',
				SEND_VIA_EMAIL: 'Per E-Mail senden',
				SHARE_VIA_EMAIL: 'Per E-Mail teilen',
				CLEAR_ALL: 'Alles löschen',
				CLEAR_ALL_TOOLTIP: 'Alle Informationen löschen',
				SAVE_TOOLTIP: 'Informationen speichern',
				OPTIONAL_FIELD_SAVE_ERROR: 'Fehler beim Speichern der Änderungen an optionalen Feldern'
			},
			EMAIL: {
				SEND_VIA_MAIL: 'Per E-Mail senden',
				RECEIVER_EMAIL_IDS: 'Empfänger-E-Mail-IDs',
				SEARCH_USER: 'Benutzer suchen',
				SELECT_ENTER_EMAIL_IDS: 'E-Mail-IDs auswählen/eingeben',
				DONE: 'Fertig',
				SELECT: 'Auswählen',
				PLEASE_SELECT_RECIPIENTS: 'Bitte Empfänger auswählen',
				SUBJECT: 'Betreff',
				DEFAULT_SUBJECT: 'Uptime AI: Fall erstellt',
				ASSET: 'Asset',
				OWNER: 'Inhaber',
				CREATED_BY: 'Erstellt von',
				CREATED_ON: 'Erstellt am',
				CASE_STATUS: 'Fallstatus',
				CATEGORY: 'Kategorie',
				MODIFIED_ON: 'Geändert am',
				CASE_NAME: 'Fallname',
				USERS: 'Benutzer',
				CANCEL: 'Abbrechen',
				SEND_EMAIL: 'E-Mail senden',
				PLEASE_SELECT_RECIPIENTS_TOOLTIP: 'Bitte Empfänger auswählen',
			},
			NOTIFICATION: {
				FMS_ADDED_SUCCESS: 'Fehlermodi erfolgreich hinzugefügt',
				ANALYSIS_ADDED_SUCCESS: 'Ausgewählte Analysen erfolgreich hinzugefügt',
				VIEWS_ADDED_SUCCESS: 'Ausgewählte Ansichten erfolgreich hinzugefügt',
				FMS_ADDED_SUCCESS_ALT: 'Ausgewählte Fehlermodi erfolgreich hinzugefügt',
				ALL_RECOMMENDATIONS_ADDED: 'Alle Empfehlungen aus freigegebenen Fehlermodi hinzugefügt',
				RECOMMENDATIONS_ADDED_SUCCESS: 'Ausgewählte Empfehlungen erfolgreich hinzugefügt',
				GENERATING_PDF: 'Ihr PDF wird generiert... Wir senden es Ihnen per E-Mail, wenn es fertig ist.',
				NO_VALID_FILES: 'Keine gültigen Dateien ausgewählt. Nur Dateien mit den Erweiterungen {{extensions}} sind zulässig',
				UPLOAD_SIZE_LIMIT: '{{name}} konnte aufgrund der Dateigrößenbeschränkung nicht hochgeladen werden.',
				UPLOAD_FAILED: '{{name}} konnte nicht hochgeladen werden.',
				FAILED_TO_GENERATE_PDF: 'PDF-Generierung fehlgeschlagen',
				BULK_REPORT_TITLE: 'Aggregierten Fallbericht generieren',
				PREPARING_DOWNLOAD: 'Ihr Download wird vorbereitet. Dies kann einen Moment dauern.',
				CSV_DOWNLOAD_SUCCESS: 'CSV erfolgreich heruntergeladen',
				CSV_DOWNLOAD_FAILED: 'CSV-Export fehlgeschlagen',
				SELECT_STATUS_TO_SAVE: 'Bitte wählen Sie den Fallstatus aus, um den Fall zu speichern',
				SELECT_CATEGORY_TO_SAVE: 'Bitte wählen Sie die Fallkategorie aus, um den Fall zu speichern',
				CASE_ADDED_SUCCESS: 'Fall erfolgreich hinzugefügt',
				CASE_UPDATED_SUCCESS: 'Fall erfolgreich aktualisiert',
				ENTER_TITLE_TO_PROCEED: 'Bitte geben Sie einen Titel ein, um fortzufahren'
			}
		},
		IOW: {
			FACILITY: 'Anlage',
			SELECT_FACILITY: 'Anlage auswählen',
			SEARCH_FACILITY: 'Anlage suchen...',
			NO_FACILITY_FOUND: 'Keine passende Anlage gefunden',
			UNIT: 'Einheit',
			SELECT_UNIT: 'Einheit auswählen',
			SEARCH_UNIT: 'Einheit suchen...',
			NO_UNIT_FOUND: 'Keine passende Einheit gefunden',
			SYSTEM: 'System',
			SELECT_SYSTEM: 'System auswählen',
			SEARCH_SYSTEM: 'System suchen...',
			NO_SYSTEM_FOUND: 'Kein passendes System gefunden',
			TAGS: 'Tags',
			SELECT_TAGS: 'Tags auswählen',
			SEARCH_TAG: 'Tag suchen...',
			NO_TAG_FOUND: 'Kein passendes Tag gefunden',
			CASE_STATUS: 'Fallstatus',
			EXCEEDANCE_TYPE: 'Überschreitungstyp',
			SELECT_EXCEEDANCE_TYPE: 'Überschreitungstyp auswählen',
			SELECT_ALL: 'Alle auswählen',
			ANALYSE_TOP_TRENDS: 'Top 20 Trends analysieren',
			SAVE: 'Speichern',
			COPY: 'Kopieren',
			ADD_NEW: 'Neu hinzufügen',
			EDIT: 'Bearbeiten',
			DELETE: 'Löschen',
			DOWNLOAD: 'Herunterladen',
			ACTIVE_EXCEEDANCES: 'Aktive Überschreitungen',
			DATE_RANGE_DISABLED_TOOLTIP: 'Die Datumsbereichsauswahl ist nicht verfügbar, wenn der Filter für aktive Überschreitungen ausgewählt ist.',
			SELECT_DATE_RANGE: 'Datumsbereich auswählen',
			ENTER_DATE_RANGE: 'Datumsbereich eingeben',
			START_DATE: 'Startdatum',
			END_DATE: 'Enddatum',
			APPLY_TIME_CHANGE: 'Zeitänderung anwenden',
			SUMMARY: 'Zusammenfassung',
			SELECT_SYSTEM_MESSAGE: 'Bitte wählen Sie ein System aus, um Überschreitungen anzuzeigen.',
			LOADING: 'Wird geladen...',
			NO_EXCEEDANCE_FOUND: 'Keine Überschreitung gefunden.',
			NO_ACTIVE_EXCEEDANCE_FOUND: 'Keine aktive Überschreitung gefunden.',
			NO_DATA_AVAILABLE: 'Für den ausgewählten Zeitraum sind keine Daten verfügbar',
			TRY_SELECTING_DIFFERENT_RANGE: 'Versuchen Sie, einen anderen Zeitraum auszuwählen',
			CRUNCHING_DATA: 'Daten werden verarbeitet, bitte warten!',
			TOTAL_EXCEEDANCES: 'Gesamtzahl der Systemüberschreitungen',
			GROUP_TRENDS: 'Trends gruppieren',
			TRENDS_PER_CHART: 'Trends / Diagramm (bis zu 8)',
			CANCEL: 'Abbrechen',
			PROCEED: 'Fortfahren',
			SELECT: 'Auswählen',
			SELECT_DATE_RANGE_LABEL: 'Datumsbereich auswählen',
			DATE_RANGE: 'Datumsbereich',
			DATE_RANGE_REQUIRED: 'Datumsbereich ist erforderlich.',
			REGROUP_EXCEEDENCES: 'Überschreitungen neu gruppieren',
			DURATION_MINUTES: 'Dauer (in Min.)',
			DURATION_REQUIRED: 'Dauer ist erforderlich.',
			ENTER_VALID_NUMBER: 'Bitte geben Sie eine gültige Zahl ein.',
			DOWNLOAD_TITLE: 'IOW-Bericht herunterladen',
			GROUP_BY_SYSTEM: 'Nach System gruppieren',
			GROUP_BY_UOM: 'Nach Maßeinheit gruppieren',
			GROUP_COUNT_REQUIRED: 'Gruppenanzahl ist erforderlich.',
			MIN_VALUE_2: 'Der Mindestwert ist 2.',
			MAX_VALUE_8: 'Der Höchstwert ist 8.',
			GROUP_COUNT_INVALID: 'Gruppenanzahl ist ungültig.',
			WATCHERS: 'Beobachter',
			CLOSE: 'Schließen',
		},
		CAPACITY_OPTIMIZATION: {
			COMMON: {
				SAVE: 'Speichern',
				CANCEL: 'Abbrechen',
				DELETE: 'Löschen',
				EDIT: 'Bearbeiten',
				CLOSE: 'Schließen',
				LOADING: 'Laden...',
				SEARCH: 'Suchen...',
				ACTIONS: 'Aktionen',
				NAME: 'Name',
				DESCRIPTION: 'Beschreibung',
				STATUS: 'Status',
				TYPE: 'Typ',
				CREATED: 'Erstellt',
				LAST_UPDATED: 'Zuletzt aktualisiert',
				DOWNLOAD: 'Herunterladen',
				UPLOAD: 'Hochladen',
				IMPORT: 'Importieren',
				EXPORT: 'Exportieren',
				RUN: 'Ausführen',
				STOP: 'Stoppen',
				YES: 'Ja',
				NO: 'Nein',
				APPLY: 'Anwenden',
				RESET: 'Zurücksetzen',
				CONFIRM: 'Bestätigen',
				BACK: 'Zurück',
				NEXT: 'Weiter',
			},
			NAV: {
				SCENARIOS: 'Szenarien',
				DASHBOARD: 'Dashboard',
				COMPARISON: 'Vergleich',
				SETTINGS: 'Einstellungen',
				MODELS: 'Modelle',
				SIMULATION: 'Simulation',
				REALTIME: 'Echtzeit',
				TOPOLOGY: 'Topologie',
				STRATEGIC: 'Strategisch',
			},
			LANDING: {
				TITLE: 'Kapazitätsoptimierung',
				SUBTITLE: 'Optimieren Sie die Strom- und Wassererzeugung in Ihrer Flotte',
			},
			SCENARIO: {
				TITLE: 'Szenariobibliothek',
				NEW_SCENARIO: 'Neues Szenario',
				SEARCH_SCENARIO: 'Szenario suchen',
				DUPLICATE: 'Duplizieren',
				RUN_OPTIMIZATION: 'Optimierung starten',
				FORCE_STOP: 'Erzwungener Stopp',
				VIEW_RESULTS: 'Ergebnisse anzeigen',
				SCENARIO_NAME: 'Szenarioname',
				CLASSIFICATION: 'Klassifizierung',
				SOLVER: 'Solver',
				RUN_MODE: 'Ausführungsmodus',
				STATUS_READY: 'Bereit',
				STATUS_RUNNING: 'Läuft',
				STATUS_COMPLETED: 'Abgeschlossen',
				STATUS_FAILED: 'Fehlgeschlagen',
				PROMOTE: 'Hochstufen',
				ALTERNATIVE_SOLVER: 'Alternativer Solver',
			},
			CONFIG: {
				TITLE: 'Szenariokonfiguration',
				TABS: {
					AVAILABILITY: 'Anlagenverfügbarkeit',
					DEMAND: 'Nachfrageprognose',
					CONSTRAINTS: 'Einschränkungen',
					SOLVER: 'Solver & Ausführung',
					TESTING: 'Testprofile',
					GROWTH_FACTOR: 'Wachstumsfaktor',
					SWRO_AVAILABILITY: 'SWRO-Verfügbarkeit',
				},
				HORIZON: 'Horizont (Std.)',
				STEP: 'Schritt (min)',
				START_HOUR: 'Startstunde',
				TARGET_DATE: 'Zieldatum',
				LATITUDE: 'Breitengrad',
				LONGITUDE: 'Längengrad',
				PERF_CURVE: 'Leistungskurvenquelle',
				OEM_CURVES: 'OEM-Designkurven',
				HISTORICAL_ML: 'Historische Daten (ML)',
				PLANNING_OFFLINE: 'Planung (Offline)',
				LIVE_REALTIME: 'Live (Echtzeit)',
				UPLOAD_CSV: 'CSV hochladen',
				DOWNLOAD_CSV: 'CSV herunterladen',
				POWER_MW: 'Leistung (MW)',
				WATER_MIGD: 'Wasser (MIGD)',
				POWER_IMPORT: 'Stromimport',
				POWER_EXPORT: 'Stromexport',
				WATER_IMPORT: 'Wasserimport',
				WATER_EXPORT: 'Wasserexport',
				INITIAL_STATUS: 'Anfangsstatus',
				DURATION_IN_STATE: 'Dauer im Zustand (Stunden)',
				ON: 'EIN',
				OFF: 'AUS',
			},
			CONSTRAINTS: {
				TITLE: 'Einschränkungskonfiguration',
				ANCILLARY_SERVICES: 'Hilfsdienste',
				MIN_UP_DOWN_TIME: 'Mindest-Ein-/Ausschaltzeit',
				RAMP_LIMITS: 'Rampenlimits',
				FIXED_LOADS: 'Festlasten',
				AGC_DISPATCH: 'AGC-Dispatch',
				ALLOW_LOAD_SHEDDING: 'Lastabwurf erlauben',
				ALLOW_WATER_SHORTAGE: 'Wasserknappheit erlauben',
				ENFORCE_FUEL_LIMITS: 'Kraftstofflimits durchsetzen',
				SPINNING_RESERVE: 'Drehende Reserve (MW)',
				OPERATING_RESERVE: 'Betriebsreserve (MW)',
				WATER_RESERVE: 'Wasserreserve (MIGD)',
			},
			GROWTH_FACTOR: {
				TITLE: 'Wachstumsfaktorkonfiguration',
				ADJUSTMENT_TYPE: 'Anpassungstyp',
				VALUE: 'Wachstumsfaktorwert',
				TARGET_METRIC: 'Zielmetrik',
				START_TIME: 'Startzeit',
				END_TIME: 'Endzeit',
			},
			SWRO: {
				TITLE: 'SWRO-Verfügbarkeitskonfiguration',
				SELECT_PLANTS: 'SWRO-Anlagen auswählen',
				FLAT_VALUE: 'Flacher Verfügbarkeitswert',
			},
			DASHBOARD: {
				TITLE: 'Optimierungsergebnisse',
				STATION_FILTER: 'Stationsfilter',
				ALL_STATIONS: 'Alle Stationen',
				TOTAL_COST: 'Gesamtkosten',
				POWER_GENERATION: 'Stromerzeugung',
				WATER_PRODUCTION: 'Wasserproduktion',
				FUEL_CONSUMPTION: 'Kraftstoffverbrauch',
			},
			COMPARISON: {
				TITLE: 'Szenariovergleich',
				SEARCH_SCENARIO: 'Szenario suchen',
				BASELINE: 'Basislinie',
				SELECT_BASELINE: 'Basislinie auswählen',
			},
			SETTINGS: {
				TITLE: 'Einstellungen',
				PLATFORM: 'Plattform-Setup',
				DATA_MGMT: 'Datenverwaltung',
				MODULE_CONFIG: 'Modulkonfiguration',
				TAGS: 'Tags',
				TEMPLATES: 'Vorlagen',
				TOPOLOGY: 'Topologie',
				TRAINING: 'Training',
				USERS: 'Benutzer',
			},
			PLATFORM_SETUP: {
				TITLE: 'Plattform- und Anlagen-Setup',
				ENTERPRISE_NAME: 'Unternehmensname',
				STREET_ADDRESS: 'Straßenadresse',
				CITY: 'Stadt',
				STATE: 'Bundesland',
				COUNTRY: 'Land',
				ZIP_CODE: 'Postleitzahl',
				LATITUDE: 'Breitengrad',
				LONGITUDE: 'Längengrad',
				INDUSTRY: 'Branche',
				TIMEZONE: 'Zeitzone',
				BUSINESS: 'Unternehmen',
				NOTES: 'Notizen',
				COST_PER_UNIT: 'Kosten pro Einheit ($)',
				CAPACITY_PER_HOUR: 'Kapazität pro Stunde',
				REVENUE_PER_HOUR: 'Umsatz pro Stunde ($)',
				OPERATIONAL_MARGIN: 'Betriebsmarge (%)',
				TECHNICIAN_SALARY: 'Technikergehalt ($/Std.)',
				HELPER_SALARY: 'Helfergehalt ($/Std.)',
			},
			USER_MGMT: {
				TITLE: 'Benutzerverwaltung',
				ADD_USER: 'Benutzer hinzufügen',
				USERNAME: 'Benutzername',
				DISPLAY_NAME: 'Anzeigename',
				PASSWORD: 'Passwort',
				ROLE: 'Rolle',
				ADMIN: 'Administrator',
				SUPER_USER: 'Superbenutzer',
				USER: 'Benutzer',
				NO_PERMISSION: 'Sie haben keine Berechtigung, auf diesen Bereich zuzugreifen.',
			},
			SIMULATION: {
				TITLE: 'Sensitivitätssimulation',
				TARGET_EQUIPMENT: 'Zielgerät',
				SWEEP_PARAMETER: 'Sweep-Parameter',
				START_VALUE: 'Startwert',
				END_VALUE: 'Endwert',
				STEPS: 'Schritte',
				RUN_SWEEP: 'Sweep ausführen',
			},
			REALTIME: {
				TITLE: 'Echtzeit-Dashboard',
				CONFIRMED_TARGET: 'Bestätigtes Ziel',
				SELECT_DATE: 'Datum auswählen',
				SCENARIO_NAME: 'Szenarioname',
				HORIZON_HOURS: 'Horizont (Stunden)',
				SOLVER: 'Solver',
				PERF_CURVE: 'Leistungskurve',
				START_MODE: 'Startmodus',
				RAMP_LIMITS: 'Rampenlimits',
				MIN_UP_DOWN: 'Mindest-Ein-/Ausschaltzeit',
				ANCILLARY: 'Hilfsdienste',
				IMPORT_SCENARIO: 'Aus Szenario importieren',
			},
			TOPOLOGY: {
				TITLE: 'SCADA-Topologie',
				POWER_VIEW: 'Strom',
				WATER_VIEW: 'Wasser',
				AUTO_CORRECT: 'Automatische Korrektur',
				FLEET_OVERVIEW: 'Flottenübersicht',
			},
			DEMAND: {
				HORIZON: 'Horizont (Std.)',
				STEP: 'Schritt (min)',
				START_HOUR: 'Startstunde',
				UPDATE_PLAN: 'Bedarfsplan aktualisieren',
				UPDATE_PLAN_TOOLTIP: 'Alle Zeitplantabellen auf das neue Zeitraster neu abtasten und die bereits erfassten Werte interpolieren.',
				UPDATE_PLAN_HINT: 'Zeitplanparameter geändert — auf „Bedarfsplan aktualisieren“ klicken, um die Tabellen neu abzutasten.',
				SOLAR_INPUT: 'Solareingabe',
				SOLAR_PHASES_ACTIVE: 'Phasen aktiv',
			},
			TAG_EXPLORER: {
				TITLE: 'Tag-Explorer',
				SUBTITLE: 'Historische Werte für jeden zugeordneten Tag darstellen. Punkte werden serverseitig aggregiert, damit auch lange Zeiträume flüssig bleiben.',
				TAGS: 'Tags',
				TAGS_PLACEHOLDER: 'Bis zu 10 Tags auswählen',
				TAGS_SEARCH_PLACEHOLDER: 'Nach Parameter oder Tag-Name suchen...',
				START_DATE: 'Startdatum',
				END_DATE: 'Enddatum',
				PLOT: 'Darstellen',
				LOADING_TAGS: 'Tag-Liste wird geladen...',
				QUERYING: 'Historische Daten werden abgefragt...',
				NO_DATA_FOR: 'Keine Daten in diesem Zeitraum für:',
				UNITS_DROPPED: 'Das Diagramm zeigt zwei Einheiten gleichzeitig; Reihen in {{units}} wurden nicht dargestellt.',
				BUCKET_HINT: 'Aggregiert auf {{bucket}}-Intervalle.',
				COL_PARAMETER: 'Parameter',
				COL_TAG: 'Tag',
				COL_UNIT: 'Einheit',
				COL_POINTS: 'Punkte',
				COL_MIN: 'Min.',
				COL_MAX: 'Max.',
				COL_AVERAGE: 'Mittelwert',
				GROUP_SYSTEM_DEMAND: 'Systembedarf',
				GRID_POWER_DEMAND: 'Netz-Strombedarf',
				GRID_WATER_DEMAND: 'Netz-Wasserbedarf',
				AXIS_TIME: 'Zeit',
				AXIS_VALUE: 'Wert',
				REQUEST_FAILED: 'Anfrage fehlgeschlagen ({{status}})',
				SERVER_UNREACHABLE: 'Server nicht erreichbar.',
			},
		},
		DISPLAY_TAGS: {
			HEADER: 'Andere Tags anzeigen',
			CLOSE: 'Schließen',
			SEARCH_PLACEHOLDER: 'Suchen...',
			FILTER_TOOLTIP: 'Tags filtern',
			SELECT_SYSTEM: 'System auswählen',
			ALL_SYSTEMS: 'Alle Systeme',
			FILTER_BY: 'Filtern nach',
			ALL_TAGS: 'Alle Tags',
			MODELED_TAGS: 'Modellierte Tags',
			SHOW_CALCULATED_TAGS: 'Berechnete Tags anzeigen',
			NO_MATCHING_RESULTS: 'Keine passenden Ergebnisse',
			START_TYPING: 'Beginnen Sie zu tippen, um passende Tags zu sehen.',
		},
		PROCESS: {
      LIST_TABLE: {
				NO_CURRENT_BATCHES_TITLE: 'Keine aktuellen Chargen',
				NO_CURRENT_BATCHES_CONTENT: 'Aktive oder laufende Chargen werden hier angezeigt, sobald ein Prozess startet.',
				NO_PAST_BATCHES_TITLE: 'Keine vergangenen Chargen',
				NO_PAST_BATCHES_CONTENT: 'Abgeschlossene, gestoppte oder fehlgeschlagene Chargen werden hier angezeigt, sobald ein Chargenlauf beendet ist.'
			},
			LIST: {
				PAGE_TITLE: 'Prozess',
				SEARCH_PLACEHOLDER: 'Nach Batch-ID suchen',
				CURRENT_BATCHES_TAB: 'Aktuelle Batches',
				PAST_BATCHES_TAB: 'Vergangene Batches',
				FILTER: {
					SYSTEM: 'System',
					SEARCH_SYSTEM: 'System suchen',
					CREATED_BETWEEN: 'Erstellt zwischen',
					STARTED_ON: 'Gestartet am',
					CLEAR_DATE: 'Datum löschen',
					OWNER: 'Verantwortlicher',
					SEARCH_OWNER: 'Verantwortlichen suchen',
				},
			},
			TABLE: {
				COL_BATCH_NAME_ID: 'Batch-Name / ID',
				COL_START_DATE_TIME: 'Startdatum / -uhrzeit',
				COL_END_DATE_TIME: 'Enddatum / -uhrzeit',
				COL_LAST_UPDATED: 'Zuletzt aktualisiert',
				COL_DURATION: 'Dauer',
				COL_RUN_TIME: 'Laufzeit',
				COL_STATUS: 'Status',
				COL_OWNER: 'Verantwortlicher',
				COL_WATCHERS: 'Beobachter',
				COL_PERCENT_COMPLETE: 'Fertigstellungsgrad',
				COL_PROJECTED_PRODUCT: 'Geplantes Produkt',
				COL_FINAL_PRODUCT: 'Endprodukt',
				SELECT_COLUMNS: 'Spalten auswählen',
				SAVE_VIEW: 'Ansicht speichern',
				APPLY: 'Anwenden',
				LOADING: 'Wird geladen...',
				NO_RECORDS: 'Keine Einträge gefunden',
			},
			DETAILS: {
				TITLE_PREFIX: 'Prozessdetails',
				BATCH_NAME: 'Batch-Name',
				FACILITY: 'Anlage',
				UNIT: 'Einheit',
				SYSTEM: 'System',
				STATUS: 'Status',
				START_DATE_TIME: 'Startdatum / -uhrzeit',
				LAST_UPDATED: 'Zuletzt aktualisiert',
				OVERLAY: 'Überlagerung',
				STACKED: 'Gestapelt',
				GRID: 'Raster',
				SELECT_OWNER: 'Verantwortlichen auswählen',
				WATCHERS_TOOLTIP: 'Beobachter',
				FILTER: {
					LAB_PARAMETERS: 'Laborparameter',
					BATCH: 'Batch',
					OTHERS: 'Sonstige',
					SEARCH_BATCH: 'Batch suchen',
				},
				GOLDEN_BATCH_BAND: 'Goldener Batch-Bereich',
				PREDICTION: 'Vorhersage',
			},
		},
		DYNAMIC_DASHBOARD: {
			DASHBOARD_WIZARD: 'Dashboard-Assistent',
			ADD_NEW_DASHBOARD: 'Neues Dashboard hinzufügen',
			CREATE_DASHBOARD: 'Dashboard erstellen',
			SEARCH: 'Suchen',
			EDIT_MODE: 'Bearbeitungsmodus',
			SAVE_DASHBOARD: 'Dashboard speichern',
			PUBLIC: 'Öffentlich',
			PRIVATE: 'Privat',
			SENSOR_DATA: 'Sensordaten',
			NON_SENSOR_DATA: 'Nicht-Sensordaten',
			ENTER_DATE_RANGE: 'Datumsbereich eingeben',
			START_DATE: 'Startdatum',
			END_DATE: 'Enddatum',
			APPLY_TIME_CHANGE: 'Zeitänderung anwenden',
			MORE: 'Mehr',
			NOTHING_CREATED: 'Sie haben noch nichts erstellt',
			LOADING: 'Wird geladen...',
			NO_DATA: 'Keine Daten für die ausgewählten Attribute verfügbar',
			CONFIGURE_ATTRIBUTES: 'Attribute zum Rendern konfigurieren',
			SELECT_CHART_TYPE: 'Diagrammtyp auswählen',
			CONFIG_ONLY_WIDGET: 'Dies ist ein reines Konfigurations-Widget. Es werden keine Diagramme angezeigt.',
			TYPE_OF_CONFIG: 'Konfigurationstyp:',
			GROUP_KEY: 'Gruppenschlüssel:',
			SPECIFICATION_LIMIT: 'Spezifikationsgrenze',
			PLEASE_ADD_STATS: 'Bitte Statistik-Karte hinzufügen',
			ADD_ATTRIBUTES: 'Attribute zur Anzeige hinzufügen',
			PROCESSING_DATA: 'Daten werden verarbeitet – bitte warten...',
			EDIT: 'Bearbeiten',
			DUPLICATE: 'Duplizieren',
			REMOVE: 'Entfernen',
			CANCEL: 'Abbrechen',
			SAVE: 'Speichern',
			BACK: 'Zurück',
			PERFORMANCE_CURVE_OF: 'Leistungskurve von',
			NO_WIDGETS_AVAILABLE: 'Keine Widgets verfügbar. Fügen Sie ein Widget hinzu, um zu starten',
			TAB_EMPTY_STATES: {
				ALL: {
					HEADING: 'Noch keine Dashboards',
					CONTENT: 'Erstellen Sie Ihr erstes Dashboard, um wichtige Kennzahlen, Trends und Erkenntnisse an einem Ort zu überwachen.',
				},
				MY_DASHBOARD: {
					HEADING: 'Keine von Ihnen erstellten Dashboards',
					CONTENT: 'Von Ihnen erstellte Dashboards werden hier angezeigt.',
				},
				SHARED: {
					HEADING: 'Noch keine geteilten Dashboards',
					CONTENT: 'Dashboards, die andere mit Ihnen teilen, werden hier angezeigt.',
				},
				PRIVATE: {
					HEADING: 'Noch keine privaten Dashboards',
					CONTENT: 'Dashboards, die Sie erstellen und privat halten, werden hier angezeigt.',
				},
				SEARCH: {
					HEADING: 'Keine Dashboards gefunden',
					CONTENT: 'Versuchen Sie ein anderes Stichwort oder löschen Sie die Suche.',
				},
			},
			SLICER_POPUP: {
				SELECT_ALL: 'Select All',
				PREVIEW: 'Preview',
				APPLY_AND_CLOSE: 'Apply & Close',
				APPLYING: 'Applying...',
      		},
			COLLABORATOR: {
				TITLE_SUFFIX: 'Mitarbeiter',
				SEARCH_PLACEHOLDER: 'Nach Name oder E-Mail suchen',
				COLLABORATED_WITH: 'Zusammengearbeitet mit',
				USERS: 'Benutzern',
				ALL_USERS: 'Alle Benutzer',
				OWNER: 'Eigentümer',
				CANCEL: 'Abbrechen',
				SAVE: 'Speichern',
				CANCEL_CHANGES: 'Änderungen verwerfen',
				SAVE_CHANGES: 'Änderungen speichern',
				ROLE: {
					FULL: 'Vollständig',
					FULL_DESC: 'Vollständiger Zugriff',
					EDIT: 'Bearbeiten',
					EDIT_DESC: 'Anzeige- und Bearbeitungszugriff',
					VIEW: 'Anzeigen',
					VIEW_DESC: 'Nur Anzeigezugriff',
				},
			},
			EDIT_PANEL: {
				CREATE_PANEL: 'Panel erstellen',
				EDIT_PANEL: 'Panel bearbeiten',
				CANCEL: 'Abbrechen',
				SAVE: 'Speichern',
				SELECT_CHART_TYPE: 'Diagrammtyp',
				ADD_TITLE: 'Titel',
				PANEL_NAME: 'Panelname',
				ADDITIONAL_GRAPH_OPTIONS: 'Zusätzliche Diagrammoptionen',
				SETTINGS: 'Einstellungen',
			},
			DASHBOARD_POPUP: {
				TITLE: 'Dashboard',
				SELECT_TYPE: 'Dashboard-Typ auswählen',
				TYPE_DASHBOARD: 'Dashboard',
				TYPE_CONFIG: 'Konfiguration',
				TYPE_PERFORMANCE_CURVES: 'Leistungskurven',
				NAME: 'Name',
				NAME_TAKEN: 'Name ist bereits vergeben',
				NAME_REQUIRED: 'Name ist erforderlich',
				LEVEL: 'Ebene',
				SELECT_LEVEL: 'Ebene auswählen',
				FACILITY: 'Anlage',
				SELECT_FACILITY: 'Anlage auswählen',
				FACILITY_REQUIRED: 'Anlage ist erforderlich',
				UNIT: 'Einheit',
				SELECT_UNIT: 'Einheit auswählen',
				UNIT_REQUIRED: 'Einheit ist erforderlich',
				CANCEL: 'Abbrechen',
				SAVE: 'Speichern',
			},
			TAG_PANEL: {
				ENABLE_QUICK_PLOT: 'Schnelldiagramm aktivieren',
				SELECT_UNITS: 'Einheiten auswählen',
				SEARCH_UNIT: 'Einheit suchen...',
				NO_UNIT_FOUND: 'Keine passende Einheit gefunden',
				SELECT_SYSTEMS: 'Systeme auswählen',
				SEARCH_SYSTEM: 'System suchen...',
				NO_SYSTEM_FOUND: 'Kein passendes System gefunden',
				ADD: 'Hinzufügen',
				PREVIEW: 'Vorschau',
				PREVIEW_CHART: 'Diagrammvorschau',
				DRAG_AND_DROP: 'Ziehen und Ablegen',
				COPY: 'Kopieren',
				DELETE: 'Löschen',
				EDIT: 'Bearbeiten',
				LABEL: 'Bezeichnung',
				TAG: 'Tag',
				X_TAG: 'X-Tag',
				Y_TAG: 'Y-Tag',
				Z_TAG: 'Z-Tag',
				SEARCH_TAG: 'Tag suchen...',
				NO_TAG_FOUND: 'Kein passender Tag gefunden',
				DESIGN_VALUE_TAG: 'Designwert-Tag',
				CALC_TYPE: 'Berechnungstyp',
				CALC_ORIGINAL: 'Original',
				CALC_AVERAGE: 'Durchschnitt',
				CALC_MOVING_AVG: 'Gleitender Durchschnitt',
				CALC_MAX: 'Maximum',
				CALC_MIN: 'Minimum',
				CALC_SUM: 'Summe',
				CALC_MEDIAN: 'Median',
				CALC_MOVING_DELTA: 'Gleitendes Delta',
				CALC_COUNT_EVENT: 'Ereignisse zählen',
				AGGREGATE: 'Aggregieren',
				AGGREGATE_WINDOW: 'Aggregationsfenster',
				COUNT_WINDOW: 'Zählfenster',
				AGGREGATE_WINDOW_UNIT: 'Aggregationsfenstereinheit',
				COUNT_WINDOW_UNIT: 'Zählfenstereinheit',
				WINDOW_SIZE: 'Fenstergröße',
				MINUTES: 'Minute(n)',
				HOURS: 'Stunde(n)',
				DAYS: 'Tag(e)',
				WEEKS: 'Woche(n)',
				GREATER_THAN: 'Größer als',
				LESS_THAN: 'Kleiner als',
				EQUAL_TO: 'Gleich',
				RESET_FILTER: 'Filter zurücksetzen',
				SELECT_AXIS: 'Achse auswählen',
				X_AXIS: 'X-Achse',
				Y_AXIS: 'Y-Achse',
				SPEC_LABEL: 'Bezeichnung (max. 6 Zeichen)',
				DESCRIPTION: 'Beschreibung',
				VALUE: 'Wert',
				ENABLE_TREND_CHART: 'Trenddiagramm aktivieren',
				ADD_TITLE: 'Titel hinzufügen',
				ADD_SUBTITLE: 'Untertitel hinzufügen',
				UNIT: 'Einheit',
				SELECT_ICON: 'Symbol auswählen',
				SEARCH_ICONS: 'Symbole suchen...',
				FORMULA: 'Formel',
				FORMULA_PLACEHOLDER: 'Formel eingeben, z.B. (A+B)*C',
				ERROR_INVALID_VARS: 'Ungültige Variable(n) verwendet',
				ERROR_INVALID_SYNTAX: 'Ungültiger mathematischer Ausdruck',
				ERROR_FORMULA_REQUIRED: 'Formel ist erforderlich',
				ERROR_LESS_THAN_THRESHOLD: "Dieser Wert muss kleiner sein als der Schwellenwert 'Kleiner als'.",
				ERROR_GREATER_THAN_THRESHOLD: "Dieser Wert muss größer sein als der Schwellenwert 'Größer als'.",
				SELECT_CHILDREN: 'Untergeordnete auswählen',
				AT_LEAST_ONE: 'Mindestens 1 Option muss ausgewählt werden',
				TITLE_REQUIRED: 'Titel ist erforderlich',
				TITLE_DUPLICATE: 'Dieser Titel wird bereits für eine andere Formel verwendet',
				ADD_A_TITLE: 'Titel hinzufügen',
				DELETE_BUTTON: 'Löschen',
			},
			SENSOR_TABLE_CONFIG: {
				ADD_ROW: 'Zeile hinzufügen',
				ADD_COLUMN: 'Spalte hinzufügen',
				COLUMN_NAME: 'Spaltenname',
				DELETE_COLUMN: 'Spalte löschen',
				DATE_FILTER: 'Datumsfilter',
				ROWS: 'Zeilen',
				NUMBER_OF_ROWS: 'Zeilenanzahl',
				SELECT_TAG: 'Tag auswählen',
				CONFIGURE_TAG: 'Tag konfigurieren',
				DELETE_ROW: 'Zeile löschen',
				APPLY_DATE_FILTERS: 'Datumsfilter auf Spalten anwenden',
				NONE: 'Keine',
				SELECT_FY_START: 'Ersten Tag des Geschäftsjahres auswählen',
				CANCEL: 'Abbrechen',
				APPLY: 'Anwenden',
				SEARCH_TAG: 'Tag suchen...',
				NO_TAG_FOUND: 'Kein passender Tag gefunden',
				GREATER_THAN: 'Größer als',
				LESS_THAN: 'Kleiner als',
				EQUAL_TO: 'Gleich',
				LESS_GREATER_ERROR: "Der Wert 'Kleiner als' muss größer sein als der Wert 'Größer als'.",
				IGNORE_NULLS: 'Nullwerte ignorieren',
				AGGREGATION: 'Aggregation',
				DEFINE_COLOR: 'Tag-Wert zur Textfarbgebung festlegen',
				LESSER_THAN: 'Kleiner als',
				PICK_COLOR: 'Farbe auswählen',
				COLOR: 'Farbe',
				LESSER_THAN_ERROR: 'Der Wert muss kleiner sein als der definierte größere Wert.',
				GREATER_THAN_ERROR: 'Der Wert muss größer sein als der definierte kleinere Wert.',
				BETWEEN: 'Zwischen',
				AND: 'Und',
				BETWEEN_RANGE_ERROR: 'Gültigen Bereich eingeben – Untergrenze muss kleiner als Obergrenze sein.',
			},
			RECENT: 'Zuletzt verwendet',
			FAVOURITES: 'Favoriten',
			CREATED_BY_ME: 'Von mir erstellt',
			TAB_ALL: 'Alle',
			TAB_MY_DASHBOARD: 'Mein Dashboard',
			TAB_SHARED: 'Geteilt',
			TAB_PRIVATE: 'Privat',
			ALL_DASHBOARDS: 'Alle Dashboards',
			MY_DASHBOARDS: 'Meine Dashboards',
			SHARED_DASHBOARDS: 'Geteilte Dashboards',
			PRIVATE_DASHBOARDS: 'Private Dashboards',
			COL_NAME: 'Name',
			COL_CREATED_ON: 'Erstellt am',
			COL_UPDATED_ON: 'Aktualisiert am',
			COL_OWNED_BY: 'Eigentümer',
			COL_SHARED: 'Geteilt',
			COPY_LINK: 'Link kopieren',
			RENAME: 'Umbenennen',
			OPEN_IN_NEW_TAB: 'In neuem Tab öffnen',
			SELECT: 'Auswählen',
			SELECT_PERFORMANCE_CURVE: 'Leistungskurve auswählen',
			MENU_EDIT_DASHBOARD: 'Dashboard bearbeiten',
			MENU_COPY_DASHBOARD: 'Dashboard kopieren',
			MENU_PUBLISH: 'Veröffentlichen',
			MENU_UNPUBLISH: 'Veröffentlichung aufheben',
			MENU_DELETE_DASHBOARD: 'Dashboard löschen',
			MONGO: {
				SELECT_GRAPH_FIRST: '*Bitte zuerst Diagrammtyp auswählen',
				LABEL_USED: 'Label bereits verwendet',
				REQUIRED: '*Pflichtfeld',
				DEFINE_RELATION: 'Relation definieren',
				INVALID_VARIABLE: 'Ungültige Variable in der Formel.',
				INVALID_RELATION: 'Ungültige Relation mit Quelle.',
				INVALID_FORMULA_SYNTAX: 'Ungültige Formelsyntax.',
				SOURCE: 'Quelle',
				ATTRIBUTE: 'Attribut',
				DISPLAY_ATTRIBUTE: 'Attribut anzeigen',
				GROUP_BY_ATTR: 'Gruppieren nach',
				AGGREGATION: 'Aggregation',
				OPEN_FILTERS: 'Filter öffnen',
				REMOVE_COLUMN: 'Spalte entfernen',
				ADD_ATTRIBUTE: 'Attribut hinzufügen',
				RAW_ATTRIBUTE: 'Rohattribut',
				CALC_ATTRIBUTE: 'Berechnetes Attribut',
				ADD_RAW_ATTRIBUTE_COL: 'Rohattribut-Spalte hinzufügen',
				ADD_CALC_ATTRIBUTE_COL: 'Berechnete Attribut-Spalte hinzufügen',
				GROUP_BY: 'Gruppieren nach',
				GROUP_DISPLAY_TYPE: 'Gruppenanzeige-Typ',
				SORT_BY: 'Sortieren nach',
				SORT_ASC: 'A → Z',
				SORT_DESC: 'Z → A',
				SIDE_BY: 'Nebeneinander',
				NA: 'K.A.',
				STACK_BY: 'Stapeln nach',
				NO_OF_BINS: 'Anzahl der Bins',
				SLICERS: 'Slicer (bis zu {{limit}} auswählen)',
				SELECT_UP_TO: 'Bis zu auswählen',
				DRILL_DOWN: 'Drilldown',
				DRILL_DOWN_ATTRS: 'Attribute für Drilldown (bis zu {{limit}} auswählen)',
				SELECT_ATTRS: 'Attribute auswählen',
			},
			TAG_AGG: {
				SELECT_TAG: 'Tag auswählen',
				SELECT_AGGREGATE_TYPE: 'Aggregationstyp auswählen',
				ENABLE_AGGREGATE: 'Aggregation aktivieren',
			},
			SIDE_PANEL: {
				SETTINGS: 'Einstellungen',
				SAVE: 'Speichern',
				CLOSE: 'Schließen',
				PANEL: 'Panel',
				AXIS: 'Achse',
				GRAPH_OPTIONS: 'Diagrammoptionen',
				SELECT_CONFIG_TYPE: 'Konfigurationstyp auswählen',
				EXCEL_CONFIG: 'Excel-Konfiguration',
				TAG_GROUP: 'Tag-Gruppe',
				PANEL_DESCRIPTION: 'Panel-Beschreibung',
				X_AXIS_MIN: 'X-Achse Min',
				X_AXIS_MAX: 'X-Achse Max',
				X_AXIS_UNIT: 'X-Achsen-Einheit',
				Y_AXIS_UNIT: 'Y-Achsen-Einheit',
				SHOW_LEGEND: 'Legende anzeigen',
				OVERLAP_LEGENDS: 'Legenden überlappen',
				TABLE_MODE: 'Tabellenmodus',
				TITLE_COLOR: 'Titelfarbe',
				BORDER_COLOR: 'Rahmenfarbe',
				TREND_CHART_COLOR: 'Trenddiagramm-Farbe',
				UPLOAD: 'Hochladen',
				DOWNLOAD: 'Herunterladen',
				UPLOAD_BASE_CURVE: 'Basiskurve hochladen',
				BASE_CURVE_FORMAT: 'Basiskurven-Format',
				DELETE_CURVE_GRAPH: 'Kurvendiagramm löschen',
			},
			SINGLE_STATS: {
				ADD_STAT: 'Statistik hinzufügen',
				COLOR_PICKER: 'Farbauswahl',
				COLOR_TITLE: 'Titel',
				COLOR_BORDER: 'Rahmen',
				COLOR_ICON: 'Symbol',
				COLOR_ICON_OUTLINE: 'Symbol-Umriss',
				NO_ICON_FOUND: 'Kein passendes Symbol gefunden',
			},
		},
		SCHEDULER: {
			LIST: {
				TITLE: 'Zeitplanliste',
				HEADER_TITLE: 'Berichtsplaner',
				NEW_SCHEDULER_TOOLTIP: 'Neuen Zeitplan erstellen',
				NEW_SCHEDULER: 'Neuer Zeitplan',
				COL_TITLE: 'Titel',
				COL_MEDIUM: 'Medium',
				COL_SUBJECT: 'Betreff',
				COL_RUNS: 'Ausführungen',
				COL_MODIFIED_ON: 'Geändert am',
				COL_CREATED_ON: 'Erstellt am',
				COL_ACTIONS: 'Aktionen',
				EDIT_TOOLTIP: 'Zeitplan bearbeiten',
				DELETE_TOOLTIP: 'Zeitplan löschen',
				MEDIUM_EMAIL: 'E-Mail',
				MEDIUM_SMS: 'SMS',
				MEDIUM_CALL: 'Anruf',
				SCHEDULER_DELETED: 'Zeitplan gelöscht',
				DELETE_FAILED: 'Löschen fehlgeschlagen',
				OKAY: 'Okay',
				NO_REPORT: 'Keine Berichte gefunden'
			},
			DETAILS: {
				TITLE: 'Zeitplan',
				CREATE_TITLE: 'Zeitplan erstellen',
				EDIT_DETAILS_TITLE: 'Details bearbeiten',
				SCHEDULE_DETAILS_TITLE: 'Zeitplandetails',
				CANCEL: 'Abbrechen',
				SAVE: 'Speichern',
				SELECT_FACILITY: 'Anlage auswählen',
				LOADING: 'Wird geladen...',
				SCHEDULE_RECURRING_REPORTS: 'Wiederkehrende Berichte planen',
				MONTHS: 'Monate',
				ALL: 'Alle',
				DAY: 'Tag',
				EVERY: 'Alle',
				TH_DAY: '. Tag',
				WEEKDAYS: 'Wochentage',
				TIME: 'Uhrzeit',
				SELECT_TIME: 'Uhrzeit auswählen',
				HOUR: 'Stunde',
				MINUTE: 'Minute',
				FILE_NAME_LABEL: 'Dateiname',
				REPORT_NAME_LABEL: 'Berichtsname',
				ENTER_NAME: 'Namen eingeben',
				REPORT_TITLE: 'Berichtstitel (max. 20 Zeichen)',
				ENTER_TITLE: 'Titel eingeben',
				REPORTING_INTERVAL: 'Berichtsintervall',
				MEDIUM: 'Medium',
				TEMPLATE_NAME: 'Vorlagenname',
				SUBJECT: 'Betreff',
				ENTER_SUBJECT: 'Betreff eingeben',
				SELECT_USERS: 'Benutzer auswählen',
				SEARCH_BY_EMAIL: 'Nach E-Mail-Adressen suchen',
				NO_MATCHING_EMAIL: 'Keine passende E-Mail-Adresse gefunden',
				ADD_EMAILS_LABEL: 'Durch Komma getrennte E-Mail-Adressen hinzufügen',
				OKAY: 'Okay',
				SELECT_AT_LEAST_ONE_UNIT: 'Bitte mindestens eine Einheit auswählen',
				SELECT_AT_LEAST_ONE_SYSTEM: 'Bitte mindestens ein System auswählen',
				SELECT_USER_OR_EMAIL: 'Bitte mindestens einen Benutzer auswählen oder E-Mail-Adresse(n) hinzufügen',
				INVALID_EMAILS: 'Ungültige E-Mail-Adresse(n) eingegeben',
			},
			TEMPLATES: {
				DAILY_REPORT: 'Täglicher Bericht',
				BIWEEKLY_REPORT: 'Zweiwöchentlicher Bericht',
				KPI_REPORT_THERMAL: 'KPI-Bericht - Thermal',
				ALERT_STATUS_UPDATE_REPORT: 'Alarmstatus-Aktualisierungsbericht',
				DATA_QUALITY_REPORT: 'Datenqualitätsbericht',
				DATA_LAG_REPORT: 'Datenverzögerungsbericht',
				IOW_REPORT: 'IOW-Bericht',
				SERVER_EXCEPTION_REPORT: 'Serverausnahmebericht',
			},
			REPORTING_INTERVALS: {
				LAST_8_HOURS: 'Letzte 8 Stunden',
				LAST_12_HOURS: 'Letzte 12 Stunden',
				LAST_24_HOURS: 'Letzte 24 Stunden',
				TODAY: 'Heute',
				YESTERDAY: 'Gestern',
				LAST_7_DAYS: 'Letzte 7 Tage',
				THIS_WEEK: 'Diese Woche',
				PREVIOUS_WEEK: 'Vorherige Woche',
				LAST_15_DAYS: 'Letzte 15 Tage',
				LAST_30_DAYS: 'Letzte 30 Tage',
				THIS_MONTH: 'Dieser Monat',
				PREVIOUS_MONTH: 'Vorheriger Monat',
				THIS_QUARTER: 'Dieses Quartal',
				PREVIOUS_QUARTER: 'Vorheriges Quartal',
				LAST_3_MONTHS: 'Letzte 3 Monate',
				LAST_6_MONTHS: 'Letzte 6 Monate',
				LAST_12_MONTHS: 'Letzte 12 Monate',
				THIS_YEAR: 'Dieses Jahr',
				PREVIOUS_YEAR: 'Vorheriges Jahr',
			},
		},
		ANALYSIS_VIEWS: {
			UNABLE_TO_CREATE_ANALYSIS_TEMPLATE: 'Analysetemplate kann nicht aus mehreren Anlagen erstellt werden',
			TITLE: 'Analyse & Ansichten',
			CLOSE: 'Schließen',
			EXPORT_TO_EXTERNAL: 'Ausgewählte Tags in externes System exportieren',
			SAVED_ANALYSIS: 'Gespeicherte Analyse',
			CREATE_NEW: 'Neu erstellen',
			SAVED_VIEWS: 'Gespeicherte Ansichten',
			SAVE_CURRENT_VIEW: 'Aktuelle Ansicht speichern',
			SAVE_DISABLED_TOOLTIP: 'Nur der Alarm-Eigentümer kann Tag-Ansichten speichern oder ändern.',
			TEMPLATE_TAG: '[Vorlage]',
			SNAPSHOT_TAG: '[Snapshot]',
			EDIT: 'Bearbeiten',
			DELETE: 'Löschen',
			SAVED_DASHBOARDS: 'Gespeicherte Dashboards',
			NO_DASHBOARDS: 'Keine gespeicherten Dashboards verfügbar',
		},
		THRESHOLD_PANEL: {
			TITLE: 'Schwellenwert',
			CLOSE: 'Schließen',
			ONGOING: 'Laufend',
			SHOW_LESS: 'Weniger anzeigen',
			SEE_MORE: 'Mehr anzeigen',
		},
		ACTIVITY_LOGS: {
			TITLE: 'Aktivitätsprotokolle',
			ACTIONS: 'Aktionen ({{count}})',
			CLOSE: 'Schließen',
			SEARCH_PLACEHOLDER: 'Suchen...',
		},
		FEEDBACK_RIGHT_NAV: {
			TITLE: 'Feedback',
			CLOSE: 'Schließen',
			APPROVED: 'Genehmigt',
			RELEARNED: 'Neu gelernt',
			QUOTE_APPROVED_HYPOTHESIS: 'Genehmigte Hypothese',
			QUOTE_RELEARNED_HYPOTHESIS: 'Neu gelernte Hypothese',
			QUOTE_APPROVED_CAUSAL: 'Genehmigter Ursachenkettenschritt',
			QUOTE_RELEARNED_CAUSAL: 'Neu gelernter Ursachenkettenschritt',
			QUOTE_APPROVED_RECOMMENDATION: 'Genehmigte Empfehlung',
			QUOTE_RELEARNED_RECOMMENDATION: 'Neu gelernte Empfehlung',
			QUOTE_OTHER: 'Sonstiges',
			FILE_ALT: 'Datei',
			EMPTY_HEADING: 'Kein Feedback verfügbar',
			EMPTY_CONTENT: 'Bitte genehmigen oder neu lernen, um Feedback hinzuzufügen.',
		},
		DISCUSSION: {
			TITLE: 'Diskussion',
			COMMENTS_COUNT: 'Kommentare ({{count}})',
			CLOSE: 'Schließen',
			CREATE_CASE_TITLE: 'Erstellen Sie einen Fall, um Folgemaßnahmen zu verwalten',
			CREATE_CASE: 'Fall erstellen',
			BACK: 'Zurück',
			THREAD_BY: 'Thread von',
			SEARCH_PLACEHOLDER: 'Suchen...',
			NO_COMMENTS_HEADING: 'Keine Kommentare vorhanden',
			NO_COMMENTS_BODY: 'Hinterlassen Sie Ihren ersten Kommentar, um die Diskussion zu diesem Thema zu starten.',
			EDITED: 'Bearbeitet',
			RCA_VERSION_DELETED: 'RCA-Version gelöscht',
			COMMENT_DELETED: 'Dieser Kommentar wurde gelöscht.',
			COMMENT_DELETED_ALT: 'Dieser Kommentar wurde gelöscht.',
			REPLY_SINGULAR: 'Antwort',
			REPLY_PLURAL: 'Antworten',
			LAST_REPLY: 'Letzte Antwort',
			REPLY_PROMPT: 'Antworten...',
			COMMENT_PLACEHOLDER: 'Kommentar hinzufügen, verwenden Sie @, um Teammitglieder zu markieren',
			REPLY_TO_COMMENT_PLACEHOLDER: 'Auf Kommentar antworten...',
		},
		RETRAIN_MODEL: {
			TITLE: 'Modell neu trainieren',
			CLOSE: 'Schließen',
			CURRENT_MODEL_DETAILS: 'Aktuelle Modelldetails',
			DEPLOYED_VERSION_LABEL: 'Bereitgestellte Version - Datum / Uhrzeit',
			LAST_PREDICTION_LABEL: 'Letzte Vorhersage - Datum / Uhrzeit',
			FORM_ERROR: 'Hoppla! Ändern Sie ein paar Dinge und versuchen Sie es erneut.',
			TRAINING_PERIOD: 'Trainingszeitraum',
			DATE_RANGE_SELECTION_METHOD: 'Methode zur Auswahl des Datumsbereichs',
			SELECT_TRAINING_MODE_ARIA: 'Trainingsauswahlmodus wählen',
			CALENDAR_SELECTION: 'Kalenderauswahl',
			CHART_BASED_SELECTION: 'Diagrammbasierte Auswahl',
			VIEW_EDIT_NOTE: 'Notiz anzeigen/bearbeiten',
			ADD_NOTE: 'Notiz hinzufügen',
			ADD_TRAINING_RANGE: 'Trainingsbereich hinzufügen',
			DELETE_TRAINING_RANGE: 'Trainingsbereich löschen',
			ADVANCED_SETTINGS: 'Erweiterte Einstellungen',
			BAND_LEARNING_BEHAVIOUR: 'Bandlernverhalten',
			SELECT_BAND_LEARNING_ARIA: 'Bandlernverhalten auswählen',
			CONSERVATIVE_TOOLTIP: 'Erstellt schmalere Bänder um die ausgewählte Trainingsregion',
			CONSERVATIVE: 'Konservativ',
			MODERATE_TOOLTIP: 'Erstellt ausgewogene Bänder um die ausgewählte Trainingsregion',
			MODERATE: 'Moderat',
			AGGRESSIVE_TOOLTIP: 'Erstellt breitere Bänder um die ausgewählte Trainingsregion',
			AGGRESSIVE: 'Aggressiv',
			PREDICTION_SMOOTHING_SETTINGS: 'Einstellungen zur Vorhersageglättung',
			SMOOTHING: 'Glättung',
			WINDOW_SIZE: 'Fenstergröße',
			WINDOW_SIZE_PLACEHOLDER: 'Fenstergröße (in Stunden)',
			VALUE_IS: 'Wert ist',
			REQUIRED: 'erforderlich',
			VALUE_MIN: 'Wert muss größer oder gleich sein wie',
			POLYNOMIAL_ORDER: 'Polynomordnung',
			SIGMA: 'Sigma',
			SELECT_ATTENTION_TAGS: 'Aufmerksamkeits-Tags auswählen',
			SEARCH_PLACEHOLDER: 'Suchen...',
			NO_MATCHING_TAGS: 'Keine passenden Tags gefunden',
			SHOW_ALL_TAGS: 'Alle Tags anzeigen',
			SHOW_ATTENTION_TAGS_ONLY: 'Nur Aufmerksamkeits-Tags anzeigen',
			MODELING_TECHNIQUE: 'Modellierungstechnik',
			AUTO_ENCODER: 'Auto-Encoder',
			ATTENTION_AUTO_ENCODER: 'Attention-Auto-Encoder',
			CANCEL_TOOLTIP: 'Änderungen abbrechen',
			CANCEL: 'Abbrechen',
			RETRAIN_DEPLOY_TOOLTIP: 'Neu trainieren & bereitstellen',
		},
		ROOT_CAUSE_RECOMMENDATION: {
			CLOSE: 'Schließen',
			ICON_ALT: 'Grundursachensymbol',
			NOT_GENERATED_MESSAGE: 'Sie haben die Ursachenanalyse noch nicht erstellt. Bitte erstellen Sie sie, um fortzufahren.',
			FAILED_MESSAGE: 'Ihre letzte Ursachenanalyse ist fehlgeschlagen.<br> Bitte erstellen Sie sie erneut, um fortzufahren.',
			GENERATE_NOW: 'Jetzt erstellen',
			REFRESH: 'Aktualisieren',
			LAST_GENERATED: 'Zuletzt erstellt',
			GENERATING: 'Ursachenanalyse wird erstellt',
			LOADER_ALT: 'Lädt',
			LIKE_ALT: 'Gefällt mir',
			DISLIKE_ALT: 'Gefällt mir nicht-Symbol',
			MONETARY_VALUE: 'Geldwert',
			FAILURE_HISTORY: 'Fehlerverlauf',
			INFO_CARD_ARIA: 'Infokarte',
			PREVIOUS_FAILURE_MODES: 'Frühere Fehlermodi',
			HYPOTHESIS_PREFIX: 'Hypothese',
			MOST_LIKELY: '(Am wahrscheinlichsten)',
			CASCADES_AS_FOLLOWS: '.Diese Grundursache kaskadiert wahrscheinlich wie folgt:',
			AGREE: 'Zustimmen',
			PARTIALLY_AGREE: 'Teilweise zustimmen',
			DISAGREE: 'Ablehnen',
			TELL_US_MORE: 'Erzählen Sie uns mehr:',
			FEEDBACK_PLACEHOLDER: 'Fügen Sie gerne weitere Details hinzu',
			CANCEL: 'Abbrechen',
			SUBMIT: 'Senden',
		},
		RIGHT_PANEL_DOCUMENTS: {
			TITLE: 'Dokumente',
			CLOSE: 'Schließen',
			SEARCH_PLACEHOLDER: 'Suchen...',
			FILTER_TAGS: 'Tags filtern',
			EMPTY_HEADING: 'Keine Dokumente verfügbar',
		},
		MONETORY_VALUE_DIALOG: {
			TITLE: 'Geldwerte',
			CURRENCY_HINT: 'Geldwerte werden in {{currency}} eingegeben',
			RELIABILITY: 'Zuverlässigkeit',
			MAINTENANCE: 'Wartung',
			PERFORMANCE: 'Leistung',
			POTENTIAL_SUFFIX: ' (Potenziell)',
			ENTER_VALUE: 'Wert eingeben',
			COMMENT_REQUIRED_ERROR: 'Der Kommentar darf nicht leer sein.',
			AMOUNT_REQUIRED_ERROR: 'Mindestens ein Wert muss eingegeben werden.',
			COMMENT: 'Kommentar',
			COMMENT_PLACEHOLDER: 'Kommentar hinzufügen',
			CANCEL: 'Abbrechen',
			SAVE: 'Speichern',
		},
		FAILURE_MODE_DETAILS: {
			TITLE: 'Fehlermodus-Details',
			OPEN_ALERT: 'Alarm öffnen',
			TTF_ALT: 'TTF',
			ADD_MONETARY_VALUE: 'Geldwert hinzufügen',
			CMMS_NUMBER_TOOLTIP: 'CMMS-Nummer',
			MORE_SUFFIX: 'weitere',
			ADD_CMMS_NUMBER: 'CMMS-Nummer hinzufügen',
			BREAKDOWN_CATEGORY: 'Aufschlüsselungskategorie',
			BREAKDOWN_COMPONENT: 'Aufschlüsselungskomponente',
			ERROR_LABEL: 'Fehler',
			TAG_CHARTS_SUFFIX: 'Tag-Diagramme',
		},
		DATA_QUALITY_PANEL: {
			TITLE: 'Datenqualität',
			CLOSE: 'Schließen',
			SEE_LESS: 'Weniger anzeigen',
			SEE_MORE: 'Mehr anzeigen',
		},
		FAILURE_TIMELINE_PANEL: {
			SORT_BY: 'Sortieren nach:',
			ASSET: 'Anlage:',
			REASON: 'Grund:',
			RECOMMENDATIONS: 'Empfehlungen:',
			NA: 'NA',
		},
		REPORT_ISSUE_SIDEPANEL: {
			TITLE: 'Problem melden',
			SUBTITLE: 'Teilen Sie uns mit, was beim RCA-Agenten schiefgelaufen ist.',
			CLOSE: 'Schließen',
			WARNING_BANNER: 'Dies aktualisiert oder führt die aktuelle RCA nicht erneut aus. Um eine Hypothese, Ursachenkette oder Empfehlung zu verbessern, verwenden Sie die Feedback-Optionen innerhalb der RCA.',
			SECTION_TITLE: 'Was ist schiefgelaufen?',
			SECTION_HINT: 'Wählen Sie alle Zutreffenden aus.',
			ISSUES_ERROR: 'Wählen Sie mindestens eine Option aus.',
			DETAILS_ERROR: 'Fügen Sie Details zu dem aufgetretenen Problem hinzu.',
			DETAILS_LABEL_REQUIRED: 'Zusätzliche Details (Erforderlich)',
			DETAILS_LABEL_OPTIONAL: 'Zusätzliche Details (Optional)',
			DETAILS_PLACEHOLDER: 'Zum Beispiel: Die RCA identifizierte den korrekten Druckverlauf, kam jedoch zu dem Schluss, dass die Pumpe das Ereignis verursachte, obwohl die Wartungshistorie auf ein Ventilversagen hinwies.',
			DISCLAIMER: 'Durch das Einreichen dieses Berichts werden relevante RCA-Daten und Aktivitätsprotokolle mit dem autorisierten UptimeAI-Team zur Untersuchung geteilt.',
			CANCEL: 'Abbrechen',
			SUBMIT_REPORT: 'Bericht senden',
			RUN_RCA_FIRST: 'Führen Sie eine RCA aus, bevor Sie ein Problem mit dem Agenten melden.',
			SUBMITTED_SUCCESS: 'Problem erfolgreich gemeldet',
			SUBMIT_FAILED: 'Problem konnte nicht gemeldet werden. Bitte versuchen Sie es erneut.',
			OPT_PLATFORM_DATA_LABEL: 'Relevante Plattformdaten wurden nicht berücksichtigt',
			OPT_PLATFORM_DATA_HINT: 'Die RCA hat nicht alle relevanten Alarme, Tags, Trends, Ereignisse oder anderen auf der Plattform verfügbaren Daten verwendet.',
			OPT_EVIDENCE_LABEL: 'Dokumente oder Belege wurden nicht korrekt berücksichtigt',
			OPT_EVIDENCE_HINT: 'Hochgeladene Dokumente, vorgeschlagene Belege oder andere unterstützende Informationen wurden ignoriert oder falsch interpretiert.',
			OPT_USER_INPUT_LABEL: 'Meine Eingabe wurde nicht ordnungsgemäß berücksichtigt',
			OPT_USER_INPUT_HINT: 'Die RCA hat den Kontext, die Anweisungen, Notizen oder das Feedback, die ich während dieser Untersuchung oder in früheren Wiederholungen gegeben habe, nicht ordnungsgemäß berücksichtigt.',
			OPT_CAUSAL_LABEL: 'Die kausale Argumentation war falsch',
			OPT_CAUSAL_HINT: 'Die RCA berücksichtigte relevante Informationen, kam jedoch zu einer falschen Schlussfolgerung.',
			OPT_WEIGHTED_LABEL: 'Belege wurden falsch gewichtet',
			OPT_WEIGHTED_HINT: 'Die RCA konzentrierte sich zu stark auf einen Datenpunkt und berücksichtigte andere wichtige Belege nicht ausreichend.',
			OPT_UNSUPPORTED_LABEL: 'Eine Schlussfolgerung wurde nicht durch Belege gestützt',
			OPT_UNSUPPORTED_HINT: 'Die RCA erstellte eine Behauptung oder Schlussfolgerung ohne ausreichende unterstützende Daten oder Belege.',
			OPT_RECOMMENDATION_LABEL: 'Die Empfehlung war nicht umsetzbar',
			OPT_RECOMMENDATION_HINT: 'Die Empfehlung war zu allgemein, unpraktisch oder betrieblich nicht nützlich.',
			OPT_UNCLEAR_LABEL: 'Die Erklärung war unklar',
			OPT_UNCLEAR_HINT: 'Die Argumentation war schwer verständlich oder bot nicht genügend Begründung.',
			OPT_OTHER_LABEL: 'Sonstiges',
			OPT_OTHER_HINT: 'Melden Sie ein Problem, das oben nicht aufgeführt ist.',
		},
		LIBRARY: {
			TITLE: 'Bibliothek',
			SUBTITLE: 'R&I-Schemata und technische Dokumente (Handbücher, Datenblätter, Alarm- / Abschaltlisten) an einem Ort.',
			SEARCH: 'Zeichnungen, Dokumente, Ausrüstung oder einen Tag suchen (z. B. PT-0940)…',
			TAB_PIDS: 'R&I-Schemata',
			TAB_DOCS: 'Handbücher & Daten',
			PIDS: {
				LOADING: 'Zeichnungen werden geladen…',
				FAILED: 'Die Zeichnungen konnten nicht geladen werden.',
				LOCATED: 'Zeichnungen mit {{tag}}',
				NOT_LOCATED: '{{tag}} ist auf keiner indizierten Zeichnung.',
				NO_MATCH: 'Keine Zeichnung passt zur Suche.',
				TAGS: '{{count}} Tags',
				PICK: 'Wählen Sie links eine Zeichnung oder suchen Sie einen Tag, um die Zeichnungen zu finden, die ihn zeigen.',
				VIEW_DRAWING: 'Zeichnung',
				VIEW_PDF: 'Ganzes PDF',
				PDF_LOADING: 'PDF wird geladen…',
				PDF_FAILED: 'Das PDF dieser Zeichnung ist nicht verfügbar.',
				OTHER: 'Weitere Zeichnungen',
				REFERENCE: 'Legenden & Zeichnungsverzeichnisse',
			},
			DOCS: {
				LOADING: 'Dokumente werden geladen…',
				FAILED: 'Die Dokumente konnten nicht geladen werden.',
				EMPTY: 'Keine Dokumente.',
				NO_MATCH: 'Kein Dokument passt zur Suche.',
				PICK: 'Wählen Sie ein Dokument, um es hier zu lesen.',
				GROUP_ITEM: 'An diesem Ort',
				GROUP_ABOVE: 'Von {{floc}}',
				GROUP_BELOW: 'Unterhalb dieses Orts',
				GROUP_TYPE: '{{type}}',
			},
		},
		ASSET_EXPLORER: {
			FLOC: {
				TITLE: '{{facility}} – Anlagenbaum (SAP-Technische Plätze)',
				SEARCH_PLACEHOLDER: 'TP, Anlage oder Historian-Tag suchen…',
				SEARCH_HINT: 'Passende Anlagen stehen unten; einen Tag-Vorschlag wählen, um ihn im R&I-Schema zu zeigen.',
				HIDE_EMPTY: 'Plätze ohne Tags ausblenden',
				HIDE_EMPTY_HINT: 'Blendet Technische Plätze ohne Historian-Tag im Teilbaum aus. Pakete und nicht zugeordnete Gruppen werden immer angezeigt.',
				NODE_HITS: 'Passende Anlagen ({{count}})',
				CLOSE_HITS: 'Ergebnisse schließen',
				NODE_SEARCH_FAILED: 'Anlagensuche fehlgeschlagen. Bitte erneut versuchen.',
				NO_NODE_HITS: 'Keine Anlage passt zu „{{query}}“.',
				REVEAL_FAILED: 'Diese Anlage konnte im Baum nicht geöffnet werden.',
				TREE_EMPTY: 'Der Anlagenbaum ist leer.',
				TREE_HIDDEN: '{{count}} Plätze ohne Tags ausgeblendet',
				CHILDREN_FAILED: 'Die Unterknoten konnten nicht geladen werden.',
				CHILDREN_HIDDEN: '{{count}} untergeordnete Plätze ohne Historian-Tags sind ausgeblendet.',
				COUNT_TIP: '{{count}} Historian-Tags in diesem Teilbaum',
				PATH: 'Anlagenpfad',
				UNASSIGNED_NAME: 'Nicht zugeordnete Tags',
				UNASSIGNED_TIP: 'Historian-Tags ohne TP- oder Paketzuordnung, gruppiert nach dem Systemcode im Tag-Namen',
				UNASSIGNED_NOTE: 'Diese Historian-Tags haben weder einen SAP-Technischen Platz noch ein Anlagenpaket. Sie sind hier nur nach dem Systemcode im Tag-Namen gruppiert (oder auf Standortebene, wenn keiner vorhanden ist); ihre Anlage ist unbekannt.',
				PACKAGE_NOTE: 'Paket rotierender Maschinen: Die Tags sind dem Paket als Ganzes zugeordnet, nicht einem einzelnen SAP-Technischen Platz.',
				LEVEL_SITE: 'Standort',
				LEVEL_SYSTEM: 'System',
				LEVEL_SUBSYSTEM: 'Teilsystem',
				LEVEL_EQUIPMENT: 'Anlage',
				LEVEL_PACKAGE: 'Paket',
				LEVEL_UNASSIGNED: 'Nicht zugeordnet',
				KIND_FLOC: 'SAP-Technischer Platz',
				KIND_PACKAGE: 'Anlagenpaket',
				KIND_UNASSIGNED: 'Gruppe nicht zugeordneter Tags',
				SUBTREE_TAGS: '{{count}} Tags im Teilbaum',
				LOOP_TAGS_BADGE: '{{count}} Paket-Tags mit gleichem Loop',
				PIDS_SHOWING: 'In {{count}} R&I-Schema(ta)',
				PROP_FLOC: 'TP-Code',
				PROP_CODE: 'Paketcode',
				PROP_LEVEL: 'Ebene',
				PROP_KIND: 'Art',
				PROP_LOOP: 'Loop-Nummer',
				PROP_OWN_TAGS: 'Tags an diesem Knoten',
				PROP_SUBTREE_TAGS: 'Tags im Teilbaum',
				WITH_DATA: '{{count}} mit Daten',
				N_TAGS: '{{count}} Tags',
				INCLUDE_SUBTREE: 'Teilbaum einbeziehen',
				TAGS_OWN_NOTE: 'Direkt an diesem Knoten platzierte Tags.',
				TAGS_SUBTREE_NOTE: 'An diesem Knoten und allen darunterliegenden Knoten platzierte Tags.',
				DETAIL_FAILED: 'Dieser Knoten konnte nicht geladen werden. Bitte erneut versuchen.',
				NO_OWN_TAGS: 'An diesem Knoten sind keine Historian-Tags platziert.',
				NO_OWN_TAGS_LOOP: 'Am Technischen Platz selbst sind keine Historian-Tags platziert; die Paket-Tags mit derselben Loop-Nummer stehen unten.',
				TRUNCATED: 'Die ersten {{shown}} von {{total}} Tags werden angezeigt.',
				FILTER_TAGS: 'Tags filtern…',
				NO_FILTER_MATCH: 'Kein Tag entspricht dem Filter.',
				COL_RULE: 'Platzierungsregel',
				COL_DATA: 'Daten',
				PLACED_AT: 'An',
				LOOP_TITLE: 'Paket-Tags mit dieser Loop-Nummer ({{count}})',
				LOOP_EXPLAIN: 'Diese Tags gehören zu Paketen rotierender Maschinen, nicht zu diesem Technischen Platz. Sie werden angezeigt, weil ihr Tag-Name die Loop-Nummer {{loop}} trägt, wie diese Anlage. Sie zählen nicht zu den Tag-Summen dieses Knotens.',
				LOOP_GROUP: 'Loop {{loop}} · Paket {{package}} ({{count}})',
				OPEN_PACKAGE: 'Paket öffnen',
				PID_GROUP_NODE: 'Zeigt {{name}}',
				PID_NODE_FOUND: '{{name}} (Anlagensymbol oder Tags) erscheint in {{count}} Schema(ta).',
				PID_NODE_NONE: 'Kein digitalisiertes R&I-Schema zeigt {{name}} oder seine ersten Tags.',
				CHIPS_MORE: '{{shown}} von {{total}} Knoten-Tags angezeigt; weitere über die Übersichtstabelle oder die Suche hinzufügen.',
				RULE_FLOC_CURATED: 'TP (kuratiert)',
				RULE_FLOC_CURATED_HINT: 'TP aus der kuratierten Tag-Anlagen-Zuordnungsliste.',
				RULE_FLOC_BACKFILLED: 'TP (ergänzt)',
				RULE_FLOC_BACKFILLED_HINT: 'TP aus der Tag-Asset-Zuordnung des Historians, wenn die kuratierte Liste keinen enthält.',
				RULE_FLOC_WELL: 'TP über Subsea-Bohrung',
				RULE_FLOC_WELL_HINT: 'Subsea-Tag am Produktionsbaum-TP seiner Bohrung (oder am Bohrungs-TP) anhand der Bohrungsnummer im Tag-Namen.',
				RULE_FLOC_LOOP: 'TP über Loop-Nummer',
				RULE_FLOC_LOOP_HINT: 'Am einzigen Anlagen-TP platziert, dessen Code auf die Loop-Nummer des Tags endet.',
				RULE_PACKAGE_PREFIX: 'Paket über Tag-Präfix',
				RULE_PACKAGE_PREFIX_HINT: 'Einem Anlagenpaket zugeordnet; unter dem im Tag-Namen codierten Teilsystem platziert.',
				RULE_PACKAGE_SITE: 'Paket (Standort)',
				RULE_PACKAGE_SITE_HINT: 'Einem Anlagenpaket zugeordnet; der Tag-Name enthält kein Teilsystem, daher auf Standortebene.',
				RULE_UNASSIGNED: 'Nicht zugeordnet (Tag-Präfix)',
				RULE_UNASSIGNED_HINT: 'Kein TP und kein Paket; unter dem im Tag-Namen codierten Teilsystem gruppiert.',
				RULE_SITE: 'Standort',
				RULE_SITE_HINT: 'Kein TP, kein Paket und kein Teilsystemcode; auf Standortebene belassen.',
			},
			TITLE: '{{facility}} – Anlagenhierarchie',
			BREADCRUMB: 'Asset-Explorer',
			RELOAD: 'Neu laden',
			LOADING_TREE: 'Anlagenhierarchie wird geladen…',
			LOAD_FAILED: 'Die Anlagenhierarchie konnte nicht geladen werden. Bitte erneut versuchen.',
			SEARCH_PLACEHOLDER: 'Anlage oder Historian-Tag suchen…',
			SEARCH_HINT: 'Eingabe filtert den Baum; Tag wählen, um ihn im R&I-Schema zu zeigen.',
			TREE_EMPTY: 'Keine Anlagen entsprechen der Suche.',
			EXPAND: 'Aufklappen',
			COLLAPSE: 'Zuklappen',
			LEVEL_KICKER: 'Ebene {{level}}',
			NODE_ID: 'ID',
			TAGS_MAPPED: '{{count}} Historian-Tags',
			PIDS_LINKED: '{{count}} verknüpfte R&I-Schemata',
			TAB_OVERVIEW: 'Übersicht',
			TAB_PID: 'R&I-Schema',
			TAB_TELEMETRY: 'Zeitreihen',
			TAB_DOCS: 'Dokumente',
			DOCS: {
				VIEW: 'Dokumente ({{count}})',
				HINT: 'Handbücher, Datenblätter und Alarm- / Abschaltlisten für {{name}} und die übergeordneten Orte.',
				ALSO_PIDS: 'Auch auf {{count}} R&I-Blättern',
				OPEN_LIBRARY: 'Bibliothek öffnen',
				EMPTY: 'Mit diesem Ort und den übergeordneten Orten sind keine Dokumente verknüpft.',
			},
			OPEN_KG: 'Im Wissensgraphen öffnen',
			VIEW_ALERTS: 'Alarme anzeigen',
			VIEW_PID: 'R&I-Schema anzeigen',
			VIEW_TELEMETRY: 'Zeitreihen anzeigen',
			DESCRIPTION: 'Beschreibung',
			NO_DESCRIPTION: 'Für diese Anlage ist keine Beschreibung hinterlegt.',
			CHILDREN: 'Untergeordnete Anlagen ({{count}})',
			PROPERTIES: 'Eigenschaften',
			TAGS_TITLE: 'Historian-Tags ({{count}})',
			NO_TAGS: 'Dieser Anlage sind keine Historian-Tags zugeordnet.',
			COL_TAG: 'Tag',
			COL_COMPONENT: 'Komponente',
			COL_RANGE: 'Betriebsbereich',
			COL_UNIT: 'Einheit',
			COL_ACTIONS: 'Aktionen',
			LOCATE_ON_PID: 'Im R&I-Schema zeigen',
			PLOT: 'Plotten',
			NO_SELECTION: 'Wählen Sie eine Anlage in der Hierarchie oder suchen Sie einen Tag.',
			LEVEL: {
				FACILITY: 'Anlage',
				SYSTEM: 'System',
				SUBSYSTEM: 'Teilsystem',
				EQUIPMENT: 'Ausrüstung',
				COMPONENT: 'Komponente',
				INSTRUMENT: 'Instrument',
			},
			PID: {
				SHEET: 'Zeichnung',
				SEARCH_SHEETS: 'Zeichnungen suchen…',
				SEARCH_ON_DRAWING: 'Tag in dieser Zeichnung finden…',
				NO_MATCHES: 'Kein Tag in dieser Zeichnung passt.',
				FILTER_ALL: 'Alle',
				FILTER_INSTRUMENTS: 'Instrumente',
				FILTER_EQUIPMENT: 'Ausrüstung',
				FILTER_NONE: 'Keine',
				GROUP_LOCATED: 'Zeichnungen mit {{tag}}',
				GROUP_NODE: 'Verknüpft mit {{name}}',
				GROUP_ALL: 'Alle Zeichnungen ({{count}})',
				SOURCE_DIGITISED: 'digitalisiert',
				SOURCE_TEXT: 'textindiziert',
				SOURCE_NEEDS_OCR: 'OCR nötig',
				SOURCE_CATALOGUED: 'katalogisiert',
				SOURCE_BLANK: 'kein Text',
				DETECTIONS: '{{count}} Objekte',
				LOCATING: '{{tag}} wird in den R&I-Schemata gesucht…',
				LOCATE_FAILED: '{{tag}} konnte in den R&I-Schemata nicht gesucht werden.',
				NOT_ON_PID: '{{tag}} ist in keinem digitalisierten R&I-Schema enthalten.',
				FOUND_ON: '{{tag}} ist auf {{count}} Zeichnung(en)',
				CLEAR_LOCATE: 'Zurücksetzen',
				TYPE_INSTRUMENT: 'Instrument',
				TYPE_EQUIPMENT: 'Ausrüstung',
				CONFIDENCE: '{{pct}} % Konfidenz',
				CANONICAL: 'Kanonischer Tag',
				HISTORIAN_TAG: 'Historian-Tag',
				NOT_LINKED: 'Nicht mit einem Historian-Tag verknüpft',
				PLOT: 'In Zeitreihen plotten',
			},
			PID_VIEWER: {
				ZOOM_IN: 'Vergrößern',
				ZOOM_OUT: 'Verkleinern',
				FIT: 'An Ansicht anpassen',
				FOCUS_HIGHLIGHT: 'Zum markierten Tag',
				FULLSCREEN: 'Vollbild',
				EXIT_FULLSCREEN: 'Vollbild beenden',
				LOADING: 'Zeichnung wird geladen…',
				NO_DRAWING: 'Keine Zeichnung ausgewählt.',
				LOAD_FAILED: 'Diese Zeichnung konnte nicht geladen werden.',
				NO_IMAGE: 'Kein Bild für diese Zeichnung',
				NO_IMAGE_HINT: 'Die Zeichnung ist digitalisiert ({{count}} Objekte, {{highlighted}} markiert), aber das Bild ist nicht verfügbar.',
				PAN_HINT: 'Ziehen zum Verschieben · Scrollen zum Zoomen',
				ASPECT_WARNING: 'Bild- und Zeichnungsgröße weichen ab; Rahmen können versetzt sein.',
				HISTORIAN_TAG: 'Historian-Tag',
				NOT_LINKED: 'Nicht verknüpft',
				CLICK_HINT: 'Zum Auswählen klicken',
				UNTAGGED: 'Objekt ohne Tag',
			},
			TAG_SEARCH: {
				SEARCHING: 'Suche läuft…',
				FAILED: 'Tag-Suche fehlgeschlagen. Bitte erneut versuchen.',
				NO_RESULTS: 'Kein Historian-Tag passt zu „{{query}}“.',
				HAS_DATA: 'Daten vorhanden',
				NO_DATA: 'Keine Daten',
				ALREADY_ADDED: 'Bereits ausgewählt',
			},
			TELEMETRY: {
				ACTIVE_TAGS: 'Tags im Diagramm ({{count}} / {{max}})',
				SEARCH_PLACEHOLDER: 'Historian-Tags zum Hinzufügen suchen…',
				DROPPED: 'Höchstens {{max}} Tags: {{tag}} wurde entfernt.',
				REMOVE: 'Aus Diagramm entfernen',
				WINDOW: 'Zeitfenster',
				WINDOW_7D: '7 T',
				WINDOW_30D: '30 T',
				WINDOW_90D: '90 T',
				WINDOW_1Y: '1 J',
				CHART_TITLE: 'Historian-Zeitreihen',
				POINTS: '{{count}} Punkte',
				LOADING: 'Zeitreihen werden geladen…',
				NO_DATA: 'Keine Messwerte für die gewählten Tags in diesem Zeitfenster.',
				NO_TAGS: 'Suchen Sie einen Tag oder wählen Sie oben einen aus.',
				SUMMARY: 'Zusammenfassung',
				LATEST: 'Letzter',
				MIN: 'Min',
				MAX: 'Max',
				MEAN: 'Mittel',
			},
		},
		TRIAGE: {
			RULE_SIGNALS: {
				TITLE: 'What this rule measures',
				MEASURED: 'Measured',
				CONTEXT: 'Context',
				HAS_READINGS: 'Readings before the alert',
				NO_READINGS: 'No readings in the 24 h before the alert',
				SOURCE: 'Mapping from {{source}}',
				GUESSED: 'Shell\'s configuration does not list this rule\'s inputs; the charted signals were chosen by the agent from the well\'s sensors.',
			},
			BASIS: {
				NO_RESULT: 'No decision yet: run the agent on this alert.',
				RECOMMENDATIONS: 'Recommendations',
				NO_RECOMMENDATIONS: 'The agent made no recommendations for this alert.',
				FINAL_HYPOTHESES: 'Final hypotheses (adjudicator)',
				NO_FACT_SPAN: 'This run did not record which evidence it read.',
				LINK_RCA: 'Deep RCA · {{count}} verified facts',
				LINK_EVIDENCE: 'Evidence used',
			},
			PFLOW: {
				ALERT_DRAWINGS: 'Drawings the alert equipment is on (open with the alert context)',
				TAB: 'Process flow',
				TITLE: 'Block flow (process units)',
				CHECKED_LEGEND: 'Checked by the agent ({{n}})',
				OPEN_MAP: 'Open process map',
				OPEN_ON_MAP: 'Show on process map',
				ALERT_UNIT: 'Alert\'s unit',
				STATE_MOVED: 'Moved',
				STATE_HELD: 'Steady',
				STATE_NODATA: 'No data',
				TIMING_BEFORE: 'before the alert',
				TIMING_TOGETHER: 'with the alert',
				TIMING_AFTER: 'after the alert',
				TIMING_EARLIER: '> 48 h earlier',
				KEY_SENSORS: 'Key sensors (click to chart)',
				CHART_IT: 'chart it on the right',
				ON_DRAWING: 'Equipment on the alert\'s drawing',
			},
			STEP_PANEL: {
				DQ: 'Data quality of the readings before the alert',
				NO_DQ: 'No data-quality assessment was recorded for this alert.',
				STATE: 'Alert tag with the machine\'s run indicator',
				LIMITS: 'Limits of this tag and when they applied',
				RULE: 'The detector and the tags it watches',
				EQUIPMENT: 'Sensors on this equipment — click one to chart it on the right',
				PROCESS: 'Live P&ID — click a tag to chart it on the right',
				NO_ANOMALY: 'The run has no anomaly-model analysis for this alert.',
			},
			DOCPAGE: {
				MAXIMIZE: 'Maximize',
				RESTORE: 'Restore',
				MARKING: 'Finding the cited passage on this page…',
				MARKING_TERMS: 'Finding the search words on this page…',
				MARK_FAILED: 'The page is shown, but the passage could not be located on it.',
				PAGE_OF: 'page {{page}} of {{pages}}',
				PREV: 'Previous page',
				NEXT: 'Next page',
				CITED_FOUND: 'The red box marks the passage the triage relied on.',
				OCR: 'This page is a scan, read by OCR, so the box position is approximate.',
				CITED_MISSING: 'The cited words could not be found on this page image (the scan reads differently); the passage is the one quoted in the triage.',
				CITED_ON: 'The cited passage is on page {{page}}.',
				LOADING: 'Loading the page…',
				CLOSE: 'Close',
			},
			DOCS: {
				REFERRED: 'Referred documents',
				ALL: 'All documents',
				SEARCH_PLACEHOLDER: 'Filter by name — press Enter to search inside the documents',
				SEARCH_INSIDE: 'Search inside',
				WHOLE_SITE: 'Whole site',
				RESULTS: 'Pages matching “{{q}}”',
				NO_RESULTS: 'No page matches these words.',
				PAGE: 'p.{{n}}',
				USED: 'Passages the triage used',
				USED_HINT: 'Click a passage to open its page with the passage in a red box',
				CITED: 'cited',
				VIEW_PAGE: 'View page',
			},
			SEE: {
				RULE: 'Rule, delay and replay: see Source Alert',
				SENSORS: 'Sensors on this machine: see System Details',
				TAGS: 'Plot them: see Tags',
				CONNECTED: 'Upstream and downstream units: see System details › Process flow',
				PID: 'P&ID drawings: see System details',
				WORK_ORDERS: 'Open work: see Work Orders',
				ALERTS: 'Earlier alerts: see Alerts',
				REPORTS: 'Shift reports: see Reports',
				REASONING: 'How the agent reasoned: see Reasoning',
			},
			PANE_SPLIT_HINT: 'Drag to resize; double-click to reset',
			RELATED: {
				TITLE: 'Related alerts',
				HELP: 'Found by the known-issue check: earlier alerts on this equipment known before this alert\'s cut-off, and later alerts that linked to this one. Each alert keeps its own label.',
				NONE: 'No related alert found.',
				ISSUE_SIZE: 'Issue of {{n}} alerts',
				REL_COVERED_BY: 'Service already raised',
				REL_SAME_CONDITION: 'Same condition',
				REL_SAME_EVENT: 'Same event',
				DIR_EARLIER: 'earlier alert',
				DIR_LATER: 'later alert',
				SCORE: 'score {{s}}',
				STATUS_PROPOSED: 'Proposed',
				STATUS_CONFIRMED: 'Confirmed',
				STATUS_REJECTED: 'Rejected',
				CONFIRM: 'Confirm',
				REJECT: 'Reject',
				CHIP: 'Same issue as {{n}} other alert(s)',
				CHIP_TIP: 'The known-issue check found {{n}} other alert(s) on the same condition. Open the alert to see them under Related alerts, and confirm or reject the link.',
				CHIP_PROPOSED: 'Some links still await review.',
			},
			QUEUE_RUN: {
				BUTTON: 'Triage selected',
				HINT: 'Run the Triage Agent on each selected alert, one alert at a time per run (never grouped); a few run at once.',
				STARTED: 'Triaging {{n}} alerts individually',
				PROGRESS: 'Triage: {{done}} of {{total}} done, {{running}} running',
				DONE: 'Triage finished for {{n}} alerts ({{failed}} failed)',
			},
			LABEL_SETTINGS: {
				PROPOSALS_TITLE: 'Proposed mapping changes ({{n}})',
				PROPOSALS_HELP: 'Reviewers agreed with the agent\'s finding but expected another customer label. Apply moves the finding in the editor below; it is accepted when you save the new version.',
				N_ALERTS: '{{n}} alerts',
				APPLY: 'Apply to mapping',
				APPLIED: 'Applied — save to accept',
				REJECT: 'Reject',
				TAB_SETTINGS: 'Settings',
				TAB_LABELS: 'Labels',
				INTRO: 'The agent decides an internal finding; the mapping turns it into the label the customer sees. A change saves a new version (v{{v}} is in force) and relabels every alert at once, without re-running triage.',
				EXTERNAL_TITLE: 'External labels',
				EXTERNAL_HELP: 'The labels shown in the queue and reported to the customer. The outcome drives the approve button: close, act (raise the action type) or hold for review. Saved labels cannot be deleted, only retired; their keys are permanent.',
				COL_NAME: 'Name / key',
				COL_CUSTOMER: 'Customer value',
				COL_OUTCOME: 'Outcome',
				COL_ACTION: 'Action type',
				COL_COLOR: 'Colour',
				COL_SCORED: 'Scored as',
				COL_ACTIVE: 'Active',
				UP: 'Move up',
				DOWN: 'Move down',
				REMOVE: 'Remove (never saved)',
				FALLBACK: 'fallback',
				CUSTOMER_NONE: 'Not exported',
				ACTION_PH: 'e.g. service_notification',
				OUTCOME_CLOSE: 'Close',
				OUTCOME_ACTION: 'Action',
				OUTCOME_HOLD: 'Hold for review',
				NOT_SCORED: 'Not scored',
				NEW_KEY: 'New key, e.g. valid_monitor',
				NEW_NAME: 'Name shown to users',
				ADD: 'Add label',
				KEY_RULE: 'Key: 3–41 lower-case letters, digits or underscores, starting with a letter.',
				KEY_TAKEN: 'That key is already used (keys are never reused, even after retiring).',
				NAME_REQUIRED: 'Give the label a name.',
				FALLBACK_LABEL: 'Fallback label',
				FALLBACK_HELP: 'Used when a finding has no mapping. Must be active and hold for review.',
				MAPPING_TITLE: 'Mapping: external label ← internal findings',
				MAPPING_HELP: 'Each external label (left) owns the agent findings on the right. Every finding belongs to exactly one label. Click a finding to move it. Amber findings differ from the default mapping.',
				UNMAPPED: '{{n}} findings are not mapped; they would show as the fallback label.',
				N_FINDINGS: '{{n}} findings',
				NONE: 'No findings mapped',
				RETIRED_NONE: 'Retired: owns no findings',
				DEFAULT_WAS: 'default: {{x}}',
				CHECK_N: 'Check {{n}}',
				MOVE_TO: 'Move “{{x}}” to',
				BY_CHECK: 'View by triage check',
				NO_CHANGES: 'No changes.',
				PREVIEWING: 'Checking the change…',
				MOVING: '{{n}} triaged alerts would change label.',
				DISCARD: 'Discard',
				SAVE: 'Save new version',
				SAVED: 'Label mapping v{{v}} saved',
				HISTORY: 'Versions',
				IN_FORCE: 'in force',
				RESTORE: 'Load into editor',
				RESTORE_REASON: 'Restore the mapping of v{{v}}',
			},
			LABELS: {
				FINDING_TIP: 'Shown to Shell as “{{label}}” (label mapping v{{v}}, Settings → Labels).',
				FINDING: 'Finding',
				SOURCE_AGENT: 'Agent',
				SOURCE_POLICY: 'Policy',
				SOURCE_HUMAN: 'Reviewer',
				SOURCE_DERIVED: 'Derived',
				MAPPING: 'Mapping v{{v}} → {{label}}',
				MAPPING_TIP: 'The finding is turned into the customer label by the label mapping in Settings › Labels. Changing the mapping relabels alerts without re-running triage.',
				ALSO_FOUND: 'Also found',
				CHECK: 'check {{n}}',
				SECONDARY_ACTION: 'Also found: {{names}}. That finding leads to an action, but the main finding closes the alert. Review before closing.',
				INTERNAL_COLUMN: 'Finding',
			},
			ACT: {
				APPROVED_CLOSED: 'Approved and closed',
				CLOSED: 'Closed – False alert',
				CLOSED_FLAGGED: 'Closed – False alert · rule flagged for tuning',
				CLOSE_ALERT: 'Close alert',
				CLOSE_CONFIRM: 'Close alert',
				CLOSE_TITLE: 'Close as False – No Action',
				CREATE_INSTRUMENT_WO: 'Create instrument WO',
				CREATE_SERVICE: 'Create Service',
				DUE_DATE: 'Due date',
				EQUIPMENT: 'Equipment',
				EVIDENCE_ATTACHED: 'Evidence attached (click to leave one out)',
				FEED_CONFIRM: 'Report issue',
				FEED_LEAD: 'The alert was raised on values that are not measurements. The issue goes to {{owner}}; no work order is raised because no transmitter is broken.',
				FEED_REPORTED: 'Data-feed issue reported to {{owner}}',
				FEED_TITLE: 'Report data-feed issue',
				FEWER_FIELDS: 'Show fewer fields',
				FLAG_RULE: 'Flag rule for tuning',
				FROM_AGENT: 'from the agent',
				FROM_DQ_POLICY: 'from DQ policy',
				LINKED: 'Linked to {{id}} and closed',
				LINKED_ALERT: 'Linked alert',
				LINK_CLOSE: 'Link & close',
				LINK_CONFIRM: 'Link & close',
				LINK_LEAD: 'This condition is already covered by an open record. The alert is linked to it and closed as Valid – No Action.',
				LINK_TITLE: 'Link to the known issue',
				LOADING: 'Preparing the form…',
				MORE_FIELDS: 'Show more fields',
				NOTE: 'Note (optional)',
				NOTE_PLACEHOLDER: 'Add context for the SME team…',
				NO_EVIDENCE: 'Nothing cited to attach',
				NO_REPLAY: 'The detector\'s rule could not be replayed on the raw data, so no fix is suggested.',
				OPEN_CASE: 'Open case',
				OWNER: 'Owner',
				OWNER_ME: 'Me',
				PREFILLED: 'prefilled',
				PRIORITY: 'Priority',
				PROBLEM: 'Problem',
				RECOMMENDATION: 'Recommendation',
				REPORT_FEED: 'Report data-feed issue',
				ROUTE_TO: 'Route to',
				SENT_TO: 'Sent to {{owner}}.',
				SERVICE_CONFIRM: 'Create Service',
				SERVICE_CREATED: 'Service case #{{id}} created',
				SERVICE_NAME: 'Title',
				SERVICE_TITLE: 'Create Service',
				TAG: 'Tag',
				UNDO: 'Undo',
				UNDONE: 'Action undone',
				WO_CONFIRM: 'Create work order',
				WO_CREATED: 'Work order {{id}} created · {{route}}',
				WO_TITLE: 'Create instrument work order',
			},
			CHIPS: {
				UNACK_HINT: '{{n}} not yet acknowledged',
			},
			RULE: {
				FLAGGED_SHORT: 'Rule flagged',
				FLAGGED_TIP: 'The detector rule was flagged for tuning',
			},
			SETTINGS: {
				DEFAULT: 'Default',
				FROM_DEFAULT: 'default',
				FROM_FACILITY: 'facility',
				FROM_EQUIPMENT: 'this equipment',
				HISTORY: 'Change history',
				LOADING: 'Loading settings…',
				NO_HISTORY: 'No change yet: every value is the code default.',
				N_CHANGED: '{{n}} changed',
				OPEN: 'Triage settings',
				OPEN_HINT: 'Flatline, delays, HIL in memory, routing',
				READ_ONLY: 'Only an administrator can change these settings.',
				REASON: 'Reason for the change (required)',
				RESET: 'Reset',
				RE_EVAL: 'changes results',
				RE_EVAL_CHANGED: 'Run the golden set before relying on this change',
				RE_EVAL_HINT: 'Changing this changes triage results: run the golden set before relying on it',
				RE_EVAL_NOTE: 'Each change is a new version; every triage run records the version it used. Settings marked "changes results" need a golden-set run before you rely on them.',
				SAVE: 'Save',
				SAVED: 'Settings saved as version {{v}}',
				SAVE_FAILED: 'The settings could not be saved',
				SCOPE: 'Applies to',
				SCOPE_FACILITY: 'The whole facility',
				SUBTITLE: 'Version {{v}}',
				TITLE: 'Alert Triage settings',
			},
			TREE: {
				ALL_OPEN: 'All open alerts',
				CLEAR_FILTER: 'Show all nodes',
				NO_ACTION_TOTAL: 'No action',
				SHOWING_ONLY: 'Showing: {{cls}} only',
				SHOW_NODES_WITH: 'Show nodes with',
			},
			KG: {
				CLICK_TO_COLLAPSE: 'Klicken zum Zuklappen',
				NO_EXACT: 'Kein Knoten heißt „{{tag}}“',
				PICK_MATCH: 'Diese passen teilweise, je ein Anlagenteil — einen zum Erkunden wählen:',
				BREADCRUMB_OPS: 'Offshore-Betrieb',
				BREADCRUMB_TWINS: 'Topologische Zwillinge',
				BREADCRUMB_GRAPH: 'Shell Vito Wissensgraph',
				TITLE: 'Interaktiver Anlagen-Wissensgraph',
				NODES: '{{n}} Knoten',
				RELATIONSHIPS: '{{n}} Beziehungen',
				LIVE: 'Neo4j live',
				CENTER_PLACEHOLDER: 'Zentrums-Tag (z. B. PT-1502, MTR-0900)…',
				EXPLORE: 'Erkunden',
				HOPS: 'Tiefe',
				HOPS_1: '1 Schritt: direkte Nachbarn',
				HOPS_2: '2 Schritte: benachbarte Ausrüstung',
				HOPS_3: '3 Schritte: weitere Topologie',
				SHOW_TYPE: 'Diesen Typ anzeigen',
				HIDE_TYPE: 'Diesen Typ ausblenden',
				ZOOM_IN: 'Vergrößern',
				ZOOM_OUT: 'Verkleinern',
				FIT: 'An Bildschirm anpassen',
				SHOWING: '{{shown}} von {{total}} Knoten angezeigt',
				SHOW_MORE: '{{n}} weitere anzeigen',
				EXPAND_ALL: 'Alle Gruppen aufklappen',
				COLLAPSE_ALL: 'Gruppen zuklappen',
				HINT: 'Hover für Namen · Gruppe anklicken zum Aufklappen · Knoten anklicken zum Prüfen · ziehen zum Verschieben, scrollen zum Zoomen',
				LOADING: 'Wissensgraph wird gelesen…',
				LOAD_FAILED: 'Wissensgraph konnte nicht geladen werden',
				CLICK_TO_EXPAND: 'Klicken zum Auflisten und Aufklappen',
				GROUP: 'GRUPPIERTE KNOTEN',
				COLLAPSE_GROUP: 'Gruppe zuklappen',
				CENTER_ON_NODE: 'Graph auf diesen Knoten zentrieren',
				PROPERTIES: 'Knoteneigenschaften',
				LOADING_RELATIONS: 'Beziehungen werden geladen…',
				OUTGOING: 'Ausgehende Beziehungen ({{n}})',
				INCOMING: 'Eingehende Beziehungen ({{n}})',
				TYPE: {
					Equipment: 'Ausrüstung',
					ControlValve: 'Regelventil',
					Instrument: 'Instrument',
					Event: 'Alarm',
					Event_PostJune2026: 'Alarm (nach Juni 2026)',
					Alert: 'Alarm',
					TripEvent: 'Abschaltereignis',
					RootCause: 'Grundursache',
					PhaScenario: 'PHA-Szenario',
					Detector: 'Detektor',
					Measurement: 'Messung',
					Document: 'Dokument',
					PIDDrawing: 'R&I-Zeichnung',
					FLOC: 'FLOC',
					ProcessLine: 'Prozessleitung',
					System: 'System',
				},
			},
			LIBRARY: {
				TITLE: 'Bibliotheks-Spezialist',
				EXCERPTS_N: '{{n}} Auszüge · {{docs}} Dokumente',
				NONE: 'Kein Handbuch im Bereich',
				LIMITS_N: '{{n}} genannte Grenzwerte',
				SCOPE: 'Gesucht für',
				HINT: 'Hersteller-Handbücher, Datenblätter und Alarm- & Abschaltlisten zu dieser Ausrüstung (nach FLOC), nach Bedeutung und Wörtern durchsucht. Der Agent zitiert sie als LIB-n.',
				QUESTIONS: 'Gestellte Fragen',
				NONE_HINT: 'Für diese Ausrüstung oder ihre übergeordneten FLOCs ist kein Handbuch oder Datenblatt abgelegt.',
				STATED_LIMITS: 'Für dieses Instrument genannte Grenzwerte',
				EXCERPTS: 'Auszüge',
			},
			LIMITS: {
				ROW_FOUND: 'The red box marks the row this limit was read from.',
				OPEN_PAGE: 'Open the source page',
				OPEN_ROW: 'Open the source row',
				HIDE_SOURCE: 'Hide the source',
				SHEET_TITLE: 'Source row in the Shell workbook',
				SHEET_UNAVAILABLE: 'The workbook could not be read.',
				SHEET_ROWS: '{{n}} row(s) name this tag, of {{total}}',
				SHEET_NO_ROW: 'No row in this sheet names the tag.',
				SHEET_ROW: 'Row {{n}}',
				AT_ALERT: 'In force at the alert ({{t}}) marked',
				IN_FORCE: 'in force',
				NOT_IN_FORCE: 'not in force then',
				FROM: 'from {{from}}',
				QUOTED_FROM: 'quoted {{from}} – {{to}}',
				MAPPING_REVIEW: 'instrument ↔ tag mapping under review',
				DCS: 'DCS limit tags (historian)',
				AT_ALERT_VALUE: 'at the alert: {{v}}',
				TITLE: 'Grenzwerte',
				CLOSEST: '{{kind}} {{value}} · {{headroom}}% Reserve',
				NONE: 'Kein Grenzwert bekannt',
				RULE_BREACHED: 'TMP-Änderungsregel erfüllt',
				HINT: 'Alle bekannten technischen Grenzwerte des Alarm-Tags (Shell-TMP PSV-Sollwert / DCS / PTM, SimpleLimits, Handbuchwerte in gleicher Einheit) gegen den letzten Wert und das 24-h-Maximum bzw. -Minimum vor dem Alarm.',
				NONE_HINT: 'Für diesen Tag ist kein TMP-, SimpleLimits-, Detektor- oder Handbuch-Grenzwert bekannt.',
				SOURCE: 'Quelle',
				LIMIT: 'Grenzwert',
				VALUE: 'Wert',
				EXTREME_24H: '24 h Max. / Min.',
				HEADROOM: 'Reserve',
				STATUS: 'Status',
				RATE_RULES: 'TMP-Änderungsregeln',
				LARGEST_CHANGE: 'größte Änderung {{value}}',
				BREACHED: 'Überschritten',
				NOT_BREACHED: 'Nicht überschritten',
				DETECTOR: 'Detektor-Konfiguration',
				CONFLICT: 'Widersprüchliche TMP-Werte:',
				REACHED: 'Erreicht',
				NEAR: 'Nahe',
				CLEAR: 'Frei',
				NO_READING: 'Kein Messwert',
			},
			PREFS: {
				TITLE: 'Einstellungen',
				HEIGHT: 'Bevorzugte Diagrammhöhe',
				CONDENSED: 'Kompakt',
				NORMAL: 'Normal',
				EXPANDED: 'Erweitert',
				LIMITS_AND_VALUES: 'Tag-Grenzwerte und Werte',
				SHOW: 'Anzeigen',
				HIDE: 'Ausblenden',
				OTHER: 'Standardmäßig gezeichnete Grenzlinien',
				TRIP_LINE: 'Abschaltlinie',
				ALARM_LINE: 'Alarmlinie',
				THRESHOLD_LINE: 'Schwellenwertlinie',
				INSTRUMENT_LINE: 'Messbereichslinie',
				NOTE: 'Gilt für alle Triage-Diagramme. Das schattierte Band ist die Fehlerepisode (Signalbeginn bis Rückkehr zum Normalzustand). Grenzwerte stammen nur aus geladenen Shell-Daten (TMP, SimpleLimits).',
				RESET: 'Auf Standard zurücksetzen',
			},
			PLAYBOOK: {
				TITLE: 'Standort-Playbook-Prüfungen',
				META: '{{count}} Regeln ausgewertet',
				META_HINT: 'Aus den Prüfnotizen des Standorts für diesen Detektor gewonnene, zum Alarmzeitpunkt gültige Regeln, geprüft an den Belegen vor dem Stichtag',
				LEGEND: '✓ erfüllt · ✗ nicht erfüllt · ? nicht auswertbar. Eine erfüllte AUSSER-WENN-Prüfung blockiert die Regel; nicht prüfbare Teile beurteilt der Agent.',
				OPEN_RULE: 'Regel in Erkenntnisse öffnen',
				DISPOSITION_HINT: 'Was die Standortpraxis tut, wenn diese Regel greift',
				UNLESS_HINT: 'Ausnahmen: Ist eine erfüllt, greift die Regel nicht',
				JUDGED_BY_AGENT: 'Vom Agenten beurteilt',
				JUDGED_HINT: 'Dieser Teil ist nicht maschinell prüfbar; der Agent wägt ihn anhand der Belege ab',
				VALUE_YES: 'erfüllt',
				VALUE_NO: 'nicht erfüllt',
				VALUE_UNKNOWN: 'nicht auswertbar',
				ST_MATCHED: 'Zutreffend',
				ST_MATCHED_HINT: 'Alle WENN-Prüfungen erfüllt, keine Ausnahme',
				ST_PARTLY: 'Teilweise zutreffend',
				ST_PARTLY_HINT: 'Die maschinellen Prüfungen sind erfüllt; ob die Regel ganz greift, entscheiden die vom Agenten beurteilten Teile',
				ST_EXCEPTED: 'Ausgenommen',
				ST_EXCEPTED_HINT: 'Die Regel würde greifen, aber eine Ausnahme (AUSSER WENN) ist erfüllt',
				ST_UNDETERMINED: 'Unbestimmt',
				ST_UNDETERMINED_HINT: 'Eine Prüfung war mit den Belegen vor dem Stichtag nicht auswertbar',
				ST_NOT_MATCHED: 'Nicht zutreffend',
				ST_NOT_MATCHED_HINT: 'Eine WENN-Prüfung ist nicht erfüllt',
			},
			LEARNING_CHECK: {
				OR: 'oder',
				HOURS: '{{n}} h',
				DAYS: '{{n}} Tagen',
				ON_ITEM: 'an diesem Objekt',
				V_STOPPED: 'gestoppt',
				V_STARTED: 'gestartet',
				V_RESTARTED: 'neu gestartet',
				V_SHUTDOWN_OR_STARTUP: 'heruntergefahren oder angefahren',
				V_NO_SIGNIFICANT_CHANGE: 'keine wesentliche Änderung',
				V_PROCESS_OR_OPERATING_CHANGE: 'eine Prozess- oder Betriebsänderung',
				V_SINGLE_TAG_DEPARTURE: 'ein einzelner Tag weicht allein ab',
				V_MIXED: 'gemischte Muster',
				V_CONSISTENT: 'mit dem Normalzustand vereinbar',
				V_MOVED_TOGETHER: 'gemeinsam damit bewegt',
				MACHINE_EVENT: 'Maschine innerhalb von {{window}} {{events}}',
				MACHINE_EVENT_NO_WINDOW: 'Maschine {{events}}',
				MACHINE_EVENT_ANY: 'ein Maschinenstopp oder -start innerhalb von {{window}}',
				SINCE_RESTART: 'Maschine höchstens {{window}} vor dem Alarm neu gestartet',
				RUNNING: 'Maschine läuft zum Alarmzeitpunkt',
				NOT_RUNNING: 'Maschine läuft zum Alarmzeitpunkt nicht',
				WITHIN_BASELINE: 'Alarm-Tag zum Alarmzeitpunkt wieder im Normalband',
				OUTSIDE_BASELINE: 'Alarm-Tag zum Alarmzeitpunkt außerhalb des Normalbands',
				SUSTAINED: 'eine anhaltende Abweichung vom Normalzustand',
				NOT_SUSTAINED: 'keine anhaltende Abweichung vom Normalzustand',
				CHART_PATTERN: 'Diagramme zeigen {{patterns}}',
				CHART_PATTERN_ANY: 'ein Diagrammmuster wird gelesen',
				MULTIVARIATE: 'das multivariate Modell ergibt {{values}}',
				MULTIVARIATE_ANY: 'das multivariate Modell hat ein Ergebnis',
				CONNECTED: 'verbundene Systeme: {{values}}',
				CONNECTED_ANY: 'verbundene Systeme wurden gelesen',
				MOVED_TOGETHER: 'verwandte Tags bewegten sich gemeinsam',
				NOT_MOVED_TOGETHER: 'verwandte Tags bewegten sich nicht gemeinsam',
				OPEN_WORK: 'offene Meldung oder offener Auftrag an diesem Objekt',
				NO_OPEN_WORK: 'keine offene Meldung und kein offener Auftrag an diesem Objekt',
				COHORT: 'viele Alarme im selben System zugleich (gemeinsame Ursache)',
				NO_COHORT: 'keine Häufung von Alarmen im selben System',
				SENSOR_FAULT: 'der Sensor ist gestört oder seine Daten unbrauchbar',
				SENSOR_OK: 'die Sensordaten sind brauchbar',
				RETURNED: 'das Signal war vor dem Alarmzeitpunkt wieder normal',
				NOT_RETURNED: 'das Signal war bis zum Alarmzeitpunkt nicht wieder normal',
				SHIFT_LOG: 'ein Schichtbericht aus den letzten {{window}} erwähnt „{{query}}“',
				NO_SHIFT_LOG: 'kein Schichtbericht aus den letzten {{window}} erwähnt „{{query}}“',
				RECENT_WORK: 'Instandhaltungsarbeit aus den letzten {{window}} passend zu „{{query}}“',
				NO_RECENT_WORK: 'keine Instandhaltungsarbeit aus den letzten {{window}} passend zu „{{query}}“',
				OTHER_ALERTS: 'mindestens {{n}} weitere Alarme desselben Detektors innerhalb von {{window}}',
				PRIOR_ALERTS: 'mindestens {{n}} frühere Alarme auf diesem Tag in den letzten {{window}}',
				PRIOR_ALERTS_EVER: 'mindestens {{n}} frühere Alarme auf diesem Tag',
			},
			LEARNING_EDIT: {
				TITLE: 'Erkenntnis bearbeiten',
				ASOF_WARNING: 'Speichern schreibt Version v{{next}}, gültig ab jetzt. Die Triage früherer Alarme behält die damals gültige Version (as-of).',
				F_TITLE: 'Titel',
				RECOMPILE: 'Die maschinellen Prüfungen werden aus der neuen Bedingung neu erstellt.',
				ACTIVE_HINT: 'der Agent zieht sie heran',
				RETIRED_HINT: 'ab jetzt zurückgezogen',
				REASON: 'Grund der Änderung',
				REASON_HINT: 'Wird mit der neuen Version gespeichert und im Verlauf angezeigt.',
				NO_CHANGES: 'Noch nichts geändert.',
				SAVE: 'Neue Version speichern',
				SAVED: 'Als v{{version}} gespeichert, gültig ab jetzt; frühere Triagen behalten die vorherige Version.',
			},
			LEARNING_DETAIL: {
				TITLE: 'Erkenntnis',
				EDIT: 'Bearbeiten',
				CLOSE: 'Schließen',
				EFFECTIVE: 'gültig seit {{date}}',
				SUPPORT: 'Stützung: {{support}}',
				CONSISTENCY: 'Konsistenz {{pct}}',
				MANUAL_FIELDS: 'von Hand gesetzt: {{fields}}',
				CONDITION: 'Bedingung',
				EXCEPTIONS: 'Ausnahmen',
				CHECKS: 'Maschinelle Prüfungen',
				CHECKS_HINT: 'Die Bedingung, übersetzt in Fakten, die der Agent an den Belegen zum Alarmzeitpunkt prüfen kann; der Rest wird vom Agenten beurteilt.',
				CHECKS_STALE: 'Die Bedingung wurde bearbeitet: Ihre maschinellen Prüfungen werden neu erstellt und bis dahin nicht verwendet.',
				WHEN: 'Wenn',
				UNLESS: 'Außer wenn',
				MANUAL: 'Vom Agenten beurteilt',
				NO_CHECKS: 'Keine maschinell prüfbare Bedingung',
				GROUPS: 'Sensorgruppen, die seine Alarme betreffen',
				TYPICAL_TAGS: 'Typische Tags',
				QUOTES: 'Aus den Prüfnotizen',
				GRAPH: 'Umfeld im Wissensgraphen',
				GRAPH_MISSING: 'Noch nicht im Wissensgraphen.',
				REL_DETECTOR: 'Für Detektor',
				REL_FLOC: 'An Funktionsort',
				REL_SUPERSEDES: 'Ersetzt',
				NO_LINKS: 'Keine Verknüpfungen zu Detektor, Ort oder früheren Versionen.',
				SIMILAR: 'Ähnliche Erkenntnisse',
				NO_SIMILAR: 'Keine aktive Erkenntnis mit ähnlicher Bedeutung.',
				OPEN_SIMILAR: 'Diese Erkenntnis öffnen',
				ASOF_NOTE: 'Versionen werden nie überschrieben: Eine Triage zum Zeitpunkt t verwendet die zu t gültige Version.',
				NOW: 'jetzt',
				CHANGED: 'Geändert:',
				SHOW_DIFF: 'Regelunterschied zeigen',
				HIDE_DIFF: 'Unterschied ausblenden',
				F_TITLE: 'Titel',
				F_RULE: 'Regel',
				F_DISPOSITION: 'Einstufung',
				F_STATUS: 'Status',
				F_CONDITION: 'Bedingung',
				F_EXCEPTIONS: 'Ausnahmen',
				F_SUPPORT: 'Stützung',
				SHOW_ALL_SOURCES: 'Alle {{count}} zeigen',
			},
			PID: {
				CLICK_TO_PLOT: 'Klicken zum Plotten',
				NO_HISTORIAN_DATA: 'Keine Historian-Daten',
				MORE_TAGS: '+{{count}} weitere Tags an diesem Element',
				NO_DATA_AT_ALERT: 'Keine Messwerte in den 72 h vor dem Alarm',
				CLICKABLE_COUNT: '{{clickable}} von {{total}} Tags haben Daten',
				TAGS_FAILED: 'Tags dieser Zeichnung konnten nicht geladen werden',
				HIDE_LEGEND: 'Legende ausblenden',
				SHOW_LEGEND: 'Legende einblenden',
				LEGEND_DATA: 'Hat Historian-Daten (klicken)',
				LEGEND_NO_DATA: 'Keine Historian-Daten',
				LEGEND_ALERT: 'Alarm-Tag',
				LEGEND_RELATED: 'Gleiches Equipment / gleicher Kreis wie der Alarm',
				LEGEND_SUGGESTED: 'Zum Ansehen empfohlen',
				ONLY_WITH_DATA: 'Nur Tags mit Daten',
				SHEET_N: 'Blatt {{sheet}}',
				BACK: 'Zurück',
				BACK_TIP: 'Zurück zum vorherigen Blatt ({{count}} im Verlauf)',
				SHOW_PANEL: 'Panel einblenden',
				HIDE_PANEL: 'Panel ausblenden',
				FROM_UPSTREAM: 'Von stromaufwärts',
				TO_DOWNSTREAM: 'Nach stromabwärts',
				RESIZE: 'Ziehen, um das Panel zu verbreitern',
				ON_DRAWING: 'Auf der Zeichnung',
				LOCATE_ITEM: 'Auf der Zeichnung zeigen',
				FROM_OTHER_SHEET: 'Auf einem anderen Blatt ausgewählt',
				ITEM_TAGS: 'Tags an diesem Element ({{count}})',
				SWITCH_TIP: 'klicken, um stattdessen diesen Tag zu plotten',
				ADD_TO_CHART: 'Zum Diagramm hinzufügen',
				REMOVE_FROM_CHART: 'Aus dem Diagramm entfernen',
				ON_CHART: '{{count}} / {{max}} im Diagramm',
				ALERT_WINDOW: 'Alarm um {{asOf}} · 3 Tage davor bis 1 Tag danach',
				LAST_DAYS: 'Letzte {{days}} Tage verfügbarer Daten',
				CHART_FULL: 'Höchstens {{max}} Tags können zusammen geplottet werden',
				TIME_SERIES: 'Zeitreihe',
				LOOK_NEXT: 'Als Nächstes ansehen',
				CONTEXT_FAILED: 'Verwandte Tags konnten nicht geladen werden',
				CONTEXT_UNKNOWN: 'Dieser Tag ist nicht im Sensorkatalog',
				LOOP_N: 'Kreis {{loop}}',
				SAME_LOOP: 'Gleicher Kreis',
				SAME_EQUIPMENT: 'Gleiches Equipment',
				UPSTREAM: 'Einheiten stromaufwärts',
				DOWNSTREAM: 'Einheiten stromabwärts',
				SERVICE: 'Versorgende Hilfssysteme',
				NONE_WITH_DATA: 'Keine mit Historian-Daten',
				SHOW_MORE: '{{count}} weitere zeigen',
				NO_UNITS: 'Keine verbundenen Einheiten',
				HOPS: '{{count}} Schritt(e)',
				OPEN_DRAWING: 'Zeichnung öffnen',
				MORE_SENSORS: '+{{count}} weitere Sensoren',
				TWIN: 'Paralleler Strang: {{unit}}',
				TWIN_ON_CHART: 'Zwillings-Tag ist im Diagramm',
				COMPARE_TWIN: 'Mit Zwilling vergleichen',
				TWIN_NO_TAG: 'Kein Tag gleicher Position auf {{unit}} bekannt',
				TWIN_SAME_MEASURE: 'Gleiche Messgröße auf {{unit}}',
				LOCATE_ON_SHEET: 'Auf diesem Blatt zeigen',
				OTHER_CONNECTORS: 'Hilfssysteme & Entlastung ({{count}})',
				OTHER_CONNECTORS_TIP: 'Steuer-, Hilfssystem- und Entlastungsverbinder auf diesem Blatt',
				SIDE_BY_SIDE: 'Nebeneinander',
				SIDE_BY_SIDE_TIP: 'Vollbild: Zeichnung und Panel nebeneinander',
				REL: {
					ALERT: 'Alarm-Tag',
					LOOP: 'Gleicher Kreis',
					EQUIPMENT: 'Gleiches Equipment',
				},
			},
			BATCH: {
				TOGGLE: 'Batch',
				TOGGLE_HINT: 'Batch-Modus: Gruppen von Alarmen auf demselben FLOC innerhalb eines Zeitfensters auflisten und jede Gruppe gemeinsam bewerten',
				TOGGLE_OFF_HINT: 'Zurück zur Liste einzelner Alarme',
				WINDOW_LABEL: '{{hours}}-h-Fenster',
				WINDOW_HINT: 'Batch-Fenster: Alarme auf einem FLOC innerhalb so vieler Stunden nach dem ersten bilden eine Gruppe',
				WINDOW_TITLE: 'Batch-Fenster',
				WINDOW_OPTION: '{{hours}} h',
				HELP: 'Alarme werden nach FLOC gruppiert. Das Fenster beginnt beim ersten Alarm der Gruppe; der Stichzeitpunkt ist das jüngste Mitglied, daher wird jedes Mitglied mit dem damaligen Wissensstand bewertet. Eine Untersuchung deckt die Gruppe ab und gibt jedem Mitglied eine eigene Einstufung. Gruppen nutzen die Filter Datum, Suche, FLOC, Ziel und Status.',
				GROUPS_TITLE: 'Batches · {{hours}}-h-Fenster',
				GROUPS_COUNT: '({{groups}} Gruppen · {{alerts}} von {{considered}} Alarmen)',
				NEWEST_FIRST: 'Neueste zuerst',
				EMPTY: 'Keine Batches',
				EMPTY_HINT: 'Mit den aktuellen Filtern hat kein FLOC zwei oder mehr Alarme innerhalb des Fensters.',
				COL_SIZE: 'Größe',
				COL_SPAN: 'Zeitspanne',
				COL_DETECTORS: 'Detektoren',
				COL_CLASSES: 'Aktuelle Klassen',
				COL_TAG: 'Tag',
				COL_AS_OF: 'Stand',
				TOGGLE_MEMBERS: 'Alarme dieser Gruppe ein- oder ausblenden',
				N_ALERTS: '{{count}} Alarme',
				SPAN: '{{count}} Alarme in {{span}}',
				MINUTES: '{{count}} Min.',
				HOURS_MINUTES: '{{hours}} h {{minutes}} Min.',
				CUTOFF: 'Stichzeit',
				N_UNTRIAGED: '{{count}} nicht bewertet',
				ALL_TRIAGED: 'Alle bewertet',
				RUNNING: 'Batch-Lauf läuft',
				TRIAGE_BATCH: 'Batch bewerten ({{count}})',
				TRIAGE_SELECTED: '{{count}} ausgewählte bewerten',
				TRIAGE_HINT: 'Eine gemeinsame Untersuchung dieser Alarme zum Stand des jüngsten Mitglieds; jeder Alarm erhält eine eigene Einstufung',
				SELECT_MIN: 'Mindestens {{count}} Alarme dieser Gruppe auswählen',
				SELECT_MAX: 'Ein Batch umfasst höchstens {{count}} Alarme: bis zu {{count}} auswählen',
				PAGE_HINT: 'Die Seiten zählen Gruppen',
				RANGE: '{{start}}–{{end}} von {{total}} Gruppen',
				DONE: 'Batch mit {{count}} Alarmen bewertet',
				GATED: 'Batch nicht analysiert: die Datenqualitätsprüfung hat den Lauf blockiert (siehe Canvas)',
				FAILED: 'Der Batch-Lauf wurde nicht abgeschlossen',
				ROW_CHIP: 'Batch mit {{count}}',
				ROW_CHIP_TIP: 'Der letzte Lauf hat diesen Alarm zusammen mit {{count}} Alarmen auf seinem FLOC bewertet (eine Untersuchung, eine Einstufung je Alarm)',
				CARD_TITLE: 'Gruppenbewertung',
				CARD_META: 'Batch mit {{count}} · {{hours}}-h-Fenster · Stichzeit {{time}}',
				EPISODE_CLASS: 'Episode',
				EPISODE_HINT: 'Einstufung der Gruppe als Ganzes',
				THIS_MEMBER: 'Dieser Alarm',
				MEMBERS: 'Alarme im Batch',
				THIS_ALERT: 'dieser Alarm',
				NOW_IN_GROUP: 'Dieser Alarm liegt jetzt in einer Gruppe von {{count}} auf seinem FLOC ({{hours}}-h-Fenster, {{span}} Min., {{untriaged}} nicht bewertet).',
				MORE_DETECTORS: '+{{count}} weitere',
				TRIAGE_WITH: 'Mit {{count}} Alarmen auf diesem FLOC bewerten',
			},
			UEV: {
				TITLE: 'Nachweise & Feedback',
				HINT: 'Feldbeobachtungen, SAP-Meldungen, Historian-Tags und Dateien, die Sie hier hinzufügen, erhält der Agent bei einer Neuausführung – als vom Benutzer geliefert markiert und getrennt vom Stichtagsbestand gewichtet.',
				BADGE_N: '{{count}} Element(e)',
				BADGE_CHANGED: 'hat die Antwort geändert',
				EMPTY: 'Noch keine Nachweise hinzugefügt.',
				LOAD_ERROR: 'Nachweise konnten nicht geladen werden',
				ADD: 'Nachweis hinzufügen',
				ADDED: 'Nachweis hinzugefügt',
				UPDATED: 'Nachweis aktualisiert',
				REMOVED_NOTICE: 'Nachweis entfernt',
				TYPE_OBSERVATION: 'Feedback / Beobachtung',
				TYPE_SAP: 'SAP-Meldung',
				TYPE_TAG: 'Historian-Tag',
				TYPE_FILE: 'Datei',
				TEXT_LABEL: 'Was beobachtet oder gemessen wurde',
				TEXT_PLACEHOLDER: 'z. B. Vor-Ort-Manometer zeigt 30 scfm; Ablassventil undicht',
				CONTEXT_LABEL: 'Warum es für diesen Alarm wichtig ist',
				CONTEXT_PLACEHOLDER: 'Kontextnotiz für den Agenten (optional)',
				NOTIF_LABEL: 'Meldungsnummer',
				LOOKUP: 'Nachschlagen',
				NOTIF_NOT_FOUND: 'Meldung nicht gefunden',
				NOTIF_AFTER: '{{hours}} h nach dem Alarm angelegt',
				NOTIF_BEFORE: 'Vor dem Alarm angelegt',
				NOTIF_NAMES_TAG: 'Nennt den Alarm-Tag {{tag}}',
				FLOC_EQUIPMENT: 'Gleiches Equipment',
				FLOC_UNIT: 'Gleiche Einheit',
				FLOC_FACILITY: 'Anderes Equipment',
				RAISED: 'Angelegt {{time}}',
				COMPLETED: 'Abgeschlossen {{time}}',
				TAG_LABEL: 'Historian-Tag',
				TAG_PLACEHOLDER: 'Tags suchen (z. B. LIC0920)',
				TAG_HINT: 'Der Agent liest diesen Tag zum Alarmzeitpunkt, wie jeden anderen Tag.',
				FILE_CHOOSE: 'Datei wählen',
				FILE_HINT: 'PDF, Bild, Text, CSV, Word oder Excel, bis 10 MB',
				FILE_TYPE_ERROR: 'Nicht unterstützter Dateityp: PDF, PNG, JPG, Text, CSV, Word oder Excel hochladen',
				FILE_SIZE_ERROR: 'Die Datei ist größer als 10 MB',
				FILE_META: '{{pages}} Seite(n), {{size}} KB',
				FILE_NO_TEXT: 'kein Text extrahiert ({{note}})',
				OPEN_FILE: 'Datei öffnen',
				SAVE: 'Hinzufügen',
				CANCEL: 'Abbrechen',
				EDIT: 'Bearbeiten',
				REMOVE: 'Entfernen',
				REMOVE_CONFIRM: 'Dieses Element entfernen? Frühere Versionen bleiben erhalten, und Läufe, die sie genutzt haben, nennen sie weiterhin.',
				REASON: 'Grund (optional)',
				SAVE_EDIT: 'Als neue Version speichern',
				VERSIONS: 'Verlauf',
				REMOVED: 'Entfernt',
				SHOW_REMOVED: 'Entfernte anzeigen',
				HIDE_REMOVED: 'Entfernte ausblenden',
				BY: 'Hinzugefügt von {{name}} · {{time}}',
				EDITED_BY: 'v{{n}} von {{name}} · {{time}}',
				AFTER_CUTOFF: 'nach dem Stichtag',
				RERUN: 'Mit Nachweisen neu ausführen',
				RERUN_HINT: 'Führt den Triage-Agenten erneut mit den {{count}} aktiven Element(en) aus; live im Lauf-Canvas verfolgen',
				RERUN_BATCH: 'Batch neu ausführen ({{count}} Alarme)',
				RERUN_BATCH_HINT: 'Führt den Batch erneut mit den aktiven Nachweisen aller Mitglieder aus',
				LAST_RUN: 'Letzte Neuausführung nutzte {{refs}}',
				OUTCOME_CHANGED: 'Antwort geändert: {{from}} → {{to}}',
				OUTCOME_UNCHANGED: 'Antwort unverändert',
				OUTCOME_NOT_ATTRIBUTED: 'Antwort geändert ({{from}} → {{to}}), nicht den Nachweisen zugeschrieben',
				OUTCOME_NO_BASELINE: 'Laut Agent haben die Nachweise die Antwort entschieden',
				AGENT_LINE: 'Antwort aus einer Neuausführung mit Benutzernachweisen {{refs}}',
				NODE: 'Benutzernachweise',
				CANVAS_BADGE: 'Benutzernachweise · {{count}}',
				CANVAS_HINT: 'Neuausführung mit vom Benutzer gelieferten Nachweisen: {{refs}}',
				PICKER: 'Benutzernachweise',
				INSPECTOR_ITEMS: 'Verwendete Elemente ({{count}})',
				INSPECTOR_BASELINE: 'Antwort ohne diese Nachweise: {{cls}}',
				INSPECTOR_NO_BASELINE: 'Kein früherer Lauf ohne Benutzernachweise',
				INSPECTOR_AUDIT: 'Vom Benutzer gelieferte Elemente bleiben außerhalb der Stichtagssicht; die Leck-Prüfung deckt nur die Fakten des Harness ab.',
				ATTRIBUTION_USER_EVIDENCE: 'Durch Nachweise geändert: {{from}} → {{to}}',
				ATTRIBUTION_USER_EVIDENCE_NO_BASELINE: 'Durch Nachweise entschieden (kein früherer Lauf)',
				ATTRIBUTION_NOT_ATTRIBUTED: 'Geändert, nicht zugeschrieben: {{from}} → {{to}}',
				ATTRIBUTION_UNCHANGED: 'Unverändert',
				EFFECT_CHANGED_ANSWER: 'hat die Antwort geändert',
				EFFECT_SUPPORTED_ANSWER: 'stützt die Antwort',
				EFFECT_CONTRADICTED: 'widerspricht, nicht übernommen',
				EFFECT_NO_BEARING: 'ohne Bezug',
				EFFECT_NOT_ADDRESSED: 'nicht behandelt',
			},
			WATCH: {
				STATUS_WATCHING: 'Beobachtet',
				ACTION: 'Beobachten',
				ACTION_HINT: 'Diesen Alarm später erneut prüfen, mit den nach dieser Bewertung erfassten Daten',
				UNWATCH: 'Nicht mehr beobachten',
				DIALOG_TITLE: 'Alarm beobachten',
				DIALOG_LEAD: 'Der Alarm bleibt bis zum Fälligkeitstermin unter Beobachtung; danach kann er mit allem, was seit dieser Bewertung erfasst wurde, neu bewertet werden.',
				ASSESSED_AS_OF: 'Aktuelle Bewertung zum Stand',
				ASSESSED_HINT: 'Der Stichzeitpunkt der angezeigten Bewertung. Die Voreinstellungen zählen ab diesem Zeitpunkt, nicht ab heute.',
				LOOK_AGAIN: 'Erneut prüfen',
				PRESET_HOURS: '+{{count}} h',
				PRESET_DAYS: '+{{count}} T',
				PRESET_CUSTOM: 'Datum & Uhrzeit',
				DUE_AT: 'Fällig am',
				DUE_LINE: 'Fällig {{time}}',
				DUE_BEFORE_ASSESSMENT: 'muss nach der Bewertung liegen',
				SUGGESTED: 'Vom Agenten vorgeschlagen',
				USE_SUGGESTION: 'Als Grund übernehmen',
				REASON: 'Grund',
				REASON_HINT: 'Was bei Fälligkeit zu prüfen ist (Pflichtfeld)',
				CONFIRM: 'Beobachten',
				SET_NOTICE: 'Alarm unter Beobachtung gestellt',
				BANNER_DUE: 'Beobachtung fällig',
				BANNER_WAITING: 'Unter Beobachtung',
				CHIP_DUE: 'Fällig · {{time}}',
				CHIP_WAITING: 'Beobachtet · fällig {{time}}',
				TIP_DUE: 'Unter Beobachtung, fällig seit {{time}}: mit den neuen Daten neu bewerten',
				TIP_WAITING: 'Unter Beobachtung bis {{time}}',
				SET_BY: 'Gesetzt von {{name}} am {{date}}',
				BASELINE: 'Beobachtet wird die Bewertung zum Stand {{time}}',
				CHECKING: 'Prüfe, was seitdem erfasst wurde…',
				NOTHING_NEW: 'Seit der Bewertung wurde noch nichts Neues erfasst.',
				LATER_ALERTS: 'Spätere Alarme',
				BEYOND: '+{{count}} danach',
				OPEN_LATER: 'Diesen Alarm öffnen',
				SAP_RECORDS: 'SAP-Datensätze',
				SUPERVISOR_REPORTS: 'Supervisor-Berichte',
				HISTORIAN: 'Historian',
				HOURS: '{{count}} h',
				ON_TAGS: 'auf {{count}} Tags',
				WINDOW: 'Neue Daten von {{from}} bis {{to}}',
				REASSESS: 'Mit neuen Daten neu bewerten',
				REASSESS_HINT: 'Neu bewerten mit auf den Fälligkeitstermin verschobener Stichzeit (nie später als jetzt); der Canvas folgt dem Lauf',
				REASSESS_WAIT: 'Verfügbar, sobald die Beobachtung fällig ist',
				NEW_DATA: 'neue Daten',
				NEW_DATA_DOT: 'Fällig, mit seit der Bewertung erfassten Daten',
				FILTER_LABEL: 'Beobachtung',
				FILTER_DUE: 'Fällig',
				FILTER_WAITING: 'Beobachtet (nicht fällig)',
				REASSESSED_HEADER: 'Neu bewertet zum Stand {{time}} (zuerst bewertet zum Stand {{previous}}: {{cls}})',
			},
			SHELL: {
				TOGGLE: 'HIL-Labels anzeigen',
				TOGGLE_HINT: 'Fügt das HIL-Prüflabel (Human-in-the-Loop) und den Kommentar als Spalten zum Vergleich hinzu. Nur Validierungsdaten: nie eine Eingabe für den Triage-Agenten.',
				VALIDATION_ONLY: 'HIL-Labels (Human-in-the-Loop) sind Validierungsdaten. Sie sind nie eine Eingabe für den Triage-Agenten.',
				COLUMN: 'HIL-Label',
				NOT_VETTED: 'Nicht geprüft',
				NOT_VETTED_TIP: 'Kein HIL-Label für diesen Alarm',
				STATE: 'HIL-Status',
				COMMENT: 'Kommentar',
				ACTION_TAKEN: 'Ergriffene Maßnahme',
				RELIABILITY: 'Zuverlässigkeit',
				INHERITED: 'Von der übergeordneten Episode übernommen',
				AGREES: 'Stimmt mit HIL überein',
				DIFFERS: 'Weicht von HIL ab',
				AGREES_TIP: 'Unsere Klassifizierung stimmt mit dem HIL-Label überein',
				DIFFERS_TIP: 'Unsere: {{ours}} · HIL: {{shell}}',
				AGREEMENT: 'Stimmt bei {{agree}} von {{compared}} triagierten mit HIL überein',
				AGREEMENT_TIP: 'Gefilterte, triagierte (nicht ausstehende) Alarme mit HIL-Label und wie viele dieselbe Klasse haben.\nHIL-Labels sind Validierungsdaten, nie eine Eingabe für den Agenten.',
				CARD_TITLE: 'HIL-Prüfung',
				FILTER_LABEL: 'HIL-Label',
				FILTER_NONE: 'Nicht geprüft',
				COLUMN_COMMENT: 'HIL-Kommentar',
			},
			FACTS: {
				TITLE: 'Gelesene Evidenz — älteste → neueste (alle vor der Stichzeit)',
				HINT: 'Zeitraum der Fakten, die der Lauf aus jeder Quelle gelesen hat. Jede Abfrage endet an der Stichzeit.',
				CUTOFF: 'Stichzeit {{time}}',
				COL_SOURCE: 'Quelle',
				COL_OLDEST: 'Älteste',
				COL_NEWEST: 'Neueste',
				COL_GAP: 'Vor der Stichzeit',
				SOURCE_HISTORIAN: 'Historian',
				SOURCE_SAP_NOTIFICATION: 'SAP-Meldungen',
				SOURCE_SAP_WORKORDER: 'SAP-Aufträge',
				SOURCE_SUPERVISOR_REPORT: 'Supervisor-Berichte',
				SOURCE_ALERTS: 'Alarme',
				SOURCE_MEMORY: 'Gedächtnis',
				NOT_READ: 'Keine Fakten gelesen',
				POST_ALERT: 'Datensätze nach dem Alarm',
				POST_ALERT_NONE: 'keine abgerufen: jede Abfrage endet an der Stichzeit',
				AFTER_CUTOFF: 'nach der Stichzeit',
				GAP_SECONDS: '{{count}} s',
				GAP_MINUTES: '{{count}} Min.',
				GAP_HOURS: '{{count}} h',
				GAP_DAYS: '{{count}} T',
			},
			SENSOR: {
				MEASURE: {
					temperature: 'Temperatur',
					pressure: 'Druck',
					differential_pressure: 'Differenzdruck',
					level: 'Füllstand',
					flow: 'Durchfluss',
					vibration: 'Vibration',
					axial_position: 'Axialposition',
					speed: 'Drehzahl',
					current: 'Strom',
					power: 'Leistung',
					voltage: 'Spannung',
					valve_position: 'Ventilstellung',
					status: 'Status',
					composition: 'Zusammensetzung',
				},
				GROUP: {
					vibration: 'Vibration',
					bearing_temperature: 'Lagertemperatur',
					axial_position: 'Axialposition',
					speed_run: 'Drehzahl & Laufstatus',
					lube_oil: 'Schmieröl',
					seal_gas: 'Sperrgas',
					suction: 'Saugseite',
					discharge: 'Druckseite',
					cooling: 'Kühlung',
					anti_surge: 'Pumpschutz',
					scrubber_level: 'Abscheiderstand',
					control_valve: 'Regelventil',
					motor_electrical: 'Motor elektrisch',
					turbine: 'Turbine',
				},
				ROLE: {
					process_value: 'Prozesswert',
					setpoint: 'Sollwert',
					controller_output: 'Reglerausgang',
					limit: 'Grenzwert',
					mode: 'Modus',
					totaliser: 'Summenzähler',
				},
				GROUP_NONE: 'Sonstige',
				COL_SENSOR: 'Sensor',
				CONVENTION_ONLY: 'nur Tag-Konvention',
				TIP_MEASURES: 'Misst: {{value}}',
				TIP_WHY: 'Warum es überwacht wird (Technischer Überwachungsplan)',
				TIP_NO_REASON: 'Für diesen Sensor ist kein Überwachungsgrund erfasst.',
				TIP_CONVENTION: 'Nur durch die R&I-Tag-Konvention beschrieben; der Überwachungsplan deckt ihn nicht ab.',
				TIP_ACTION: 'Empfohlene Maßnahme',
				TIP_UNIT: 'Einheit: {{unit}}',
				TIP_LIMITS: 'Grenzwerte: {{value}}',
				TIP_SOURCES: 'Quellen: {{value}}',
				TIP_LOW: 'Nur die Tag-Benennung beschreibt diesen Sensor, seine Bedeutung ist daher weniger sicher.',
				LIMIT_LOW: 'unten',
				LIMIT_HIGH: 'oben',
			},
			CONNECTED: {
				USUALLY_LEADS: 'läuft üblicherweise {{t}} voraus (r {{r}})',
				USUALLY_LAGS: 'folgt üblicherweise {{t}} später (r {{r}})',
				USUALLY_WITH: 'bewegt sich üblicherweise gleichzeitig (r {{r}})',
				NOT_COUPLED: 'üblicherweise nicht gekoppelt (r {{r}})',
				USUAL_DELAY: 'mit der üblichen Verzögerung bewegt',
				NOT_USUAL_DELAY: 'nicht mit der üblichen Verzögerung',
				COUPLING_HINT: 'Wie dieser Sensor über die Laufbasis üblicherweise mit dem Alarm-Tag zusammenhängt: Verzögerung der besten Korrelation und deren r. „Übliche Verzögerung“ vergleicht das jetzige Timing damit.',
				TITLE: 'Verbundene Systeme',
				VERDICT: {
					upstream_led: 'Vorgelagerte Einheit bewegte sich zuerst',
					service_related: 'Eine versorgende Utility hat sich mitbewegt',
					downstream_followed: 'Nachgelagerte folgten — die Änderung beginnt hier',
					moved_together: 'Verbundene Einheiten bewegten sich gemeinsam',
					isolated: 'Verbundene Systeme blieben stabil — lokal an dieser Ausrüstung',
					background_drift: 'Verbundene Einheiten seit Tagen abseits der Basislinie (Hintergrund)',
					moved_unordered: 'Verbundene Einheiten bewegten sich, Reihenfolge unklar',
					insufficient: 'Zu wenige Sensoren für eine Bewertung',
				},
				UPSTREAM: 'Vorgelagert',
				DOWNSTREAM: 'Nachgelagert',
				SERVICE: 'Versorgende Utilities',
				REL_UPSTREAM: 'vorgelagert',
				REL_DOWNSTREAM: 'nachgelagert',
				REL_SERVICE: 'versorgende Utility',
				AS_OF: 'Stand zum Alarmzeitpunkt — nach dem Alarm Aufgezeichnetes wird nicht verwendet',
				OF_SENSORS: 'von {{total}} Sensoren mit Daten',
				RATIO_HINT: 'Schnittstellensensoren der Nachbareinheiten mit verwertbaren Messwerten vor dem Alarm',
				ANCHOR_ONSET: 'Beginn des Alarm-Tags',
				PLOT: 'Alarm-Tag und Schnittstellensensoren',
				PLOT_TITLE: 'Diagramm der verbundenen Systeme',
				PLOT_CAPTION: 'Schwarz = Alarm-Tag · graue Fläche = Maschine gestoppt · gestrichelte Linie = Beginn des Alarm-Tags · graues Band = innerhalb ±3 sd der Laufbasislinie. Zum Vergrößern klicken.',
				NEIGHBOURS: 'Verbundene Einheiten',
				NEIGHBOURS_META: '{{total}} verbundene Einheiten gelesen, {{moved}} bewegt',
				EXPAND_ALL: 'Alle aufklappen',
				COLLAPSE_ALL: 'Stabile einklappen',
				NO_NEIGHBOURS: 'Es wurden keine verbundenen Einheiten gelesen.',
				OPEN_UNIT: 'Diese Einheit in der Prozessansicht öffnen',
				LINK_HIGH: 'Verbindung: hoch',
				LINK_MEDIUM: 'Verbindung: mittel',
				LINK_LOW: 'Verbindung: niedrig',
				LINK_HINT: 'Wie sicher die Zeichnungen sind, dass diese beiden Einheiten verbunden sind',
				STATE_MOVED: 'bewegt',
				STATE_HELD: 'stabil',
				STATE_NO_DATA: 'keine Daten',
				SENSORS_N: '{{count}} Sensoren',
				COL_SENSOR: 'Schnittstellensensor',
				COL_STATE: 'Zustand',
				COL_Z_LAST: 'z zuletzt',
				COL_Z_LAST_HINT: 'Abstand des letzten Messwerts vor dem Alarm von der Laufbasislinie in Standardabweichungen',
				COL_Z_DAY: 'z 24 h',
				COL_Z_DAY_HINT: 'Medianer Abstand von der Laufbasislinie in den 24 h vor dem Alarm in Standardabweichungen',
				COL_ONSET: 'Abweichung begann',
				NO_READINGS: 'Keine verwertbaren Messwerte vor dem Alarm',
				RELIEF: 'Entlastungsleitungen',
				MORE: 'Mehr anzeigen',
				LESS: 'Weniger anzeigen',
				DUR_MIN: '{{n}} Min.',
				DUR_H: '{{n}} h',
				DUR_D: '{{n}} Tage',
				TIMING_BEFORE: 'bewegte sich {{t}} vor dem Alarm-Tag',
				TIMING_BEFORE_SHORT: '{{t}} davor',
				TIMING_AFTER: 'bewegte sich {{t}} nach dem Alarm-Tag',
				TIMING_AFTER_SHORT: '{{t}} danach',
				TIMING_TOGETHER: 'bewegte sich gemeinsam mit dem Alarm-Tag',
				TIMING_TOGETHER_SHORT: 'gemeinsam',
				TIMING_EARLIER: 'begann {{t}} vor dem Alarm-Tag — Hintergrund',
				TIMING_EARLIER_SHORT: '{{t}} früher · Hintergrund',
				TIMING_EARLIER_NO_DUR: 'begann lange vor dem Alarm-Tag — Hintergrund',
				TIMING_EARLIER_NO_DUR_SHORT: 'lange davor · Hintergrund',
				TIMING_HELD: 'blieb nahe der Basislinie',
				TIMING_NO_DATA: 'keine verwertbaren Messwerte vor dem Alarm',
				TIMING_UNCLEAR: 'bewegte sich, Zeitpunkt unklar',
			},
			GAPS: {
				TITLE: 'Erwartete Sensoren ohne Tag ({{count}})',
				LINK: 'Erwartete Sensoren ohne Tag ({{count}})',
				LINK_HINT: 'Vom Maschinenmodell erwartete Sensoren ohne Historian-Tag',
				EXPLAIN: 'Dies sind Sensoren, die die C3-Asset-Vorlage für diese Maschine erwartet, die aber keiner Historian-Tag-ID zugeordnet werden konnten; für sie können daher keine Daten gelesen werden. Die Liste dient nur der Information und kann hier nicht bearbeitet werden.',
				NONE: 'Keine nicht zugeordneten Sensoren.',
				COL_MACHINE: 'Maschine',
				COL_SENSOR: 'Erwarteter Sensor',
				COL_FAILURE_GROUP: 'Ausfallgruppe',
				COL_UNIT_TYPE: 'Einheitentyp',
			},
			FLOC: {
				LEVEL_1: 'Asset',
				LEVEL_2: 'Einrichtung',
				LEVEL_3: 'System',
				LEVEL_4: 'Untersystem',
				LEVEL_5: 'Ausrüstung',
				PATH: 'FLOC-Pfad',
				LEGEND_TITLE: 'FLOC-Ebenen',
				LEGEND_HINT: 'Jeder Standort wird über seinen SAP-Technischen-Platz-Code (FLOC) identifiziert. Die Ebenen reichen vom Asset bis zur Ausrüstung.',
				TREE_FILTER_PLACEHOLDER: 'System oder Ausrüstung suchen (Name oder FLOC)…',
				SCOPE_N: '{{count}} FLOCs',
				SCOPE_TIP: 'Die Warteschlange ist auf diesen FLOC und alles darunter gefiltert',
				SCOPE_CLEAR: 'Standortfilter löschen',
				UNPLACED_TIP: 'Alarme ohne Technischen Platz',
				ALERTS_TOTAL: '{{count}} Alarme',
				SOURCE_ASSET_CODE: 'Über den Code im Asset-Namen zugeordnet',
				SOURCE_WELL: 'Über die Unterwasser-Bohrlochnummer zugeordnet',
				SOURCE_TRAIN: 'Über den Strang- oder Paketcode zugeordnet',
				SOURCE_TAG_MAPPING: 'Über die Historian-Tag-Zuordnung zugeordnet',
				EXTRACT_HAD: 'der Alarm-Export enthielt {{floc}}',
			},
			PMAP: {
				KEY_SENSORS: 'Schlüsselsensoren ({{count}})',
				KEY_SENSORS_HINT: 'Die Sensoren, die den Zustand dieser Einheit am besten beschreiben',
				TITLE: 'Prozessansicht',
				BUTTON: 'Prozessansicht',
				OPEN: 'Prozessansicht öffnen',
				OPEN_HINT: 'Anlagenbereiche und Prozesseinheiten, verbunden wie in den R&I-Schemata',
				BACK: 'Zurück zur Warteschlange',
				UNITS_META: '{{units}} Prozesseinheiten in {{areas}} Bereichen',
				LAYERS: 'Verbindungsebenen',
				SECONDARY: 'Sekundäre Verbindungen anzeigen ({{count}})',
				RELIEF: 'Entlastung / Fackel ({{count}})',
				UTILITY: 'Versorgung ({{count}})',
				CONTROL: 'Steuersignale ({{count}})',
				TARGET_ONLY: 'Nur Ziel',
				LEGEND_BACKBONE: 'Prozessverbindung',
				LEGEND_LINK: 'Sekundäre Verbindung',
				LEGEND_RELIEF: 'Entlastung / Fackel',
				LEGEND_UTILITY: 'Versorgung',
				LEGEND_CONTROL: 'Steuersignal',
				LEGEND_UP: 'Vorgelagert',
				LEGEND_DOWN: 'Nachgelagert',
				LEGEND_TARGET: 'Enthält Ziel-FLOCs',
				LEGEND_LOAD: 'Alarmlast',
				LANE_META: 'Einheiten: {{units}} · Alarme: {{alerts}}',
				LANE_TIP: '{{units}} Einheiten, {{alerts}} Alarme, {{targets}} Einheiten mit Ziel-FLOCs',
				EXPAND_LANE: '{{name}} aufklappen',
				COLLAPSE_LANE: '{{name}} zuklappen',
				LINKS: 'Verbindungen zwischen Prozesseinheiten',
				EDGE_ARIA: 'Verbindung {{from}} nach {{to}}, {{medium}}',
				UNIT_ALERTS: '{{total}} Alarme ({{scope}} im Umfang)',
				IN_SCOPE_N: '{{count}} im Umfang',
				TARGETS_N: '{{count}} Ziel-FLOCs',
				SHEET_N: 'Blatt {{sheet}}',
				CHIP: 'Prozess: {{name}}',
				CHIP_HINT: 'Prozessansicht für diese Einheit öffnen',
				UNITS_LABEL: 'Prozesseinheiten',
				N_MORE: '+{{count}} weitere',
				FROM_TO: '{{from}} → {{to}}',
				MEDIUM: 'Medium',
				CONFIDENCE: 'Konfidenz',
				CONF_HIGH: 'Hoch',
				CONF_MEDIUM: 'Mittel',
				CONF_LOW: 'Niedrig',
				WEAK: 'schwache Verbindung',
				ONE_END: 'nur auf einer Zeichnung sichtbar',
				TYPE: 'Typ',
				LAYER_BACKBONE: 'Prozessverbindung',
				LAYER_LINK: 'Sekundäre Verbindung',
				LAYER_RELIEF: 'Entlastung / Fackel',
				LAYER_UTILITY: 'Versorgung',
				LAYER_CONTROL: 'Steuersignal',
				CONNECTORS_N: '{{count}} Anschlüsse auf den Zeichnungen',
				EVIDENCE_LOADING: 'Zeichnungsnachweis wird gelesen…',
				PANEL_ARIA: 'Details der Prozesseinheit',
				LOADING: 'Wird geladen…',
				SHOW_ALERTS: 'Alarme dieser Einheit anzeigen',
				OPEN_EXPLORER: 'Im Asset-Explorer öffnen',
				ALERTS: 'Alarme',
				NO_ALERTS: 'Keine Alarme',
				DRAWINGS: 'Zeichnungen ({{count}})',
				NO_DRAWINGS: 'Dieser Einheit ist keine Zeichnung zugeordnet',
				OPEN_DRAWING: 'R&I-Schema öffnen',
				FLOCS: 'FLOCs ({{count}})',
				NO_FLOCS: 'Dieser Einheit ist kein FLOC zugeordnet',
				OPEN_NODE: 'Im Asset-Explorer öffnen',
				SHOW_FLOC_ALERTS: 'Alarme dieses FLOC anzeigen',
				SHARED_FLOCS: 'Mit anderen Einheiten geteilt ({{count}})',
				INBOUND: 'Eingehend ({{count}})',
				OUTBOUND: 'Ausgehend ({{count}})',
				NO_CONNECTIONS: 'Keine Verbindungen auf den Zeichnungen gefunden',
				SHOW_ALL: 'Alle {{count}} anzeigen',
				SHOW_FEWER: 'Weniger anzeigen',
			},
			SEARCH_ALERTS_PLACEHOLDER: 'Alarm, ID, Definitions-ID, Tag, FLOC suchen…',
			CANVAS: {
				CAUSAL: {
					QUERIES: 'Fragen ({{n}})',
					COL_HYPOTHESIS: 'Hypothese',
					COL_FACET: 'Aspekt',
					COL_QUERY: 'Frage',
					COL_ADMITTED: 'Zugelassen',
					NOTHING: 'nichts zugelassen',
					ADMITTED: 'Zugelassene Auszüge ({{n}})',
					EXCERPTS_FROM_TRACE: 'Auszüge aus dem Schritt-Trace (die ersten sechs); abgelehnte Treffer erscheinen, sobald das Laufdokument geladen ist.',
					REJECTED: 'Abgelehnte Treffer ({{n}})',
					NONE_REJECTED: 'Kein Treffer wurde abgelehnt.',
					FACET_DESIGN_BASIS: 'Auslegung / Betriebsbereich',
					FACET_ORIGINATING_CHANGE: 'Auslösende Änderung',
					FACET_MECHANISM_SENSITIVITY: 'Mechanismus-Empfindlichkeit',
					FACET_PROTECTION_DETECTION: 'Schutz / Erkennung',
					FACET_SYMPTOM_DIAGNOSTIC: 'Symptom / Diagnose',
					FACET_CORRECTIVE_ACTION: 'Abhilfemaßnahme',
				},
				TIER: {
					STAGE_QUICK: 'Stufe 1 · Schnelle Triage (Mini-Agent)',
					STAGE_DEEP: 'Stufe 2 · Tiefe Untersuchung',
					QUICK_ANSWER: 'Schnelle Antwort',
					FINAL_ANSWER: 'Endgültige Antwort',
					OUTCOME: 'Ergebnis',
					ACCEPTED: 'Angenommen',
					ESCALATED: 'Eskaliert',
					ROUTE_ACCEPTED: 'Angenommen → Ergebnis',
					ROUTE_ESCALATED: 'Eskaliert → Stufe 2',
					NO_GATE: 'Kein Gate (nur schnelle Triage)',
					DECIDING: 'Schnelle Antwort wird geprüft…',
					WAITING: 'Wartet auf die schnelle Antwort',
					NOT_NEEDED: 'Nicht nötig — die schnelle Antwort hat das Gate bestanden; Zeit und Tokens der tiefen Untersuchung wurden gespart.',
					NOT_RUN: 'Nicht ausgeführt — dieser Lauf war nur eine schnelle Triage.',
					WOULD_HAVE_RUN: 'Wäre ausgeführt worden',
					DEEP_SPECIALISTS: 'Langsame Spezialisten',
					SKIP_VERDICTS: 'Erneute Prüfung der Urteile',
					SKIP_ADJUDICATION: 'Vollständigkeitsprüfung und zweite Bewertung',
					CHECK_NO_ACTION: 'Antwort ohne Maßnahme',
					CHECK_CONFIDENCE: 'Konfidenz',
					CHECK_NOT_CAPPED: 'Nicht gedeckelt',
					CHECK_MODEL: 'Modell hat geantwortet',
					CHECK_NO_REAL_EVENT: 'Kein Urteil auf reales Ereignis',
					CEILING: 'Obergrenze {{pct}}',
					RULE_FALLBACK: 'Regel-Fallback',
					QUICK_NODE_NOTE: 'Stufe 1 · schnelle Triage: der Durchlauf des Mini-Agenten vor dem Gate.',
					ESCALATED_NOTE: 'Eskaliert: mindestens eine Prüfung ist fehlgeschlagen, daher lief die tiefe Untersuchung.',
					ACCEPTED_NOTE: 'Angenommen: alle Prüfungen bestanden; die schnelle Antwort ist das Ergebnis.',
					CHECKS: 'Gate-Prüfungen',
					COL_CHECK: 'Prüfung',
					COL_VALUE: 'Wert',
					COL_THRESHOLD: 'Schwelle',
					COL_RESULT: 'Ergebnis',
					PASSED: 'Bestanden',
					FAILED: 'Fehlgeschlagen',
					REASONS: 'Warum eskaliert wurde',
					QUICK_VS_FINAL: 'Schnelle vs. endgültige Antwort',
				},
				TITLE: 'Lauf-Canvas',
				OPEN: 'Canvas öffnen',
				OPEN_HINT: 'Den Lauf Schritt für Schritt verfolgen: jeder Agent, Modellaufruf und jede Abfrage',
				BACK: 'Zurück zum Alarm',
				RUN_PICKER: 'Lauf',
				RUN_PICKER_EMPTY: 'Noch keine Läufe',
				LIVE: 'Live',
				LIVE_HINT: 'Der Lauf wird live verfolgt (Aktualisierung alle 1,5 s)',
				ELAPSED: 'Verstrichen',
				DURATION: 'Dauer',
				TOKENS: '{{input}} ein / {{output}} aus Tokens',
				EVALUATION: 'Evaluierung',
				EVENTS_N: '{{count}} Ereignisse',
				EVENTS_HINT: '{{llm}} Modellaufrufe · {{lookups}} Abfragen',
				ZOOM_FIT: 'An Breite anpassen',
				ZOOM_100: 'Originalgröße',
				POLL_ERROR: 'Neue Ereignisse konnten nicht geladen werden: {{error}} — erneuter Versuch',
				LOADING: 'Lauf wird geladen…',
				NO_RUNS: 'Dieser Alarm hat noch keine Läufe',
				NO_EVENTS: 'Für diesen Lauf wurden keine Ereignisse aufgezeichnet (er liegt vor dem Lauf-Canvas)',
				PICK_NODE: 'Knoten auswählen, um Eingabe und Ausgabe zu sehen',
				IN_PROGRESS: 'Der Triage-Agent läuft. Der Lauf wird auch fortgesetzt, wenn Sie diese Seite verlassen.',
				STALLED_NOTICE: 'Verbindung zum Lauf verloren; das Ergebnis erscheint nach dem Aktualisieren der Seite.',
				RECONSTRUCTED: 'Aus dem gespeicherten Trace rekonstruiert: dieser Lauf liegt vor dem Ereignisstrom, daher sind Eingaben, Ausgaben, Modellaufrufe und Abfragen nicht verfügbar.',
				PASS_N: 'Durchgang {{n}}',
				ROUND_N: 'Runde {{n}}',
				STATUS: {
					RUNNING: 'Läuft',
					COMPLETED: 'Abgeschlossen',
					FAILED: 'Fehlgeschlagen',
					GATED: 'Nicht analysiert',
					PENDING: 'Ausstehend',
					NO_DATA: 'Keine Daten',
					SKIPPED: 'Übersprungen',
					STALLED: 'Verbindung verloren',
				},
				COL: {
					PRE_RUN: 'Vorlauf',
					RESOLVE: 'Auflösung & Signal',
					SPECIALISTS: 'Spezialisten',
					VERDICTS: 'Befunde',
					LOOP: 'Schlussfolgerungsschleife',
					DECISION: 'Entscheidung',
				},
				NODE: {
					LIBRARY_CAUSAL: 'Bibliothek · kausale Begründung',
					ESCALATION: 'Eskalations-Gate',
					LIBRARY: 'Bibliotheks-Spezialist',
					CONNECTED: 'Verbundene Systeme',
					GATE: 'DQ-Prüfung',
					TOPOLOGY: 'Topologie',
					EVIDENCE: 'Evidenz',
					VIEW: 'Stichtagssicht',
					FINAL: 'Ergebnis',
					RESOLVER: 'Auflöser',
					SIGNAL: 'Signal',
					COHORT: 'Kohorte',
					MAINTENANCE: 'Instandhaltung',
					MANUAL_PRECEDENT: 'Alarm-Präzedenz',
					LEARNINGS: 'Erkenntnisse',
					PROFILE: 'Profil',
					MULTIVARIATE: 'Multivariat',
					TMP: 'TMP',
					SHIFT_DPR: 'Schicht & DPR',
					VISUAL: 'Visueller Analyst',
					VERDICTS: 'Befunde',
					HYPOTHESIZE: 'Hypothesen',
					INVESTIGATE: 'Untersuchung',
					COMPLETENESS: 'Vollständigkeit',
					ADJUDICATOR: 'Entscheider',
					SUPERVISOR: 'Supervisor',
				},
				BADGE: {
					CAUSAL_N: '{{admitted}} Auszüge · {{queries}} Fragen',
					HEADROOM: '{{kind}} {{value}} · {{pct}}%',
					LIBRARY_N: '{{n}} Auszüge · {{docs}} Dok.',
					LIBRARY_LIMITS: '{{n}} Auszüge · {{limits}} Grenzwerte',
					GATE_PASS: 'Bestanden',
					GATE_FAIL: 'Nicht bestanden',
					TAGS_N: '{{count}} Tags',
					RECORDS_N: '{{count}} Datensätze',
					WITHHELD_N: '{{count}} zurückgehalten',
					RESOLVED: 'Aufgelöst',
					NOT_RESOLVED: 'Nicht aufgelöst',
					ALERTS_N: '{{count}} Alarme',
					FACTS_N: '{{count}} Fakten',
					PRIOR_N: '{{count}} frühere',
					LEARNINGS_N: '{{count}} Erkenntnisse',
					LOADED: 'Geladen',
					NONE: 'Keine',
					MOVED_N: '{{moved}} von {{of}} bewegt',
					VERDICTS_N: '{{count}} Befunde',
					LOOKUPS_N: '{{count}} Abfragen',
					CHECKS_N: '{{ran}} von {{of}} Prüfungen',
					SPECIALISTS_N: '{{n}} von {{of}} Spezialisten',
				},
				BATCH_BADGE: 'Gruppe von {{count}} Alarmen auf {{floc}}',
				BATCH_HINT: 'Gemeinsam als eine Episode bewertet: {{ids}}',
				REASSESS_BADGE: 'Neubewertung zum Stand {{t}}',
				REASSESS_HINT: 'Frühere Bewertung: {{cls}}',
				ZONE: {
					EVIDENCE: 'Beweiserhebung',
					PARALLEL: 'parallel',
					LOOP: 'Denkschleife',
					DECISION: 'Entscheidung',
				},
				LOOP: {
					CAUSAL_HINT: 'Nach dem ersten Board-Durchlauf stellt die Bibliothek je Hypothese technische Fragen (Auslegung, Änderung, Empfindlichkeit, Schutz, Diagnose, Abhilfe) und lässt nur Auszüge zu diesem Instrument oder dieser Ausrüstung als LIB-n-Nachweis zu',
					BOARD: 'Hypothesen-Board',
					INVESTIGATOR: 'Ermittler',
					ROUND_OF: 'Runde {{n}} von max. {{max}}',
					HINT: 'das Board schlägt vor und fragt an, der Ermittler schlägt nach, das Board gewichtet neu',
					ROUNDS_USED: '{{n}} von max. {{max}} Runden',
					REQUESTS_N: '{{count}} Anfragen',
					REWEIGH: 'Ergebnisse → neu gewichten',
					LEAD_HINT: 'Führende Hypothese, ihr Gewicht und die Änderung seit dem vorigen Durchgang',
					WEIGHING: 'Hypothesen werden gewichtet…',
					NEXT_PASS: 'Nächster Durchgang: Neugewichtung',
					CALL_NO_HINT: 'Aufruf {{n}} von {{tool}} in diesem Lauf',
					CITED_HINT: 'Zitiert vom nächsten Durchgang: {{hyps}}',
					REPEAT_OF: 'wie Runde {{n}}',
					CALLING: 'Nachschlagen läuft…',
					MOVED: 'Durchgang {{n}}:',
					MOVED_HINT: 'Wie sich das Board nach den Ergebnissen dieser Runde bewegt hat',
					SETTLED_FIRST: 'In Durchgang {{n}} entschieden: keine Nachschläge nötig',
					SETTLED_AT: 'In Durchgang {{n}} entschieden: keine weiteren Nachschläge nötig',
					BUDGET_SPENT: 'Rundenbudget ausgeschöpft ({{max}} von {{max}})',
					SHELF: 'Werkzeugleiste',
					SHELF_HINT: 'der Ermittler kann jedes Werkzeug beliebig oft mit anderen Argumenten aufrufen',
					UNUSED: 'in diesem Lauf nicht verwendet',
				},
				TOOL: {
					SEARCH_LIBRARY: 'Bibliothek durchsuchen',
					SEARCH_LEARNINGS: 'Erkenntnisse suchen',
					CONNECTED_EQUIPMENT: 'Verbundene Anlagen',
					UNIT_SENSORS: 'Einheitssensoren',
					FIND_SENSORS: 'Sensoren finden',
					PARALLEL_SYSTEMS: 'Parallele Systeme',
					SISTER_TRAIN: 'Schwesterstrang',
					UNIT_ALERTS: 'Einheitsalarme',
					TAG_WINDOW: 'Tag-Fenster',
					TAG_HISTORY: 'Tag-Historie',
					SEARCH_RECORDS: 'Datensätze suchen',
					SEARCH_REPORTS: 'Berichte suchen',
				},
				TOOL_HINT: {
					SEARCH_LEARNINGS: 'Zum Alarmzeitpunkt gültige Erkenntnisse und Standort-Playbook-Regeln, nach Bedeutung zu einer Frage geordnet.',
					CONNECTED_EQUIPMENT: 'Vor-, nachgelagerte oder benachbarte Prozesseinheiten (aus den Fließbild-Verbindern), ihre Schnittstellensensoren und ob sie sich vor, mit oder nach dem Alarm-Tag bewegt haben.',
					UNIT_SENSORS: 'Wie sich eine benannte Prozesseinheit verhalten hat, Sensor für Sensor, für die angefragten Messgrößen.',
					FIND_SENSORS: 'Welche Sensoren es für eine Frage gibt und was jeder misst.',
					PARALLEL_SYSTEMS: 'Der Zwillingsstrang (FGC A ↔ B, GLC A ↔ B …): seine Sensoren und Alarme in denselben Stunden — gemeinsame oder lokale Ursache?',
					SISTER_TRAIN: 'Der andere Strang oder der redundante Fühler desselben Kreises: gemeinsame oder lokale Ursache?',
					UNIT_ALERTS: 'Überwachungsalarme auf einer Einheit (vor-, nachgelagert, Zwilling) in den Stunden vor dem Alarm.',
					TAG_WINDOW: 'Statistik eines beliebigen Tags über die letzten N Stunden vor dem Alarm.',
					TAG_HISTORY: 'Wie oft ein Tag in bis zu 180 Tagen sein Band verlassen hat und ob Arbeiten folgten.',
					SEARCH_RECORDS: 'Stichwortsuche in SAP-Meldungen und Aufträgen (1 Jahr) und Schichtberichten (6 Monate).',
					SEARCH_REPORTS: 'Vorgesetzten- und Produktionsberichte bis zu einem Jahr zurück; jedes Wort muss passen, Passagen werden geliefert.',
				},
				CALL: {
					NTH: 'Aufruf #{{n}} von {{tool}} in diesem Lauf',
					ARGS: 'Argumente',
					NO_ARGS: 'Keine Argumente',
					REPEAT_NOTE: 'Identisch mit der Anfrage aus Runde {{n}}: nicht erneut ausgeführt, das frühere Ergebnis wurde übernommen.',
					CITED: 'Zitiert von Durchgang {{n}}',
					CALLS_N: '{{count}} Aufrufe',
					ROUNDS_LIST: 'Runden {{rounds}}',
					NOT_USED: 'Der Ermittler hat dieses Werkzeug in diesem Lauf nicht verwendet.',
					GROUPED: '{{count}} Nachschläge · verwendete Werkzeuge: {{tools}}',
					CARRIED: '{{count}} Beobachtungen aus früheren Runden übernommen',
				},
				EVO: {
					TITLE: 'Wie Belege die Einschätzung bewegten: Hypothesengewicht je Durchgang',
					HYPOTHESIS: 'Hypothese',
					AFTER_N: 'nach Runde {{n}} · {{count}} Nachschläge',
					NOT_ON_BOARD: 'In diesem Durchgang nicht auf dem Board',
					AFTER_ROUND: 'nach Runde {{n}} ({{count}} Nachschläge)',
					CITES: 'neue Belege zitieren {{calls}}',
					MOVE_AFTER: 'Nach Runde {{n}}:',
					PRECEDED_BY: 'vorausgegangene Nachschläge:',
				},
				INSPECTOR: {
					TAB_INPUT: 'Eingabe',
					TAB_OUTPUT: 'Ausgabe',
					TAB_MODEL_CALLS: 'Modellaufrufe',
					TAB_LOOKUPS: 'Abfragen',
					TAB_TRACE: 'Trace',
					EMPTY: 'leer',
					NOT_STARTED: 'Dieser Schritt hat noch nicht begonnen',
					NO_INPUT: 'Für diesen Schritt wurde keine Eingabe aufgezeichnet',
					STILL_RUNNING: 'Läuft noch — die Ausgabe erscheint, sobald der Schritt abgeschlossen ist',
					NO_OUTPUT: 'Keine Ausgabe aufgezeichnet',
					HYPOTHESES_N: '{{count}} Hypothesen',
					REQUESTS: 'Angeforderte Abfragen',
					WINDOWS: 'Ablesungen je Zeitfenster',
					LEAK_CHECK: 'Leak-Prüfung: {{value}}',
					MACHINE_STATE: 'Maschinenzustand',
					PACKAGE_TEXT: 'Signalpaket, wie das Modell es liest',
					ANOMALY_TEXT: 'Text des Anomaliemodells',
					NO_LOOKUPS: 'Keine Abfragen in diesem Schritt',
					RAW: 'Gesamte Ausgabe als Daten',
					NO_MODEL_CALLS: 'Keine Modellaufrufe in diesem Schritt',
					ATTEMPT_N: 'Versuch {{n}}',
					PROMPT: 'Prompt',
					PROMPT_SIZE: '{{chars}} Zeichen, {{images}} Bilder',
					IMAGE_PART: 'Bild ({{kb}} KB)',
					RESPONSE: 'Antwort',
					NO_TRACE: 'Keine Trace-Zeile für diesen Knoten',
				},
			},
			VALIDATION: {
				COLUMN: 'Validiert',
				FILTER: 'Validierung',
				HUMAN: 'Mensch',
				AGENT: 'Agent',
				NONE: 'Nicht triagiert',
				HUMAN_VALIDATED: 'Vom Menschen validiert',
				HUMAN_CORRECTED: 'Vom Menschen korrigiert',
				AGENT_VALIDATED: 'Vom Agenten validiert',
				TIP_AGENT: 'Vom Agenten triagiert; noch von keiner Person geprüft',
				TIP_HUMAN_UNKNOWN: 'Von einer Person validiert',
				TIP_REPLAY: 'HIL-Label, eingespielt von {{reviewer}} am {{date}}',
				TIP_UI: 'In UptimeAI geprüft von {{reviewer}} am {{date}}',
				TIP_CORRECTED: 'Mensch hat den Agenten korrigiert: {{agent}} → {{human}}',
				TIP_ABSTAINED: 'Agent überließ es der manuellen Prüfung; Mensch klassifizierte: {{human}}',
				TIP_AGREED: 'Mensch stimmte dem Agenten zu: {{human}}',
				CSV: {
					VALIDATED_BY: 'Validiert von',
					REVIEWER: 'Prüfer',
					REVIEW_SOURCE: 'Prüfquelle',
				},
			},
			REVIEW: {
				TITLE: 'SME-Prüfung',
				SOURCE_REPLAY: 'HIL-Label (wiedergegeben)',
				SOURCE_UI: 'In UptimeAI geprüft',
				BY: '{{reviewer}} · {{date}}',
				N_REVIEWS: '{{count}} Prüfungen',
				LABEL: 'Label',
				RELIABILITY: 'Verlässlichkeit: {{value}}',
				RELIABILITY_HIGH: 'hoch',
				RELIABILITY_MEDIUM: 'mittel',
				RELIABILITY_LOW: 'niedrig',
				RELIABILITY_HINT: 'Wie weit das Label als Grundwahrheit gelten kann – menschliche Labels sind fehlbar',
				ACTION_TAKEN: 'Ergriffene Maßnahme',
				NO_LABEL: 'Kein Label erfasst',
				AGENT_VS_HUMAN: 'Agent vs. Mensch',
				AGREEMENT_AGREE: 'Einig',
				AGREEMENT_DISAGREE: 'Uneinig',
				AGREEMENT_ABSTAINED: 'Enthalten',
				AGENT_CONFIDENCE: 'Agenten-Konfidenz {{value}}',
				OUTCOMES: 'SAP-Meldungen in den 30 Tagen danach (rückblickend)',
				REASONS: 'Gründe',
				AGENT_SAW_CHART: 'Diagrammurteil des Agenten',
				AGENT_SAW_STATE: 'Maschinenzustand zu dem Zeitpunkt',
				LEARNINGS_CHANGED: 'Durch diese Prüfung geänderte Erkenntnisse ({{count}})',
				EARLIER: 'Frühere Prüfungen',
				VERDICT: {
					CONFIRMED: 'Bestätigt',
					CONFIRMED_HINT: 'Agent und Mensch wählten dieselbe Klasse.',
					AGENT_WRONG: 'Agent lag falsch',
					AGENT_WRONG_HINT: 'Die Klasse des Prüfers gilt vor der des Agenten; der Agent wurde korrigiert.',
					AGENT_ABSTAINED: 'Agent enthielt sich',
					AGENT_ABSTAINED_HINT: 'Der Agent überließ es der manuellen Prüfung; das menschliche Label bestimmt die Klasse.',
					HUMAN_LIKELY_WRONG: 'Mensch vermutlich falsch',
					HUMAN_LIKELY_WRONG_HINT: 'Als „keine Aktion“ gekennzeichnet, doch innerhalb von 30 Tagen folgten SAP-Meldungen zu diesem Equipment; nicht in den Speicher übernommen.',
					CONTESTED: 'Umstritten',
					CONTESTED_HINT: 'Agent und Mensch sind uneinig, und die Folgebelege klären es nicht.',
					HUMAN_OVERRIDE: 'Menschliche Übersteuerung',
					HUMAN_OVERRIDE_HINT: 'Eine Person in UptimeAI wählte eine andere Klasse als der Agent; ihre Entscheidung gilt.',
				},
			},
			MEMORY: {
				SIMILAR: 'ähnlich {{sim}}',
				SIMILAR_HINT: 'Nicht im eigenen Bereich dieses Alarms: hinzugefügt, weil die Bedeutung dem Alarm nahekommt (Ähnlichkeit 0–1)',
				PROFILE: 'Detektorprofil',
				TITLE: 'Genutzter Betriebsspeicher',
				CHIP: 'Speicher: {{learnings}} Erkenntnisse, {{precedents}} geprüfte Präzedenzfälle',
				CHIP_HINT: 'Vor diesem Alarm bekannte Erkenntnisse und menschlich geprüfte Präzedenzfälle, die der Agent herangezogen hat',
				NO_LEARNINGS: 'Keine Erkenntnis angewendet',
				PRECEDENTS: '{{count}} geprüfte Präzedenzfälle',
				SHOW_TRACE: 'Im Trace anzeigen',
			},
			LEARNINGS: {
				STATUS_RETIRED: 'Zurückgezogen',
				SCOPE_PLAYBOOK: 'Standort-Playbook',
				SCOPE_PROFILE: 'Detektorprofil',
				ALL_SCOPES: 'Alle Bereichstypen',
				MEANING_PLACEHOLDER: 'Nach Bedeutung suchen, z. B. Lagertemperatur nach Neustart',
				MEANING_SEARCH: 'Suchen',
				MEANING_HINT: 'Ordnet die aktuellen Erkenntnisse danach, wie nah ihre Bedeutung an Ihren Worten liegt (Embeddings), nicht nach exakten Wörtern. Enter startet die Suche; Feld leeren zeigt alle.',
				RANKED_BY: 'Nach Bedeutung geordnet: „{{q}}“',
				COL_SIMILARITY: 'Ähnlichkeit',
				SIMILARITY_HINT: 'Kosinus-Ähnlichkeit der Bedeutung (0–1); ab etwa 0,8 eine enge Übereinstimmung',
				COL_LEARNING: 'Erkenntnis',
				COL_EDITED: 'Bearbeitet von',
				EDITED_BY: 'Bearbeitet von {{name}}',
				EDIT_REASON: 'Grund: {{reason}}',
				NO_DISPOSITION: 'keine (Kontext)',
				N_ALERTS: '{{count}} Alarme',
				NO_MATCH: 'Nichts mit ähnlicher Bedeutung',
				NO_MATCH_HINT: 'Andere Wörter versuchen oder die Suche leeren, um alle Erkenntnisse zu sehen.',
				BUTTON: 'Erkenntnisse',
				BUTTON_HINT: 'Erkenntnisse & Betriebsspeicher aus menschlichen Prüfungen',
				TITLE: 'Erkenntnisse & Betriebsspeicher',
				SUBTITLE: 'Aus menschlichen Prüfungen vergleichbarer Alarme abgeleitete Regeln; der Agent nutzt nur die vor dem jeweiligen Alarm bekannten',
				REFRESH: 'Aktualisieren',
				STAT_REVIEWS: 'Menschliche Prüfungen',
				STAT_REPLAYED: '{{count}} HIL-Labels eingespielt',
				STAT_IN_APP: '{{count}} in UptimeAI',
				STAT_AGREEMENT: 'Agent vs. Mensch',
				STAT_RECONCILIATION: 'Abgleich',
				STAT_LEARNINGS: 'Erkenntnisse',
				STATUS_ACTIVE: 'Aktiv',
				STATUS_CANDIDATE: 'Kandidat',
				STATUS_CONTESTED: 'Umstritten',
				SCOPE_SIGNAL: 'Signal',
				SCOPE_EQUIPMENT: 'Equipment + Detektor',
				SCOPE_DETECTOR: 'Detektor',
				SEARCH: 'Bereich, Detektor oder Regel suchen',
				N_SHOWN: '{{shown}} von {{total}}',
				EMPTY: 'Noch keine Erkenntnisse',
				EMPTY_HINT: 'Erkenntnisse erscheinen, sobald Personen triagierte Alarme prüfen.',
				COL_SCOPE: 'Bereich',
				COL_SCOPE_TYPE: 'Bereichstyp',
				COL_DISPOSITION: 'Disposition',
				COL_SUPPORT: 'Unterstützung',
				COL_SUPPORT_HINT: 'Prüfungen, die der Disposition entsprechen / Prüfungen im Bereich · Konsistenz',
				COL_STATUS: 'Status',
				COL_EFFECTIVE: 'Gültig ab',
				COL_CORRECTED: 'Agent korrigiert',
				COL_CORRECTED_HINT: 'Prüfungen, in denen die Person den Agenten korrigierte',
				COL_VERSION: 'Version',
				RULE: 'Betriebsregel',
				AUTHOR: 'Autor: {{author}}',
				CLASS_COUNTS: 'Menschliche Klassen',
				REASONS: 'Gründe',
				CHART_PATTERNS: 'Diagrammmuster',
				MACHINE_STATES: 'Maschinenzustände',
				SOURCE_ALERTS: 'Quellalarme ({{count}})',
				OPEN_ALERT: 'Alarm öffnen',
				VERSIONS: 'Versionsverlauf',
				SUPERSEDED: 'Ersetzt',
				CURRENT: 'Aktuell',
			},
			PROCESS: {
				TITLE: 'Prozesstopologie & Hierarchie',
				FLOW_SUMMARY: '{{up}} vorgelagert · {{down}} nachgelagert',
				FLOW_SUMMARY_UNITS: '{{up}} vorgelagert · {{down}} nachgelagert (Prozesseinheiten)',
				PROCESS_UNITS: 'Prozesseinheiten (PEFS)',
				NO_PID_LINE: 'Keine Leitung in den digitalisierten R&I-Fließbildern verfolgt; Verbindungen aus den Fließschema-Anschlüssen',
				IN_UNIT: 'Prozesseinheit: {{name}}',
				SERVING: 'Versorgungssysteme',
				RELIEF: 'Entlastung',
				UNIT_TIP: '{{hops}} Schritt(e) · {{media}} · Vertrauen {{confidence}}',
				SOURCE_PID: 'Anlagenfluss aus den digitalisierten R&I-Fließbildern (Leitungen auf einer Zeichnung).',
				SOURCE_BOTH: 'Anlagenfluss aus den digitalisierten R&I-Fließbildern (je Zeichnung); Prozesseinheiten aus den PEFS-Blattverbindern, dieselbe Sicht wie die Analyse verbundener Systeme.',
				HIERARCHY: 'Anlagenhierarchie',
				LEVEL_SITE: 'Standort',
				LEVEL_SYSTEM: 'System',
				LEVEL_SUBSYSTEM: 'Teilsystem',
				LEVEL_EQUIPMENT: 'Ausrüstung',
				LEVEL_PACKAGE: 'Paket',
				LEVEL_OTHER: 'Ebene',
				NOT_IN_TREE: 'Nicht im Anlagenbaum',
				NOT_IN_TREE_HINT: 'Die Alarm-Ausrüstung hat keinen technischen Platz im SAP-Anlagenbaum.',
				PARTIAL_TREE: 'Nur ein Teil des Pfads konnte im Anlagenbaum zugeordnet werden.',
				SIBLINGS: '{{count}} weitere Ausrüstungen in {{parent}}',
				SHOW_ALL: 'Alle {{count}} anzeigen',
				SHOW_FEWER: 'Weniger anzeigen',
				N_TAGS: '{{count}} Tags',
				NO_TREE_TAGS: 'Diesem Knoten sind keine Historian-Tags zugeordnet',
				FLOW: 'Prozessfluss',
				UPSTREAM: 'Vorgelagert',
				DOWNSTREAM: 'Nachgelagert',
				ALERT_EQUIPMENT: 'Alarm-Ausrüstung',
				MEASURED_BY: 'Alarm-Instrument',
				HOPS: '{{count}} Schritt(e) entfernt',
				NONE_UPSTREAM: 'Nichts vorgelagert',
				NONE_DOWNSTREAM: 'Nichts nachgelagert',
				NO_FLOW: 'Keine Prozessfluss-Verbindungen für diese Ausrüstung in den digitalisierten R&I-Schemata',
				NOT_IN_PIDS: 'Ausrüstung nicht in den digitalisierten R&I-Schemata gefunden',
				NOT_IN_PIDS_HINT: 'Vor- und nachgelagerte Elemente können ohne R&I-Zuordnung der Alarm-Ausrüstung nicht angezeigt werden.',
				CONNECTED: 'Verbundene Elemente',
				NO_CONNECTED: 'In den digitalisierten R&I-Schemata sind keine weiteren Elemente mit dieser Ausrüstung verbunden.',
				EDGE_SERVES: 'Versorgt',
				EDGE_SENSES: 'Erfasst',
				EDGE_CONTROLS: 'Regelt',
				EDGE_PROTECTS: 'Schützt',
				EDGE_SAME_LINE: 'Gleiche Prozessleitung',
				EDGE_MEASURES: 'Misst',
				EDGE_FLOWS_TO: 'Fließt zu',
				EDGE_OTHER: 'Andere Verbindungen',
				CHART_TAGS: 'Tags dieses Elements im Tab „Tags“ darstellen',
				NO_TAGS_FOR_ITEM: 'Mit diesem Element sind keine Historian-Tags verknüpft',
				NO_DATA_TAGS: 'Der Anlagenbaum ordnet diesem Element keine Tags zu',
				TAGS_FAILED: 'Die Tags dieses Elements konnten nicht geladen werden',
				FROM_TREE: 'Tag-Anzahl aus dem Anlagenbaum',
				CLICK_HINT: 'Klicken Sie auf ein Element, um seine Historian-Tags darzustellen (bis zu 8, Tags mit Daten zuerst).',
			},
			ANALYSIS: {
				FOUND_BY_MEANING: 'per Bedeutung gefunden',
				FOUND_BY_MEANING_SIM: 'per Bedeutung gefunden · {{sim}}',
				FOUND_BY_MEANING_HINT: 'Hybride Suche: Einträge werden über ihre Wörter und ihre Bedeutung (Embeddings) gefunden. Dieser wurde von der Bedeutungssuche aus demselben Teilsystem ergänzt; die Zahl ist seine Ähnlichkeit zum Alarm (0–1).',
				LEVEL_SHIFTS: 'Niveausprünge',
				LEVEL_SHIFTS_HINT: 'Zeitpunkte vor dem Stichtag, an denen ein modellierter Tag auf ein neues Niveau sprang und dort blieb (Größe in Basis-Standardabweichungen, Mittelwert vorher → nachher).',
				MODEL_CACHED: 'Modell wiederverwendet (einmal pro Maschine und Tag trainiert)',
				MODEL_CACHED_HINT: 'Für diese Maschine war für diesen Tag bereits ein Modell trainiert, mit Daten, die alle vor diesem Stichtag enden; es wurde wiederverwendet statt neu trainiert.',
				REGIMES: 'Je Betriebszustand von {{tag}} angepasst: {{parts}} ({{sep}} sd Abstand)',
				REGIMES_HINT: 'Der Lauf-Tag zeigte zwei deutlich getrennte Betriebsniveaus (Zeitanteil @ Niveau), daher wurde der Normalzustand je Niveau gelernt.',
				TRAINED_ON: 'Trainiert auf {{from}} – {{to}}',
				WINDOW_3M: '3 Monate',
				WINDOW_1W: '1 Woche',
				WINDOW_1D: '1 Tag',
				REASONING: 'Begründung',
				SETTLED: 'Abgeschlossen',
				UNSETTLED: 'Nicht abgeschlossen',
				SETTLED_HINT: 'Das Hypothesen-Board wurde beendet, da keine weitere Abfrage die führende Hypothese ändern konnte',
				UNSETTLED_HINT: 'Das Board endete am Durchlauflimit, obwohl noch Abfragen angefordert waren',
				BOARD_META: '{{passes}} Durchläufe · {{lookups}} Abfragen',
				HYPOTHESES: 'Hypothesen',
				WEIGHT_HINT: 'Gewicht dieser Hypothese auf dem Board (alle Hypothesen ergeben zusammen 100 %)',
				IMPLIES_HINT: 'Klassifizierung, die diese Hypothese nahelegt, falls sie zutrifft',
				STATUS_VALIDATED: 'Bestätigt',
				STATUS_REFINED: 'Verfeinert',
				STATUS_DEBUNKED: 'Widerlegt',
				STATUS_OPEN: 'Offen',
				FOR: 'Dafür',
				AGAINST: 'Dagegen',
				NONE: 'Keine',
				CONFLICTS: 'Widersprüche',
				LOOKUPS: 'Abfragen des Ermittlers',
				ROUND_N: 'Runde {{n}}',
				ROUND_OTHER: 'Weitere Abfragen',
				WHY_ASKED: 'Warum gefragt:',
				RESULT: 'Ergebnis',
				SIGNAL_TITLE: 'Signal & Maschine',
				N_TAGS: '{{n}} Tags',
				RUNNING_AT_CUTOFF: 'In Betrieb zum Stichzeitpunkt',
				STOPPED_AT_CUTOFF: 'Gestoppt zum Stichzeitpunkt',
				SINCE_RESTART: 'Seit Neustart',
				SINCE_STOP: 'Seit Stopp',
				HOURS: '{{n}} h',
				LAST_SHUTDOWN: 'Letzter Stillstand',
				ONGOING: 'andauernd',
				RUN_SOURCE: 'Betriebszustand: {{source}} ({{tag}})',
				RUNNING_PCT_HINT: 'Anteil des Zeitfensters, in dem die Maschine lief (grün) bzw. stand (rot)',
				RUNNING: 'in Betrieb',
				SHUTDOWNS: 'Stillstände',
				DOWN: 'Stillstand',
				MACHINE_UNKNOWN: 'Betriebszustand unbekannt: kein Betriebsstatus-Tag für dieses Equipment.',
				CHARTS_READ: 'Vom Modell gelesene Diagramme',
				ANOMALY_SCORE: 'Anomalie-Score',
				ENLARGE: 'Zum Vergrößern klicken',
				READ_ALERT_TAG: 'Alarm-Tag',
				READ_RELATED: 'Verwandte Tags',
				READ_MACHINE: 'Maschine',
				READ_ANOMALY: 'Modell-Lesart',
				CONSISTENT_WITH_HISTORY: 'Konsistent mit der Historie',
				NOT_CONSISTENT_WITH_HISTORY: 'Nicht konsistent mit der Historie',
				STATS_TITLE: 'Statistik vs. Baseline',
				STATS_HINT: '— Zelle überfahren für p5–p95, Steigung und erste 3-sd-Abweichung',
				COL_TAG: 'Tag',
				COL_MEDIAN: 'Median',
				COL_LAST: 'Letzter',
				COL_Z: 'z (Med.)',
				COL_Z_HINT: 'Median des Fensters in Baseline-Standardabweichungen',
				COL_OUT: '% außerh.',
				COL_OUT_HINT: 'Anteil der Messwerte außerhalb des Baseline-Bands p5–p95',
				ALERT_TAG: 'Alarm',
				RUN_TAG: 'Betrieb',
				TIP_BASELINE: 'Baseline: Median {{median}} ± {{sd}} sd, p5–p95 {{p5}}–{{p95}} {{unit}}',
				TIP_SPIKES: 'Entfernte Spitzen: {{value}}',
				TIP_MASKED: 'Maskierte Fehlmesswerte: {{n}}',
				TIP_RANGE: 'p5–p95: {{p5}} – {{p95}} {{unit}}',
				TIP_SLOPE: 'Steigung: {{value}} {{unit}}/Tag',
				TIP_Z_LAST: 'z (letzter): {{value}} · max. |z|: {{max}}',
				TIP_FIRST_3SD: 'Erstmals über 3 sd: {{value}} UTC',
				TIP_NEVER_3SD: 'In diesem Fenster nie über 3 sd',
				FOOT_SPIKES: 'Vor der Statistik entfernte isolierte Spitzen: {{value}}.',
				FOOT_MASKED: '{{n}} Fehlmesswerte (schlechte Qualität / außerhalb des Bereichs) maskiert.',
				ANOMALY_TITLE: 'Anomalie-Modell',
				NOT_AVAILABLE: 'Nicht verfügbar',
				VERDICT_CONSISTENT: 'Konsistent',
				VERDICT_CHANGED: 'Verändert',
				VERDICT_STARTUP: 'Anfahrtransient',
				VERDICT_INSUFFICIENT: 'Unzureichende Daten',
				MODEL_META: 'PCA {{k}} Komp. · {{pct}} Varianz · {{rows}} Trainingszeilen',
				ONSET: 'Anhaltender Beginn',
				NO_ONSET: 'keiner',
				FIRST_TO_DEVIATE: 'Erster abweichender Tag',
				ABOVE_LIMIT_24H: 'Letzte 24 h über Grenze',
				T2_SPE_HINT: 'Scores beziehen sich auf das 99,5. Perzentil des Trainings (1,0 = Grenze). T² hoch = die Tags bewegten sich gemeinsam zu einem ungewöhnlichen Betriebspunkt; SPE hoch = ein Tag passt nicht mehr zu den anderen (lokaler Fehler oder Instrument); AE = Rekonstruktionsfehler des Autoencoders.',
				AT_CUTOFF: 'Zum Stichzeitpunkt',
				AT_PEAK: 'Spitze der letzten 24 h',
				IN_TRANSIENT: 'Innerhalb des Anfahrtransienten',
				SCORE: 'Score',
				KIND_NORMAL: 'Im Normalbereich',
				KIND_SPE: 'Beziehung gestört (SPE): ein Tag passt nicht mehr zu den anderen',
				KIND_T2: 'Betriebspunkt verschoben (T²): Tags bewegten sich gemeinsam, Beziehungen bleiben',
				KIND_BOTH: 'Ungewöhnlicher Betriebspunkt und gestörte Beziehungen',
				ACTUAL_VS_EXPECTED: 'Ist vs. aus den anderen Tags erwartet',
				NOT_MODELLED: 'Nicht modelliert (zu wenig Betriebshistorie): {{tags}}',
				RECORDS_TITLE: 'Gelesene Aufzeichnungen',
				OPEN_KNOWN_ISSUE: 'Offenes bekanntes Problem',
				NO_OPEN_KNOWN_ISSUE: 'Kein offenes bekanntes Problem',
				OPEN_KNOWN_ISSUE_HINT: 'Ob eine offene Meldung oder ein offener Auftrag diesen Zustand zum Alarmzeitpunkt bereits abdeckt',
				RECORDS_COUNT: '{{read}} von {{total}} Aufzeichnungen gelesen · {{cited}} zitiert',
				RECORDS_COUNT_HINT: 'Vor dem Alarm vorliegende Aufzeichnungen: {{work}} Instandhaltung, {{reports}} Schichtberichte, {{deferments}} Produktionsausfälle; die bestplatzierten wurden gelesen',
				OPERATING_EVENTS: 'Betriebsereignisse vor dem Alarm',
				FACTS: 'Zitierte Fakten',
				NO_FACTS: 'Keine Aufzeichnung betrifft diesen Alarm.',
				RELEVANCE_DIRECT: 'Direkt',
				RELEVANCE_RELATED: 'Verwandt',
				RELEVANCE_BACKGROUND: 'Hintergrund',
				IMPL_KNOWN_ISSUE: 'Bekanntes Problem offen',
				IMPL_RECENT_WORK: 'Kürzliche Arbeit erklärt',
				IMPL_OPERATING_EVENT: 'Betriebsereignis',
				IMPL_INSTRUMENT: 'Instrumentenproblem',
				IMPL_DEGRADATION: 'Verschleißsignal',
				DIR_NO_ACTION: 'Für keine Maßnahme',
				DIR_SERVICE: 'Für Service',
				DIR_NEUTRAL: 'Neutral',
				OPEN_IN_MAINTENANCE: 'Im Tab Instandhaltung anzeigen',
				OPEN_IN_REPORTS: 'Im Tab Berichte anzeigen',
				DROPPED: '{{n}} gelesen, aber nicht relevant: {{ids}}',
			},
			VISUAL: {
				TITLE: 'Diagrammprüfung',
				PATTERN_TOGETHER: 'Tags bewegten sich gemeinsam',
				PATTERN_DEPARTED: 'Ein Tag wich allein ab',
				PATTERN_SHUTDOWN: 'Abfahren / Anfahren',
				PATTERN_NO_CHANGE: 'Keine wesentliche Änderung',
				PATTERN_SPLIT: 'Verwandte Tags uneinheitlich',
				PATTERN_INSUFFICIENT: 'Zu wenig Daten zur Beurteilung',
				PATTERN_UNKNOWN: 'Nicht klassifiziert',
				CONFIDENCE: '{{value}} Konfidenz',
				CONFIDENCE_HINT: 'Konfidenz der abschließenden Beurteilung',
				MOVED_TOGETHER_YES: 'Gemeinsam bewegt',
				MOVED_TOGETHER_NO: 'Nicht gemeinsam bewegt',
				DISAGREE: 'Statistik und Diagramme widersprechen sich — prüfen Sie die Diagramme, bevor Sie sich auf diese Beurteilung verlassen.',
				AGREE: 'Diagramme stimmen mit der Statistik überein',
				STATISTICS_SAY: 'Laut Statistik',
				CHARTS_SAY: 'Laut Diagrammen',
				LED_BY: 'Angeführt von',
				LED_BY_HINT: 'Der Tag, der sich zuerst bewegte',
				DEPARTED_ALONE: 'Allein abgewichen',
				DEPARTED_ALONE_HINT: 'Der Tag, der sich bewegte, während die verwandten Tags stabil blieben',
				REASONING: 'Begründung',
				CHARTS: 'Vom Modell gelesene Diagramme ({{count}})',
				NO_CHARTS: 'Für diesen Lauf wurden keine Diagrammbilder gespeichert.',
				OPEN_CHART: 'Diagramm {{n}} öffnen',
				CHART_ALT: 'Diagramm {{n}} bis zum Alarmzeitpunkt',
				CHART_FAILED: 'Diagrammbild konnte nicht geladen werden',
				CHART_N_OF: 'Diagramm {{n}} von {{total}}',
				CHART_DIALOG_HINT: 'Die Diagramme enden kurz vor dem Alarmzeitpunkt. Mit ← / → blättern.',
				PREV_CHART: 'Vorheriges Diagramm',
				NEXT_CHART: 'Nächstes Diagramm',
				REVIEWS: 'Prüfungen je Tag ({{count}})',
				LEVEL: 'Niveau: {{value}}',
				FLUCTUATION: 'Schwankung: {{value}}',
				MODEL: 'Geprüft von {{model}}',
			},
			CONTEXT: {
				MODE_PID: 'R&I-Schema',
				MODE_GRAPH: 'Kontextgraph',
				CHOOSE_DRAWING: 'Zeichnung wählen',
				ITEMS_COUNT: '{{count}} markiert',
				HAS_INSTRUMENT: 'Alarminstrument',
				HAS_EQUIPMENT: 'Alarmausrüstung',
				TITLE_INSTRUMENT: 'Markierte Instrumentenposition für {{tag}}',
				TITLE_EQUIPMENT: 'Markierte Ausrüstungsposition für {{tag}}',
				LOADING: 'Prozesskontext wird geladen…',
				LOAD_FAILED: 'Der Prozesskontext für diesen Alarm konnte nicht geladen werden.',
				UNRESOLVED: 'Ausrüstung und Instrument des Alarms sind nicht im Wissensgraphen',
				UNRESOLVED_HINT: 'Es können weder R&I-Position noch verbundene Anlagen angezeigt werden.',
				NO_DRAWING: 'Kein digitalisiertes R&I-Schema zeigt diese Ausrüstung',
				NO_DRAWING_HINT: 'Nutzen Sie den Kontextgraphen, um verbundene Anlagen zu sehen.',
				SAME_LINE: 'Auf derselben Leitung',
				SAME_LINE_EMPTY: 'Keine Objekte auf derselben Prozessleitung.',
				CONNECTED_ON_DRAWING: 'Verbunden in der Zeichnung',
				CONNECTED_EMPTY: 'Keine verbundenen Objekte in dieser Zeichnung.',
				CONNECTED_ELSEWHERE: 'Verbunden, nicht in dieser Zeichnung',
				LOCATE: 'In der Zeichnung zeigen',
				ADD_TO_CHART: '{{tag}} zu den Diagrammen hinzufügen',
				NOT_LINKED: 'nicht verknüpft',
				GRAPH_EMPTY: 'Für diesen Alarm wurden keine verbundenen Anlagen gefunden.',
				GRAPH_HINT: 'Größe = Anzahl Tags · Knoten mit Historian-Tag anklicken, um ihn zu plotten',
				ROLE: {
					ALERT_EQUIPMENT: 'Alarmausrüstung',
					ALERT_INSTRUMENT: 'Alarminstrument',
					CONNECTED: 'Verbunden',
					SAME_LINE: 'Gleiche Prozessleitung',
					OTHER: 'Sonstige',
				},
				EDGE: {
					FLOWS_TO: 'Fließt zu',
					SERVES: 'Versorgt',
					SENSES: 'Erfasst',
					CONTROLS: 'Regelt',
					PROTECTS: 'Schützt',
					SAME_LINE: 'Gleiche Leitung',
					MEASURES: 'Misst',
					RELATED: 'Verknüpft',
				},
				NODE_TYPE: {
					EQUIPMENT: 'Ausrüstung',
					INSTRUMENT: 'Instrument',
					CONTROLVALVE: 'Regelventil',
					PROCESSLINE: 'Prozessleitung',
				},
				TOOLTIP: {
					TAG: 'Tag',
					HISTORIAN_TAG: 'Historian-Tag',
					TYPE: 'Typ',
					ROLE: 'Rolle',
					TAG_COUNT: 'Historian-Tags',
					LINE: 'Leitung',
					DRAWING: 'Zeichnung',
				},
			},
			PAGE_TITLE: 'Alarme',
			ENTERPRISE: 'Shell',
			SEARCH_PLACEHOLDER: 'Suchen...',
			SEARCH_OWNER: 'Verantwortlichen suchen...',
			OWNER_FILTER: 'Nach Verantwortlichem filtern',
			CHOOSE_STATUSES: 'Anzuzeigende Status wählen',
			ALL_STATUSES: 'Alle Status',
			FILTERS: 'Filter',
			MORE: 'Mehr',
			WATCHERS: 'Beobachter',
			COLLAPSE_PANEL: 'Bereich einklappen',
			EXPAND_PANEL: 'Bereich ausklappen',
			RETRY: 'Erneut versuchen',
			CLOSE: 'Schließen',
			PREVIOUS: 'Vorheriger Alarm',
			NEXT: 'Nächster Alarm',
			SCORE: 'Bewertung',
			SEE_MORE: 'Mehr anzeigen',
			SEE_LESS: 'Weniger anzeigen',
			CLASS: {
				FALSE_NO_ACTION: 'Falsch – Keine Aktion',
				FALSE_DQ: 'Falsch – Datenqualität (DQ)',
				VALID_NO_ACTION: 'Gültig – Keine Aktion',
				CREATE_SERVICE: 'Gültig – Service erstellen',
				HUMAN_REVIEW: 'SME-Prüfung',
				PENDING: 'Ausstehend',
			},
			CLASS_OPTION: {
				FALSE_DQ: 'False – DQ (raised on bad data: instrument or data feed)',
				HUMAN_REVIEW: 'SME-Prüfung (manuelle Bewertung erforderlich)',
				CREATE_SERVICE: 'Fall anlegen (Untersuchung & Maßnahme starten)',
				VALID_NO_ACTION: 'Gültig – keine Aktion (Ereignis schließen – kein Service)',
				FALSE_NO_ACTION: 'Fehlalarm – keine Aktion (Ereignis schließen – kein Service)',
			},
			STATUS: {
				ACKNOWLEDGED: 'Acknowledged',
				UNACKNOWLEDGED: 'Unacknowledged',
				DEFECT_RAISED: 'Pending – Defect Raised',
				UNACTIONED: 'Unbearbeitet',
				APPROVED: 'Genehmigt',
				RELEARNED: 'Neu gelernt',
			},
			STATE: {
				ACTIVE: 'Aktiv',
				RETURNED_TO_NORMAL: 'Normalzustand erreicht',
			},
			TELEMETRY: {
				TITLE: 'Zeitreihe',
				AVAILABLE: 'Verfügbar',
				MISSING: 'Fehlt',
				TIP_AVAILABLE: 'Historian-Werte für {{tag}} in den 24 h vor dem Alarm',
				TIP_NO_DATA: 'Keine Historian-Werte für {{tag}} in den 24 h vor dem Alarm',
				TIP_NOT_IN_HISTORIAN: '{{tag}} ist nicht im Historian',
				TIP_NO_TAG: 'Der Alarm nennt keinen Historian-Tag',
				UNUSABLE: 'Nicht verwendbar',
				TIP_UNKNOWN: 'Verfügbarkeit konnte nicht geprüft werden',
			},
			TAGX: {
				THIS_EQUIPMENT: 'Dieses Equipment',
				ALL_EQUIPMENT: 'Alle zugehörigen Equipments ({{count}})',
				FILTER: 'Filtern',
				HISTORIAN_RESULTS: 'Historian-Suche',
				MODE_FUNCTION: 'Nach Funktion',
				MODE_RELATION: 'Nach Beziehung',
				FILTER_MEASURE: 'Nach Messgröße filtern',
				FILTER_GROUP: 'Nach Funktionsgruppe filtern',
				CLEAR_FILTERS: 'Filter löschen',
				SHOW_ALL: 'Alle anzeigen ({{count}} weitere)',
				NO_MATCHES_FILTERED: 'Keine Treffer für die gewählten Filter',
				TITLE: 'Weitere Tags anzeigen',
				SEARCH_PLACEHOLDER: 'Tags nach Name oder Beschreibung suchen',
				MIN_CHARS: 'Mindestens 2 Zeichen eingeben',
				SEARCHING: 'Suche läuft…',
				NO_MATCHES: 'Keine passenden Tags',
				HAS_DATA: 'Historian-Daten vorhanden',
				NO_DATA: 'Keine Historian-Daten',
				SELECTED: '{{count}} / {{max}} ausgewählt',
				MAX_REACHED: 'Höchstens {{max}} Tags können ausgewählt werden',
				CLEAR: 'Auswahl aufheben',
				CHART_TOGETHER: 'Gemeinsam darstellen',
				HIDE_CHART: 'Diagramm ausblenden',
				IN_LIST: 'In der Liste',
				VIA: 'über {{via}}',
				GROUP_ALERT: 'Alarm-Tag',
				GROUP_COMPONENT: 'Gleiche Komponente',
				GROUP_EQUIPMENT: 'Gleiches Paket / gleiche Anlage',
				GROUP_CONNECTED: 'Verbundene Anlagen',
				GROUP_PID: 'P&ID-Instrumente',
				GROUP_OTHER: 'Weitere verwandte',
				GROUP_SEARCH: 'Aus Suche hinzugefügt',
				NO_TAGS: 'Keine verwandten Tags gefunden',
				LOADING: 'Verwandte Tags werden geladen…',
				FILTER_EMPTY: 'Keine verwandten Tags passen zu „{{q}}“',
			},
			QUEUE: {
				DATE_FIELD: 'Nach Datumsfeld filtern',
				DATE_FIELD_EVENT: 'Ereigniszeit',
				DATE_FIELD_RAISED: 'Ausgelöst',
				SORT_OLDEST: 'Älteste zuerst (klicken zum Umkehren)',
				SORT_NEWEST: 'Neueste zuerst (klicken zum Umkehren)',
				PAGE_SIZE: 'Zeilen pro Seite',
				RANGE: '{{start}}–{{end}} von {{total}}',
				FIRST_PAGE: 'Erste Seite',
				PREV_PAGE: 'Vorherige Seite',
				NEXT_PAGE: 'Nächste Seite',
				LAST_PAGE: 'Letzte Seite',
				GROUPED_PAGE_HINT: 'Gruppen werden aus den Alarmen dieser Seite gebildet',
				ON_THIS_PAGE: 'auf dieser Seite',
				SIGNAL_START: 'Ereignisbeginn',
				RAISED: 'Erstellt am',
				RETURNED_TO_NORMAL_AT: 'Zuletzt aktiv (wieder normal)',
				BASELINE_REF: 'Baseline-Referenz',
				BASELINE_REF_TIP: 'Baseline-Referenzzeit des Detektors ({{time}}): die in der Alarmbeschreibung genannte „last recorded on …“-Zeit. Sie ist nicht die Ereigniszeit.',
				NOT_ANALYSED: 'Nicht analysiert: {{reason}}',
				NOT_ON_PAGE: 'Wiederholtes Auftreten ist nicht auf dieser Seite. Zum Anzeigen öffnen.',
				COLUMNS: 'Spalten',
				RESET_COLUMNS: 'Alle Spalten anzeigen',
				SET_STATUS: 'Status der ausgewählten Alarme festlegen',
				CSV: {
					PROCESS_UNIT: 'PROZESSEINHEIT',
					FLOC: 'FLOC',
					POINTS: 'TAGS',
					DEFINITION_ID: 'DEFINITIONS_ID',
					NUMBER: '#',
					ALERT_ID: 'Alarm-ID',
					SYSTEM_NAME: 'Systemname',
					SYSTEM: 'System',
					STATUS: 'Status',
					CLASSIFICATION: 'Klassifizierung',
					CONFIDENCE: 'Konfidenz',
					ALERT_NAME: 'Alarmname',
					SOURCE: 'Quelle',
					EVENT_TIME: 'Ereignisbeginn (Signalbeginn)',
					RAISED: 'Erstellt am',
					RETURNED_TO_NORMAL: 'Zuletzt aktiv (wieder normal)',
					BASELINE_REF: 'Baseline-Referenz',
					STATE: 'Zustand',
					TIME_SERIES: 'Zeitreihe',
					ANCHOR_TAG: 'Anker-Tag',
					NOT_ANALYSED: 'Nicht analysiert (DQ-Gate)',
					OWNER: 'Verantwortlich',
				},
				COLUMN_NUMBER: 'Nummer',
				SORT_BY_COLUMN: 'Nach dieser Spalte sortieren',
				DATE_ON_EVENT: 'Zeitraum gilt für den Ereignisbeginn',
				DATE_ON_CREATED: 'Zeitraum gilt für „Erstellt am“ (sortierte Spalte)',
				SHOW_COLUMNS: 'Spalten anzeigen',
				SEARCH_COLUMNS: 'Suchen...',
				SELECT_ALL_COLUMNS: 'Alle auswählen',
				RESET_DEFAULT_COLUMNS: 'Auf Standard zurücksetzen',
				RESIZE_COLUMN: 'Ziehen, um die Breite zu ändern',
				STILL_ACTIVE: 'Noch aktiv',
			},
			GROUP_BY: {
				TITLE: 'Gruppieren nach',
				EQUIPMENT: 'Equipment',
				NONE: 'Keine',
				SYSTEM: 'System',
				FACILITY: 'Anlage',
				SOURCE: 'Quelle',
				CLASSIFICATION: 'Klassifizierung',
				ALERT_STATUS: 'Alarmstatus',
			},
			MENU: {
				EXPORT: 'Daten exportieren',
				COLLAPSE_GROUPS: 'Alle Gruppen einklappen',
				EXPAND_WITHIN_GROUP: 'Alle Einträge der Gruppe ausklappen',
				AUTO_REFRESH: 'Automatische Aktualisierung',
			},
			AUTO_REFRESH: {
				OFF: 'Aus',
				LIVE: 'Live',
				MIN_5: '5 Minuten',
				MIN_15: '15 Minuten',
				MIN_30: '30 Minuten',
				HOUR_1: '1 Stunde',
			},
			FILTER: {
				TITLE: 'Filtern nach',
				SEARCH_ALERT_NAME: 'Nach Alarmname suchen...',
				START_TYPING: 'Tippen, um zu suchen',
				APPLY: 'Anwenden',
				CLEAR_ALL: 'Alle löschen',
				TARGET_ONLY: 'Nur Ziel-FLOCs',
				TARGET_TIP: 'Nur Alarme an den Ziel-FLOCs aus Asset-Hierarchien → FLOC-Hierarchie',
				TARGET_COUNT: '{{count}} Alarme in der aktuellen Ansicht',
			},
			TABLE: {
				STEP: 'Step',
				STEP_HINT: 'The triage-path step that decided the alert (amber: held for SME review)',
				TYPE: 'Type',
				PLUS_TAGS: '+{{count}} Tags',
				DEFINITION_ID: 'Definitions-ID',
				ALERTS: 'Alarme',
				N_ALERTS: '{{count}} Alarme',
				SYSTEM_NAME: 'Systemname',
				STATUS: 'Status',
				CLASSIFICATION: 'Klassifizierung',
				CONFIDENCE: 'Konf.',
				ALERT_NAME: 'Alarmname',
				SOURCE: 'Quelle',
				EVENT_TIME: 'Ereignisbeginn',
				STATE: 'Zustand',
				OWNER: 'Verantwortlich',
				EMPTY: 'Keine Alarme entsprechen den aktuellen Filtern',
				RECURRING: 'Wiederkehrend: {{count}} Vorkommen in dieser Episode',
				TOGGLE_RECURRING: 'Wiederkehrende Alarme anzeigen',
				CREATED_ON: 'Erstellt am',
				LAST_ACTIVE: 'Zuletzt aktiv',
			},
			BULK: {
				ITEMS: 'Einträge',
				ASSIGN_OWNER: 'Ausgewählten Alarmen Verantwortlichen zuweisen',
				CHANGE_CLASSIFICATION: 'Klassifizierung ändern',
				DONE: '{{count}} Alarme aktualisiert',
				PARTIAL: '{{ok}} Alarme aktualisiert, {{failed}} konnten nicht aktualisiert werden',
			},
			ACTIONS: {
				APPROVE: 'Genehmigen',
				APPROVED: 'Genehmigt',
				RELEARN: 'Neu lernen',
				RELEARNED: 'Neu gelernt',
				CLASSIFY: 'Klassifizieren',
			},
			DETECTOR: {
				POINTS_FROM_SIGNAL_TEXT: 'Tags aus SignalMeasurementText gelesen',
				POINTS_FROM_DESCRIPTION: 'Tags aus der Alarmbeschreibung gelesen',
				PRIMARY: 'primär',
				TAGS_TIP: 'Tags, auf die sich dieser Alarm bezieht ({{count}}):',
				TAGS_N: 'Tags ({{count}})',
				LABEL: 'Detektor',
				MECHANISM: 'Erkennungsmechanismus',
				MONITORED_TAG: 'Überwachter Tag',
				CLUSTER_SIZE: 'Clustergröße',
				FREQUENCY: 'Häufigkeit',
				WINDOW_SPAN: 'Zeitfenster',
				N_ALERTS: '{{count}} Alarme',
				PER_HOUR: '{{value}} Alarme/h',
				HOURS: '{{value}} Stunden',
			},
			DQ: {
				STATUS_UNUSABLE: 'Unusable',
				PENDING_DEFECT: 'Defect raised',
				PENDING_DEFECT_TIP: 'Instrument work order {{wo}}: pending',
				TITLE: 'Datenqualitätsbewertung (DQ)',
				FROZEN: 'Nulllinie',
				IMPOSSIBLE_ROC: 'Änderungsrate',
				DOMAIN_RANGE: 'Außerhalb des Bereichs',
				JITTER: 'Unregelmäßig',
				PASS_FROZEN: 'Bestanden (dynamisch)',
				PASS_IMPOSSIBLE_ROC: 'Bestanden',
				PASS_DOMAIN_RANGE: 'Innerhalb der Grenzen',
				PASS_JITTER: 'Normales Signal',
				FAIL_FROZEN: 'Eingefroren',
				FAIL_IMPOSSIBLE_ROC: 'Nicht bestanden',
				FAIL_DOMAIN_RANGE: 'Außerhalb des Bereichs',
				FAIL_JITTER: 'Unregelmäßiges Signal',
				NOT_ASSESSED: 'Nicht bewertet',
				STATUS_PASS: 'Bestanden',
				STATUS_WARN: 'Warnung',
				STATUS_FAIL: 'Fehlgeschlagen',
				STATUS_NO_DATA: 'Keine Daten',
				STATUS_UNKNOWN: 'Nicht bewertet',
				NOT_ANALYSED: 'Nicht analysiert',
				READINGS: '{{n}} Messwerte · {{bad}} maskiert',
				CHECK_INFO: 'Informativ',
				NO_GATE: 'Die Datenqualität wurde für diesen Alarm nicht bewertet',
				SCORE: 'DQ-Bewertung: {{status}}',
			},
			AGENT: {
				NO_RUN: 'Not triaged yet',
				TIER_ACCEPTED: 'Schnelle Triage · angenommen bei {{pct}} ({{time}} · {{tokens}} Tokens) — tiefe Untersuchung nicht nötig',
				TIER_QUICK_ONLY: 'Nur schnelle Triage · {{pct}} ({{time}} · {{tokens}} Tokens)',
				TIER_ESCALATED: 'An die tiefe Untersuchung eskaliert:',
				TIER_QUICK_WAS: 'Schnelle Antwort: {{cls}} {{pct}} ({{time}} · {{tokens}} Tokens)',
				TIER_FINAL_IS: 'endgültig: {{cls}} {{pct}}',
				MANUAL_CHIP: 'Handbuch · {{label}}',
				TITLE: 'Triage-Agent',
				RECOMMENDATION: 'Empfehlung',
				NOT_RUN: 'Der Triage-Agent wurde für diesen Alarm noch nicht ausgeführt. Klicken Sie auf „Triage-Agent ausführen“, um den Alarm automatisch zu klassifizieren.',
				NO_RECOMMENDATION: 'Keine Empfehlung vorhanden.',
				RUN: 'Triage-Agent ausführen',
				RUNNING: 'Läuft…',
				RERUN: 'Triage-Agent erneut ausführen',
				CREATES_CASE: 'Erstellt Fall',
				CONFIDENCE: '{{value}} Konfidenz',
				CAPPED: 'begrenzt',
				CAPPED_HINT: 'Konfidenz auf {{value}} begrenzt, da einige Prüfungen nicht ausgeführt werden konnten',
				VERIFIED_FACTS: 'Verifizierte Fakten & Telemetrie',
				N_VERIFIED: '{{count}} verifiziert',
				HYPOTHESIS: 'Arbeitshypothese & physikalischer Mechanismus (Warum)',
				SUPPORTING_TAGS: 'Unterstützende Tags',
				FMEA: 'Dynamische FMEA',
				FAILURE_MODE: 'Fehlermodus',
				MECHANISM: 'Physikalischer Mechanismus',
				IMPACT: 'Systemische Auswirkung',
				REMEDIATION: 'Abhilfe',
				DISCIPLINE: 'Fachbereich',
				ACTIONABLE: 'Umsetzbare technische Empfehlungen',
				WHAT_WOULD_CHANGE: 'Was dies ändern würde',
				DECIDED_BY: 'Beurteilt von {{model}}',
				HARNESS_VERSION: 'Harness {{v}}',
				STALE_RUN: "Veraltet: Lauf vor dem Harness-Update vom {{date}}; erneut ausführen, um den aktuellen Agenten zu sehen",
				DEGRADED: 'Regel-Fallback',
				DEGRADED_HINT: 'Das Bewertungs-LLM war nicht verfügbar; diese Einstufung stammt aus deterministischen Regeln. Vor der Genehmigung prüfen.',
			},
			DIALOG: {
				APPROVE_TITLE: 'Approve classification',
				APPROVING: 'You agree with the agent: {{x}}',
				FEEDBACK_OPTIONAL: 'Optional: anything the agent should learn from this case',
				CORRECT_FINDING: 'Correct finding',
				SELECT_FINDING: 'Select the finding…',
				MAPS_TO: 'Shown to the customer as: {{x}} (mapping in force)',
				PROPOSE_TOGGLE: 'The finding “{{x}}” is right; the customer label should be different',
				PROPOSE_HELP: 'The alert keeps its finding. An administrator sees the proposal in Settings › Labels; a mapping change relabels every alert with this finding.',
				WANTED_LABEL: 'Label the customer expects',
				PROPOSED: 'Mapping change proposed to the administrators',
				RELEARN_TITLE: 'Klassifizierung neu lernen',
				CLASSIFY_TITLE: 'Klassifizieren',
				CORRECT_CLASSIFICATION: 'Korrekte Klassifizierung',
				SELECT_CLASS: 'Neue Klassifizierungskategorie wählen...',
				FEEDBACK: 'Feedback',
				FEEDBACK_REQUIRED: 'Für die Überarbeitung erforderlich',
				CANCEL: 'Abbrechen',
				CONFIRM: 'Bestätigen',
			},
			EVIDENCE: {
				GROUP: {
					SERIES: 'Time series',
					RECORDS: 'Plant records',
				},
				ALL_TAGS: 'All tags',
				ON_DRAWING: 'Picked on the drawing:',
				CONTEXT_GRAPH: 'Context graph',
				SEARCH_REPORTS: 'Search the reports (any word in any section)',
				SEARCH_MATCHES: '{{n}} report(s) match',
				CITED_HERE: 'cited',
				AXES_UNIT: 'Axis per unit',
				AXES_TAG: 'Axis per tag',
				AXES_HINT: 'Overlay y-axes: share one axis per unit, or give every tag its own',
				SOURCE_ALERT: 'Source Alert',
				SOURCE_ALERT_FROM: 'Source alert · {{source}}',
				SYSTEM_DETAILS: 'System Details',
				REASONING_NOT_IN_RUN: 'In diesem Lauf nicht erfasst (Läufe vor Einführung dieses Abschnitts).',
				DROP_TAGS_HINT: 'Tags aus dem Bereich „Tags anzeigen“ hierher ziehen, um Diagramme hinzuzufügen',
				TAGS: 'Tags',
				MAINTENANCE: 'Instandhaltung',
				REPORTS: 'Berichte',
				ALERTS: 'Alarme',
				DOCUMENTS: 'Dokumente',
				REASONING: 'Begründung',
				REASONING_SECTION: {
					DECISION: 'Decision',
					BOARD: 'Hypothesis board',
					EVIDENCE: 'Evidence used',
					MEMORY: 'Learnings used',
					LIBRARY: 'Bibliothek',
					LIMITS: 'Grenzwerte',
					REASONING: 'Begründung',
					PLAYBOOK: 'Playbook-Prüfungen',
					SIGNAL: 'Signal & Maschine',
					CONNECTED: 'Verbundene Systeme',
					ANOMALY: 'Anomaliemodell',
					RECORDS: 'Gelesene Datensätze',
				},
				NO_TELEMETRY: 'Keine Historiendaten für diese Tags',
				NO_TELEMETRY_HINT: 'Die Historie deckt das Alarmfenster der Evidenz-Tags nicht ab.',
				NO_DATA_FOR: 'Keine Historiendaten für',
				NOTIFICATIONS: 'Meldungen',
				NOTIFICATION: 'Meldung',
				WORK_ORDERS: 'Aufträge',
				WORK_ORDER: 'Auftrag',
				NONE: 'Keine Einträge',
				ON_THIS_ITEM: 'Auf diesem Objekt',
				DESCRIPTION: 'Beschreibung',
				NOTIFICATION_NO: 'Meldungsnr.',
				TYPE: 'Art',
				PRIORITY: 'Priorität',
				RAISED_ON: 'Erstellt am',
				COMPLETED_ON: 'Abgeschlossen am',
				FLOC: 'Technischer Platz',
				HIERARCHY_TIER: 'Hierarchieebene',
				SUPERVISOR_REPORTS: 'Schichtleiterberichte',
				SHIFT_LOGS: 'Schichtprotokolle',
				RECENT_ALERTS: 'Letzte Alarme',
				RELATED_ALERTS: 'Zugehörige Alarme',
				FIRED_AT: 'Ausgelöst um',
				CONTEXT: 'Kontext',
				SHOW_AFTER_ALERT: 'Einträge nach dem Alarm anzeigen',
				HINDSIGHT_HINT: 'Aus: nur Einträge, die beim Auslösen des Alarms vorlagen (wie der Agent sie sah). Ein: auch später erstellte Einträge.',
				HINDSIGHT_ON: 'Rückblick aktiv: Nach dem Alarm erstellte Einträge werden angezeigt und als „Nach Alarm“ markiert. Der Agent hat sie nicht gesehen.',
				AFTER_ALERT: 'Nach Alarm',
				HIDDEN_AFTER_ALERT: '{{n}} nach dem Alarm erfasste ausgeblendet',
				NONE_AT_ALERT: 'Zum Alarmzeitpunkt nichts erfasst',
				NOT_ANALYSED: 'Nicht analysiert',
				NO_TIME_SERIES: 'Keine Zeitreihe: {{reason}}',
				TELEMETRY_NO_DATA: 'der Historian enthält in den 24 h vor dem Alarm keine Messwerte für den Alarm-Tag',
				TELEMETRY_NOT_IN_HISTORIAN: 'der Alarm-Tag ist nicht im Historian vorhanden',
				TELEMETRY_NO_TAG: 'der Alarm hat keinen überwachten Tag',
				TELEMETRY_UNKNOWN: 'Verfügbarkeit im Historian unbekannt',
				ADD_TAGS: 'Tags hinzufügen',
				HIDE_TAG_LIST: 'Tag-Liste ausblenden',
				INCLUDE_BASELINE: 'Baseline-Referenz einbeziehen',
				ALERT_WINDOW: 'Alarmfenster',
				BASELINE_REF_AT: 'Baseline-Referenz des Detektors: {{at}}',
				CHARTED_TOGETHER: 'Tags gemeinsam dargestellt',
				NO_TAGS_CHARTED: 'Keine Tags dargestellt',
				NO_TAGS_CHARTED_HINT: 'Suchen oder wählen Sie verwandte Tags in der Tag-Liste, um sie darzustellen.',
				TAG_LOAD_FAILED: 'Dieser Tag konnte nicht geladen werden',
				OVERLAY: 'Überlagerung – Istwerte, eine Y-Achse pro Einheit',
				OVERLAY_NORMALISED: 'Alle Tags auf einer Achse (Z-Score, unterschiedliche Einheiten)',
				STATUS_AT_ALERT: 'Status bei Alarm',
				STATUS_NOW: 'jetzt',
				OPEN_AT_ALERT: 'Offen bei Alarm',
				CLOSED_AT_ALERT: 'Geschlossen bei Alarm',
				NOT_RAISED_AT_ALERT: 'Bei Alarm noch nicht angelegt',
				SCOPE_ITEM: 'Dieses Objekt',
				SCOPE_PARENT: 'Übergeordnet',
				BREAKDOWN: 'Ausfall',
				NUMBER: 'Nummer',
				EQUIPMENT: 'Equipment',
				REPORTED_BY: 'Gemeldet von',
				PLANNING_GROUP: 'Planergruppe',
				WORK_CENTER: 'Arbeitsplatz',
				SYMPTOM: 'Symptom',
				CREATED_ON: 'Erstellt am',
				SCHEDULED_START: 'Geplanter Start',
				SCHEDULED_FINISH: 'Geplantes Ende',
				ESTIMATED_DURATION: 'Geschätzte Dauer',
				HOURS_N: '{{n}} Std.',
				COST_ESTIMATE: 'Kostenschätzung',
				KNOWN_AT: 'Erfasst seit',
				LONG_TEXT: 'Details',
				STATUS_HISTORY: 'Statusverlauf',
				PRODUCTION_REPORTS: 'Produktionsberichte',
				DEFERMENT_REPORTS: 'Minderförderungsberichte',
				SUPERVISOR_REPORT: 'Schichtleiterbericht',
				PRODUCTION_REPORT: 'Täglicher Produktionsbericht',
				DEFERMENT_REPORT: 'Minderförderungsbericht',
				FULL_SCREEN: 'Vollbild',
				EXIT_FULL_SCREEN: 'Vollbild beenden',
				BACK_TO_DOCUMENTS: 'Zurück zu Dokumenten',
				DOWNLOAD: 'Herunterladen',
				HSSE: 'HSSE',
				PRODUCTION: 'Produktion',
				HSSE_GRADE: 'HSSE-Bewertung',
				PRODUCTION_GRADE: 'Produktionsbewertung',
				REPORT_DATE: 'Berichtsdatum',
				SOURCE_FILE: 'Quelldatei',
				SUMMARY: 'Zusammenfassung',
				PRODUCTION_COMMENT: 'Produktionskommentar',
				SUPERVISOR_COMMENTS: 'Kommentare des Schichtleiters',
				ACTIVITIES: 'Aktivitäten',
				FORECAST: 'Ausblick',
				ALARMS: 'Alarme',
				DEFERMENT: 'Minderförderung',
				OOS: 'Außer Betrieb befindliche Ausrüstung',
				IOW: 'DOW- / IOW-Überschreitungen',
				MOCS: 'Temporäre MOCs',
				NO_REPORT_TEXT: 'Kein Berichtstext',
				CATEGORY: 'Kategorie',
				MAIN_CAUSE: 'Hauptursache',
				SUB_CAUSE: 'Unterursache',
				EQUIPMENT_SYSTEM: 'Anlagensystem',
				EQUIPMENT_TYPE: 'Ausrüstungstyp',
				EVENT_START: 'Ereignisbeginn',
				EVENT_END: 'Ereignisende',
				ENDED_BEFORE_ALERT: 'Vor dem Alarm beendet',
				ONGOING_AT_ALERT: 'Bei Alarm andauernd',
				RECENT_ALERTS_HINT: 'auf diesem Tag / Funktionsplatz',
				RELATED_ALERTS_HINT: 'innerhalb ±60 min, gleiches System zuerst',
				SUB_ALERTS: 'Teilalarme der Episode',
				SUB_ALERTS_HINT: 'dieser Episode zugeordnet',
				SAME_SYSTEM: 'Gleiches System',
				OPEN_ALERT: 'Diesen Alarm öffnen',
				NO_DOCUMENTS: 'Keine Dokumente mit diesem Equipment verknüpft',
				PID: 'P&ID',
				PAGES_N: '{{n}} Seiten',
				UPDATED: 'Aktualisiert',
				SOURCE: 'Quelle',
				REVISION: 'Revision',
				DOCUMENT_TYPE: 'Dokumenttyp',
				DOCUMENT_PREVIEW: 'Dokumentvorschau',
				FILE_NAME: 'Dateiname',
				PREVIEW_UNAVAILABLE: 'Vorschau nicht verfügbar',
				PREVIEW_UNAVAILABLE_HINT: 'Die Datei zu diesem Dokument liegt nicht im Dokumentenspeicher.',
				SHOWING_ALL_WO: 'Showing all {{shown}} of {{total}} work orders & notifications',
				SHOWING_EVIDENCE_WO: 'Showing {{shown}} condition-evidence records (of {{total}} total)',
				SHOW_ALL_EQUIPMENT_WO: 'Show all work orders for {{equipment}}',
				CITED_IN_PATH: 'Cited',
				LINKED_WO: 'Linked WO',
				ROOT_CAUSE: 'Root Cause',
				AGENT_READ_SUMMARY: 'Im letzten Lauf hat der Agent {{read}} Schichtberichte gelesen und {{cited}} zitiert — lesen Sie die zitierten zuerst.',
				ONLY_AGENT_READ: 'Nur vom Agenten gelesene Berichte',
				AGENT_CITED: 'Vom Agenten zitiert · {{relevance}}',
				AGENT_READ: 'Vom Agenten gelesen · nicht zitiert',
			},
			CHART: {
				JUDGED_AT: 'Judged at (raised later)',
				NO_DATA: 'No data in the historian',
				SEPARATE: 'Separate',
				OVERLAY: 'Overlay',
				SEPARATE_HINT: 'One panel per tag, sharing the time axis',
				OVERLAY_HINT: 'All tags on one panel, one y-axis per unit',
				ALL_READINGS: '*All good readings in the window',
				INSTRUMENT_RANGE: 'Instrument range',
				MEDIAN: 'Median',
				STEADY_ONLY: '*Steady running only (shutdown and start-up excluded)',
				THRESHOLD_LIMIT: 'Threshold limit',
				TRIP_LIMIT: 'Trip limit',
				LIMIT_TRIP: 'Abschaltung',
				LIMIT_ALARM: 'Alarm',
				LIMIT_THRESHOLD: 'Schwellenwert',
				LIMIT_INSTRUMENT: 'Messbereich',
				LIMIT: 'Grenze',
				LIMIT_NONE: 'Für diesen Tag ist kein Wert geladen',
				TAG_LEGEND: 'Tag-Legende',
				MASKED_HIDDEN: '{{count}} maskierte Messwerte (Datenqualität) nicht dargestellt',
				NO_UNIT: 'Ohne Einheit',
				HIGH: 'High',
				LOW: 'Low',
				AVERAGE: 'Average',
				ACTUAL: 'Istwert',
				BASELINE: 'Basislinie',
				SIGNAL_START: 'Signalbeginn',
				RAISED: 'Ausgelöst',
				RTN: 'Zuletzt aktiv',
				BASELINE_REF: 'Basislinien-Ref.',
				NORMAL_MIN: 'Normal-Min.',
				NORMAL_MAX: 'Normal-Max.',
				MASKED: 'Maskierte Messwerte (DQ)',
				MASKED_HOVER: 'Maskierter Messwert',
				ARTEFACT: 'Ersatzwert / Datenartefakt',
				ARTEFACT_HOVER: 'Datenartefakt (kein Prozesswert)',
				TIME_AXIS: 'Zeit ({{zone}})',
				OFF_SCALE: 'außerhalb der Skala',
				MIN: 'Min.',
				MAX: 'Max.',
				RANGE_BAND: 'Min.–Max.',
				LOADING: 'Daten werden geladen…',
				LOAD_ERROR: 'Daten für diesen Bereich konnten nicht geladen werden',
				NO_DATA_IN_WINDOW: 'Keine Messwerte in diesem Zeitfenster',
				HISTORIAN_SPAN: 'Historian enthält Daten von {{first}} bis {{last}}',
				CLOSE: 'Diagramm schließen',
				ZOOM_HINT: 'Ziehen zum Zoomen oder Verschieben – weitere Daten werden automatisch geladen. Doppelklick zum Zurücksetzen.',
				LAYOUT_STACKED: 'Gestapelt',
				LAYOUT_OVERLAY: 'Überlagert',
				NORM_NONE: 'Rohwerte',
				NORM_ZSCORE: 'Z-Wert',
				NORM_RANGE: '% des Bereichs',
				NORMALISED_Z: 'Z-Wert (σ)',
				NORMALISED_PCT: '% des Bereichs',
				REMOVE_TAG: 'Tag entfernen',
				NO_TAGS: 'Tags für gemeinsames Diagramm auswählen',
				TOGETHER_TITLE: 'Gemeinsam dargestellte Tags',
			},
			DETAIL: {
				CHANGE_STATUS: 'Change status',
				ACK_HINT: 'Approve the current classification',
				REOPEN_HINT: 'Undo the last decision',
				REOPENED: 'Alert reopened',
				TARGET_FLOC: 'Ziel-FLOC',
				OPEN_ALERT: 'Alarm öffnen',
				BACK_TO_QUEUE: 'Zurück zu den Alarmen',
				ALERT_ANALYSIS: 'Alarmanalyse',
				EVIDENCE: 'Nachweise',
				EVENT_TIME: 'Ereigniszeit',
				EVENT_TIME_HINT: 'Zeitpunkt, zu dem das Signal begann (Beginn der Abweichung)',
				RAISED: 'Ausgelöst',
				RAISED_HINT: 'Zeitpunkt, zu dem das Überwachungssystem den Alarm erstellt hat. Der Agent nutzt nur, was bis dahin bekannt war.',
				RTN: 'Wieder normal',
				BASELINE_REF: 'Baseline-Referenz',
				BASELINE_REF_HINT: 'Referenzzeit des Detektors (letzte Aufzeichnung seiner Baseline), nicht die Ereigniszeit',
				CLASSIFICATION_HINT: 'Aktuelle Klassifizierung. Wählen Sie eine andere Klasse, um diesen Alarm zu klassifizieren oder neu anzulernen.',
				CHANGE_CLASS: 'Klassifizierung ändern',
				CURRENT_CLASS: 'Aktuelle Klassifizierung: {{value}}',
				PREVIOUSLY_APPROVED: 'Zuvor genehmigt',
				PREVIOUSLY_RELEARNED: 'Zuvor neu angelernt',
				HUMAN_REVIEW_REQUIRED: 'SME-Prüfung — manuelle Bewertung erforderlich',
				NOT_CLASSIFIED: 'Noch nicht klassifiziert',
				AGENT_PROPOSED: 'Vom Triage-Agenten vorgeschlagen',
				NOT_ANALYSED_HINT: 'Der Triage-Agent analysiert diesen Alarm nicht: Seine Daten haben die Prüfungen vor dem Alarm nicht bestanden. Klassifizieren Sie ihn bei Bedarf manuell.',
				NOT_ANALYSED_REASON: 'Nicht analysiert: {{reason}}',
				RUN_BLOCKED: 'Nicht analysierbar',
				RUN_BLOCKED_WHY: 'Keine Analyse: {{reason}}',
				RUN_GATED: 'Nicht analysiert',
				EVENT_START: 'Ereignisbeginn',
				CREATED_ON: 'Erstellt am',
				LAST_ACTIVE: 'Zuletzt aktiv',
				LAST_ACTIVE_HINT: 'Zeitpunkt der Rückkehr in den Normalzustand (zuletzt aktiv); "Aktiv", solange der Alarm aktiv ist',
			},
			CASE: {
				CHIP: 'Fall #{{id}}',
				CREATE: 'Fall erstellen',
				MANAGE_HINT: 'Erstellen Sie einen Fall, um Folgemaßnahmen zu verwalten',
				CREATED: 'Fall #{{id}} erstellt',
				EXISTS: 'Fall #{{id}} ist bereits mit diesem Alarm verknüpft',
				CREATE_FAILED: 'Der Fall konnte nicht erstellt werden',
				BULK_CREATED: '{{count}} Fall/Fälle erstellt.',
			},
			RAIL: {
				LIMITS: 'Limits',
				ACTIVITY: 'Aktivitätsprotokoll',
				DISCUSSION: 'Diskussion',
				TRACES: 'Traces',
				PREFERENCES: 'Einstellungen',
				ANALYSIS: 'Analysen & Ansichten',
				OTHER_TAGS: 'Tags anzeigen',
				OTHER_TAGS_HINT: 'Tag anklicken oder auf die Diagramme ziehen, um ihn im Tab „Tags“ hinzuzufügen.',
				DOCUMENTS: 'Dokumente',
				NO_DOCUMENTS: 'Keine Dokumente mit diesem Alarm verknüpft',
				NO_DOCUMENTS_HINT: 'Keine Handbücher, P&IDs oder Berichte verweisen auf diese Anlage.',
				OPEN_IN_DOCUMENTS: 'Im Tab „Dokumente“ anzeigen',
				REVISION: 'Rev. {{value}}',
				PID: 'P&ID',
				EXPORT_TAGS: 'Ausgewählte Tags an externes System exportieren',
				SAVED_ANALYSIS: 'Gespeicherte Analysen',
				SAVED_VIEWS: 'Gespeicherte Ansichten',
				SAVED_DASHBOARDS: 'Gespeicherte Dashboards',
				NOT_AVAILABLE: 'Für Triage-Alarme noch nicht verfügbar',
				PREFERENCES_NOTE: 'Schattierung von Stillstandsbereichen sowie Trip-, Alarm- und Schwellenwertlinien sind für Triage-Diagramme noch nicht verfügbar.',
			},
			ACTIVITY: {
				N_ACTIONS: 'Aktionen ({{count}})',
				EMPTY: 'Noch keine Aktivität',
			},
			DISCUSSION: {
				N_COMMENTS: 'Kommentare ({{count}})',
				EMPTY: 'Noch keine Kommentare',
				PLACEHOLDER: 'Kommentar schreiben...',
				REPLY: 'Antworten',
				REPLY_PLACEHOLDER: 'Antwort schreiben...',
				SEND: 'Senden',
			},
			TRACE: {
				SEARCH: 'Search the trace (agent, finding, record id…)',
				SEARCH_MATCHES: '{{n}} agent(s) match',
				TMP_NOT_APPLIED: 'TMP-Zeile unter {{component}} abgelegt, nicht angewendet',
				TITLE: 'Agenten-Pipeline-Trace',
				EXPAND_ALL: 'Alle ausklappen',
				COLLAPSE_ALL: 'Alle einklappen',
				COMPLETED: 'Abgeschlossen',
				FAILED: 'Fehlgeschlagen',
				N_AGENTS: '{{count}} Agenten',
				NO_RUN: 'Noch kein Pipeline-Lauf',
				NO_RUN_HINT: 'Führen Sie den Triage-Agent aus, um den schrittweisen Trace aller 14 Agenten zu sehen.',
				STATUS_COMPLETED: 'Abgeschlossen',
				STATUS_NO_DATA: 'Keine Daten verfügbar',
				STATUS_FAILED: 'Fehlgeschlagen',
				STATUS_SKIPPED: 'Übersprungen',
				TOKENS: 'LLM-Tokens: {{input}} ein / {{output}} aus',
			},
			ERRORS: {
				LOAD: 'Triage-Daten konnten nicht geladen werden',
				ACTION: 'Die Aktion konnte nicht ausgeführt werden',
				RUN_FAILED: 'Der Triage-Agent-Lauf ist fehlgeschlagen',
			},
			TIMELINE: {
				TITLE: 'Ereigniszeitachse',
				N_EVENTS: '{{n}} Ereignisse',
				RELATED_ALERTS: 'Aktuelle und zugehörige Alarme',
				RANGE_ALL: 'Alle',
				RANGE_90D: '90 T',
				RANGE_30D: '30 T',
				RANGE_7D: '7 T',
				RANGE_1D: '24 Std',
				RESET_ZOOM: 'Zoom zurücksetzen',
				ZOOM_IN: 'Vergrößern',
				N_MORE: '+{{n}} weitere',
				EMPTY: 'Keine Arbeitsaufträge, Meldungen, Berichte oder Ausfälle zu diesem Alarm erfasst.',
				CLICK_TO_OPEN: 'Klicken, um es unten zu öffnen',
				MINUTES: '{{n}} Min',
				HOURS: '{{n}} Std',
				DAYS: '{{n}} Tagen',
				N_ALERTS_IN: '{{n}} Alarme innerhalb von {{span}}',
				N_EVENTS_IN: '{{n}} Ereignisse innerhalb von {{span}}',
				KIND_SELF: 'Dieser Alarm',
				KIND_ALERT: 'Alarm',
				KIND_WORK_ORDER: 'Arbeitsauftrag',
				KIND_NOTIFICATION: 'Meldung',
				KIND_SUPERVISOR: 'Schichtbericht',
				KIND_PRODUCTION: 'Produktionsbericht',
				KIND_DEFERMENT: 'Produktionsausfall',
			},
			CANCEL: 'Cancel',
			SAVE: 'Save',
			PATH: {
				CITE_HINT: 'Open this record on the right',
				LAST_RECORDED: 'Detector: last recorded',
				LAST_RECORDED_TIP: 'The time the detector states in its text ("last recorded on …"); its meaning depends on the detector.',
				PLAIN_PENDING: 'A plain-language explanation is being written; reopen in a moment.',
				WHY: 'Why',
				STEP: 'Decided at',
				SHOW_DATA: 'Show data',
				HIDE_DATA: 'Hide data',
				DATA: 'Data',
				DETECTOR_CROSSED: 'crossed: why the alert fired',
				DETECTOR_OWN: 'the detector\'s rule',
				DETECTOR_OWN_TIP: 'The detector\'s own threshold. Crossing it is what raised the alert, so it is not evidence for a service; only an independent engineering limit is.',
				AGENT_DECIDED: 'agent decided',
				AGENT_DECISION: 'Agent decision',
				BASELINE: 'Baseline',
				CHECK: {
					FROZEN: 'Frozen',
					IMPOSSIBLE_ROC: 'Spikes',
					DOMAIN_RANGE: 'Out of range / codes',
					JITTER: 'Jitter',
					NODE_SUBSTITUTION: 'Feed substitution',
					TRIGGER_READINGS: 'Trigger readings',
				},
				CLEAR: 'clear',
				CONF_HIGH: 'High',
				CONF_LOW: 'Low',
				CONF_MEDIUM: 'Medium',
				DECIDED_AT: 'Decided at step {{n}} · {{title}}',
				DELAY: 'Delay',
				DISAGREE: 'The first check that matched (step {{n}}) points to {{outcome}}; the agent chose {{agent}}.',
				DISAGREE_SHORT: 'differs from path',
				DISAGREE_SHORT_TIP: 'The first matching check (step {{n}}) gives another class than the agent chose',
				DQ_ROUTE_FEED: 'Route: data-feed issue for the PI / historian owner (no work order)',
				DQ_ROUTE_INSTRUMENT: 'Route: instrument work order (I&E)',
				EXPORT_PDF: 'Export as PDF',
				FIRST_MATCH_AT: 'First match at step {{n}} · {{title}}',
				HELD_AT: 'Held at step {{n}} · {{title}}',
				JUSTIFICATION_STEP: 'Agent justification · step {{n}}',
				LIMIT: 'Limit',
				LINK_CLOSE: 'Valid – No Action (link)',
				MACHINE_SENSORS: 'Sensors on the machine',
				MATCHED: 'matched',
				NEAR: 'near',
				NONE: 'none',
				NOT_RUNNING: 'Not running steadily:',
				NO_FINDING: 'No finding recorded for this check',
				NO_LIMITS: 'No engineering limit is known for this tag',
				PEAK_24H: '24 h peak',
				PILL_ABNORMAL: 'Abnormal → continue',
				PILL_DECIDED: 'Decided',
				PILL_HELD: 'Held: not enough evidence',
				PILL_MATCHED: 'Matched',
				PILL_NOT_REACHED: 'Not reached',
				PILL_NO_MATCH: 'No match → continue',
				PROCESS_TOPOLOGY: 'Process topology',
				REACHED: 'reached',
				RECOMMENDATIONS: 'Recommendations ({{n}})',
				REPLAY_NO: 'Rule did not reproduce on raw data',
				REPLAY_YES: 'Rule reproduced on raw data',
				RULE: 'Rule',
				RUN_AT: 'Run {{at}}',
				RUN_INDICATOR: 'Run indicator',
				SELECT_SENSOR: 'select a sensor to chart it',
				SME_INTERNAL: 'SME / HIL label (internal, validation only; never an agent input)',
				STEP_AGREE: 'This check is right',
				STEP_DISAGREE: 'This check is wrong',
				STEP_EVIDENCE: '{{tags}} tags, {{records}} records, {{docs}} docs',
				SUBTITLE: '{{n}} checks · select a step',
				TITLE: 'Triage path',
				TRUST: 'Status',
				UNTRUSTED: 'not trusted',
				VALUE: 'Value',
				DECISION_TITLE: 'Decision',
				RCA_TITLE: 'Decision & Triage Path',
				RCA_PANE_TITLE: 'Decision & Triage Path',
				PROPOSED_EVIDENCE_TITLE: 'Proposed Evidence',
				MINI_TITLE: '8-Step Triage Path',
				JUSTIFICATION: 'Justification',
				ORDERED_TITLE: 'Ordered 8-Step Triage Path',
				ORDERED_SUBTITLE: '7 checks in order — the first check that matches decides the outcome',
				STEP_PASSED: 'Passed',
				STEP_NOT_REACHED: 'Not Reached',
				RULE_FLAGGED: 'Rule Flagged for Tuning',
				RULE_FLAGGED_NOTICE: 'Alert approved & detector rule flagged for tuning',
				FLAG_RULE_CTA: 'Close & Flag Rule for Tuning',
				CREATE_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_TITLE: 'Create Instrument Work Order (Data Quality Policy)',
				INSTRUMENT_WO_POLICY: 'Routed to I&E Discipline',
				INSTRUMENT_TAG: 'Instrument Tag',
				DEFECT_DESCRIPTION: 'Defect Description',
				SUBMIT_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_CREATED: 'Instrument Work Order {{id}} raised — Status moved to Pending – Defect Raised',
				ROOTY: 'Rooty',
				ROOTY_HINT: 'Ask Rooty or open discussion on this alert',
				ASK_ROOTY_STEP: 'Ask Rooty about this step',
				STEP_COMMENT: 'Comment on this step',
				STEP_COMMENT_PLACEHOLDER: 'Add a note on this triage step…',
				PLOT_TAG_HINT: 'Plot this tag in Proposed Evidence',
				PLOT_ALL_STEP_TAGS: 'Plot all {{count}} step tags',
				OPEN_WO_HINT: 'Open this Work Order in the Work Orders tab',
				OPEN_ALERT_EVIDENCE_HINT: 'Open this alert in the Alerts tab',
				STEP3_VISUAL_TITLE: 'Machine Diagram & Operating State',
				STEP3_VISUAL_HINT: 'Click any sensor to plot it on the right',
				STEP4_VISUAL_TITLE: 'P&ID Process Flow & Event Timeline',
				STEP4_VISUAL_HINT: 'Driver and response tags are plotted on the right',
				STEP5_VISUAL_TITLE: 'Event Timeline — Cited Work Orders & Open Alerts',
				STEP5_VISUAL_HINT: 'Click a marker or chip to inspect the Work Order or Alert on the right',
				DEEP_DETAILS: 'Deep RCA Details (Verified Facts, Hypotheses & FMEA)',
			},
		},
	}
};
